// This file is auto-generated by @hey-api/openapi-ts

import * as z from "zod";

/**
 * RootResponse
 */
export const zRootResponse = z.object({
  docs: z.string(),
  message: z.string(),
  version: z.string(),
});

/**
 * ValidationError
 */
export const zValidationError = z.object({
  loc: z.array(z.union([z.string(), z.int()])),
  msg: z.string(),
  type: z.string(),
  ctx: z.record(z.string(), z.unknown()).optional(),
  input: z.unknown().optional(),
});

/**
 * HTTPValidationError
 */
export const zHttpValidationError = z.object({
  detail: z.array(zValidationError).optional(),
  body: z.unknown().optional(),
});

/**
 * TestAccountsResponse
 */
export const zTestAccountsResponse = z.object({
  message: z.string(),
  status: z.string(),
  test: z.string(),
});

/**
 * HealthResponse
 */
export const zHealthResponse = z.object({
  environment: z.string(),
  status: z.string(),
});

/**
 * ReadinessCheck
 */
export const zReadinessCheck = z.object({
  detail: z.string().nullish(),
  status: z.string(),
});

/**
 * ReadinessResponse
 */
export const zReadinessResponse = z.object({
  checks: z.record(z.string(), zReadinessCheck),
  environment: z.string(),
  status: z.string(),
});

/**
 * RegenerateBackupCodesRequest
 */
export const zRegenerateBackupCodesRequest = z.object({
  password: z.string(),
});

/**
 * BackupCodesResponse
 */
export const zBackupCodesResponse = z.object({
  backup_codes: z.array(z.string()),
});

/**
 * Disable2FARequest
 */
export const zDisable2FaRequest = z.object({
  code: z.string().min(6).max(8),
  password: z.string(),
});

/**
 * AuthMessageResponse
 */
export const zAuthMessageResponse = z.object({
  message: z.string(),
});

/**
 * Enable2FARequest
 */
export const zEnable2FaRequest = z.object({
  code: z.string().length(6),
});

/**
 * Setup2FAResponse
 */
export const zSetup2FaResponse = z.object({
  backup_codes: z.array(z.string()),
  qr_code: z.string(),
  secret: z.string(),
});

/**
 * TwoFactorRequest
 */
export const zTwoFactorRequest = z.object({
  code: z.string().min(6).max(8),
});

/**
 * TokenResponse
 */
export const zTokenResponse = z.object({
  access_token: z.string(),
  expires_in: z.int(),
  needs_2fa: z.boolean().optional().default(false),
  refresh_token: z.string(),
  token_type: z.string().optional().default("bearer"),
});

/**
 * ChangePasswordRequest
 */
export const zChangePasswordRequest = z.object({
  confirm_password: z.string().min(6),
  current_password: z.string(),
  new_password: z.string().min(6),
});

/**
 * BillingDataRequest
 *
 * Schema for billing data (juridical person)
 */
export const zBillingDataRequest = z.object({
  address_line1: z.string().max(255).nullish(),
  address_line2: z.string().max(255).nullish(),
  city: z.string().max(100).nullish(),
  company_name: z.string().max(255).nullish(),
  email: z.string().max(255).nullish(),
  phone: z.string().max(50).nullish(),
  state: z.string().max(2).nullish(),
  zip_code: z.string().max(10).nullish(),
});

/**
 * CheckoutCreditCard
 *
 * Dados do cartão de crédito para tokenização/cobrança no Asaas.
 */
export const zCheckoutCreditCard = z.object({
  ccv: z.string().max(4),
  expiry_month: z.string().max(2),
  expiry_year: z.string().max(4),
  holder_name: z.string(),
  number: z.string(),
});

/**
 * CreditCardHolder
 */
export const zCreditCardHolder = z.object({
  postal_code: z.string().regex(/^\d{5}-?\d{3}$/),
  address_number: z.string().min(1).max(20),
  phone: z
    .string()
    .max(20)
    .regex(/^(?:|(?:\D*\d){10,11}\D*)$/)
    .nullish(),
});

/**
 * CheckoutDataRequest
 *
 * Schema for updating user data during checkout
 */
export const zCheckoutDataRequest = z.object({
  address_line1: z.string().max(255).nullish(),
  address_line2: z.string().max(255).nullish(),
  billing_cycle: z.string().nullish().default("monthly"),
  billing_data: zBillingDataRequest.nullish(),
  city: z.string().max(100).nullish(),
  cnpj: z.string().max(20).nullish(),
  coupon_code: z.string().nullish(),
  cpf: z.string().max(14).nullish(),
  credit_card: zCheckoutCreditCard.nullish(),
  discount_amount: z.number().nullish(),
  payment_method: z.string().nullish().default("pix"),
  person_type: z.string().nullish().default("fisica"),
  plan_id: z.union([z.string(), z.uuid()]).nullish(),
  remote_ip: z.string().nullish(),
  state: z.string().max(2).nullish(),
  total_amount: z.number().nullish(),
  zip_code: z.string().max(10).nullish(),
  credit_card_holder: zCreditCardHolder.nullish(),
});

/**
 * CheckoutPaymentResponse
 *
 * Dados da cobrança gerada no gateway durante o checkout.
 */
export const zCheckoutPaymentResponse = z.object({
  billing_type: z.string(),
  due_date: z.string().nullish(),
  gateway_payment_id: z.string().nullish(),
  invoice_id: z.string().nullish(),
  invoice_url: z.string().nullish(),
  pix_copy_paste: z.string().nullish(),
  pix_qr_image: z.string().nullish(),
  status: z.string(),
});

/**
 * CheckoutDataResponse
 *
 * Response for checkout data update
 */
export const zCheckoutDataResponse = z.object({
  account_updated: z.boolean(),
  message: z.string(),
  payment: zCheckoutPaymentResponse.nullish(),
  user_updated: z.boolean(),
});

/**
 * ForgotPasswordRequest
 */
export const zForgotPasswordRequest = z.object({
  email: z.email(),
});

/**
 * LoginRequest
 */
export const zLoginRequest = z.object({
  email: z.email(),
  password: z.string(),
});

/**
 * RefreshTokenRequest
 */
export const zRefreshTokenRequest = z.object({
  refresh_token: z.string(),
});

/**
 * RegisterRequest
 */
export const zRegisterRequest = z.object({
  confirm_password: z.string().min(6),
  email: z.email(),
  name: z.string().min(3).max(255),
  password: z.string().min(6),
  phone: z.string().max(50).nullish(),
});

/**
 * UserResponse
 */
export const zUserResponse = z.object({
  avatar_url: z.string().nullish(),
  created_at: z.iso.datetime(),
  email: z.string(),
  id: z.uuid(),
  is_2fa_enabled: z.boolean().nullish(),
  is_active: z.boolean(),
  is_verified: z.boolean(),
  name: z.string(),
  phone: z.string().nullish(),
  user_type: z.string(),
});

/**
 * RegisterResponse
 *
 * Response for user registration with tokens
 */
export const zRegisterResponse = z.object({
  access_token: z.string(),
  expires_in: z.int(),
  needs_2fa: z.boolean().optional().default(false),
  refresh_token: z.string(),
  token_type: z.string().optional().default("bearer"),
  user: zUserResponse,
});

/**
 * ResetPasswordRequest
 */
export const zResetPasswordRequest = z.object({
  code: z.string().length(6),
  email: z.email(),
  password: z.string().min(6),
  password_confirmation: z.string().min(6),
});

/**
 * ProfileAccount
 */
export const zProfileAccount = z.object({
  customer_uuid: z.string().nullish(),
  id: z.uuid(),
  name: z.string(),
  role: z.string().nullish(),
  slug: z.string(),
  status: z.string().nullish(),
  access_level: z.enum(["admin", "editor", "viewer"]).nullish(),
});

/**
 * ProfileSubscription
 */
export const zProfileSubscription = z.object({
  billing_cycle: z.string(),
  current_period_end: z.iso.datetime(),
  id: z.uuid(),
  plan_category: z.string(),
  plan_name: z.string(),
  status: z.string(),
});

/**
 * ProfileResponse
 */
export const zProfileResponse = z.object({
  accounts: z.array(zProfileAccount).optional().default([]),
  avatar_url: z.string().nullish(),
  company_document: z.string().nullish(),
  company_name: z.string().nullish(),
  created_at: z.iso.datetime(),
  document: z.string().nullish(),
  email: z.string(),
  id: z.uuid(),
  is_2fa_enabled: z.boolean().nullish(),
  is_verified: z.boolean(),
  name: z.string(),
  phone: z.string().nullish(),
  plan_category: z.string().nullish(),
  subscription: zProfileSubscription.nullish(),
  user_type: z.string(),
  is_subscriber: z.boolean().optional(),
  can_manage_account_users: z.boolean().optional(),
  can_manage_teams: z.boolean().optional(),
  backup_codes_remaining: z.int().optional(),
});

/**
 * UpdateProfileRequest
 */
export const zUpdateProfileRequest = z.object({
  company_document: z.string().max(50).nullish(),
  company_name: z.string().max(255).nullish(),
  document: z.string().max(50).nullish(),
  name: z.string().min(3).max(255).nullish(),
  phone: z.string().max(50).nullish(),
});

/**
 * UserMessageResponse
 */
export const zUserMessageResponse = z.object({
  message: z.string(),
});

/**
 * Body_upload_avatar_api_v1_users_me_avatar_post
 */
export const zBodyUploadAvatarApiV1UsersMeAvatarPost = z.object({
  file: z.string(),
});

/**
 * UploadAvatarResponse
 */
export const zUploadAvatarResponse = z.object({
  avatar_url: z.string(),
  message: z.string().optional().default("Avatar uploaded successfully"),
});

/**
 * AuxiliaryCleanupResult
 *
 * AuxiliaryCleanupResult
 */
export const zAuxiliaryCleanupResult = z.object({
  backfill_audit_deleted: z.int().nullish().default(0),
  campaign_filter_fields_deleted: z.int().nullish().default(0),
  campaign_name_filters_deleted: z.int().nullish().default(0),
  errors: z.array(z.string()).nullish(),
  redis_keys_cleared: z.int().nullish().default(0),
  storage_limits_deleted: z.int().nullish().default(0),
  sync_jobs_deleted: z.int().nullish().default(0),
  sync_logs_deleted: z.int().nullish().default(0),
});

/**
 * TableCleanupResult
 *
 * TableCleanupResult
 */
export const zTableCleanupResult = z.object({
  rows_deleted: z.int(),
});

/**
 * MetricsCleanupTableStats
 *
 * MetricsCleanupTableStats
 */
export const zMetricsCleanupTableStats = z.object({
  customer_uuid: z.string().nullish(),
  error: z.string().nullish(),
  patterns: z.array(z.string()).nullish(),
  records_count: z.int().nullish(),
  rows_deleted: z.int().nullish(),
  source: z.string().nullish(),
  table: z.string().nullish(),
  tables_deleted: z.record(z.string(), zTableCleanupResult).nullish(),
});

/**
 * MetricsCleanupResult
 *
 * MetricsCleanupResult
 */
export const zMetricsCleanupResult = z.object({
  customer_uuid: z.string(),
  errors: z.array(z.string()).nullish(),
  related_sources: z.array(z.string()).nullish(),
  rows_deleted: z.int().nullish(),
  source: z.string(),
  tables_cleaned: z.record(z.string(), zMetricsCleanupTableStats).nullish(),
});

/**
 * ProviderDisconnectResult
 *
 * ProviderDisconnectResult
 */
export const zProviderDisconnectResult = z.object({
  attempted: z.boolean(),
  error: z.string().nullish(),
  lookup_error: z.string().nullish(),
  reason: z.string(),
  revoked: z.boolean(),
  user_id: z.string().nullish(),
});

/**
 * JobIds
 *
 * JobIds
 */
export const zJobIds = z.object({
  actual_instance: z.unknown().optional(),
  any_of_schemas: z.array(z.string()).optional().default(["List[str]"]),
  anyof_schema_1_validator: z.array(z.string()).nullish(),
  anyof_schema_2_validator: z.array(z.string()).nullish(),
});

/**
 * SyncJobsCleanupResult
 *
 * SyncJobsCleanupResult
 */
export const zSyncJobsCleanupResult = z.object({
  errors: z.array(z.string()).nullish(),
  job_ids: zJobIds.nullish(),
  jobs_deleted: z.int().nullish().default(0),
  logs_deleted: z.int().nullish().default(0),
  queue_removed: z.int().nullish().default(0),
  tasks_revoked: z.int().nullish().default(0),
});

/**
 * DisconnectResponse
 *
 * DisconnectResponse
 */
export const zDisconnectResponse = z.object({
  accounts_removed: z.int().nullish().default(0),
  auxiliary_cleanup: zAuxiliaryCleanupResult.nullish(),
  credentials_removed: z.int().nullish().default(0),
  customer_uuid: z.string(),
  errors: z.array(z.string()).nullish(),
  metrics_cleanup: zMetricsCleanupResult.nullish(),
  provider_disconnect: zProviderDisconnectResult.nullish(),
  source: z.string(),
  success: z.boolean(),
  sync_jobs_cleanup: zSyncJobsCleanupResult.nullish(),
});

/**
 * IntegrationHealth
 *
 * IntegrationHealth
 */
export const zIntegrationHealth = z.object({
  last_error: z.string().nullish(),
  last_validated_at: z.iso.datetime().nullish(),
  source: z.string(),
  token_status: z.string().nullish().default("unknown"),
});

/**
 * ConnectionInfo
 *
 * ConnectionInfo
 */
export const zConnectionInfo = z.object({
  connected: z.boolean(),
  integrations: z.array(zIntegrationHealth).nullish(),
  last_sync: z.iso.datetime().nullish(),
  source: z.string(),
  status: z.string(),
});

/**
 * ConnectionStatusResponse
 *
 * ConnectionStatusResponse
 */
export const zConnectionStatusResponse = z.object({
  connections: z.array(zConnectionInfo),
});

/**
 * UserIntegration
 */
export const zUserIntegration = z.object({
  config_data: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .optional(),
  created_at: z.string().nullish(),
  id: z.string(),
  last_sync_at: z.string().nullish(),
  name: z.string().nullish(),
  status: z.string(),
  type: z.string(),
  updated_at: z.string().nullish(),
});

/**
 * UserIntegrationsResponse
 */
export const zUserIntegrationsResponse = z.object({
  integrations: z.array(zUserIntegration),
});

/**
 * UserSession
 */
export const zUserSession = z.object({
  created_at: z.iso.datetime(),
  expires_at: z.iso.datetime(),
  id: z.uuid(),
  ip_address: z.string().nullish(),
  user_agent: z.string().nullish(),
});

/**
 * UserSessionsResponse
 */
export const zUserSessionsResponse = z.object({
  sessions: z.array(zUserSession),
});

/**
 * AiCreditPackOffer
 */
export const zAiCreditPackOffer = z.object({
  id: z.string(),
  name: z.string(),
  credits: z.int(),
  price: z.number(),
  unit_price: z.number(),
});

/**
 * AiCreditPackOfferListResponse
 */
export const zAiCreditPackOfferListResponse = z.object({
  packs: z.array(zAiCreditPackOffer),
});

/**
 * AiCreditPurchaseRequest
 */
export const zAiCreditPurchaseRequest = z.object({
  pack_id: z.uuid(),
  customer_uuid: z.uuid(),
  payment_method: z.enum(["pix", "credit_card"]).optional().default("pix"),
  credit_card: zCheckoutCreditCard.nullish(),
  credit_card_holder: zCreditCardHolder.nullish(),
  remote_ip: z.string().max(64).nullish(),
});

/**
 * PixQrResponse
 */
export const zPixQrResponse = z.object({
  pix_copy_paste: z.string().nullish(),
  pix_qr_image: z.string().nullish(),
});

/**
 * MyAccountAICreditsResponse
 *
 * Saldo de créditos de IA do assinante (pool compartilhado).
 */
export const zMyAccountAiCreditsResponse = z.object({
  balance: z.int().nullish(),
  granted: z.int().nullish(),
  period_start: z.iso.datetime().nullish(),
  unlimited: z.boolean(),
  purchased_balance: z.int().optional(),
  total_balance: z.int().nullish(),
});

/**
 * InvoiceLineItem
 *
 * An invoice line item from the JSONB items field.
 */
export const zInvoiceLineItem = z.object({
  amount: z.number().nullish(),
  description: z.string().nullish(),
  quantity: z.int().nullish(),
  type: z.string().nullish(),
  unit_price: z.number().nullish(),
});

/**
 * MyAccountInvoicePlan
 */
export const zMyAccountInvoicePlan = z.object({
  billing_cycle: z.string(),
  features: z.record(
    z.string(),
    z
      .union([
        z.int(),
        z.string(),
        z.boolean(),
        z.number(),
        z.array(z.string()),
      ])
      .nullable(),
  ),
  name: z.string(),
  price: z.number(),
});

/**
 * MyAccountInvoiceItem
 */
export const zMyAccountInvoiceItem = z.object({
  amount: z.number(),
  billing_cycle: z.string(),
  coupon_code: z.string().nullish(),
  created_at: z.string().nullish(),
  currency: z.string(),
  description: z.string().nullish(),
  discount_amount: z.number(),
  due_date: z.string().nullish(),
  id: z.string(),
  invoice_number: z.string(),
  items: z.array(zInvoiceLineItem).optional().default([]),
  month: z.string(),
  monthly_amount: z.number(),
  notes: z.string().nullish(),
  paid_at: z.string().nullish(),
  pdf_url: z.string().nullish(),
  period_end: z.string().nullish(),
  period_start: z.string().nullish(),
  plan: zMyAccountInvoicePlan.nullish(),
  setup_fee: z.number(),
  status: z.string(),
  subscription_start: z.string().nullish(),
  year: z.int(),
});

/**
 * MyAccountTrialInfo
 */
export const zMyAccountTrialInfo = z.object({
  is_in_trial: z.boolean(),
  plan_name: z.string(),
  plan_price: z.number(),
  subscription_status: z.string(),
  trial_days_remaining: z.int(),
  trial_end: z.iso.datetime().nullish(),
});

/**
 * MyAccountInvoicesResponse
 */
export const zMyAccountInvoicesResponse = z.object({
  data: z.array(zMyAccountInvoiceItem),
  trial_info: zMyAccountTrialInfo.nullish(),
});

/**
 * MyAccountInvoiceDetailResponse
 */
export const zMyAccountInvoiceDetailResponse = z.object({
  amount: z.number(),
  billing_cycle: z.string(),
  coupon_code: z.string().nullish(),
  created_at: z.iso.datetime().nullish(),
  currency: z.string(),
  description: z.string().nullish(),
  discount_amount: z.number(),
  due_date: z.iso.datetime().nullish(),
  id: z.uuid(),
  invoice_number: z.string(),
  items: z.array(zInvoiceLineItem).optional().default([]),
  month: z.string(),
  monthly_amount: z.number(),
  notes: z.string().nullish(),
  paid_at: z.iso.datetime().nullish(),
  pdf_url: z.string().nullish(),
  period_end: z.iso.datetime().nullish(),
  period_start: z.iso.datetime().nullish(),
  plan: zMyAccountInvoicePlan,
  setup_fee: z.number(),
  status: z.string(),
  subscription_start: z.iso.datetime().nullish(),
  year: z.int(),
});

/**
 * MyAccountPaymentStatusResponse
 *
 * Status de uma cobrança do assinante (para polling do checkout).
 */
export const zMyAccountPaymentStatusResponse = z.object({
  paid: z.boolean(),
  status: z.string(),
});

/**
 * MyAccountAvailablePlan
 */
export const zMyAccountAvailablePlan = z.object({
  category: z.string(),
  features: z.record(
    z.string(),
    z
      .union([
        z.int(),
        z.string(),
        z.boolean(),
        z.number(),
        z.array(z.string()),
      ])
      .nullable(),
  ),
  id: z.uuid(),
  name: z.string(),
  price: z.number(),
  tier: z.string(),
});

/**
 * MyAccountCurrentPlan
 */
export const zMyAccountCurrentPlan = z.object({
  category: z.string(),
  features: z.record(
    z.string(),
    z
      .union([
        z.int(),
        z.string(),
        z.boolean(),
        z.number(),
        z.array(z.string()),
      ])
      .nullable(),
  ),
  id: z.uuid(),
  name: z.string(),
  period_end: z.iso.datetime().nullish(),
  price: z.number(),
  status: z.string(),
  tier: z.string(),
  trial_end: z.iso.datetime().nullish(),
});

/**
 * MyAccountSubscriptionResponse
 */
export const zMyAccountSubscriptionResponse = z.object({
  available_plans: z.array(zMyAccountAvailablePlan),
  can_upgrade: z.boolean().optional().default(false),
  current_plan: zMyAccountCurrentPlan.nullish(),
  upgrade_blocked_reason: z.string().nullish(),
});

/**
 * MyAccountUserTeam
 */
export const zMyAccountUserTeam = z.object({
  id: z.uuid(),
  name: z.string(),
});

/**
 * MyAccountUserStore
 */
export const zMyAccountUserStore = z.object({
  account_id: z.uuid(),
  name: z.string(),
});

/**
 * MyAccountUserItem
 */
export const zMyAccountUserItem = z.object({
  created_at: z.iso.datetime().nullish(),
  email: z.email(),
  id: z.uuid(),
  last_login: z.iso.datetime().nullish(),
  name: z.string(),
  status: z.string(),
  user_id: z.uuid(),
  access_type: z.enum(["team", "client"]),
  access_level: z.enum(["admin", "editor", "viewer"]),
  teams: z.array(zMyAccountUserTeam),
  accounts: z.array(zMyAccountUserStore),
});

/**
 * MyAccountUsersResponse
 */
export const zMyAccountUsersResponse = z.object({
  data: z.array(zMyAccountUserItem),
});

/**
 * AccountUserCreate
 */
export const zAccountUserCreate = z.object({
  email: z.email(),
  name: z.string(),
  password: z.string(),
  access_type: z.enum(["team", "client"]).optional().default("team"),
  access_level: z.enum(["admin", "editor", "viewer"]).optional(),
  team_ids: z.array(z.uuid()).max(500).optional(),
  account_ids: z.array(z.uuid()).max(500).optional(),
});

/**
 * MyAccountUserResponse
 */
export const zMyAccountUserResponse = z.object({
  data: zMyAccountUserItem,
});

/**
 * MyAccountMessageResponse
 */
export const zMyAccountMessageResponse = z.object({
  message: z.string(),
});

/**
 * AccountUserUpdate
 */
export const zAccountUserUpdate = z.object({
  email: z.email().nullish(),
  name: z.string().nullish(),
  password: z.string().nullish(),
  access_level: z.enum(["admin", "editor", "viewer"]).nullish(),
  team_ids: z.array(z.uuid()).max(500).nullish(),
  account_ids: z.array(z.uuid()).max(500).nullish(),
});

/**
 * PlanFeatureCategory
 */
export const zPlanFeatureCategory = z.object({
  count: z.int(),
  enabled: z.int(),
  label: z.string(),
  slug: z.string(),
});

/**
 * PlanFeatureItem
 */
export const zPlanFeatureItem = z.object({
  config: z
    .record(
      z.string(),
      z.union([
        z.string(),
        z.int(),
        z.number(),
        z.boolean(),
        z.array(z.string()),
      ]),
    )
    .nullish(),
  is_enabled: z.boolean(),
  is_highlighted: z.boolean().optional().default(false),
  usage_limit: z.int().nullish(),
});

/**
 * MyPlanFeaturesResponse
 */
export const zMyPlanFeaturesResponse = z.object({
  categories: z.array(zPlanFeatureCategory),
  features: z.record(z.string(), zPlanFeatureItem),
  plan_id: z.uuid(),
  plan_name: z.string(),
});

/**
 * ManagedAccountListItem
 */
export const zManagedAccountListItem = z.object({
  address: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  created_at: z.string(),
  document: z.string().nullish(),
  id: z.string(),
  name: z.string(),
  person_type: z.string().nullish(),
  phone: z.string().nullish(),
  segment: z.string().nullish(),
  slug: z.string(),
  status: z.string(),
});

/**
 * ManagedAccountListResponse
 */
export const zManagedAccountListResponse = z.object({
  accounts: z.array(zManagedAccountListItem),
  max_accounts: z.int().nullish(),
});

/**
 * ManagedAccountCreateRequest
 */
export const zManagedAccountCreateRequest = z.object({
  address: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  document: z.string().nullish().default(""),
  name: z.string(),
  person_type: z.string().nullish().default("fisica"),
  phone: z.string().nullish().default(""),
  segment: z.string().max(100),
});

/**
 * ManagedAccountResponse
 */
export const zManagedAccountResponse = z.object({
  address: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  created_at: z.string(),
  document: z.string().nullish(),
  id: z.string(),
  name: z.string(),
  person_type: z.string().nullish(),
  phone: z.string().nullish(),
  segment: z.string().nullish(),
  slug: z.string(),
  status: z.string(),
  user_created: z.boolean().nullish(),
});

/**
 * ManagedAccountSwitchRequest
 */
export const zManagedAccountSwitchRequest = z.object({
  account_id: z.string(),
});

/**
 * ManagedAccountSwitchAccount
 */
export const zManagedAccountSwitchAccount = z.object({
  id: z.string(),
  name: z.string(),
  segment: z.string().nullish(),
  slug: z.string(),
  status: z.string(),
});

/**
 * ManagedAccountSwitchResponse
 */
export const zManagedAccountSwitchResponse = z.object({
  account: zManagedAccountSwitchAccount,
  customer_uuid: z.string(),
  message: z.string(),
  subaccount_token: z.string(),
  success: z.boolean(),
});

/**
 * ManagedAccountDeleteResponse
 */
export const zManagedAccountDeleteResponse = z.object({
  account_name: z.string(),
  deleted_records: z.record(z.string(), z.int()),
  message: z.string(),
  user_email: z.string(),
});

/**
 * ManagedAccountUpdateRequest
 */
export const zManagedAccountUpdateRequest = z.object({
  address: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  document: z.string().nullish(),
  name: z.string().nullish(),
  person_type: z.string().nullish(),
  phone: z.string().nullish(),
  segment: z.string().max(100).nullish(),
});

/**
 * ManagedAccountStatusRequest
 */
export const zManagedAccountStatusRequest = z.object({
  status: z.string(),
});

/**
 * ManagedAccountStatusResponse
 */
export const zManagedAccountStatusResponse = z.object({
  id: z.string(),
  message: z.string(),
  name: z.string(),
  status: z.string(),
});

/**
 * DataDeletionResponse
 */
export const zDataDeletionResponse = z.object({
  confirmed_at: z.string(),
  deletion_request_id: z.string(),
  message: z.string(),
  status: z.string(),
});

/**
 * StorageUsageResponse
 */
export const zStorageUsageResponse = z.object({
  is_exceeded: z.boolean().optional().default(false),
  is_limit_set: z.boolean().optional().default(false),
  is_near_limit: z.boolean().optional().default(false),
  max_storage_bytes: z.int().nullish(),
  remaining_bytes: z.int().nullish(),
  total_bytes_used: z.int().optional().default(0),
  usage_by_integration: z.record(z.string(), z.int()).optional(),
  usage_percentage: z.number().nullish(),
});

/**
 * PlanResponse
 */
export const zPlanResponse = z.object({
  created_at: z.iso.datetime(),
  description: z.string().nullish(),
  features: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .optional(),
  id: z.uuid(),
  is_active: z.boolean(),
  is_public: z.boolean(),
  max_accounts: z.int().gte(1).optional().default(1),
  max_users_per_account: z.int().gte(1).optional().default(5),
  name: z.string().min(3).max(255),
  price_monthly: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  price_yearly: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  slug: z.string().min(3).max(255),
  trial_days: z.int().gte(0).optional().default(0),
  type: z.string(),
  updated_at: z.iso.datetime(),
});

/**
 * ProrationPreview
 */
export const zProrationPreview = z.object({
  days_remaining_in_period: z.int(),
  next_renewal_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  next_renewal_date: z.iso.datetime(),
  prorated_difference: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
});

/**
 * EligiblePlanItem
 */
export const zEligiblePlanItem = z.object({
  plan: zPlanResponse,
  proration_preview: zProrationPreview,
});

/**
 * EligiblePlansResponse
 */
export const zEligiblePlansResponse = z.object({
  can_upgrade: z.boolean().optional().default(false),
  current_plan: zPlanResponse.nullish(),
  eligible_plans: z.array(zEligiblePlanItem).optional(),
  upgrade_blocked_reason: z.string().nullish(),
});

/**
 * RetentionStatusResponse
 */
export const zRetentionStatusResponse = z.object({
  data_retention_deadline: z.iso.datetime().nullish(),
  days_until_deletion: z.int().nullish(),
  message: z.string().nullish(),
  status: z.string(),
  trial_ends_at: z.iso.datetime().nullish(),
});

/**
 * UpgradeRequest
 */
export const zUpgradeRequest = z.object({
  billing_cycle: z.enum(["monthly", "yearly"]).optional().default("monthly"),
  credit_card: zCheckoutCreditCard.nullish(),
  payment_method: z.enum(["pix", "credit_card"]).optional().default("pix"),
  plan_id: z.uuid(),
  remote_ip: z.string().nullish(),
  credit_card_holder: zCreditCardHolder.nullish(),
});

/**
 * AdminRegenerateBackupCodesRequest
 */
export const zAdminRegenerateBackupCodesRequest = z.object({
  password: z.string(),
});

/**
 * AdminBackupCodesResponse
 */
export const zAdminBackupCodesResponse = z.object({
  backup_codes: z.array(z.string()),
});

/**
 * AdminReconfigure2FARequest
 */
export const zAdminReconfigure2FaRequest = z.object({
  password: z.string(),
});

/**
 * AdminMessageResponse
 *
 * Resposta administrativa simples sem envelope de sucesso.
 */
export const zAdminMessageResponse = z.object({
  message: z.string(),
});

/**
 * AdminReset2FARequest
 *
 * Requisição de reset de 2FA para desenvolvimento.
 */
export const zAdminReset2FaRequest = z.object({
  email: z.string().nullish(),
});

/**
 * Admin2FASetupResponse
 *
 * Resposta de configuração 2FA
 */
export const zAdmin2FaSetupResponse = z.object({
  message: z
    .string()
    .optional()
    .default("Escaneie o QR Code com seu aplicativo de autenticação"),
  qr_code: z.string(),
  secret: z.string(),
  uri: z.string(),
  backup_codes: z.array(z.string()).optional(),
});

/**
 * Admin2FASetupRequest
 *
 * Requisição para configuração inicial do 2FA
 */
export const zAdmin2FaSetupRequest = z.object({
  session_token: z.string(),
});

/**
 * Admin2FARequest
 *
 * Requisição de verificação 2FA
 */
export const zAdmin2FaRequest = z.object({
  code: z.string().regex(/^(\d{6}|[0-9A-Fa-f]{8})$/),
  session_token: z.string(),
});

/**
 * AdminUserInfo
 *
 * Informações do usuário admin
 */
export const zAdminUserInfo = z.object({
  email: z.string(),
  id: z.uuid(),
  last_access_at: z.iso.datetime().nullable(),
  name: z.string(),
  profile_name: z.string(),
});

/**
 * Admin2FAResponse
 *
 * Resposta de verificação 2FA bem sucedida
 */
export const zAdmin2FaResponse = z.object({
  access_token: z.string(),
  expires_at: z.iso.datetime(),
  permissions: z.record(z.string(), z.array(z.string())),
  token_type: z.string().optional().default("bearer"),
  user: zAdminUserInfo,
});

/**
 * AdminChangePasswordRequest
 *
 * Requisição de troca de senha do admin atual.
 */
export const zAdminChangePasswordRequest = z.object({
  confirm_password: z.string().nullish(),
  current_password: z.string().nullish(),
  new_password: z.string().nullish(),
});

/**
 * AdminSuccessMessageResponse
 *
 * Resposta administrativa simples com mensagem.
 */
export const zAdminSuccessMessageResponse = z.object({
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminLoginRequest
 *
 * Requisição de login de admin
 */
export const zAdminLoginRequest = z.object({
  email: z.email(),
  password: z.string().min(6),
});

/**
 * AdminLoginResponse
 *
 * Resposta de login de admin - primeiro passo
 */
export const zAdminLoginResponse = z.object({
  message: z
    .string()
    .optional()
    .default("Por favor, insira o código de autenticação de dois fatores"),
  needs_2fa_setup: z.boolean().optional().default(false),
  requires_2fa: z.boolean().optional().default(true),
  session_token: z.string(),
});

/**
 * AdminTokenResponse
 *
 * Resposta com token de acesso admin.
 */
export const zAdminTokenResponse = z.object({
  access_token: z.string(),
  expires_at: z.iso.datetime(),
  token_type: z.string().optional().default("bearer"),
});

/**
 * AdminCurrentUserInfo
 */
export const zAdminCurrentUserInfo = z.object({
  email: z.string(),
  id: z.uuid(),
  is_2fa_enabled: z.boolean(),
  last_access_at: z.iso.datetime().nullable(),
  name: z.string(),
  profile_name: z.string(),
  backup_codes_remaining: z.int().optional(),
});

/**
 * AdminCurrentUserResponse
 */
export const zAdminCurrentUserResponse = z.object({
  permissions: z.record(z.string(), z.array(z.string())),
  user: zAdminCurrentUserInfo,
});

/**
 * AdminPasswordResetConfirm
 *
 * Confirmação de reset de senha
 */
export const zAdminPasswordResetConfirm = z.object({
  confirm_password: z.string().min(8),
  new_password: z.string().min(8),
  token: z.string(),
});

/**
 * AdminPasswordResetRequest
 *
 * Requisição de reset de senha
 */
export const zAdminPasswordResetRequest = z.object({
  email: z.email(),
});

/**
 * AdminUserList
 *
 * Usuário admin para listagem
 */
export const zAdminUserList = z.object({
  active_sessions: z.int().optional().default(0),
  created_at: z.iso.datetime(),
  department: z.string().nullable(),
  email: z.string(),
  id: z.uuid(),
  is_2fa_enabled: z.boolean().nullish(),
  is_active: z.boolean(),
  last_login_at: z.iso.datetime().nullable(),
  name: z.string(),
  phone: z.string().nullable(),
  profile_name: z.string(),
  total_sessions: z.int().optional().default(0),
});

/**
 * AdminUsersPagination
 */
export const zAdminUsersPagination = z.object({
  page: z.int(),
  page_size: z.int(),
  pages: z.int(),
  total: z.int(),
});

/**
 * AdminUsersListResponse
 */
export const zAdminUsersListResponse = z.object({
  items: z.array(zAdminUserList),
  pagination: zAdminUsersPagination,
  success: z.boolean(),
  total: z.int(),
  total_pages: z.int(),
});

/**
 * AdminUserCreate
 *
 * Criação de novo usuário admin
 */
export const zAdminUserCreate = z.object({
  department: z.string().max(100).nullish(),
  email: z.email(),
  is_active: z.boolean().optional().default(true),
  name: z.string().min(1).max(255),
  notes: z.string().nullish(),
  password: z.string().min(8),
  phone: z.string().max(50).nullish(),
  profile_id: z.uuid(),
  requires_2fa: z.boolean().optional().default(true),
});

/**
 * AdminUserMutationData
 */
export const zAdminUserMutationData = z.object({
  email: z.email(),
  id: z.uuid(),
  name: z.string(),
});

/**
 * AdminUserMutationResponse
 */
export const zAdminUserMutationResponse = z.object({
  data: zAdminUserMutationData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminBulkAction
 *
 * Ações em lote para usuários admin
 */
export const zAdminBulkAction = z.object({
  action: z.string().regex(/^(activate|deactivate|reset_2fa|revoke_sessions)$/),
  new_password: z.string().min(8).nullish(),
  send_notification: z.boolean().optional().default(true),
  user_ids: z.array(z.uuid()),
});

/**
 * AdminUserBulkActionData
 */
export const zAdminUserBulkActionData = z.object({
  error_count: z.int(),
  errors: z.array(
    z.record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    ),
  ),
  success_count: z.int(),
});

/**
 * AdminUserBulkActionResponse
 */
export const zAdminUserBulkActionResponse = z.object({
  data: zAdminUserBulkActionData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminPasswordReset
 *
 * Reset de senha por admin
 */
export const zAdminPasswordReset = z.object({
  new_password: z.string().min(8),
  require_change_on_login: z.boolean().optional().default(true),
  send_notification: z.boolean().optional().default(true),
  user_id: z.uuid(),
});

/**
 * AdminUserMessageResponse
 */
export const zAdminUserMessageResponse = z.object({
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminProfileBase
 *
 * Base do perfil admin
 */
export const zAdminProfileBase = z.object({
  created_at: z.iso.datetime(),
  description: z.string().nullable(),
  id: z.uuid(),
  is_system: z.boolean(),
  name: z.string(),
  permissions: z.record(z.string(), z.array(z.string())),
  total_users: z.int().optional().default(0),
  updated_at: z.iso.datetime(),
});

/**
 * AdminProfileListResponse
 */
export const zAdminProfileListResponse = z.object({
  data: z.array(zAdminProfileBase),
  success: z.boolean(),
  total: z.int(),
});

/**
 * AdminProfileCreate
 *
 * Criação de perfil
 */
export const zAdminProfileCreate = z.object({
  description: z.string().nullish(),
  name: z.string().min(1).max(100),
  permissions: z.record(z.string(), z.array(z.string())),
});

/**
 * AdminProfileMutationData
 */
export const zAdminProfileMutationData = z.object({
  id: z.uuid(),
  name: z.string(),
});

/**
 * AdminProfileMutationResponse
 */
export const zAdminProfileMutationResponse = z.object({
  data: zAdminProfileMutationData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminProfileUpdate
 *
 * Atualização de perfil
 */
export const zAdminProfileUpdate = z.object({
  description: z.string().nullish(),
  name: z.string().min(1).max(100).nullish(),
  permissions: z.record(z.string(), z.array(z.string())).nullish(),
});

/**
 * AdminUserActiveSession
 */
export const zAdminUserActiveSession = z.object({
  created_at: z.iso.datetime(),
  expires_at: z.iso.datetime(),
  id: z.uuid(),
  ip_address: z.string().nullish(),
  last_activity_at: z.iso.datetime(),
  user_agent: z.string().nullish(),
});

/**
 * AdminUserProfileDetail
 */
export const zAdminUserProfileDetail = z.object({
  description: z.string().nullish(),
  id: z.uuid(),
  is_system: z.boolean(),
  name: z.string(),
  permissions: z.record(
    z.string(),
    z
      .union([
        z.int(),
        z.string(),
        z.boolean(),
        z.number(),
        z.array(z.string()),
      ])
      .nullable(),
  ),
});

/**
 * AdminUserRecentLog
 */
export const zAdminUserRecentLog = z.object({
  action: z.string(),
  created_at: z.iso.datetime(),
  id: z.uuid(),
  ip_address: z.string().nullish(),
  resource_id: z.string().nullish(),
  resource_type: z.string().nullish(),
});

/**
 * AdminUserDetail
 *
 * Detalhes completos do usuário admin
 */
export const zAdminUserDetail = z.object({
  active_sessions: z.array(zAdminUserActiveSession),
  created_at: z.iso.datetime(),
  department: z.string().nullable(),
  email: z.string(),
  id: z.uuid(),
  is_2fa_enabled: z.boolean().nullish(),
  is_active: z.boolean(),
  last_login_at: z.iso.datetime().nullable(),
  name: z.string(),
  notes: z.string().nullable(),
  phone: z.string().nullable(),
  profile: zAdminUserProfileDetail,
  recent_logs: z.array(zAdminUserRecentLog),
  stats: z.record(z.string(), z.int()),
});

/**
 * AdminUserDetailResponse
 */
export const zAdminUserDetailResponse = z.object({
  data: zAdminUserDetail,
  success: z.boolean(),
});

/**
 * AdminUserUpdate
 *
 * Atualização de usuário admin
 */
export const zAdminUserUpdate = z.object({
  department: z.string().max(100).nullish(),
  is_active: z.boolean().nullish(),
  name: z.string().min(1).max(255).nullish(),
  notes: z.string().nullish(),
  phone: z.string().max(50).nullish(),
  profile_id: z.uuid().nullish(),
});

/**
 * AdminPasswordUpdate
 *
 * Atualização de senha
 */
export const zAdminPasswordUpdate = z.object({
  current_password: z.string(),
  logout_all_sessions: z.boolean().optional().default(true),
  new_password: z.string().min(8),
});

/**
 * AdminUserPasswordResetRequest
 *
 * Reset direto de senha de usuário admin por ID de rota.
 */
export const zAdminUserPasswordResetRequest = z.object({
  new_password: z.string().nullish(),
});

/**
 * BillingAddress
 *
 * Endereço de cobrança
 */
export const zBillingAddress = z.object({
  cep: z.string().max(10).nullish(),
  cidade: z.string().max(100).optional().default(""),
  complemento: z.string().max(100).nullish(),
  estado: z.string().max(2).optional().default(""),
  logradouro: z.string().max(255).optional().default(""),
  numero: z.string().max(20).optional().default(""),
});

/**
 * AdminSubscriberUser
 */
export const zAdminSubscriberUser = z.object({
  created_at: z.iso.datetime().nullish(),
  document: z.string().nullish(),
  email: z.string(),
  id: z.uuid(),
  is_2fa_enabled: z.boolean().nullish(),
  is_active: z.boolean(),
  is_verified: z.boolean(),
  last_login_at: z.iso.datetime().nullish(),
  name: z.string(),
  phone: z.string().nullish(),
});

/**
 * AdminSubscriberListItem
 */
export const zAdminSubscriberListItem = z.object({
  active_subscriptions: z.int(),
  billing_address: zBillingAddress.nullish(),
  billing_email: z.string(),
  company_document: z.string(),
  company_name: z.string(),
  created_at: z.iso.datetime().nullish(),
  current_plan: z.string().nullish(),
  id: z.uuid(),
  is_active: z.boolean(),
  total_accounts: z.int(),
  updated_at: z.iso.datetime().nullish(),
  user: zAdminSubscriberUser,
});

/**
 * AdminSubscriberPagination
 */
export const zAdminSubscriberPagination = z.object({
  limit: z.int(),
  page: z.int().nullish(),
  page_size: z.int().nullish(),
  pages: z.int(),
  skip: z.int(),
  total: z.int(),
});

/**
 * AdminSubscriberListResponse
 */
export const zAdminSubscriberListResponse = z.object({
  data: z.array(zAdminSubscriberListItem),
  pagination: zAdminSubscriberPagination,
  success: z.boolean(),
});

/**
 * SubscriberCreate
 *
 * Criação de novo assinante
 */
export const zSubscriberCreate = z.object({
  billing_address: zBillingAddress.nullish(),
  billing_email: z.email().nullish(),
  company_document: z.string().max(50).nullish(),
  company_name: z.string().max(255).nullish(),
  document: z.string().max(50).nullish(),
  email: z.email(),
  name: z.string().min(1).max(255),
  password: z.string().min(6),
  phone: z.string().max(50).nullish(),
  plan_id: z.uuid(),
});

/**
 * AdminSubscriberMutationData
 */
export const zAdminSubscriberMutationData = z.object({
  company_name: z.string().nullish(),
  email: z.string(),
  id: z.uuid(),
});

/**
 * AdminSubscriberMutationResponse
 */
export const zAdminSubscriberMutationResponse = z.object({
  data: zAdminSubscriberMutationData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * AssignPlanByUserRequest
 */
export const zAssignPlanByUserRequest = z.object({
  plan_id: z.uuid(),
  user_id: z.uuid(),
});

/**
 * AssignPlanResponse
 */
export const zAssignPlanResponse = z.object({
  credits_balance: z.int().nullish(),
  current_period_end: z.iso.datetime(),
  current_period_start: z.iso.datetime(),
  plan_id: z.uuid(),
  plan_name: z.string(),
  status: z.string(),
  subscription_id: z.uuid(),
});

/**
 * SubscriberBulkAction
 *
 * Ações em lote para assinantes
 */
export const zSubscriberBulkAction = z.object({
  action: z.string().regex(/^(activate|deactivate|suspend|delete)$/),
  reason: z.string().nullish(),
  subscriber_ids: z.array(z.uuid()),
});

/**
 * BulkActionError
 *
 * An error record from a bulk action operation.
 */
export const zBulkActionError = z.object({
  error: z.string(),
  subscriber_id: z.string(),
});

/**
 * AdminSubscriberBulkActionData
 */
export const zAdminSubscriberBulkActionData = z.object({
  error_count: z.int(),
  errors: z.array(zBulkActionError),
  success_count: z.int(),
});

/**
 * AdminSubscriberBulkActionResponse
 */
export const zAdminSubscriberBulkActionResponse = z.object({
  data: zAdminSubscriberBulkActionData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminSubscriberDistributionItem
 */
export const zAdminSubscriberDistributionItem = z.object({
  count: z.int(),
  percentage: z.number(),
  plan_name: z.string().nullish(),
});

/**
 * AdminSubscriberDistributionData
 */
export const zAdminSubscriberDistributionData = z.object({
  chart_data: z.array(zAdminSubscriberDistributionItem),
  total: z.int(),
});

/**
 * AdminSubscriberDistributionResponse
 */
export const zAdminSubscriberDistributionResponse = z.object({
  data: zAdminSubscriberDistributionData,
  success: z.boolean(),
});

/**
 * AdminSubscriberTimeseriesItem
 */
export const zAdminSubscriberTimeseriesItem = z.object({
  count: z.int(),
  month: z.string(),
});

/**
 * AdminSubscriberTimeseriesResponse
 */
export const zAdminSubscriberTimeseriesResponse = z.object({
  data: z.array(zAdminSubscriberTimeseriesItem),
  success: z.boolean(),
});

/**
 * AdminHardDeleteItem
 */
export const zAdminHardDeleteItem = z.object({
  accounts_count: z.int().nullish(),
  admin_email: z.string(),
  admin_id: z.string(),
  created_at: z.iso.datetime(),
  id: z.string(),
  integrations_count: z.int().nullish(),
  message: z.string().nullish(),
  reason: z.string(),
  status: z.enum(["completed", "failed"]),
  subscriber_id: z.string(),
  user_email: z.string(),
});

/**
 * AdminHardDeletePagination
 */
export const zAdminHardDeletePagination = z.object({
  page: z.int(),
  page_size: z.int(),
  pages: z.int(),
  total: z.int(),
});

/**
 * AdminHardDeleteListResponse
 */
export const zAdminHardDeleteListResponse = z.object({
  data: z.array(zAdminHardDeleteItem),
  pagination: zAdminHardDeletePagination,
  success: z.boolean(),
});

/**
 * SubscriberSummaryData
 */
export const zSubscriberSummaryData = z.object({
  active_subscribers: z.int(),
  active_subscribers_growth: z.number(),
  inactive_subscribers: z.int(),
  monthly_churn_growth: z.number(),
  monthly_churn_rate: z.number(),
  new_subscribers_growth: z.number(),
  new_subscribers_this_month: z.int(),
  previous_month_churn_rate: z.number(),
  total_subscribers: z.int(),
  total_subscribers_growth: z.number(),
  with_active_subscription: z.int(),
  with_active_subscription_growth: z.number(),
});

/**
 * AdminSubscriberSummaryResponse
 */
export const zAdminSubscriberSummaryResponse = z.object({
  data: zSubscriberSummaryData,
  success: z.boolean(),
});

/**
 * AdminSubscriberMessageResponse
 */
export const zAdminSubscriberMessageResponse = z.object({
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminSubscriberIntegration
 */
export const zAdminSubscriberIntegration = z.object({
  connected_at: z.iso.datetime().nullish(),
  error_message: z.string().nullish(),
  id: z.uuid(),
  integration_id: z.string().nullish(),
  is_active: z.boolean(),
  last_error_at: z.iso.datetime().nullish(),
  last_sync_at: z.iso.datetime().nullish(),
  type: z.string(),
});

/**
 * AdminSubscriberAccountUser
 */
export const zAdminSubscriberAccountUser = z.object({
  created_at: z.iso.datetime().nullish(),
  email: z.string(),
  id: z.uuid(),
  is_active: z.boolean(),
  last_login_at: z.iso.datetime().nullish(),
  name: z.string(),
  phone: z.string().nullish(),
  role: z.string().nullish(),
});

/**
 * AdminSubscriberAccount
 */
export const zAdminSubscriberAccount = z.object({
  active_users: z.int(),
  created_at: z.iso.datetime(),
  id: z.uuid(),
  integrations: z.array(zAdminSubscriberIntegration),
  name: z.string(),
  slug: z.string(),
  status: z.string(),
  total_integrations: z.int(),
  total_users: z.int(),
  users: z.array(zAdminSubscriberAccountUser),
});

/**
 * AdminSubscriberRevenue
 */
export const zAdminSubscriberRevenue = z.object({
  total: z.number(),
});

/**
 * AdminSubscriberSubscription
 */
export const zAdminSubscriberSubscription = z.object({
  billing_cycle: z.string(),
  created_at: z.iso.datetime(),
  current_period_end: z.iso.datetime(),
  current_period_start: z.iso.datetime(),
  id: z.uuid(),
  plan_name: z.string(),
  status: z.string(),
  trial_end: z.iso.datetime().nullish(),
});

/**
 * AdminSubscriberDetailData
 */
export const zAdminSubscriberDetailData = z.object({
  accounts: z.array(zAdminSubscriberAccount),
  billing_address: zBillingAddress.nullish(),
  billing_email: z.string().nullish(),
  company_document: z.string().nullish(),
  company_name: z.string().nullish(),
  created_at: z.iso.datetime(),
  id: z.uuid(),
  is_active: z.boolean(),
  revenue: zAdminSubscriberRevenue,
  subscriptions: z.array(zAdminSubscriberSubscription),
  updated_at: z.iso.datetime(),
  user: zAdminSubscriberUser,
});

/**
 * AdminSubscriberDetailResponse
 */
export const zAdminSubscriberDetailResponse = z.object({
  data: zAdminSubscriberDetailData,
  success: z.boolean(),
});

/**
 * SubscriberUpdate
 *
 * Atualização de assinante
 */
export const zSubscriberUpdate = z.object({
  billing_address: zBillingAddress.nullish(),
  billing_email: z.email().nullish(),
  company_document: z.string().max(50).nullish(),
  company_name: z.string().max(255).nullish(),
  document: z.string().max(50).nullish(),
  is_active: z.boolean().nullish(),
  name: z.string().min(1).max(255).nullish(),
  phone: z.string().max(50).nullish(),
});

/**
 * CreateAccountForSubscriber
 *
 * Criar conta para assinante
 */
export const zCreateAccountForSubscriber = z.object({
  name: z.string().min(1).max(255),
  send_welcome_email: z.boolean().nullish().default(true),
  slug: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[a-z0-9-]+$/),
  user_email: z.email(),
  user_name: z.string().min(1).max(255),
  user_password: z.string().min(6),
  user_role: z.string().optional().default("owner"),
});

/**
 * AdminSubscriberAccountData
 */
export const zAdminSubscriberAccountData = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
});

/**
 * AdminSubscriberAccountResponse
 */
export const zAdminSubscriberAccountResponse = z.object({
  data: zAdminSubscriberAccountData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminSubscriberActivityItem
 */
export const zAdminSubscriberActivityItem = z.object({
  description: z.string(),
  timestamp: z.iso.datetime(),
  type: z.string(),
  user: z.string().nullish(),
});

/**
 * AdminSubscriberActivityData
 */
export const zAdminSubscriberActivityData = z.object({
  activities: z.array(zAdminSubscriberActivityItem),
  total: z.int(),
});

/**
 * AdminSubscriberActivityResponse
 */
export const zAdminSubscriberActivityResponse = z.object({
  data: zAdminSubscriberActivityData,
  success: z.boolean(),
});

/**
 * AssignPlanRequest
 */
export const zAssignPlanRequest = z.object({
  plan_id: z.uuid(),
});

/**
 * AdminSubscriberCreateAccountRequest
 */
export const zAdminSubscriberCreateAccountRequest = z.object({
  account_name: z.string().nullish(),
  account_slug: z.string().nullish(),
  send_welcome_email: z.boolean().nullish(),
});

/**
 * AdminHardDeleteRequest
 */
export const zAdminHardDeleteRequest = z.object({
  confirmation_id: z.string(),
  reason: z.string().min(1).max(2000),
});

/**
 * AdminHardDeleteResponse
 */
export const zAdminHardDeleteResponse = z.object({
  accounts_count: z.int(),
  integrations_count: z.int(),
  message: z.string(),
  status: z.enum(["completed", "failed"]),
  subscriber_id: z.string(),
});

/**
 * ApiErrorResponse
 */
export const zApiErrorResponse = z.object({
  detail: z.string(),
});

/**
 * AdminSubscriberInvoiceItem
 */
export const zAdminSubscriberInvoiceItem = z.object({
  amount: z.number(),
  created_at: z.iso.datetime(),
  due_date: z.iso.datetime(),
  id: z.uuid(),
  invoice_number: z.string(),
  paid_at: z.iso.datetime().nullish(),
  status: z.string(),
});

/**
 * AdminSubscriberInvoicesResponse
 */
export const zAdminSubscriberInvoicesResponse = z.object({
  data: z.array(zAdminSubscriberInvoiceItem),
  pagination: zAdminSubscriberPagination,
  success: z.boolean(),
});

/**
 * AdminCourseListItem
 */
export const zAdminCourseListItem = z.object({
  active_students: z.int().optional().default(0),
  completion_rate: z.number().optional().default(0),
  created_at: z.iso.datetime(),
  description: z.string().nullish(),
  id: z.uuid(),
  is_active: z.boolean(),
  is_published: z.boolean(),
  price: z.number().nullish(),
  slug: z.string(),
  thumbnail_url: z.string().nullish(),
  title: z.string(),
  total_duration: z.int().optional().default(0),
  total_enrollments: z.int().optional().default(0),
  total_lessons: z.int().optional().default(0),
  total_modules: z.int().optional().default(0),
  updated_at: z.iso.datetime(),
});

/**
 * AdminCoursePagination
 *
 * Pagination metadata returned by admin course lists.
 */
export const zAdminCoursePagination = z.object({
  limit: z.int().nullish(),
  page: z.int().nullish(),
  page_size: z.int().nullish(),
  pages: z.int(),
  skip: z.int().nullish(),
  total: z.int(),
});

/**
 * AdminCourseListResponse
 */
export const zAdminCourseListResponse = z.object({
  data: z.array(zAdminCourseListItem),
  pagination: zAdminCoursePagination,
  success: z.boolean(),
});

/**
 * CourseCreate
 *
 * Criação de novo curso
 */
export const zCourseCreate = z.object({
  allowed_plan_ids: z.array(z.uuid()).optional(),
  description: z.string().min(1).nullish(),
  difficulty_level: z
    .string()
    .regex(/^(beginner|intermediate|advanced)$/)
    .nullish(),
  estimated_duration: z.int().gte(0).nullish(),
  is_active: z.boolean().optional().default(true),
  is_public: z.boolean().optional().default(false),
  preview_video_url: z.url().min(1).max(2083).nullish(),
  price: z
    .union([
      z.number().gte(0),
      z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    ])
    .nullish(),
  short_description: z.string().max(500).nullish(),
  slug: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[a-z0-9-]+$/),
  tags: z.array(z.string()).optional(),
  thumbnail_url: z.url().min(1).max(2083).nullish(),
  title: z.string().min(1).max(255),
});

/**
 * CourseCreatedData
 */
export const zCourseCreatedData = z.object({
  id: z.string(),
  slug: z.string(),
  title: z.string(),
});

/**
 * AdminCourseCreateResponse
 */
export const zAdminCourseCreateResponse = z.object({
  data: zCourseCreatedData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * BulkEnrollment
 *
 * Matrícula em lote
 */
export const zBulkEnrollment = z.object({
  course_id: z.uuid(),
  expiration_date: z.iso.datetime().nullish(),
  grant_immediate_access: z.boolean().optional().default(true),
  notify_users: z.boolean().optional().default(true),
  user_emails: z.array(z.string()).min(1),
});

/**
 * BulkEnrollResultData
 */
export const zBulkEnrollResultData = z.object({
  already_enrolled: z.array(z.string()).optional().default([]),
  enrolled_count: z.int().optional().default(0),
  not_found: z.array(z.string()).optional().default([]),
  total_processed: z.int().optional().default(0),
});

/**
 * AdminCourseBulkEnrollResponse
 */
export const zAdminCourseBulkEnrollResponse = z.object({
  data: zBulkEnrollResultData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * EnrollmentsEvolutionChartPoint
 */
export const zEnrollmentsEvolutionChartPoint = z.object({
  enrollments: z.int(),
  month: z.string(),
  month_key: z.string(),
});

/**
 * ChartPeriod
 */
export const zChartPeriod = z.object({
  end: z.string().nullish(),
  months: z.int().optional().default(0),
  start: z.string().nullish(),
});

/**
 * EnrollmentsEvolutionData
 */
export const zEnrollmentsEvolutionData = z.object({
  chart_data: z.array(zEnrollmentsEvolutionChartPoint),
  period: zChartPeriod,
});

/**
 * AdminCourseEnrollmentsEvolutionResponse
 */
export const zAdminCourseEnrollmentsEvolutionResponse = z.object({
  data: zEnrollmentsEvolutionData,
  success: z.boolean(),
});

/**
 * TopCourseChartPoint
 */
export const zTopCourseChartPoint = z.object({
  course_title: z.string(),
  enrollments: z.int(),
  percentage: z.number(),
});

/**
 * TopCoursesPeriod
 */
export const zTopCoursesPeriod = z.object({
  days: z.int().optional().default(0),
});

/**
 * TopCoursesData
 */
export const zTopCoursesData = z.object({
  chart_data: z.array(zTopCourseChartPoint),
  period: zTopCoursesPeriod,
  total_enrollments: z.int().optional().default(0),
});

/**
 * AdminCourseTopCoursesResponse
 */
export const zAdminCourseTopCoursesResponse = z.object({
  data: zTopCoursesData,
  success: z.boolean(),
});

/**
 * CourseClone
 *
 * Clonar curso
 */
export const zCourseClone = z.object({
  include_lessons: z.boolean().optional().default(true),
  include_modules: z.boolean().optional().default(true),
  include_settings: z.boolean().optional().default(true),
  new_slug: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[a-z0-9-]+$/),
  new_title: z.string().min(1).max(255),
  set_as_draft: z.boolean().optional().default(true),
  source_course_id: z.uuid(),
});

/**
 * AdminCourseCloneResponse
 */
export const zAdminCourseCloneResponse = z.object({
  data: zCourseCreatedData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * LessonMaterial
 */
export const zLessonMaterial = z.object({
  file_size: z.int().nullish(),
  file_type: z.string().nullish(),
  id: z.string().nullish(),
  title: z.string().optional().default(""),
  type: z.string().optional().default(""),
  url: z.string().nullish(),
});

/**
 * LessonCreate
 *
 * Criação de aula
 */
export const zLessonCreate = z.object({
  content_html: z.string().nullish(),
  description: z.string().nullish(),
  is_active: z.boolean().optional().default(true),
  is_free: z.boolean().optional().default(false),
  materials: z.array(zLessonMaterial).optional(),
  module_id: z.uuid(),
  order: z.int().gte(0),
  title: z.string().min(1).max(255),
  video_duration: z.int().gte(0).nullish(),
  video_url: z.string().nullish(),
});

/**
 * LessonCreatedData
 */
export const zLessonCreatedData = z.object({
  id: z.string(),
  order: z.int(),
  title: z.string(),
});

/**
 * AdminCourseLessonCreateResponse
 */
export const zAdminCourseLessonCreateResponse = z.object({
  data: zLessonCreatedData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * LegacyCourseReorderItem
 *
 * Compatibility reorder item for module, lesson, or media order updates.
 */
export const zLegacyCourseReorderItem = z.object({
  id: z.string().nullish(),
  order: z.int().nullish(),
});

/**
 * LegacyCourseReorderRequest
 *
 * Compatibility request body for legacy course reorder endpoints.
 */
export const zLegacyCourseReorderRequest = z.object({
  items: z.array(zLegacyCourseReorderItem).nullish(),
});

/**
 * AdminCourseMessageResponse
 *
 * Admin course mutation response without body data.
 */
export const zAdminCourseMessageResponse = z.object({
  message: z.string(),
  success: z.boolean(),
});

/**
 * LessonMediaDetail
 *
 * Detalhes da multimídia
 */
export const zLessonMediaDetail = z.object({
  created_at: z.iso.datetime(),
  description: z.string().nullish(),
  duration: z.int().nullish(),
  file_name: z.string().nullish(),
  file_size: z.int().nullish(),
  file_url: z.string(),
  height: z.int().nullish(),
  id: z.uuid(),
  is_active: z.boolean(),
  lesson_id: z.uuid(),
  media_type: z.string(),
  mime_type: z.string().nullish(),
  order: z.int(),
  title: z.string(),
  updated_at: z.iso.datetime(),
  width: z.int().nullish(),
});

/**
 * AdminLessonDetailData
 */
export const zAdminLessonDetailData = z.object({
  content_html: z.string().nullish(),
  created_at: z.iso.datetime(),
  description: z.string().nullish(),
  id: z.uuid(),
  is_active: z.boolean(),
  is_free: z.boolean(),
  materials: z.array(zLessonMaterial).nullish(),
  media: z.array(zLessonMediaDetail),
  module_id: z.uuid(),
  order: z.int(),
  slug: z.string(),
  title: z.string(),
  updated_at: z.iso.datetime(),
  video_duration: z.int().nullish(),
  video_url: z.string().nullish(),
});

/**
 * AdminCourseLessonDetailResponse
 */
export const zAdminCourseLessonDetailResponse = z.object({
  data: zAdminLessonDetailData,
  success: z.boolean(),
});

/**
 * LessonUpdate
 *
 * Atualização de aula
 */
export const zLessonUpdate = z.object({
  content_html: z.string().nullish(),
  description: z.string().nullish(),
  is_active: z.boolean().nullish(),
  is_free: z.boolean().nullish(),
  materials: z.array(zLessonMaterial).nullish(),
  title: z.string().min(1).max(255).nullish(),
  video_duration: z.int().gte(0).nullish(),
  video_url: z.string().nullish(),
});

/**
 * LessonMediaList
 *
 * Lista de multimídias
 */
export const zLessonMediaList = z.object({
  created_at: z.iso.datetime(),
  duration: z.int().nullish(),
  file_size: z.int().nullish(),
  file_url: z.string(),
  id: z.uuid(),
  is_active: z.boolean(),
  media_type: z.string(),
  order: z.int(),
  title: z.string(),
});

/**
 * AdminCourseMediaListResponse
 */
export const zAdminCourseMediaListResponse = z.object({
  data: z.array(zLessonMediaList),
  success: z.boolean(),
});

/**
 * LessonMediaCreate
 *
 * Criação de multimídia da aula
 */
export const zLessonMediaCreate = z.object({
  description: z.string().nullish(),
  duration: z.int().gte(0).nullish(),
  file_name: z.string().max(255).nullish(),
  file_size: z.int().gte(0).nullish(),
  file_url: z.string().min(1).max(500),
  height: z.int().gte(0).nullish(),
  is_active: z.boolean().optional().default(true),
  media_type: z.string().regex(/^(video|image|document|pdf|audio)$/),
  mime_type: z.string().max(100).nullish(),
  order: z.int().gte(0).optional().default(0),
  title: z.string().min(1).max(255),
  width: z.int().gte(0).nullish(),
});

/**
 * MediaCreatedData
 */
export const zMediaCreatedData = z.object({
  file_url: z.string(),
  id: z.string(),
  media_type: z.string(),
  title: z.string(),
});

/**
 * AdminCourseMediaCreateResponse
 */
export const zAdminCourseMediaCreateResponse = z.object({
  data: zMediaCreatedData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * Body_upload_lesson_media_api_v1_admin_courses_lessons__lesson_id__upload_media_post
 */
export const zBodyUploadLessonMediaApiV1AdminCoursesLessonsLessonIdUploadMediaPost =
  z.object({
    file: z.string(),
  });

/**
 * UploadMediaResultData
 */
export const zUploadMediaResultData = z.object({
  file_name: z.string().nullish(),
  file_size: z.int().nullish(),
  file_url: z.string(),
  id: z.string(),
  media_type: z.string(),
  mime_type: z.string().nullish(),
  title: z.string(),
});

/**
 * AdminCourseLessonUploadMediaResponse
 */
export const zAdminCourseLessonUploadMediaResponse = z.object({
  data: zUploadMediaResultData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * LessonMediaUpdate
 *
 * Atualização de multimídia da aula
 */
export const zLessonMediaUpdate = z.object({
  description: z.string().nullish(),
  duration: z.int().gte(0).nullish(),
  file_name: z.string().max(255).nullish(),
  file_size: z.int().gte(0).nullish(),
  file_url: z.string().min(1).max(500).nullish(),
  height: z.int().gte(0).nullish(),
  is_active: z.boolean().nullish(),
  mime_type: z.string().max(100).nullish(),
  order: z.int().gte(0).nullish(),
  title: z.string().min(1).max(255).nullish(),
  width: z.int().gte(0).nullish(),
});

/**
 * MediaUpdatedData
 */
export const zMediaUpdatedData = z.object({
  id: z.string(),
  media_type: z.string(),
  title: z.string(),
});

/**
 * AdminCourseMediaUpdateResponse
 */
export const zAdminCourseMediaUpdateResponse = z.object({
  data: zMediaUpdatedData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * ModuleCreate
 *
 * Criação de módulo do curso
 */
export const zModuleCreate = z.object({
  course_id: z.uuid(),
  description: z.string().nullish(),
  is_active: z.boolean().optional().default(true),
  order_index: z.int().gte(0),
  title: z.string().min(1).max(255),
});

/**
 * ModuleCreatedData
 */
export const zModuleCreatedData = z.object({
  id: z.string(),
  order_index: z.int(),
  title: z.string(),
});

/**
 * AdminCourseModuleCreateResponse
 */
export const zAdminCourseModuleCreateResponse = z.object({
  data: zModuleCreatedData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminModuleLessonItem
 */
export const zAdminModuleLessonItem = z.object({
  content_html: z.string().nullish(),
  description: z.string().nullish(),
  id: z.string(),
  is_active: z.boolean().optional().default(true),
  is_free: z.boolean().optional().default(false),
  media_count: z.int().optional().default(0),
  order: z.int(),
  title: z.string(),
  video_duration: z.int().nullish(),
  video_url: z.string().nullish(),
});

/**
 * AdminModuleDetailData
 */
export const zAdminModuleDetailData = z.object({
  course_id: z.string(),
  created_at: z.iso.datetime(),
  description: z.string().nullish(),
  id: z.string(),
  is_active: z.boolean(),
  lessons: z.array(zAdminModuleLessonItem),
  order: z.int(),
  title: z.string(),
  updated_at: z.iso.datetime(),
});

/**
 * AdminCourseModuleDetailResponse
 */
export const zAdminCourseModuleDetailResponse = z.object({
  data: zAdminModuleDetailData,
  success: z.boolean(),
});

/**
 * ModuleUpdate
 *
 * Atualização de módulo
 */
export const zModuleUpdate = z.object({
  description: z.string().nullish(),
  is_active: z.boolean().nullish(),
  order_index: z.int().gte(0).nullish(),
  title: z.string().min(1).max(255).nullish(),
});

/**
 * AdminCourseSummaryData
 */
export const zAdminCourseSummaryData = z.object({
  active_courses: z.int().optional().default(0),
  active_courses_growth: z.number().optional().default(0),
  active_students: z.int().optional().default(0),
  active_students_growth: z.number().optional().default(0),
  new_enrollments_growth: z.number().optional().default(0),
  new_enrollments_this_month: z.int().optional().default(0),
  total_courses: z.int().optional().default(0),
  total_courses_growth: z.number().optional().default(0),
});

/**
 * AdminCourseSummaryResponse
 */
export const zAdminCourseSummaryResponse = z.object({
  data: zAdminCourseSummaryData,
  success: z.boolean(),
});

/**
 * Body_upload_file_api_v1_admin_courses_upload_post
 */
export const zBodyUploadFileApiV1AdminCoursesUploadPost = z.object({
  file: z.string(),
});

/**
 * UploadFileData
 */
export const zUploadFileData = z.object({
  file_name: z.string(),
  file_size: z.int(),
  file_url: z.string(),
  mime_type: z.string(),
});

/**
 * AdminCourseUploadResponse
 */
export const zAdminCourseUploadResponse = z.object({
  data: zUploadFileData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * EnrollmentListItem
 */
export const zEnrollmentListItem = z.object({
  access_type: z.string().optional().default(""),
  completed_at: z.iso.datetime().nullish(),
  enrolled_at: z.iso.datetime(),
  id: z.uuid(),
  is_active: z.boolean().optional().default(true),
  progress_percentage: z.number().nullish().default(0),
  user_email: z.string().nullish(),
  user_id: z.uuid(),
  user_name: z.string().nullish(),
});

/**
 * ModuleLesson
 */
export const zModuleLesson = z.object({
  content_html: z.string().nullish(),
  description: z.string().nullish(),
  id: z.uuid(),
  is_active: z.boolean().optional().default(true),
  is_free: z.boolean().optional().default(false),
  media_count: z.int().optional().default(0),
  order: z.int(),
  title: z.string(),
  video_duration: z.int().nullish(),
  video_url: z.string().nullish(),
});

/**
 * ModuleWithLessons
 *
 * Módulo com suas aulas
 */
export const zModuleWithLessons = z.object({
  description: z.string().nullish(),
  id: z.uuid(),
  is_active: z.boolean(),
  lessons: z.array(zModuleLesson),
  order: z.int(),
  title: z.string(),
  total_lessons: z.int(),
});

/**
 * CourseStats
 */
export const zCourseStats = z.object({
  active_students: z.int().optional().default(0),
  completed_students: z.int().optional().default(0),
  total_duration: z.int().optional().default(0),
  total_enrollments: z.int().optional().default(0),
  total_lessons: z.int().optional().default(0),
  total_modules: z.int().optional().default(0),
});

/**
 * AdminCourseDetailData
 */
export const zAdminCourseDetailData = z.object({
  allowed_plan_ids: z.array(z.string()).optional().default([]),
  created_at: z.iso.datetime(),
  description: z.string().nullish(),
  difficulty_level: z.string().nullish(),
  enrollments: z.array(zEnrollmentListItem),
  estimated_duration: z.int().nullish(),
  id: z.uuid(),
  is_active: z.boolean(),
  is_public: z.boolean(),
  modules: z.array(zModuleWithLessons),
  preview_video_url: z.string().nullish(),
  price: z.number().nullish(),
  short_description: z.string().nullish(),
  slug: z.string(),
  stats: zCourseStats,
  tags: z.array(z.string()).optional().default([]),
  thumbnail_url: z.string().nullish(),
  title: z.string(),
  updated_at: z.iso.datetime(),
});

/**
 * AdminCourseDetailResponse
 */
export const zAdminCourseDetailResponse = z.object({
  data: zAdminCourseDetailData,
  success: z.boolean(),
});

/**
 * CourseUpdate
 *
 * Atualização de curso
 */
export const zCourseUpdate = z.object({
  allowed_plan_ids: z.array(z.uuid()).nullish(),
  description: z.string().min(1).nullish(),
  difficulty_level: z
    .string()
    .regex(/^(beginner|intermediate|advanced)$/)
    .nullish(),
  estimated_duration: z.int().gte(0).nullish(),
  is_active: z.boolean().nullish(),
  is_public: z.boolean().nullish(),
  preview_video_url: z.url().min(1).max(2083).nullish(),
  price: z
    .union([
      z.number().gte(0),
      z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    ])
    .nullish(),
  short_description: z.string().max(500).nullish(),
  tags: z.array(z.string()).nullish(),
  thumbnail_url: z.url().min(1).max(2083).nullish(),
  title: z.string().min(1).max(255).nullish(),
});

/**
 * AdminCourseUpdateResponse
 */
export const zAdminCourseUpdateResponse = z.object({
  data: zCourseCreatedData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * LegacyCourseBulkEnrollmentRequest
 *
 * Compatibility request body for course-scoped bulk enrollment.
 */
export const zLegacyCourseBulkEnrollmentRequest = z.object({
  send_notification: z.boolean().nullish(),
  user_emails: z.array(z.string()).nullish(),
});

/**
 * BulkEnrollCourseResultData
 */
export const zBulkEnrollCourseResultData = z.object({
  enrolled_count: z.int().optional().default(0),
  total_emails: z.int().optional().default(0),
});

/**
 * AdminCourseBulkEnrollCourseResponse
 */
export const zAdminCourseBulkEnrollCourseResponse = z.object({
  data: zBulkEnrollCourseResultData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * LegacyCourseCloneRequest
 *
 * Compatibility request body for course-scoped clone endpoint.
 */
export const zLegacyCourseCloneRequest = z.object({
  copy_lessons: z.boolean().nullish(),
  copy_modules: z.boolean().nullish(),
  new_slug: z.string().nullish(),
  new_title: z.string().nullish(),
  set_as_draft: z.boolean().nullish(),
});

/**
 * CourseEnrollmentStatsData
 */
export const zCourseEnrollmentStatsData = z.object({
  active_students: z.int().optional().default(0),
  average_progress: z.number().optional().default(0),
  completed_students: z.int().optional().default(0),
  completion_rate: z.number().optional().default(0),
  total_enrollments: z.int().optional().default(0),
});

/**
 * AdminCourseEnrollmentStatsV2Response
 */
export const zAdminCourseEnrollmentStatsV2Response = z.object({
  data: zCourseEnrollmentStatsData,
  success: z.boolean(),
});

/**
 * LegacyCourseModuleCreateRequest
 *
 * Compatibility request body for course-scoped module creation.
 */
export const zLegacyCourseModuleCreateRequest = z.object({
  description: z.string().nullish(),
  is_active: z.boolean().nullish(),
  order: z.int().nullish(),
  title: z.string().nullish(),
});

/**
 * ModuleWithOrderData
 */
export const zModuleWithOrderData = z.object({
  id: z.string(),
  order: z.int(),
  title: z.string(),
});

/**
 * AdminCourseModuleCreateV2Response
 */
export const zAdminCourseModuleCreateV2Response = z.object({
  data: zModuleWithOrderData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * LegacyCourseLessonCreateRequest
 *
 * Compatibility request body for course-scoped lesson creation.
 */
export const zLegacyCourseLessonCreateRequest = z.object({
  content_html: z.string().nullish(),
  description: z.string().nullish(),
  is_free: z.boolean().nullish(),
  materials: z.array(zLessonMaterial).nullish(),
  order: z.int().nullish(),
  slug: z.string().nullish(),
  title: z.string().nullish(),
  video_duration: z.int().nullish(),
  video_url: z.string().nullish(),
});

/**
 * AdminCourseLessonCreateV2Response
 */
export const zAdminCourseLessonCreateV2Response = z.object({
  data: zModuleWithOrderData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * StudentProgressListStudent
 */
export const zStudentProgressListStudent = z.object({
  enrolled_at: z.string().nullish(),
  last_activity: z.string().nullish(),
  progress_percentage: z.number(),
  user_email: z.string(),
  user_id: z.string(),
  user_name: z.string(),
});

/**
 * StudentProgressListData
 */
export const zStudentProgressListData = z.object({
  students: z.array(zStudentProgressListStudent),
  total: z.int().optional().default(0),
});

/**
 * AdminCourseStudentProgressResponse
 */
export const zAdminCourseStudentProgressResponse = z.object({
  data: zStudentProgressListData,
  success: z.boolean(),
});

/**
 * StudentModuleProgress
 */
export const zStudentModuleProgress = z.object({
  completed_lessons: z.int(),
  module_id: z.string(),
  module_title: z.string(),
  percentage: z.number(),
  total_lessons: z.int(),
});

/**
 * StudentProgress
 *
 * Progresso do aluno no curso
 */
export const zStudentProgress = z.object({
  completed_at: z.iso.datetime().nullish(),
  completed_lessons: z.int(),
  course_id: z.uuid(),
  course_title: z.string(),
  enrolled_at: z.iso.datetime(),
  enrollment_id: z.uuid(),
  last_activity: z.iso.datetime().nullish(),
  modules_progress: z.array(zStudentModuleProgress),
  progress_percentage: z.number(),
  total_lessons: z.int(),
  user_email: z.string(),
  user_id: z.uuid(),
  user_name: z.string(),
});

/**
 * AdminCourseStudentsResponse
 */
export const zAdminCourseStudentsResponse = z.object({
  data: z.array(zStudentProgress),
  pagination: zAdminCoursePagination,
  success: z.boolean(),
});

/**
 * AdminBillingMessageResponse
 */
export const zAdminBillingMessageResponse = z.object({
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminBillingQuarterlyPeriod
 */
export const zAdminBillingQuarterlyPeriod = z.object({
  description: z.string(),
  end: z.string(),
  start: z.string(),
});

/**
 * AdminBillingQuarterlyRevenueData
 */
export const zAdminBillingQuarterlyRevenueData = z.object({
  chart_data: z.array(z.record(z.string(), z.union([z.number(), z.string()]))),
  period: zAdminBillingQuarterlyPeriod,
  total_revenue: z.number(),
});

/**
 * AdminBillingQuarterlyRevenueResponse
 */
export const zAdminBillingQuarterlyRevenueResponse = z.object({
  data: zAdminBillingQuarterlyRevenueData,
  success: z.boolean(),
});

/**
 * AdminBillingRevenueEvolutionData
 */
export const zAdminBillingRevenueEvolutionData = z.object({
  chart_data: z.array(z.record(z.string(), z.union([z.number(), z.string()]))),
  plan_names: z.array(z.string()),
});

/**
 * AdminBillingRevenueEvolutionResponse
 */
export const zAdminBillingRevenueEvolutionResponse = z.object({
  data: zAdminBillingRevenueEvolutionData,
  success: z.boolean(),
});

/**
 * AdminBillingCouponItem
 */
export const zAdminBillingCouponItem = z.object({
  code: z.string(),
  created_at: z.iso.datetime(),
  current_uses: z.int(),
  description: z.string().nullish(),
  discount_type: z.string(),
  discount_value: z.number(),
  id: z.uuid(),
  is_active: z.boolean(),
  max_uses: z.int().nullish(),
  valid_from: z.iso.datetime(),
  valid_until: z.iso.datetime().nullish(),
});

/**
 * AdminBillingCouponListResponse
 */
export const zAdminBillingCouponListResponse = z.object({
  data: z.array(zAdminBillingCouponItem),
  success: z.boolean(),
  total: z.int(),
});

/**
 * CouponCreate
 *
 * Criar cupom de desconto
 */
export const zSchemasAdminBillingCouponCreate = z.object({
  applies_to: z.array(z.string()).optional(),
  code: z
    .string()
    .min(3)
    .max(50)
    .regex(/^[A-Z0-9-]+$/),
  description: z.string().nullish(),
  discount_type: z.string().regex(/^(percentage|fixed)$/),
  discount_value: z.union([
    z.number().gte(0),
    z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  ]),
  first_time_only: z.boolean().optional().default(false),
  max_uses: z.int().gte(1).nullish(),
  max_uses_per_subscriber: z.int().gte(1).optional().default(1),
  minimum_amount: z
    .union([
      z.number().gte(0),
      z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    ])
    .nullish(),
  valid_from: z.iso.datetime(),
  valid_until: z.iso.datetime().nullish(),
});

/**
 * AdminBillingCouponData
 */
export const zAdminBillingCouponData = z.object({
  code: z.string(),
  id: z.uuid(),
});

/**
 * AdminBillingCouponResponse
 */
export const zAdminBillingCouponResponse = z.object({
  data: zAdminBillingCouponData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * CouponUpdate
 *
 * Atualizar cupom
 */
export const zSchemasAdminBillingCouponUpdate = z.object({
  description: z.string().nullish(),
  is_active: z.boolean().nullish(),
  max_uses: z.int().gte(1).nullish(),
  valid_until: z.iso.datetime().nullish(),
});

/**
 * InvoiceList
 *
 * Fatura para listagem
 */
export const zInvoiceList = z.object({
  amount: z.number(),
  company_name: z.string().nullable(),
  created_at: z.iso.datetime(),
  due_date: z.iso.datetime(),
  id: z.uuid(),
  invoice_number: z.string(),
  paid_at: z.iso.datetime().nullable(),
  period_end: z.iso.datetime(),
  period_start: z.iso.datetime(),
  status: z.string(),
  subscriber_email: z.string(),
  subscriber_id: z.uuid(),
  subscriber_name: z.string(),
});

/**
 * CustomerHistorySubscriber
 */
export const zCustomerHistorySubscriber = z.object({
  company_name: z.string().nullish(),
  customer_since: z.iso.datetime(),
  email: z.string(),
  id: z.uuid(),
  is_active: z.boolean(),
  name: z.string(),
});

/**
 * CustomerHistorySummary
 */
export const zCustomerHistorySummary = z.object({
  days_overdue: z.int().nullish(),
  has_overdue: z.boolean(),
  last_payment: z.iso.datetime().nullish(),
  total_invoices: z.int(),
  total_paid: z.number(),
  total_pending: z.number(),
  total_overdue: z.number().optional(),
});

/**
 * CustomerBillingHistoryData
 */
export const zCustomerBillingHistoryData = z.object({
  invoices: z.array(zInvoiceList),
  subscriber: zCustomerHistorySubscriber,
  summary: zCustomerHistorySummary,
});

/**
 * AdminBillingCustomerHistoryResponse
 */
export const zAdminBillingCustomerHistoryResponse = z.object({
  data: zCustomerBillingHistoryData,
  success: z.boolean(),
});

/**
 * AdminBillingPagination
 */
export const zAdminBillingPagination = z.object({
  limit: z.int(),
  pages: z.int(),
  skip: z.int(),
  total: z.int(),
});

/**
 * AdminBillingInvoiceListResponse
 */
export const zAdminBillingInvoiceListResponse = z.object({
  data: z.array(zInvoiceList),
  pagination: zAdminBillingPagination,
  success: z.boolean(),
});

/**
 * InvoicePaymentInfo
 */
export const zInvoicePaymentInfo = z.object({
  amount: z.number(),
  gateway_payment_id: z.string().nullish(),
  id: z.uuid(),
  method: z.string(),
  processed_at: z.iso.datetime().nullish(),
  status: z.string(),
});

/**
 * InvoiceSubscriberInfo
 */
export const zInvoiceSubscriberInfo = z.object({
  billing_email: z.string().nullish(),
  company_name: z.string().nullish(),
  email: z.string(),
  id: z.uuid(),
  name: z.string(),
});

/**
 * InvoiceSubscriptionInfo
 */
export const zInvoiceSubscriptionInfo = z.object({
  billing_cycle: z.string(),
  id: z.uuid(),
  plan_name: z.string(),
  status: z.string(),
});

/**
 * InvoiceDetail
 *
 * Detalhes completos da fatura
 */
export const zInvoiceDetail = z.object({
  amount: z.number(),
  created_at: z.iso.datetime(),
  currency: z.string(),
  description: z.string().nullable(),
  due_date: z.iso.datetime(),
  id: z.uuid(),
  invoice_number: z.string(),
  items: z
    .array(
      z.record(
        z.string(),
        z
          .union([
            z.int(),
            z.string(),
            z.boolean(),
            z.number(),
            z.array(z.string()),
          ])
          .nullable(),
      ),
    )
    .nullable(),
  paid_at: z.iso.datetime().nullable(),
  payments: z.array(zInvoicePaymentInfo),
  pdf_url: z.string().nullable(),
  period_end: z.iso.datetime(),
  period_start: z.iso.datetime(),
  status: z.string(),
  subscriber: zInvoiceSubscriberInfo,
  subscription: zInvoiceSubscriptionInfo,
  updated_at: z.iso.datetime(),
});

/**
 * AdminBillingInvoiceDetailResponse
 */
export const zAdminBillingInvoiceDetailResponse = z.object({
  data: zInvoiceDetail,
  success: z.boolean(),
});

/**
 * InvoiceUpdate
 *
 * Atualização de fatura
 */
export const zInvoiceUpdate = z.object({
  description: z.string().nullish(),
  due_date: z.iso.datetime().nullish(),
  notes: z.string().nullish(),
  status: z
    .string()
    .regex(/^(pending|paid|overdue|cancelled)$/)
    .nullish(),
});

/**
 * PaymentRegister
 *
 * Registrar pagamento manual
 */
export const zPaymentRegister = z.object({
  amount: z.union([
    z.number().gte(0),
    z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  ]),
  gateway_payment_id: z.string().nullish(),
  invoice_id: z.uuid(),
  method: z
    .string()
    .regex(/^(credit_card|debit_card|pix|boleto|manual|bank_transfer)$/),
  notes: z.string().nullish(),
  payment_details: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  processed_at: z.iso.datetime().nullish(),
  reference: z.string().nullish(),
});

/**
 * AdminBillingPaymentData
 */
export const zAdminBillingPaymentData = z.object({
  amount: z.number(),
  payment_id: z.uuid(),
  status: z.string(),
});

/**
 * AdminBillingPaymentResponse
 */
export const zAdminBillingPaymentResponse = z.object({
  data: zAdminBillingPaymentData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * RefundRequest
 *
 * Solicitação de reembolso
 */
export const zRefundRequest = z.object({
  amount: z.union([
    z.number().gte(0),
    z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  ]),
  notify_customer: z.boolean().optional().default(true),
  payment_id: z.uuid(),
  reason: z.string().min(10),
});

/**
 * AdminBillingRefundResponse
 */
export const zAdminBillingRefundResponse = z.object({
  message: z.string(),
  payment_id: z.uuid(),
  refund_amount: z.number(),
  status: z.string(),
  success: z.boolean(),
});

/**
 * AdminBillingSummaryData
 */
export const zAdminBillingSummaryData = z.object({
  active_subscriptions: z.int(),
  arr: z.number(),
  churn_rate: z.number(),
  failed_payments: z.int(),
  growth_rate: z.number(),
  mrr: z.number(),
  pending_invoices: z.int(),
  total_revenue: z.number(),
});

/**
 * AdminBillingSummaryResponse
 */
export const zAdminBillingSummaryResponse = z.object({
  data: zAdminBillingSummaryData,
  success: z.boolean(),
});

/**
 * AdminBillingSummaryFixData
 */
export const zAdminBillingSummaryFixData = z.object({
  monthly_percentage_of_total: z.number(),
  monthly_revenue: z.number(),
  monthly_revenue_growth: z.number(),
  new_subscriptions_growth: z.number(),
  new_subscriptions_this_month: z.int(),
  subscriptions_growth: z.number(),
  total_revenue: z.number(),
  total_subscriptions: z.int(),
});

/**
 * AdminBillingSummaryFixResponse
 */
export const zAdminBillingSummaryFixResponse = z.object({
  data: zAdminBillingSummaryFixData,
  success: z.boolean(),
});

/**
 * TransactionListItem
 */
export const zTransactionListItem = z.object({
  amount: z.number(),
  company_name: z.string().nullish(),
  created_at: z.string().nullish(),
  id: z.string(),
  invoice_number: z.string().nullish(),
  invoice_url: z.string().nullish(),
  payment_method: z.string().nullish(),
  status: z.string(),
  subscriber_email: z.string().nullish(),
  subscriber_name: z.string().nullish(),
});

/**
 * AdminBillingTransactionPagination
 */
export const zAdminBillingTransactionPagination = z.object({
  limit: z.int(),
  page: z.int(),
  pages: z.int(),
  total: z.int(),
});

/**
 * AdminBillingTransactionListResponse
 */
export const zAdminBillingTransactionListResponse = z.object({
  items: z.array(zTransactionListItem),
  pagination: zAdminBillingTransactionPagination,
  success: z.boolean(),
  total: z.int(),
  total_pages: z.int(),
});

/**
 * TransactionAccountInfo
 */
export const zTransactionAccountInfo = z.object({
  address: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  billing_data: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  document: z.string().nullish(),
  id: z.uuid(),
  name: z.string().nullish(),
  person_type: z.string().nullish(),
  phone: z.string().nullish(),
  status: z.string(),
  website: z.string().nullish(),
});

/**
 * TransactionInvoiceInfo
 */
export const zTransactionInvoiceInfo = z.object({
  amount: z.number(),
  description: z.string().nullish(),
  due_date: z.string().nullish(),
  id: z.uuid(),
  invoice_number: z.string(),
  paid_amount: z.number().nullish(),
  paid_at: z.string().nullish(),
  pdf_url: z.string().nullish(),
  period_end: z.string().nullish(),
  period_start: z.string().nullish(),
  received_amount: z.number().nullish(),
  received_at: z.string().nullish(),
  status: z.string(),
  tariffs: z.number().optional().default(0),
});

/**
 * TransactionSubscriptionInfo
 */
export const zTransactionSubscriptionInfo = z.object({
  billing_cycle: z.string(),
  id: z.uuid(),
  plan_name: z.string(),
  plan_type: z.string(),
  status: z.string(),
});

/**
 * TransactionDetailData
 */
export const zTransactionDetailData = z.object({
  accounts: z.array(zTransactionAccountInfo),
  amount: z.number(),
  billing_address: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  billing_email: z.string().nullish(),
  company_document: z.string().nullish(),
  company_name: z.string().nullish(),
  created_at: z.string().nullish(),
  gateway_payment_id: z.string().nullish(),
  id: z.uuid(),
  invoice: zTransactionInvoiceInfo,
  payment_details: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  payment_method: z.string().nullish(),
  status: z.string(),
  subscriber_cnpj: z.string().nullish(),
  subscriber_document: z.string().nullish(),
  subscriber_email: z.string(),
  subscriber_name: z.string(),
  subscriber_phone: z.string().nullish(),
  subscription: zTransactionSubscriptionInfo,
});

/**
 * AdminBillingTransactionDetailResponse
 */
export const zAdminBillingTransactionDetailResponse = z.object({
  data: zTransactionDetailData,
  success: z.boolean(),
});

/**
 * AiCreditPackResponse
 */
export const zAiCreditPackResponse = z.object({
  id: z.string(),
  name: z.string(),
  credits: z.int(),
  price: z.number(),
  unit_price: z.number(),
  is_active: z.boolean(),
  sort_order: z.int(),
  created_at: z.iso.datetime(),
  updated_at: z.iso.datetime(),
});

/**
 * AiCreditPackListResponse
 */
export const zAiCreditPackListResponse = z.object({
  packs: z.array(zAiCreditPackResponse),
});

/**
 * AiCreditPackCreate
 */
export const zAiCreditPackCreate = z.object({
  name: z.string().min(1).max(100),
  credits: z.int().gte(1).lte(1000000),
  price: z.number().gt(0).lte(99999999.99),
  is_active: z.boolean().optional().default(true),
  sort_order: z.int().gte(0).lte(10000).optional().default(0),
});

/**
 * AiCreditPackUpdate
 */
export const zAiCreditPackUpdate = z.object({
  name: z.string().min(1).max(100).optional(),
  credits: z.int().gte(1).lte(1000000).optional(),
  price: z.number().gt(0).lte(99999999.99).optional(),
  is_active: z.boolean().optional(),
  sort_order: z.int().gte(0).lte(10000).optional(),
});

/**
 * AiCreditPackDeleteResponse
 */
export const zAiCreditPackDeleteResponse = z.object({
  success: z.literal(true),
  message: z.string(),
});

/**
 * CouponWithStats
 */
export const zCouponWithStats = z.object({
  available: z.int().nullable(),
  code: z.string(),
  created_at: z.iso.datetime(),
  current_uses: z.int(),
  discount_type: z.string(),
  discount_value: z.number(),
  id: z.uuid(),
  limited_to_plan: z.boolean(),
  max_uses: z.int().nullable(),
  plan_id: z.uuid().nullable(),
  plan_name: z.string().nullish(),
  status: z.string(),
  updated_at: z.iso.datetime(),
  usage_percent: z.number(),
  used_count: z.int(),
  validity_months: z.int().nullable(),
  validity_type: z.string(),
});

/**
 * CouponPagination
 */
export const zCouponPagination = z.object({
  page: z.int(),
  page_size: z.int(),
  pages: z.int(),
  total: z.int(),
});

/**
 * CouponStats
 */
export const zCouponStats = z.object({
  active_coupons: z.int(),
  inactive_coupons: z.int(),
  total_available: z.int().nullable(),
  total_coupons: z.int(),
  total_uses: z.int(),
  usage_ratio: z.number(),
});

/**
 * CouponListResponse
 */
export const zCouponListResponse = z.object({
  data: z.array(zCouponWithStats),
  pagination: zCouponPagination,
  stats: zCouponStats,
  success: z.boolean(),
  total: z.int(),
  total_pages: z.int(),
});

/**
 * CouponCreate
 */
export const zSchemasAdminCouponCouponCreate = z.object({
  code: z.string().min(1).max(20),
  discount_type: z
    .string()
    .regex(/^(percentage|fixed)$/)
    .optional()
    .default("fixed"),
  discount_value: z.number().gte(0),
  limited_to_plan: z.boolean().optional().default(false),
  max_uses: z.int().gte(0).nullish(),
  plan_id: z.uuid().nullish(),
  status: z
    .string()
    .regex(/^(active|inactive)$/)
    .optional()
    .default("active"),
  validity_months: z.int().gte(1).nullish(),
  validity_type: z
    .string()
    .regex(/^(first_invoice|months|until_end)$/)
    .optional()
    .default("first_invoice"),
});

/**
 * CouponCreateData
 */
export const zCouponCreateData = z.object({
  id: z.uuid(),
});

/**
 * CouponCreateResponse
 */
export const zCouponCreateResponse = z.object({
  data: zCouponCreateData,
  success: z.boolean(),
});

/**
 * CouponRedemption
 */
export const zCouponRedemption = z.object({
  id: z.uuid(),
  used_at: z.iso.datetime(),
  discount_applied: z.number(),
  coupon: z.object({
    id: z.uuid(),
    code: z.string(),
    status: z.enum(["active", "inactive"]),
  }),
  subscriber: z.object({
    id: z.uuid(),
    name: z.string(),
    email: z.string(),
    company_name: z.string().nullable(),
  }),
  invoice: z
    .object({
      id: z.uuid(),
      invoice_number: z.string(),
      status: z.enum(["pending", "paid", "overdue", "cancelled"]),
      paid_at: z.iso.datetime().nullable(),
    })
    .nullable(),
});

/**
 * CouponRedemptionListResponse
 */
export const zCouponRedemptionListResponse = z.object({
  success: z.boolean(),
  data: z.array(zCouponRedemption),
  pagination: zCouponPagination,
});

/**
 * CouponUsageTimeseriesItem
 */
export const zCouponUsageTimeseriesItem = z.object({
  count: z.int(),
  month: z.string(),
});

/**
 * CouponUsageTimeseriesResponse
 */
export const zCouponUsageTimeseriesResponse = z.object({
  data: z.array(zCouponUsageTimeseriesItem),
  success: z.boolean(),
});

/**
 * CouponSuccessResponse
 */
export const zCouponSuccessResponse = z.object({
  success: z.boolean(),
});

/**
 * CouponUpdate
 */
export const zSchemasAdminCouponCouponUpdate = z.object({
  code: z.string().min(1).max(20).nullish(),
  discount_type: z
    .string()
    .regex(/^(percentage|fixed)$/)
    .nullish(),
  discount_value: z.number().gte(0).nullish(),
  limited_to_plan: z.boolean().nullish(),
  max_uses: z.int().gte(0).nullish(),
  plan_id: z.uuid().nullish(),
  status: z
    .string()
    .regex(/^(active|inactive)$/)
    .nullish(),
  validity_months: z.int().gte(1).nullish(),
  validity_type: z
    .string()
    .regex(/^(first_invoice|months|until_end)$/)
    .nullish(),
});

/**
 * CouponMessageResponse
 */
export const zCouponMessageResponse = z.object({
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminFeatureItem
 */
export const zAdminFeatureItem = z.object({
  category: z.string(),
  color: z.string().nullish(),
  config_schema: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  created_at: z.iso.datetime(),
  default_config: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  description: z.string().nullish(),
  icon: z.string().nullish(),
  id: z.uuid(),
  is_active: z.boolean(),
  is_premium: z.boolean(),
  name: z.string(),
  order_priority: z.int(),
  slug: z.string(),
  subcategory: z.string().nullish(),
  updated_at: z.iso.datetime(),
});

/**
 * AdminFeatureListResponse
 */
export const zAdminFeatureListResponse = z.object({
  data: z.array(zAdminFeatureItem),
  success: z.boolean(),
  total: z.int(),
});

/**
 * FeatureCreate
 *
 * Criação de funcionalidade
 */
export const zFeatureCreate = z.object({
  category: z.string().min(1).max(100),
  color: z
    .string()
    .max(7)
    .regex(/^#[0-9A-Fa-f]{6}$/)
    .nullish(),
  config_schema: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  default_config: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  description: z.string().nullish(),
  icon: z.string().max(100).nullish(),
  is_active: z.boolean().optional().default(true),
  is_premium: z.boolean().optional().default(false),
  name: z.string().min(1).max(255),
  order_priority: z.int().optional().default(0),
  slug: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[a-z0-9:-]+$/),
  subcategory: z.string().max(100).nullish(),
});

/**
 * AdminFeatureMutationData
 */
export const zAdminFeatureMutationData = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
});

/**
 * AdminFeatureMutationResponse
 */
export const zAdminFeatureMutationResponse = z.object({
  data: zAdminFeatureMutationData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminFeatureCategoryItem
 */
export const zAdminFeatureCategoryItem = z.object({
  feature_count: z.int(),
  name: z.string(),
});

/**
 * AdminFeatureCategoriesResponse
 */
export const zAdminFeatureCategoriesResponse = z.object({
  data: z.array(zAdminFeatureCategoryItem),
  success: z.boolean(),
});

/**
 * AdminFeaturePlanFeatureInfo
 */
export const zAdminFeaturePlanFeatureInfo = z.object({
  config: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  id: z.uuid(),
  is_enabled: z.boolean(),
  is_highlighted: z.boolean(),
  usage_limit: z.int().nullish(),
});

/**
 * AdminFeaturePlanFeatureItem
 */
export const zAdminFeaturePlanFeatureItem = z.object({
  category: z.string(),
  color: z.string().nullish(),
  description: z.string().nullish(),
  icon: z.string().nullish(),
  id: z.uuid(),
  is_active: z.boolean(),
  is_premium: z.boolean(),
  name: z.string(),
  order_priority: z.int(),
  plan_feature: zAdminFeaturePlanFeatureInfo.nullish(),
  slug: z.string(),
  subcategory: z.string().nullish(),
});

/**
 * AdminFeaturePlanFeaturesResponse
 */
export const zAdminFeaturePlanFeaturesResponse = z.object({
  data: z.array(zAdminFeaturePlanFeatureItem),
  success: z.boolean(),
});

/**
 * PlanFeatureCreate
 *
 * Criação de relacionamento plano-funcionalidade
 */
export const zPlanFeatureCreate = z.object({
  config: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  feature_id: z.uuid(),
  is_enabled: z.boolean().optional().default(true),
  is_highlighted: z.boolean().nullish().default(false),
  usage_limit: z.int().nullish(),
});

/**
 * PlanFeatureBulkUpdate
 *
 * Atualização em lote de funcionalidades do plano
 */
export const zPlanFeatureBulkUpdate = z.object({
  features: z.array(zPlanFeatureCreate),
});

/**
 * AdminFeaturePlanFeaturesUpdateData
 */
export const zAdminFeaturePlanFeaturesUpdateData = z.object({
  features_updated: z.int(),
  message: z.string(),
  plan_id: z.uuid(),
});

/**
 * AdminFeaturePlanFeaturesUpdateResponse
 */
export const zAdminFeaturePlanFeaturesUpdateResponse = z.object({
  data: zAdminFeaturePlanFeaturesUpdateData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminFeatureMessageResponse
 */
export const zAdminFeatureMessageResponse = z.object({
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminFeatureDetailItem
 */
export const zAdminFeatureDetailItem = z.object({
  category: z.string(),
  color: z.string().nullish(),
  config_schema: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  created_at: z.iso.datetime(),
  default_config: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  description: z.string().nullish(),
  icon: z.string().nullish(),
  id: z.uuid(),
  is_active: z.boolean(),
  is_premium: z.boolean(),
  name: z.string(),
  order_priority: z.int(),
  plan_count: z.int(),
  slug: z.string(),
  subcategory: z.string().nullish(),
  updated_at: z.iso.datetime(),
});

/**
 * AdminFeatureDetailResponse
 */
export const zAdminFeatureDetailResponse = z.object({
  data: zAdminFeatureDetailItem,
  success: z.boolean(),
});

/**
 * FeatureUpdate
 *
 * Atualização de funcionalidade
 */
export const zFeatureUpdate = z.object({
  category: z.string().min(1).max(100).nullish(),
  color: z
    .string()
    .max(7)
    .regex(/^#[0-9A-Fa-f]{6}$/)
    .nullish(),
  config_schema: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  default_config: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  description: z.string().nullish(),
  icon: z.string().max(100).nullish(),
  is_active: z.boolean().nullish(),
  is_premium: z.boolean().nullish(),
  name: z.string().min(1).max(255).nullish(),
  order_priority: z.int().nullish(),
  subcategory: z.string().max(100).nullish(),
});

/**
 * AdminPlanListItem
 *
 * Plano retornado na listagem administrativa.
 */
export const zAdminPlanListItem = z.object({
  active_subscriptions: z.int().nullish(),
  ai_enabled: z.boolean().optional().default(false),
  ai_interactions_limit: z.int().nullish(),
  category: z.string().nullish(),
  created_at: z.iso.datetime().nullish(),
  deleted_at: z.iso.datetime().nullish(),
  description: z.string().nullish(),
  features: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .optional(),
  id: z.uuid(),
  is_active: z.boolean(),
  is_public: z.boolean(),
  max_accounts: z.int(),
  max_storage_bytes: z.int().nullish(),
  max_users_per_account: z.int(),
  monthly_revenue: z.number().nullish(),
  name: z.string(),
  price_monthly: z.number(),
  price_yearly: z.number(),
  setup_fee: z.number().optional().default(0),
  slug: z.string(),
  total_subscriptions: z.int().nullish(),
  trial_days: z.int(),
  trial_subscriptions: z.int().nullish(),
  type: z.string(),
  updated_at: z.iso.datetime().nullish(),
});

/**
 * AdminPlanPagination
 */
export const zAdminPlanPagination = z.object({
  has_next: z.boolean(),
  has_previous: z.boolean(),
  limit: z.int(),
  page: z.int(),
  page_size: z.int(),
  skip: z.int(),
  total: z.int(),
  total_pages: z.int(),
});

/**
 * AdminPlanListResponse
 */
export const zAdminPlanListResponse = z.object({
  data: z.array(zAdminPlanListItem),
  pagination: zAdminPlanPagination,
  success: z.boolean(),
  total: z.int(),
});

/**
 * PlanCreate
 *
 * Criação de novo plano
 */
export const zPlanCreate = z.object({
  ai_enabled: z.boolean().optional().default(false),
  ai_interactions_limit: z.int().gte(0).nullish(),
  category: z
    .string()
    .regex(/^(lojista|agencia)$/)
    .optional()
    .default("lojista"),
  description: z.string().max(255).nullish(),
  features: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .optional(),
  is_active: z.boolean().optional().default(true),
  is_public: z.boolean().optional().default(true),
  max_accounts: z.int().gte(1).optional().default(1),
  max_storage_bytes: z.int().gte(0).nullish(),
  max_users_per_account: z.int().gte(1).optional().default(5),
  name: z.string().min(1).max(255),
  price_monthly: z.union([
    z.number().gte(0),
    z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  ]),
  price_yearly: z.union([
    z.number().gte(0),
    z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  ]),
  setup_fee: z
    .union([
      z.number().gte(0),
      z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    ])
    .optional()
    .default("0"),
  slug: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[a-z0-9-]+$/),
  trial_days: z.int().gte(0).optional().default(0),
  type: z.string().regex(/^(free|basic|pro|enterprise)$/),
});

/**
 * AdminPlanMutationData
 */
export const zAdminPlanMutationData = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
});

/**
 * AdminPlanMutationResponse
 */
export const zAdminPlanMutationResponse = z.object({
  data: zAdminPlanMutationData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminPlanMessageResponse
 */
export const zAdminPlanMessageResponse = z.object({
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminPlanDetailData
 */
export const zAdminPlanDetailData = z.object({
  ai_enabled: z.boolean().optional().default(false),
  ai_interactions_limit: z.int().nullish(),
  category: z.string().nullish(),
  created_at: z.iso.datetime().nullish(),
  description: z.string().nullish(),
  features: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .optional(),
  id: z.uuid(),
  is_active: z.boolean(),
  is_public: z.boolean(),
  max_accounts: z.int(),
  max_storage_bytes: z.int().nullish(),
  max_users_per_account: z.int(),
  name: z.string(),
  price_monthly: z.number(),
  price_yearly: z.number(),
  setup_fee: z.number().optional().default(0),
  slug: z.string(),
  trial_days: z.int(),
  type: z.string(),
  updated_at: z.iso.datetime().nullish(),
});

/**
 * AdminPlanDetailResponse
 */
export const zAdminPlanDetailResponse = z.object({
  data: zAdminPlanDetailData,
  success: z.boolean(),
});

/**
 * PlanUpdate
 *
 * Atualização de plano
 */
export const zPlanUpdate = z.object({
  ai_enabled: z.boolean().nullish(),
  ai_interactions_limit: z.int().gte(0).nullish(),
  category: z
    .string()
    .regex(/^(lojista|agencia)$/)
    .nullish(),
  description: z.string().max(255).nullish(),
  features: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .nullish(),
  is_active: z.boolean().nullish(),
  is_public: z.boolean().nullish(),
  max_accounts: z.int().gte(1).nullish(),
  max_storage_bytes: z.int().gte(0).nullish(),
  max_users_per_account: z.int().gte(1).nullish(),
  name: z.string().min(1).max(255).nullish(),
  price_monthly: z
    .union([
      z.number().gte(0),
      z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    ])
    .nullish(),
  price_yearly: z
    .union([
      z.number().gte(0),
      z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    ])
    .nullish(),
  setup_fee: z
    .union([
      z.number().gte(0),
      z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    ])
    .nullish(),
  slug: z
    .string()
    .min(1)
    .max(255)
    .regex(/^[a-z0-9-]+$/)
    .nullish(),
  trial_days: z.int().gte(0).nullish(),
});

/**
 * PlanFeatureUpdate
 *
 * Atualização de features do plano
 */
export const zPlanFeatureUpdate = z.object({
  features: z.record(
    z.string(),
    z
      .union([
        z.int(),
        z.string(),
        z.boolean(),
        z.number(),
        z.array(z.string()),
      ])
      .nullable(),
  ),
});

/**
 * AdminPlanFeaturesData
 */
export const zAdminPlanFeaturesData = z.object({
  features: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .optional(),
  id: z.uuid(),
});

/**
 * AdminPlanFeaturesResponse
 */
export const zAdminPlanFeaturesResponse = z.object({
  data: zAdminPlanFeaturesData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * AdminPlanReactivateData
 */
export const zAdminPlanReactivateData = z.object({
  id: z.uuid(),
  is_active: z.boolean(),
  name: z.string(),
});

/**
 * AdminPlanReactivateResponse
 */
export const zAdminPlanReactivateResponse = z.object({
  data: zAdminPlanReactivateData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * CouponValidationData
 */
export const zCouponValidationData = z.object({
  code: z.string(),
  discount_type: z.string(),
  discount_value: z.number(),
  limited_to_plan: z.boolean(),
  plan_id: z.string().nullable(),
  validity_months: z.int().nullable(),
  validity_type: z.string(),
});

/**
 * CouponValidationResponse
 */
export const zCouponValidationResponse = z.object({
  data: zCouponValidationData.nullish(),
  reason: z.string().nullish(),
  valid: z.boolean(),
});

/**
 * PublicPlanFeatureResponse
 */
export const zPublicPlanFeatureResponse = z.object({
  id: z.string(),
  is_enabled: z.boolean(),
  is_highlighted: z.boolean(),
  name: z.string(),
});

/**
 * PublicPlanResponse
 */
export const zPublicPlanResponse = z.object({
  category: z.string().nullable(),
  description: z.string().nullable(),
  features: z.record(
    z.string(),
    z
      .union([
        z.int(),
        z.string(),
        z.boolean(),
        z.number(),
        z.array(z.string()),
      ])
      .nullable(),
  ),
  id: z.string(),
  name: z.string(),
  plan_features: z.array(zPublicPlanFeatureResponse),
  price_monthly: z.number(),
  price_yearly: z.number(),
  setup_fee: z.number(),
  slug: z.string(),
  trial_days: z.int(),
  type: z.string(),
});

/**
 * PublicPlansResponse
 */
export const zPublicPlansResponse = z.object({
  data: z.array(zPublicPlanResponse),
});

/**
 * BenchmarkSegmentResponse
 */
export const zBenchmarkSegmentResponse = z.object({
  created_at: z.iso.datetime(),
  id: z.uuid(),
  is_active: z.boolean(),
  name: z.string(),
  slug: z.string(),
  updated_at: z.iso.datetime().nullish(),
  accounts_count: z.int().optional(),
});

/**
 * BenchmarkSegmentListResponse
 */
export const zBenchmarkSegmentListResponse = z.object({
  segments: z.array(zBenchmarkSegmentResponse),
});

/**
 * BenchmarkSegmentCreate
 */
export const zBenchmarkSegmentCreate = z.object({
  is_active: z.boolean().optional().default(true),
  name: z.string().min(1).max(200),
  slug: z.string().min(1).max(100),
});

/**
 * BenchmarkSegmentUpdate
 */
export const zBenchmarkSegmentUpdate = z.object({
  is_active: z.boolean().nullish(),
  name: z.string().min(1).max(200).nullish(),
  slug: z.string().min(1).max(100).nullish(),
});

/**
 * BenchmarkSegmentUpdateResponse
 */
export const zBenchmarkSegmentUpdateResponse = z.object({
  affected_accounts: z.int().optional().default(0),
  created_at: z.iso.datetime(),
  id: z.uuid(),
  is_active: z.boolean(),
  name: z.string(),
  slug: z.string(),
  updated_at: z.iso.datetime().nullish(),
});

/**
 * AdminStoreMetricsResponse
 */
export const zAdminStoreMetricsResponse = z.object({
  investment: z.number(),
  orders: z.number(),
  revenue: z.number(),
  roas: z.number().nullable(),
  sessions: z.number(),
});

/**
 * SourceStatus
 */
export const zSourceStatus = z.object({
  ga4: z.string(),
  google: z.string(),
  meta: z.string(),
});

/**
 * AdminStoreItem
 */
export const zAdminStoreItem = z.object({
  agency_name: z.string().nullable(),
  id: z.string(),
  last_updated: z.string().nullish(),
  metrics: zAdminStoreMetricsResponse,
  name: z.string(),
  non_participation_reason: z.string().nullish(),
  participates: z.boolean(),
  segment: z.string().nullable(),
  source_status: zSourceStatus,
});

/**
 * AdminBenchmarkSummary
 */
export const zAdminBenchmarkSummary = z.object({
  not_participating: z.int(),
  participating: z.int(),
  segments_with_stores: z.int(),
  total_active_stores: z.int(),
});

/**
 * AdminBenchmarkStoresResponse
 */
export const zAdminBenchmarkStoresResponse = z.object({
  ok: z.boolean(),
  stores: z.array(zAdminStoreItem),
  summary: zAdminBenchmarkSummary,
});

/**
 * DashboardActivityItem
 */
export const zDashboardActivityItem = z.object({
  description: z.string(),
  timestamp: z.string(),
  type: z.string(),
  user_id: z.string(),
});

/**
 * DashboardActivitiesAndTotal
 */
export const zDashboardActivitiesAndTotal = z.object({
  activities: z.array(zDashboardActivityItem),
  total: z.int(),
});

/**
 * AdminDashboardActivitiesResponse
 */
export const zAdminDashboardActivitiesResponse = z.object({
  data: zDashboardActivitiesAndTotal,
  success: z.boolean(),
});

/**
 * DashboardAlertItem
 */
export const zDashboardAlertItem = z.object({
  id: z.uuid(),
  type: z.string(),
  severity: z.string(),
  title: z.string(),
  message: z.string(),
  subscriber_id: z.uuid().nullable(),
  subscriber_name: z.string().nullable(),
  invoice_id: z.uuid().nullable(),
  invoice_number: z.string().nullable(),
  created_at: z.string(),
});

/**
 * DashboardAlertsAndTotal
 */
export const zDashboardAlertsAndTotal = z.object({
  alerts: z.array(zDashboardAlertItem),
  total: z.int(),
});

/**
 * AdminDashboardAlertsResponse
 */
export const zAdminDashboardAlertsResponse = z.object({
  data: zDashboardAlertsAndTotal,
  success: z.boolean(),
});

/**
 * ChurnByCohortItem
 */
export const zChurnByCohortItem = z.object({
  churn_rate: z.number(),
  cohort: z.string(),
  subscribers: z.int(),
});

/**
 * ChurnByPlanItem
 */
export const zChurnByPlanItem = z.object({
  churn_count: z.int(),
  churn_rate: z.number(),
  plan_name: z.string(),
});

/**
 * DashboardChurnData
 */
export const zDashboardChurnData = z.object({
  by_cohort: z.array(zChurnByCohortItem),
  by_plan: z.array(zChurnByPlanItem),
  monthly_churn_rate: z.number(),
  reasons: z.array(z.string()),
});

/**
 * AdminDashboardChurnResponse
 */
export const zAdminDashboardChurnResponse = z.object({
  data: zDashboardChurnData,
  success: z.boolean(),
});

/**
 * DashboardForecastDay
 */
export const zDashboardForecastDay = z.object({
  date: z.string(),
  forecast: z.number(),
  iso: z.string(),
  paid: z.number(),
  received: z.number(),
  tariffs: z.number(),
});

/**
 * AdminDashboardForecastResponse
 */
export const zAdminDashboardForecastResponse = z.object({
  data: z.array(zDashboardForecastDay),
  success: z.boolean(),
});

/**
 * DashboardGrowthMetricsData
 */
export const zDashboardGrowthMetricsData = z.object({
  chart_data: z.array(z.number()),
  revenue_growth: z.number(),
  subscription_growth: z.int(),
  user_growth: z.int(),
});

/**
 * AdminDashboardGrowthResponse
 */
export const zAdminDashboardGrowthResponse = z.object({
  data: zDashboardGrowthMetricsData,
  success: z.boolean(),
});

/**
 * DashboardHealthData
 */
export const zDashboardHealthData = z.object({
  api_response_time: z.int(),
  cache: z.string(),
  database: z.string(),
  storage: z.string(),
});

/**
 * AdminDashboardHealthResponse
 */
export const zAdminDashboardHealthResponse = z.object({
  data: zDashboardHealthData,
  success: z.boolean(),
});

/**
 * DashboardMutationData
 */
export const zDashboardMutationData = z.object({
  daily_mrr: z.number(),
  daily_revenue: z.number(),
  date: z.string(),
  total_subscribers: z.int(),
});

/**
 * AdminDashboardMutationResponse
 */
export const zAdminDashboardMutationResponse = z.object({
  data: zDashboardMutationData,
  message: z.string(),
  success: z.boolean(),
});

/**
 * DashboardRevenueMetricsData
 */
export const zDashboardRevenueMetricsData = z.object({
  chart_data: z.array(z.number()),
  current_period: z.number(),
  growth_rate: z.number(),
  previous_period: z.number(),
});

/**
 * AdminDashboardRevenueMetricsResponse
 */
export const zAdminDashboardRevenueMetricsResponse = z.object({
  data: zDashboardRevenueMetricsData,
  success: z.boolean(),
});

/**
 * DashboardByPlan
 */
export const zDashboardByPlan = z.object({
  count: z.int(),
  name: z.string(),
});

/**
 * DashboardSubscriptionMetricsData
 */
export const zDashboardSubscriptionMetricsData = z.object({
  active_subscriptions: z.int(),
  by_plan: z.array(zDashboardByPlan),
  cancelled_subscriptions: z.int(),
  churn_rate: z.number(),
  total_subscriptions: z.int(),
});

/**
 * AdminDashboardSubscriptionMetricsResponse
 */
export const zAdminDashboardSubscriptionMetricsResponse = z.object({
  data: zDashboardSubscriptionMetricsData,
  success: z.boolean(),
});

/**
 * DashboardSubscriptionDistributionItem
 */
export const zDashboardSubscriptionDistributionItem = z.object({
  count: z.int(),
  name: z.string(),
  type: z.string(),
});

/**
 * DashboardPlansList
 */
export const zDashboardPlansList = z.object({
  plans: z.array(zDashboardSubscriptionDistributionItem),
});

/**
 * AdminDashboardDistributionResponse
 */
export const zAdminDashboardDistributionResponse = z.object({
  data: zDashboardPlansList,
  success: z.boolean(),
});

/**
 * DashboardAccountsData
 */
export const zDashboardAccountsData = z.object({
  active: z.int(),
  total: z.int(),
});

/**
 * DashboardActivityData
 */
export const zDashboardActivityData = z.object({
  active_users_today: z.int(),
  new_subscribers_today: z.int(),
  revenue_today: z.number(),
});

/**
 * DashboardForecastData
 */
export const zDashboardForecastData = z.object({
  current_month: z.number(),
  growth_percentage: z.number(),
  previous_month: z.number(),
});

/**
 * DashboardIntegrationsData
 */
export const zDashboardIntegrationsData = z.object({
  by_type: z.record(z.string(), z.int()),
  total: z.int(),
});

/**
 * DashboardOverview
 */
export const zDashboardOverview = z.object({
  active_subscriptions: z.int(),
  mrr: z.number(),
  total_revenue: z.number(),
  total_users: z.int(),
});

/**
 * DashboardRevenueDay
 */
export const zDashboardRevenueDay = z.object({
  date: z.string(),
  value: z.number(),
});

/**
 * DashboardRevenueData
 */
export const zDashboardRevenueData = z.object({
  current_mrr: z.number(),
  growth_percentage: z.number(),
  last_30_days: z.array(zDashboardRevenueDay),
});

/**
 * DashboardSubscribersData
 */
export const zDashboardSubscribersData = z.object({
  active: z.int(),
  growth_percentage: z.number(),
  total: z.int(),
  trial: z.int(),
});

/**
 * DashboardSubscriptionsData
 */
export const zDashboardSubscriptionsData = z.object({
  by_plan: z.record(z.string(), z.int()),
  total: z.int(),
});

/**
 * DashboardUsersData
 */
export const zDashboardUsersData = z.object({
  active_today: z.int(),
  total: z.int(),
});

/**
 * DashboardSummaryData
 */
export const zDashboardSummaryData = z.object({
  accounts: zDashboardAccountsData,
  activity: zDashboardActivityData,
  forecast: zDashboardForecastData,
  integrations: zDashboardIntegrationsData,
  overview: zDashboardOverview,
  revenue: zDashboardRevenueData,
  subscribers: zDashboardSubscribersData,
  subscriptions: zDashboardSubscriptionsData,
  users: zDashboardUsersData,
});

/**
 * AdminDashboardSummaryResponse
 */
export const zAdminDashboardSummaryResponse = z.object({
  data: zDashboardSummaryData,
  success: z.boolean(),
});

/**
 * DashboardTopPlanItem
 */
export const zDashboardTopPlanItem = z.object({
  id: z.string(),
  name: z.string(),
  percentage: z.number(),
  revenue: z.number(),
  subscriber_count: z.int(),
});

/**
 * DashboardPlansAndTotal
 */
export const zDashboardPlansAndTotal = z.object({
  plans: z.array(zDashboardTopPlanItem),
});

/**
 * AdminDashboardTopPlansResponse
 */
export const zAdminDashboardTopPlansResponse = z.object({
  data: zDashboardPlansAndTotal,
  success: z.boolean(),
});

/**
 * DashboardUserMetricsData
 */
export const zDashboardUserMetricsData = z.object({
  active_users: z.int(),
  chart_data: z.array(z.number()),
  new_users: z.int(),
  total_users: z.int(),
  user_growth: z.number(),
});

/**
 * AdminDashboardUserMetricsResponse
 */
export const zAdminDashboardUserMetricsResponse = z.object({
  data: zDashboardUserMetricsData,
  success: z.boolean(),
});

/**
 * AdminDataDeletionRequestItem
 */
export const zAdminDataDeletionRequestItem = z.object({
  created_at: z.iso.datetime(),
  external_accounts_count: z.int().nullish(),
  id: z.string(),
  integrations_count: z.int().nullish(),
  message: z.string().nullish(),
  status: z.string(),
  user_email: z.string(),
  user_id: z.string(),
});

/**
 * AdminDataDeletionPagination
 */
export const zAdminDataDeletionPagination = z.object({
  page: z.int(),
  page_size: z.int(),
  pages: z.int(),
  total: z.int(),
});

/**
 * AdminDataDeletionListResponse
 */
export const zAdminDataDeletionListResponse = z.object({
  data: z.array(zAdminDataDeletionRequestItem),
  pagination: zAdminDataDeletionPagination,
  success: z.boolean(),
});

/**
 * AiPromptVariable
 */
export const zAiPromptVariable = z.object({
  name: z.string(),
  description: z.string(),
  required: z.boolean(),
});

/**
 * AiPromptResponse
 */
export const zAiPromptResponse = z.object({
  key: z.string(),
  group: z.enum(["diagnostic", "agent", "agent_chat", "architect", "insights"]),
  group_label: z.string(),
  label: z.string(),
  description: z.string(),
  variables: z.array(zAiPromptVariable),
  content: z.string(),
  default_content: z.string(),
  is_default: z.boolean(),
  updated_at: z.string().nullable(),
});

/**
 * AiPromptListResponse
 */
export const zAiPromptListResponse = z.object({
  prompts: z.array(zAiPromptResponse),
});

/**
 * AiPromptUpdateRequest
 */
export const zAiPromptUpdateRequest = z.object({
  content: z.string().max(100000),
});

/**
 * MaintenanceMode
 */
export const zMaintenanceMode = z.enum(["ENABLED", "DISABLED"]);

/**
 * SettingsResponse
 */
export const zSettingsResponse = z.object({
  created_at: z.iso.datetime(),
  id: z.uuid(),
  maintenance_message: z.string().nullish(),
  maintenance_mode: zMaintenanceMode,
  updated_at: z.iso.datetime(),
});

/**
 * SettingsUpdate
 */
export const zSettingsUpdate = z.object({
  maintenance_message: z.string().nullish(),
  maintenance_mode: zMaintenanceMode.nullish(),
});

/**
 * MaintenanceModeStatusResponse
 */
export const zMaintenanceModeStatusResponse = z.object({
  is_enabled: z.boolean(),
  maintenance_message: z.string().nullable(),
  maintenance_mode: zMaintenanceMode,
});

/**
 * MaintenanceModeToggleRequest
 */
export const zMaintenanceModeToggleRequest = z.object({
  admin_password: z.string(),
  enabled: z.boolean(),
});

/**
 * StorageItem
 */
export const zStorageItem = z.object({
  customer_email: z.string().nullish(),
  customer_name: z.string().nullish(),
  customer_uuid: z.string(),
  total_bytes: z.int().optional().default(0),
  total_max_bytes: z.int().nullish(),
  updated_at: z.iso.datetime().nullish(),
  usage_by_integration: z.record(z.string(), z.int()),
});

/**
 * StoragePagination
 */
export const zStoragePagination = z.object({
  page: z.int().gte(1),
  page_size: z.int().gte(1),
  total: z.int().gte(0),
  total_pages: z.int().gte(0),
});

/**
 * AdminStorageListResponse
 */
export const zAdminStorageListResponse = z.object({
  items: z.array(zStorageItem),
  pagination: zStoragePagination,
});

/**
 * SetLimitsRequest
 *
 * SetLimitsRequest
 */
export const zSetLimitsRequest = z.object({
  customer_uuid: z.string(),
  total_max_bytes: z.int().gte(0),
});

/**
 * SetLimitsResponse
 *
 * SetLimitsResponse
 */
export const zSetLimitsResponse = z.object({
  limit_updated: z.boolean(),
  status: z.string(),
});

/**
 * AsaasWebhookRefund
 */
export const zAsaasWebhookRefund = z.object({
  status: z.string().nullish(),
  value: z.number().nullish(),
});

/**
 * AsaasWebhookPayment
 *
 * Subset of the Asaas ``payment`` object we consume (extras are ignored).
 */
export const zAsaasWebhookPayment = z.object({
  billingType: z.string().nullish(),
  customer: z.string().nullish(),
  externalReference: z.string().nullish(),
  id: z.string().nullish(),
  invoiceUrl: z.string().nullish(),
  status: z.string().nullish(),
  value: z.number().nullish(),
  refunds: z.array(zAsaasWebhookRefund).nullish(),
});

/**
 * AsaasWebhookPayload
 *
 * Typed webhook body. Unknown fields Asaas sends are ignored by default.
 */
export const zAsaasWebhookPayload = z.object({
  event: z.string().nullish(),
  payment: zAsaasWebhookPayment.nullish(),
});

/**
 * WebhookAck
 */
export const zWebhookAck = z.object({
  handled: z.boolean().optional().default(false),
  received: z.boolean(),
});

/**
 * SyncConfigUpdate
 */
export const zSyncConfigUpdate = z.object({
  enabled: z.boolean().nullish(),
  max_concurrent_syncs: z.int().nullish(),
  retry_attempts: z.int().nullish(),
  sync_interval_hours: z.int().nullish(),
  sync_period_days: z.int().nullish(),
});

/**
 * SyncConfig
 */
export const zSyncConfig = z.object({
  enabled: z.boolean().optional().default(true),
  max_concurrent_syncs: z.int().optional().default(3),
  retry_attempts: z.int().optional().default(3),
  sync_interval_hours: z.int().optional().default(1),
  sync_period_days: z.int().optional().default(7),
});

/**
 * SyncConfigUpdateResponse
 */
export const zSyncConfigUpdateResponse = z.object({
  config: zSyncConfig,
  message: z.string(),
  success: z.boolean(),
});

/**
 * SyncMessageResponse
 */
export const zSyncMessageResponse = z.object({
  message: z.string(),
  success: z.boolean(),
});

/**
 * ForceSyncRequest
 */
export const zForceSyncRequest = z.object({
  account_id: z.uuid().nullish(),
  integration_type: z.string(),
});

/**
 * SyncErrorItem
 */
export const zSyncErrorItem = z.object({
  account_id: z.string().nullish(),
  error: z.string().nullish(),
});

/**
 * SyncForceResponse
 */
export const zSyncForceResponse = z.object({
  errors: z.array(zSyncErrorItem).nullish(),
  message: z.string(),
  success: z.boolean(),
  synced_count: z.int().nullish(),
});

/**
 * SyncHealthResponse
 */
export const zSyncHealthResponse = z.object({
  active_accounts: z.int(),
  database_connection: z.boolean(),
  last_sync: z.string().nullish(),
  scheduler_enabled: z.boolean(),
  services: z.record(z.string(), z.boolean()),
  status: z.string(),
  total_syncs: z.int(),
});

/**
 * SyncIntegrationType
 */
export const zSyncIntegrationType = z.object({
  description: z.string(),
  display_name: z.string(),
  name: z.string(),
});

/**
 * SyncIntegrationTypesResponse
 */
export const zSyncIntegrationTypesResponse = z.object({
  integration_types: z.array(zSyncIntegrationType),
});

/**
 * SyncHealthStatus
 */
export const zSyncHealthStatus = z.object({
  active_accounts: z.int().optional().default(0),
  database_connection: z.boolean(),
  error: z.string().nullish(),
  last_sync: z.iso.datetime().nullish(),
  scheduler_enabled: z.boolean().optional().default(false),
  services: z.record(z.string(), z.boolean()).nullish(),
  status: z.string(),
  total_syncs: z.int().optional().default(0),
});

/**
 * SyncStats
 */
export const zSyncStats = z.object({
  failed_syncs: z.int().optional().default(0),
  last_sync_time: z.iso.datetime().nullish(),
  successful_syncs: z.int().optional().default(0),
  sync_duration: z.number().nullish(),
  total_syncs: z.int().optional().default(0),
});

/**
 * SyncSchedulerStatus
 */
export const zSyncSchedulerStatus = z.object({
  config: zSyncConfig,
  next_sync: z.iso.datetime().nullish(),
  scheduler_status: z.string(),
  stats: zSyncStats,
});

/**
 * SyncStatsSummary
 */
export const zSyncStatsSummary = z.object({
  active_accounts: z.int(),
  enabled: z.boolean(),
  last_sync: z.string().nullish(),
  status: z.string(),
  success_rate: z.number(),
  total_syncs: z.int(),
});

/**
 * SyncStatsResponse
 */
export const zSyncStatsResponse = z.object({
  health: zSyncHealthStatus,
  scheduler: zSyncSchedulerStatus,
  summary: zSyncStatsSummary,
});

/**
 * SyncStatusResponse
 */
export const zApiSyncControlSyncStatusResponse = z.object({
  config: zSyncConfig,
  next_sync: z.iso.datetime().nullish(),
  scheduler_status: z.string(),
  stats: zSyncStats,
});

/**
 * AccountInfo
 *
 * AccountInfo
 */
export const zAccountInfo = z.object({
  account_id: z.string().nullish(),
  account_name: z.string().nullish(),
  account_type: z.string().nullish(),
  created_at: z.string().nullish(),
  property_id: z.string().nullish(),
  status: z.string().nullish(),
  subaccounts: z.array(z.lazy((): any => zAccountInfo)).nullish(),
  website_url: z.string().nullish(),
});

/**
 * DiscoveredAccounts
 *
 * DiscoveredAccounts
 */
export const zDiscoveredAccounts = z.object({
  facebook_page_insights: z.array(zAccountInfo).nullish(),
  ga4: z.array(zAccountInfo).nullish(),
  google_ads: z.array(zAccountInfo).nullish(),
  instagram_insights: z.array(zAccountInfo).nullish(),
  meta_ads: z.array(zAccountInfo).nullish(),
  search_console: z.array(zAccountInfo).nullish(),
});

/**
 * DiscoveryErrorInfo
 *
 * DiscoveryErrorInfo
 */
export const zDiscoveryErrorInfo = z.object({
  body_raw: z.string().nullish(),
  cached_accounts_count: z.int().nullish(),
  cached_accounts_used: z.boolean().nullish(),
  integration_key: z.string().nullish(),
  message: z.string().nullish(),
  retry_after: z.string().nullish(),
  status_code: z.int().nullish(),
  type: z.string().nullish(),
  url: z.string().nullish(),
});

/**
 * AvailableAccountsResponse
 *
 * Resposta com contas disponíveis agrupadas por tipo
 */
export const zAvailableAccountsResponse = z.object({
  accounts: zDiscoveredAccounts.nullish(),
  errors: z.record(z.string(), zDiscoveryErrorInfo).nullish(),
  source: z.string(),
});

/**
 * SelectAccountItem
 *
 * Item de conta na seleção
 */
export const zSelectAccountItem = z.object({
  currency: z.string().nullish(),
  external_id: z.string(),
  metadata: z.record(z.string(), z.string()).nullish(),
  name: z.string(),
  timezone: z.string().nullish(),
  type: z.string(),
});

/**
 * SelectAccountRequest
 *
 * Requisição para selecionar contas
 */
export const zSelectAccountRequest = z.object({
  customer_uuid: z.string().nullish(),
  selected_accounts: z.array(zSelectAccountItem),
  source: z.string(),
});

/**
 * SelectAccountResponse
 *
 * Resposta após seleção de contas
 */
export const zSelectAccountResponse = z.object({
  accounts_saved: z.int(),
  message: z.string(),
});

/**
 * SelectedExternalAccount
 *
 * Conta externa selecionada pelo usuário.
 */
export const zSelectedExternalAccount = z.object({
  currency: z.string().nullish(),
  external_id: z.string(),
  id: z.string(),
  last_sync: z.string().nullish(),
  name: z.string(),
  timezone: z.string().nullish(),
  type: z.string(),
});

/**
 * SelectedExternalAccountsResponse
 *
 * Resposta com contas externas selecionadas.
 */
export const zSelectedExternalAccountsResponse = z.object({
  accounts: z.array(zSelectedExternalAccount),
});

/**
 * IntegrationAuthUrlResponse
 */
export const zIntegrationAuthUrlResponse = z.object({
  state: z.string(),
  url: z.string(),
});

/**
 * CleanupResult
 */
export const zCleanupResult = z.object({
  message: z.string(),
  source: z.string(),
  success: z.boolean(),
});

/**
 * IntegrationDisconnectResponse
 */
export const zIntegrationDisconnectResponse = z.object({
  cleanup: zCleanupResult.nullish(),
  customer_uuid_cleaned: z.string(),
  message: z.string(),
  source: z.string().nullish(),
  success: z.boolean(),
});

/**
 * OAuthTokenPayload
 *
 * OAuthTokenPayload
 */
export const zOAuthTokenPayload = z.object({
  access_token: z.string(),
  expires_in: z.int().nullish(),
  id_token: z.string().nullish(),
  refresh_token: z.string().nullish(),
  scope: z.string().nullish(),
  token_type: z.string().nullish(),
});

/**
 * IntegrationRefreshTokenResponse
 */
export const zIntegrationRefreshTokenResponse = z.object({
  message: z.string(),
  success: z.boolean(),
  token: zOAuthTokenPayload.nullish(),
});

/**
 * OAuthAuthUrlResponse
 *
 * OAuthAuthUrlResponse
 */
export const zOAuthAuthUrlResponse = z.object({
  auth_url: z.string(),
});

/**
 * OAuthTokenResponse
 *
 * OAuthTokenResponse
 */
export const zOAuthTokenResponse = z.object({
  status: z.string(),
  token: zOAuthTokenPayload,
});

/**
 * SyncTriggerRequest
 */
export const zSyncTriggerRequest = z.object({
  account_uuid: z.string(),
  customer_uuid: z.string().nullish(),
  date_end: z.iso.date(),
  date_start: z.iso.date(),
  integration: z.string(),
});

/**
 * SyncResponse
 *
 * SyncResponse
 */
export const zSyncResponse = z.object({
  job_id: z.uuid(),
  message: z.string(),
  status: z.string(),
});

/**
 * BackfillScheduledResponse
 *
 * BackfillScheduledResponse
 */
export const zBackfillScheduledResponse = z.object({
  integration: z.string(),
  message: z.string(),
  pipeline_id: z.string(),
  scheduled_integrations: z.int(),
  scheduled_windows: z.int(),
});

/**
 * JobId
 *
 * JobId
 */
export const zJobId = z.object({
  actual_instance: z.unknown().optional(),
  any_of_schemas: z.array(z.string()).optional().default(["UUID", "str"]),
  anyof_schema_1_validator: z.uuid().nullish(),
  anyof_schema_2_validator: z.string().nullish(),
});

/**
 * RetryState
 *
 * RetryState
 */
export const zRetryState = z.object({
  at: z.iso.datetime(),
  attempt: z.int().nullish(),
  reason: z.string(),
});

/**
 * SyncJobMetadata
 *
 * SyncJobMetadata
 */
export const zSyncJobMetadata = z.object({
  account_id: z.string().nullish(),
  api_requeue_state: zRetryState.nullish(),
  backfill_sequence: z.int().nullish(),
  backfill_window_label: z.string().nullish(),
  comparison_period: z.string().nullish(),
  date_end: z.string().nullish(),
  date_start: z.string().nullish(),
  execution_lane: z.string().nullish(),
  fifo_retry_state: zRetryState.nullish(),
  ga4_job_type: z.string().nullish(),
  initial_sync_phase: z.string().nullish(),
  integration: z.string().nullish(),
  phase_window_days: z.int().nullish(),
  pipeline_id: z.string().nullish(),
  sync_kind: z.string().nullish(),
});

/**
 * SyncJobSummary
 *
 * SyncJobSummary
 */
export const zSyncJobSummary = z.object({
  created_at: z.iso.datetime().nullish(),
  date_end: z.iso.date().nullish(),
  date_start: z.iso.date().nullish(),
  error: z.string().nullish(),
  finished_at: z.iso.datetime().nullish(),
  integration: z.string(),
  job_id: zJobId,
  metadata: zSyncJobMetadata.nullish(),
  started_at: z.iso.datetime().nullish(),
  status: z.string(),
  updated_at: z.iso.datetime().nullish(),
});

/**
 * BackfillProgressInfo
 *
 * Informações sobre o progresso do backfill
 */
export const zBackfillProgressInfo = z.object({
  current_phase: z.string().nullish(),
  is_backfilling: z.boolean().nullish().default(false),
  jobs_completed: z.int().nullish().default(0),
  jobs_pending: z.int().nullish().default(0),
  phase_progress_percent: z.int().nullish(),
  total_jobs: z.int().nullish().default(0),
});

/**
 * DataPeriodInfo
 *
 * Informações sobre o período de dados disponível
 */
export const zDataPeriodInfo = z.object({
  end_date: z.iso.date().nullish(),
  start_date: z.iso.date().nullish(),
  total_days: z.int().nullish(),
});

/**
 * SourceGroupDataPeriod
 *
 * Período de dados por grupo de fonte (Google ou Meta)
 */
export const zSourceGroupDataPeriod = z.object({
  google: zDataPeriodInfo.nullish(),
  meta: zDataPeriodInfo.nullish(),
});

/**
 * SourceJobsInfo
 *
 * Informações de jobs por fonte
 */
export const zSourceJobsInfo = z.object({
  completed: z.int().nullish().default(0),
  pending: z.int().nullish().default(0),
  total: z.int().nullish().default(0),
});

/**
 * SourceGroupJobs
 *
 * Jobs por grupo de fonte (Google ou Meta)
 */
export const zSourceGroupJobs = z.object({
  google: zSourceJobsInfo.nullish(),
  meta: zSourceJobsInfo.nullish(),
});

/**
 * IntegrationLastSyncInfo
 *
 * Última sincronização por integração com janela de dados.
 */
export const zIntegrationLastSyncInfo = z.object({
  integration: z.string(),
  last_completed_at: z.iso.datetime(),
  window_end: z.iso.date(),
  window_start: z.iso.date(),
});

/**
 * ConsistentSyncWindow
 *
 * Janela de sincronização consistente entre integrações.
 */
export const zConsistentSyncWindow = z.object({
  integrations: z.array(z.string()),
  last_completed_at: z.iso.datetime(),
  window_end: z.iso.date(),
  window_start: z.iso.date(),
});

/**
 * SourceGroupLastSync
 *
 * Última sincronização consistente por grupo de fonte.
 */
export const zSourceGroupLastSync = z.object({
  google: zConsistentSyncWindow.nullish(),
  meta: zConsistentSyncWindow.nullish(),
});

/**
 * SyncStatusResponse
 *
 * SyncStatusResponse
 */
export const zNexusSdkModelsSyncStatusResponseSyncStatusResponse = z.object({
  active_jobs: z.array(zSyncJobSummary),
  backfill_progress: zBackfillProgressInfo.nullish(),
  data_period: zDataPeriodInfo.nullish(),
  data_period_by_integration: z.record(z.string(), zDataPeriodInfo).nullish(),
  data_period_by_source: zSourceGroupDataPeriod.nullish(),
  estimated_completion: z.iso.datetime().nullish(),
  is_backfilling: z.boolean().nullish().default(false),
  is_initial_sync: z.boolean().nullish().default(false),
  is_syncing: z.boolean(),
  jobs_by_source: zSourceGroupJobs.nullish(),
  last_sync_by_integration: z
    .record(z.string(), zIntegrationLastSyncInfo)
    .nullish(),
  last_sync_by_source: zSourceGroupLastSync.nullish(),
  recent_jobs: z.array(zSyncJobSummary),
  source: z.string().nullish(),
  sync_phase: z.string().nullish(),
});

/**
 * JobStatusResponse
 *
 * JobStatusResponse
 */
export const zNexusSdkModelsJobStatusResponseJobStatusResponse = z.object({
  created_at: z.iso.datetime().nullish(),
  details: z.string().nullish(),
  job_id: z.uuid(),
  status: z.string(),
  updated_at: z.iso.datetime().nullish(),
});

/**
 * Ga4PropertyInfo
 *
 * Ga4PropertyInfo
 */
export const zGa4PropertyInfo = z.object({
  days_available: z.int().gte(0),
  first_date: z.iso.date().nullish(),
  last_date: z.iso.date().nullish(),
  property_description: z.string(),
  property_id: z.string(),
  total_records: z.int().gte(0),
});

/**
 * Ga4PropertiesResponse
 *
 * Ga4PropertiesResponse
 */
export const zGa4PropertiesResponse = z.object({
  properties: z.array(zGa4PropertyInfo),
  total: z.int().gte(0),
});

/**
 * GoogleAnalyticsAccount
 */
export const zGoogleAnalyticsAccount = z.object({
  created_at: z.iso.datetime(),
  currency_code: z.string().nullish(),
  external_account_id: z.string(),
  id: z.uuid(),
  integration_id: z.int(),
  is_active: z.boolean(),
  last_sync_at: z.iso.datetime().nullish(),
  name: z.string().nullish(),
  source: z.string(),
  timezone: z.string().nullish(),
  updated_at: z.iso.datetime().nullish(),
});

/**
 * GoogleAnalyticsContentMetrics
 *
 * Schema completo para métricas de conteúdo
 */
export const zGoogleAnalyticsContentMetrics = z.object({
  account_id: z.uuid(),
  date: z.iso.date(),
  event_count: z.int().nullish(),
  event_name: z.string().nullish(),
  event_rate: z.number().nullish(),
  event_value: z.number().nullish(),
  id: z.uuid(),
  page_path: z.string().nullish(),
  page_title: z.string().nullish(),
  unique_events: z.int().nullish(),
});

/**
 * GoogleAnalyticsAdvancedMetrics
 *
 * Schema para métricas avançadas do Google Analytics
 */
export const zGoogleAnalyticsAdvancedMetrics = z.object({
  account_id: z.uuid(),
  active_users: z.int().nullish(),
  ad_clicks: z.int().nullish(),
  ad_cost: z.number().nullish(),
  ad_cost_per_click: z.number().nullish(),
  ad_impressions: z.int().nullish(),
  add_to_carts: z.int().nullish(),
  average_purchase_revenue: z.number().nullish(),
  avg_session_duration: z.number().nullish(),
  bounce_rate: z.number().nullish(),
  cart_to_view_rate: z.number().nullish(),
  checkouts: z.int().nullish(),
  conversion_rate: z.number().nullish(),
  date: z.iso.date(),
  desktop_sessions: z.int().nullish(),
  direct_sessions: z.int().nullish(),
  ecommerce_conv_rate: z.number().nullish(),
  email_sessions: z.int().nullish(),
  engaged_sessions: z.int().nullish(),
  engagement_rate: z.number().nullish(),
  events: z.int().nullish(),
  first_time_purchasers: z.int().nullish(),
  goal_completions: z.int().nullish(),
  id: z.uuid(),
  item_revenue: z.number().nullish(),
  items_added_to_cart: z.int().nullish(),
  items_purchased: z.int().nullish(),
  items_viewed: z.int().nullish(),
  mobile_sessions: z.int().nullish(),
  new_users: z.int().nullish(),
  organic_sessions: z.int().nullish(),
  pageviews: z.int().nullish(),
  paid_sessions: z.int().nullish(),
  purchase_revenue: z.number().nullish(),
  purchase_to_view_rate: z.number().nullish(),
  referral_sessions: z.int().nullish(),
  returning_users: z.int().nullish(),
  revenue: z.number().nullish(),
  roas: z.number().nullish(),
  sessions: z.int().nullish(),
  social_sessions: z.int().nullish(),
  tablet_sessions: z.int().nullish(),
  total_purchasers: z.int().nullish(),
  transactions: z.int().nullish(),
  unique_pageviews: z.int().nullish(),
  user_engagement_duration: z.number().nullish(),
  users: z.int().nullish(),
});

/**
 * GoogleAnalyticsDemographics
 *
 * Schema completo para dados demográficos
 */
export const zGoogleAnalyticsDemographics = z.object({
  account_id: z.uuid(),
  age_group: z.string().nullish(),
  avg_session_duration: z.number().nullish(),
  conversion_rate: z.number().nullish(),
  date: z.iso.date(),
  gender: z.string().nullish(),
  id: z.uuid(),
  revenue: z.number().nullish(),
  sessions: z.int().nullish(),
  users: z.int().nullish(),
});

/**
 * GoogleAnalyticsAdvancedResponse
 *
 * Response expandida com todas as métricas avançadas
 */
export const zGoogleAnalyticsAdvancedResponse = z.object({
  content_metrics: z.array(zGoogleAnalyticsContentMetrics),
  daily_metrics: z.array(zGoogleAnalyticsAdvancedMetrics),
  demographics: z.array(zGoogleAnalyticsDemographics),
  end_date: z.iso.date(),
  start_date: z.iso.date(),
  total_records: z.int(),
});

/**
 * GoogleAnalyticsMetrics
 */
export const zGoogleAnalyticsMetrics = z.object({
  account_id: z.uuid(),
  active_users: z.int().nullish(),
  ad_clicks: z.int().nullish(),
  ad_cost: z.number().nullish(),
  ad_cost_per_click: z.number().nullish(),
  ad_impressions: z.int().nullish(),
  add_to_carts: z.int().nullish(),
  average_purchase_revenue: z.number().nullish(),
  avg_session_duration: z.number().nullish(),
  bounce_rate: z.number().nullish(),
  cart_to_view_rate: z.number().nullish(),
  checkouts: z.int().nullish(),
  conversion_rate: z.number().nullish(),
  date: z.iso.date(),
  desktop_sessions: z.int().nullish(),
  direct_sessions: z.int().nullish(),
  ecommerce_conv_rate: z.number().nullish(),
  email_sessions: z.int().nullish(),
  engaged_sessions: z.int().nullish(),
  engagement_rate: z.number().nullish(),
  events: z.int().nullish(),
  first_time_purchasers: z.int().nullish(),
  goal_completions: z.int().nullish(),
  id: z.uuid(),
  item_revenue: z.number().nullish(),
  items_added_to_cart: z.int().nullish(),
  items_purchased: z.int().nullish(),
  items_viewed: z.int().nullish(),
  mobile_sessions: z.int().nullish(),
  new_users: z.int().nullish(),
  organic_sessions: z.int().nullish(),
  pageviews: z.int().nullish(),
  paid_sessions: z.int().nullish(),
  purchase_revenue: z.number().nullish(),
  purchase_to_view_rate: z.number().nullish(),
  referral_sessions: z.int().nullish(),
  returning_users: z.int().nullish(),
  revenue: z.number().nullish(),
  roas: z.number().nullish(),
  sessions: z.int().nullish(),
  social_sessions: z.int().nullish(),
  tablet_sessions: z.int().nullish(),
  total_purchasers: z.int().nullish(),
  transactions: z.int().nullish(),
  unique_pageviews: z.int().nullish(),
  user_engagement_duration: z.number().nullish(),
  users: z.int().nullish(),
});

/**
 * GoogleAnalyticsGeographyMetrics
 */
export const zGoogleAnalyticsGeographyMetrics = z.object({
  account_id: z.uuid(),
  avg_session_duration: z.number().nullish(),
  bounce_rate: z.number().nullish(),
  city: z.string().nullish(),
  conversion_rate: z.number().nullish(),
  country: z.string(),
  country_code: z.string().nullish(),
  date: z.iso.date(),
  id: z.uuid(),
  new_users: z.int().nullish(),
  pageviews: z.int().nullish(),
  region: z.string().nullish(),
  revenue: z.number().nullish(),
  sessions: z.int().nullish(),
  transactions: z.int().nullish(),
  users: z.int().nullish(),
});

/**
 * GoogleAnalyticsPageMetrics
 */
export const zGoogleAnalyticsPageMetrics = z.object({
  account_id: z.uuid(),
  avg_time_on_page: z.number().nullish(),
  bounce_rate: z.number().nullish(),
  date: z.iso.date(),
  exit_rate: z.number().nullish(),
  id: z.uuid(),
  page_path: z.string().nullish(),
  page_title: z.string().nullish(),
  pageviews: z.int().nullish(),
  unique_pageviews: z.int().nullish(),
});

/**
 * GoogleAnalyticsRealTimeMetrics
 */
export const zGoogleAnalyticsRealTimeMetrics = z.object({
  account_id: z.uuid(),
  active_users: z.int().nullish(),
  active_users_1_minute: z.int().nullish(),
  active_users_30_minutes: z.int().nullish(),
  active_users_5_minutes: z.int().nullish(),
  id: z.uuid(),
  timestamp: z.iso.date(),
  top_page_path: z.string().nullish(),
  top_page_title: z.string().nullish(),
  top_page_views: z.int().nullish(),
  conversions_last_minute: z.int().nullish(),
  events_last_minute: z.int().nullish(),
});

/**
 * GoogleAnalyticsTechnologyMetrics
 */
export const zGoogleAnalyticsTechnologyMetrics = z.object({
  account_id: z.uuid(),
  avg_session_duration: z.number().nullish(),
  bounce_rate: z.number().nullish(),
  browser: z.string().nullish(),
  browser_version: z.string().nullish(),
  conversion_rate: z.number().nullish(),
  date: z.iso.date(),
  device_category: z.string().nullish(),
  id: z.uuid(),
  new_users: z.int().nullish(),
  operating_system: z.string().nullish(),
  os_version: z.string().nullish(),
  pageviews: z.int().nullish(),
  revenue: z.number().nullish(),
  sessions: z.int().nullish(),
  transactions: z.int().nullish(),
  users: z.int().nullish(),
});

/**
 * GoogleAnalyticsCompleteResponse
 *
 * Response completa com todas as métricas do Google Analytics
 */
export const zGoogleAnalyticsCompleteResponse = z.object({
  content_metrics: z.array(zGoogleAnalyticsContentMetrics),
  daily_metrics: z.array(zGoogleAnalyticsMetrics),
  demographics: z.array(zGoogleAnalyticsDemographics),
  end_date: z.iso.date(),
  geography_data: z.array(zGoogleAnalyticsGeographyMetrics),
  page_metrics: z.array(zGoogleAnalyticsPageMetrics),
  realtime_data: zGoogleAnalyticsRealTimeMetrics.nullish(),
  start_date: z.iso.date(),
  technology_data: z.array(zGoogleAnalyticsTechnologyMetrics),
  total_records: z.int(),
});

/**
 * GoogleAnalyticsDisconnectResponse
 */
export const zGoogleAnalyticsDisconnectResponse = z.object({
  cleanup: zCleanupResult.nullish(),
  customer_uuid_cleaned: z.string(),
  message: z.string(),
});

/**
 * GoogleAnalyticsGeographyResponse
 */
export const zGoogleAnalyticsGeographyResponse = z.object({
  end_date: z.iso.date(),
  geography_data: z.array(zGoogleAnalyticsGeographyMetrics),
  start_date: z.iso.date(),
  total_countries: z.int(),
});

/**
 * GoogleAnalyticsMetricsResponse
 */
export const zGoogleAnalyticsMetricsResponse = z.object({
  end_date: z.iso.date(),
  metrics: z.array(zGoogleAnalyticsMetrics),
  start_date: z.iso.date(),
  total: z.int(),
});

/**
 * GoogleAnalyticsOverviewData
 *
 * Dados consolidados para o dashboard overview
 */
export const zGoogleAnalyticsOverviewData = z.object({
  average_order_value: z.number(),
  avg_session_duration: z.number(),
  bounce_rate: z.number(),
  conversion_rate: z.number(),
  desktop_percentage: z.number(),
  direct_percentage: z.number(),
  engaged_sessions: z.int(),
  engagement_rate: z.number(),
  mobile_percentage: z.number(),
  organic_percentage: z.number(),
  paid_percentage: z.number(),
  social_percentage: z.number(),
  tablet_percentage: z.number(),
  total_pageviews: z.int(),
  total_revenue: z.number(),
  total_sessions: z.int(),
  total_transactions: z.int(),
  total_users: z.int(),
});

/**
 * ConsolidatedTotals
 */
export const zConsolidatedTotals = z.object({
  average_order_value: z.number(),
  avg_bounce_rate: z.number(),
  avg_conversion_rate: z.number(),
  avg_session_duration: z.number(),
  total_events: z.int(),
  total_pageviews: z.int(),
  total_revenue: z.number(),
  total_sessions: z.int(),
  total_transactions: z.int(),
  total_users: z.int(),
});

/**
 * OverviewPeriod
 */
export const zOverviewPeriod = z.object({
  end_date: z.iso.date(),
  start_date: z.iso.date(),
  total_days: z.int(),
});

/**
 * PropertyBreakdownItem
 */
export const zPropertyBreakdownItem = z.object({
  property_name: z.string().nullish(),
  total_pageviews: z.int().optional().default(0),
  total_revenue: z.number().optional().default(0),
  total_sessions: z.int().optional().default(0),
  total_transactions: z.int().optional().default(0),
  total_users: z.int().optional().default(0),
});

/**
 * OverviewSummary
 */
export const zOverviewSummary = z.object({
  date_range: z.string(),
  properties_with_data: z.int(),
  total_properties: z.int(),
});

/**
 * GoogleAnalyticsConsolidatedOverviewResponse
 */
export const zGoogleAnalyticsConsolidatedOverviewResponse = z.object({
  consolidated_totals: zConsolidatedTotals,
  period: zOverviewPeriod,
  properties_breakdown: z.record(z.string(), zPropertyBreakdownItem),
  summary: zOverviewSummary,
});

/**
 * GoogleAnalyticsPageMetricsResponse
 */
export const zGoogleAnalyticsPageMetricsResponse = z.object({
  end_date: z.iso.date(),
  pages: z.array(zGoogleAnalyticsPageMetrics),
  start_date: z.iso.date(),
  total: z.int(),
});

/**
 * GoogleAnalyticsPerformanceKPIs
 */
export const zGoogleAnalyticsPerformanceKpis = z.object({
  average_order_value: z.number(),
  conversion_rate: z.number(),
  customer_acquisition_cost: z.number(),
  roas: z.number(),
});

/**
 * GoogleAnalyticsPerformancePeriod
 */
export const zGoogleAnalyticsPerformancePeriod = z.object({
  end_date: z.iso.date(),
  start_date: z.iso.date(),
});

/**
 * GoogleAnalyticsPerformanceTotals
 */
export const zGoogleAnalyticsPerformanceTotals = z.object({
  ad_cost: z.number(),
  revenue: z.number(),
  sessions: z.int(),
  transactions: z.int(),
  users: z.int(),
});

/**
 * GoogleAnalyticsPerformanceTrends
 */
export const zGoogleAnalyticsPerformanceTrends = z.object({
  conversion_trend: z.string(),
  revenue_trend: z.string(),
  traffic_trend: z.string(),
});

/**
 * GoogleAnalyticsPerformanceInsightsResponse
 */
export const zGoogleAnalyticsPerformanceInsightsResponse = z.object({
  kpis: zGoogleAnalyticsPerformanceKpis,
  period: zGoogleAnalyticsPerformancePeriod,
  totals: zGoogleAnalyticsPerformanceTotals,
  trends: zGoogleAnalyticsPerformanceTrends,
});

/**
 * GoogleAnalyticsRealTimeResponse
 */
export const zGoogleAnalyticsRealTimeResponse = z.object({
  realtime_data: zGoogleAnalyticsRealTimeMetrics,
  timestamp: z.iso.datetime(),
});

/**
 * GoogleAnalyticsConnectionStatus
 */
export const zGoogleAnalyticsConnectionStatus = z.object({
  account_name: z.string().nullish(),
  error_message: z.string().nullish(),
  is_connected: z.boolean(),
  last_sync: z.iso.datetime().nullish(),
});

/**
 * GoogleAnalyticsSyncRequest
 */
export const zGoogleAnalyticsSyncRequest = z.object({
  account_id: z.uuid(),
  end_date: z.iso.date().nullish(),
  force: z.boolean().optional().default(false),
  start_date: z.iso.date().nullish(),
});

/**
 * GoogleAnalyticsSyncResponse
 */
export const zGoogleAnalyticsSyncResponse = z.object({
  end_date: z.iso.date(),
  message: z.string(),
  start_date: z.iso.date(),
  success: z.boolean(),
  synced_records: z.int(),
});

/**
 * GoogleAnalyticsSyncAccountsResponse
 */
export const zGoogleAnalyticsSyncAccountsResponse = z.object({
  accounts: z.array(zGoogleAnalyticsAccount),
  message: z.string(),
  success: z.boolean(),
});

/**
 * GoogleAnalyticsAdvancedContentItem
 */
export const zGoogleAnalyticsAdvancedContentItem = z.object({
  date: z.string(),
  event_count: z.int(),
  event_name: z.string(),
  event_rate: z.number().nullish(),
  event_value: z.number().nullish(),
  page_path: z.string(),
  page_title: z.string(),
  unique_events: z.int().nullish(),
});

/**
 * GoogleAnalyticsAdvancedDailyMetric
 */
export const zGoogleAnalyticsAdvancedDailyMetric = z.object({
  ad_clicks: z.int().nullish(),
  ad_cost: z.number().nullish(),
  ad_cost_per_click: z.number().nullish(),
  ad_impressions: z.int().nullish(),
  bounce_rate: z.number(),
  cart_to_view_rate: z.number().nullish(),
  date: z.string(),
  first_time_purchasers: z.int().nullish(),
  item_revenue: z.number().nullish(),
  new_users: z.int(),
  pageviews: z.int(),
  purchase_to_view_rate: z.number().nullish(),
  returning_users: z.int().nullish(),
  revenue: z.number(),
  roas: z.number().nullish(),
  sessions: z.int(),
  total_purchasers: z.int().nullish(),
  transactions: z.int(),
  unique_pageviews: z.int().nullish(),
  user_engagement_duration: z.number().nullish(),
  users: z.int(),
});

/**
 * GoogleAnalyticsAdvancedDemographic
 */
export const zGoogleAnalyticsAdvancedDemographic = z.object({
  age_group: z.string(),
  avg_session_duration: z.number().nullish(),
  conversion_rate: z.number(),
  date: z.string(),
  gender: z.string(),
  revenue: z.number(),
  sessions: z.int(),
  users: z.int(),
});

/**
 * GoogleAnalyticsAdvancedRealtime
 */
export const zGoogleAnalyticsAdvancedRealtime = z.object({
  active_users: z.int(),
  active_users_1_minute: z.int().nullish(),
  active_users_30_minutes: z.int().nullish(),
  active_users_5_minutes: z.int().nullish(),
  top_page_path: z.string().nullish(),
  top_page_title: z.string().nullish(),
  top_page_views: z.int().nullish(),
  conversions_last_minute: z.int().nullish(),
  events_last_minute: z.int().nullish(),
});

/**
 * GoogleAnalyticsAdvancedData
 */
export const zGoogleAnalyticsAdvancedData = z.object({
  content: z.array(zGoogleAnalyticsAdvancedContentItem).optional().default([]),
  daily_metrics: z
    .array(zGoogleAnalyticsAdvancedDailyMetric)
    .optional()
    .default([]),
  demographics: z
    .array(zGoogleAnalyticsAdvancedDemographic)
    .optional()
    .default([]),
  realtime: zGoogleAnalyticsAdvancedRealtime.nullish(),
});

/**
 * GoogleAnalyticsAdvancedSyncResponse
 *
 * Response de sincronização completa do Google Analytics
 */
export const zGoogleAnalyticsAdvancedSyncResponse = z.object({
  data: zGoogleAnalyticsAdvancedData.nullish(),
  end_date: z.iso.date(),
  message: z.string(),
  start_date: z.iso.date(),
  success: z.boolean(),
  sync_timestamp: z.iso.datetime(),
});

/**
 * GoogleAnalyticsPropertySyncResult
 */
export const zGoogleAnalyticsPropertySyncResult = z.object({
  error: z.string().nullish(),
  message: z.string().nullish(),
  property_id: z.string(),
  property_name: z.string().nullish(),
  success: z.boolean(),
  synced_records: z.int(),
});

/**
 * GoogleAnalyticsSyncAllResponse
 */
export const zGoogleAnalyticsSyncAllResponse = z.object({
  end_date: z.iso.date(),
  message: z.string(),
  properties_results: z.array(zGoogleAnalyticsPropertySyncResult),
  start_date: z.iso.date(),
  success: z.boolean(),
  total_properties: z.int(),
  total_synced_records: z.int(),
});

/**
 * GoogleAnalyticsCompleteSyncResponse
 *
 * Response de sincronização completa do Google Analytics
 */
export const zGoogleAnalyticsCompleteSyncResponse = z.object({
  content_metrics_synced: z.int(),
  daily_metrics_synced: z.int(),
  demographics_synced: z.int(),
  end_date: z.iso.date(),
  geography_synced: z.int(),
  message: z.string(),
  page_metrics_synced: z.int(),
  realtime_synced: z.boolean(),
  start_date: z.iso.date(),
  success: z.boolean(),
  synced_records: z.int(),
  technology_synced: z.int(),
});

/**
 * GoogleAnalyticsTechnologyResponse
 */
export const zGoogleAnalyticsTechnologyResponse = z.object({
  end_date: z.iso.date(),
  start_date: z.iso.date(),
  technology_data: z.array(zGoogleAnalyticsTechnologyMetrics),
  total_browsers: z.int(),
});

/**
 * GoogleAdsManagerTotalResponse
 *
 * GoogleAdsManagerTotalResponse
 */
export const zGoogleAdsManagerTotalResponse = z.object({
  cpa: z.union([z.number(), z.int()]),
  cpa_change_percentage: z.union([z.number(), z.int()]),
  cpa_data_type: z.string(),
  cpa_trend_indicator: z.string(),
  cpc: z.union([z.number(), z.int()]),
  cpc_change_percentage: z.union([z.number(), z.int()]),
  cpc_data_type: z.string(),
  cpc_trend_indicator: z.string(),
  ctr: z.union([z.number(), z.int()]),
  ctr_change_percentage: z.union([z.number(), z.int()]),
  ctr_data_type: z.string(),
  ctr_trend_indicator: z.string(),
  currency_symbol: z.string(),
  impressions: z.union([z.number(), z.int()]),
  impressions_change_percentage: z.union([z.number(), z.int()]),
  impressions_data_type: z.string(),
  impressions_trend_indicator: z.string(),
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]),
  investment_data_type: z.string(),
  investment_projection: z.union([z.number(), z.int()]),
  investment_projection_change_percentage: z.union([z.number(), z.int()]),
  investment_projection_data_type: z.string(),
  investment_projection_trend_indicator: z.string(),
  investment_trend_indicator: z.string(),
  percentage_symbol: z.string(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]),
  revenue_data_type: z.string(),
  revenue_projection: z.union([z.number(), z.int()]),
  revenue_projection_change_percentage: z.union([z.number(), z.int()]),
  revenue_projection_data_type: z.string(),
  revenue_projection_trend_indicator: z.string(),
  revenue_trend_indicator: z.string(),
  roas: z.union([z.number(), z.int()]),
  roas_change_percentage: z.union([z.number(), z.int()]),
  roas_data_type: z.string(),
  roas_trend_indicator: z.string(),
});

/**
 * GoogleAdsAccountInfo
 *
 * Schema para informações básicas da conta do Google Ads
 */
export const zGoogleAdsAccountInfo = z.object({
  account_id: z.string(),
  account_name: z.string(),
  currency_code: z.string(),
  customer_id: z.string(),
  is_active: z.boolean(),
  last_sync_at: z.iso.datetime().nullish(),
  timezone: z.string(),
});

/**
 * GoogleAdsAdPerformanceItem
 */
export const zGoogleAdsAdPerformanceItem = z.object({
  ad_type: z.string(),
  avg_ctr: z.number(),
  campaign_id: z.string(),
  count: z.int(),
  total_clicks: z.int(),
  total_conversions: z.number(),
  total_cost: z.number(),
  total_impressions: z.int(),
});

/**
 * GoogleAdsAdPerformanceListResponse
 */
export const zGoogleAdsAdPerformanceListResponse = z.object({
  ad_performance: z.array(zGoogleAdsAdPerformanceItem),
  end_date: z.string(),
  start_date: z.string(),
  total_records: z.int(),
});

/**
 * GoogleAdsAuthUrl
 *
 * Schema para URL de autenticação OAuth
 */
export const zGoogleAdsAuthUrl = z.object({
  state: z.string(),
  url: z.string(),
});

/**
 * GoogleAdsCampaign
 *
 * Schema para dados de campanha do Google Ads
 */
export const zGoogleAdsCampaign = z.object({
  average_cpc: z.number().nullish(),
  bidding_strategy: z.string().nullish(),
  budget_amount: z.number().nullish(),
  budget_delivery_method: z.string().nullish(),
  campaign_id: z.string(),
  campaign_name: z.string(),
  campaign_status: z.string(),
  campaign_type: z.string(),
  clicks: z.int().nullish().default(0),
  conversions: z.number().nullish().default(0),
  cost: z.number().nullish().default(0),
  cost_per_conversion: z.number().nullish(),
  ctr: z.number().nullish(),
  display_impression_share: z.number().nullish(),
  impressions: z.int().nullish().default(0),
  last_sync_at: z.iso.datetime().nullish(),
  search_impression_share: z.number().nullish(),
  video_quartile_100_rate: z.number().nullish(),
  video_quartile_25_rate: z.number().nullish(),
  video_quartile_50_rate: z.number().nullish(),
  video_quartile_75_rate: z.number().nullish(),
  video_view_rate: z.number().nullish(),
  video_views: z.int().nullish(),
  view_through_conversions: z.int().nullish(),
});

/**
 * GoogleAdsCityMetricsItem
 *
 * GoogleAdsCityMetricsItem
 */
export const zGoogleAdsCityMetricsItem = z.object({
  average_cpc: z.union([z.number(), z.int()]),
  city_name: z.string(),
  clicks: z.int().gte(0),
  conversion_rate: z.union([z.number(), z.int()]),
  conversions: z.union([z.number(), z.int()]),
  cost: z.union([z.number(), z.int()]),
  cost_per_conversion: z.union([z.number(), z.int()]),
  ctr: z.union([z.number(), z.int()]),
  impressions: z.int().gte(0),
});

/**
 * GoogleAdsCityMetricsPagination
 *
 * GoogleAdsCityMetricsPagination
 */
export const zGoogleAdsCityMetricsPagination = z.object({
  current_page: z.int().gte(1),
  page_size: z.int().gte(1),
  total_items: z.int().gte(0),
  total_pages: z.int().gte(0),
});

/**
 * GoogleAdsCityMetricsResponse
 *
 * GoogleAdsCityMetricsResponse
 */
export const zGoogleAdsCityMetricsResponse = z.object({
  items: z.array(zGoogleAdsCityMetricsItem),
  pagination: zGoogleAdsCityMetricsPagination,
});

/**
 * GoogleAdsAdPerformance
 *
 * Schema completo para performance de anúncios
 */
export const zGoogleAdsAdPerformance = z.object({
  account_id: z.int(),
  ad_id: z.string(),
  ad_type: z.string().nullish(),
  campaign_id: z.int(),
  clicks: z.int().nullish(),
  conversion_value: z.number().nullish(),
  conversions: z.number().nullish(),
  cost_micros: z.int().nullish(),
  ctr: z.number().nullish(),
  date: z.iso.date(),
  description: z.string().nullish(),
  display_url: z.string().nullish(),
  final_url: z.string().nullish(),
  headline_1: z.string().nullish(),
  headline_2: z.string().nullish(),
  id: z.int(),
  impressions: z.int().nullish(),
});

/**
 * GoogleAdsDemographics
 *
 * Schema completo para dados demográficos
 */
export const zGoogleAdsDemographics = z.object({
  account_id: z.int(),
  age_range: z.string().nullish(),
  campaign_id: z.int(),
  clicks: z.int().nullish(),
  conversion_rate: z.number().nullish(),
  conversions: z.number().nullish(),
  cost_micros: z.int().nullish(),
  date: z.iso.date(),
  gender: z.string().nullish(),
  household_income: z.string().nullish(),
  id: z.int(),
  impressions: z.int().nullish(),
  parental_status: z.string().nullish(),
});

/**
 * GoogleAdsExtensions
 *
 * Schema completo para extensões de anúncios
 */
export const zGoogleAdsExtensions = z.object({
  account_id: z.int(),
  campaign_id: z.int(),
  clicks: z.int().nullish(),
  cost_micros: z.int().nullish(),
  date: z.iso.date(),
  extension_text: z.string().nullish(),
  extension_type: z.string(),
  extension_url: z.string().nullish(),
  id: z.int(),
  impressions: z.int().nullish(),
});

/**
 * GoogleAdsGeographics
 *
 * Schema completo para dados geográficos
 */
export const zGoogleAdsGeographics = z.object({
  account_id: z.int(),
  campaign_id: z.int(),
  city_name: z.string().nullish(),
  clicks: z.int().nullish(),
  conversions: z.number().nullish(),
  cost_micros: z.int().nullish(),
  cost_per_conversion: z.number().nullish(),
  country_code: z.string().nullish(),
  country_name: z.string().nullish(),
  date: z.iso.date(),
  id: z.int(),
  impressions: z.int().nullish(),
  region_code: z.string().nullish(),
  region_name: z.string().nullish(),
});

/**
 * GoogleAdsCompleteResponse
 *
 * Response completa com todas as métricas avançadas
 */
export const zGoogleAdsCompleteResponse = z.object({
  ads_performance: z.array(zGoogleAdsAdPerformance),
  campaigns: z.array(zGoogleAdsCampaign),
  demographics: z.array(zGoogleAdsDemographics),
  end_date: z.iso.date(),
  extensions: z.array(zGoogleAdsExtensions),
  geographic: z.array(zGoogleAdsGeographics),
  start_date: z.iso.date(),
  total_records: z.int(),
});

/**
 * GoogleAdsDemographicSegmentItem
 */
export const zGoogleAdsDemographicSegmentItem = z.object({
  age_range: z.string(),
  avg_conversion_rate: z.number(),
  count: z.int(),
  gender: z.string(),
  total_clicks: z.int(),
  total_conversions: z.number(),
  total_cost: z.number(),
  total_impressions: z.int(),
});

/**
 * GoogleAdsDemographicsResponse
 */
export const zGoogleAdsDemographicsResponse = z.object({
  demographics: z.array(zGoogleAdsDemographicSegmentItem),
  end_date: z.string(),
  start_date: z.string(),
  total_segments: z.int(),
});

/**
 * GoogleAdsDeviceMetricsItem
 *
 * GoogleAdsDeviceMetricsItem
 */
export const zGoogleAdsDeviceMetricsItem = z.object({
  device_type: z.string(),
  total_clicks: z.int(),
  total_conversions: z.union([z.number(), z.int()]),
  total_cost: z.union([z.number(), z.int()]),
});

/**
 * GoogleAdsDeviceMetricsResponse
 *
 * GoogleAdsDeviceMetricsResponse
 */
export const zGoogleAdsDeviceMetricsResponse = z.object({
  devices: z.array(zGoogleAdsDeviceMetricsItem),
});

/**
 * GoogleAdsDisconnectResponse
 */
export const zGoogleAdsDisconnectResponse = z.object({
  cleanup: zCleanupResult.nullish(),
  customer_uuid_cleaned: z.string(),
  message: z.string(),
});

/**
 * GoogleAdsExtensionItem
 */
export const zGoogleAdsExtensionItem = z.object({
  count: z.int(),
  ctr: z.number(),
  extension_text: z.string().nullish(),
  extension_type: z.string(),
  extension_url: z.string().nullish(),
  total_clicks: z.int(),
  total_cost: z.number(),
  total_impressions: z.int(),
});

/**
 * GoogleAdsExtensionsResponse
 */
export const zGoogleAdsExtensionsResponse = z.object({
  end_date: z.string(),
  extensions: z.array(zGoogleAdsExtensionItem),
  start_date: z.string(),
  total_records: z.int(),
});

/**
 * GoogleAdsGeographicItem
 */
export const zGoogleAdsGeographicItem = z.object({
  avg_ctr: z.number(),
  city: z.string(),
  count: z.int(),
  country: z.string(),
  total_clicks: z.int(),
  total_conversions: z.number(),
  total_cost: z.number(),
  total_impressions: z.int(),
});

/**
 * GoogleAdsGeographicResponse
 */
export const zGoogleAdsGeographicResponse = z.object({
  end_date: z.string(),
  geographic: z.array(zGoogleAdsGeographicItem),
  start_date: z.string(),
  total_regions: z.int(),
});

/**
 * GoogleAdsHourlyMetricsItem
 *
 * GoogleAdsHourlyMetricsItem
 */
export const zGoogleAdsHourlyMetricsItem = z.object({
  all_conversions: z.union([z.number(), z.int()]),
  average_cpc: z.union([z.number(), z.int()]),
  clicks: z.int(),
  conversions: z.union([z.number(), z.int()]),
  cost: z.union([z.number(), z.int()]),
  ctr: z.union([z.number(), z.int()]),
  hour: z.int(),
  impressions: z.int(),
});

/**
 * GoogleAdsHourlyMetricsResponse
 *
 * GoogleAdsHourlyMetricsResponse
 */
export const zGoogleAdsHourlyMetricsResponse = z.object({
  data: z.array(zGoogleAdsHourlyMetricsItem),
});

/**
 * GoogleAdsKeyword
 *
 * Schema para dados de palavras-chave do Google Ads
 */
export const zGoogleAdsKeyword = z.object({
  average_cpc: z.number().nullish(),
  average_position: z.number().nullish(),
  campaign_name: z.string().nullish(),
  clicks: z.int().nullish().default(0),
  cost: z.number().nullish().default(0),
  ctr: z.number().nullish(),
  impressions: z.int().nullish().default(0),
  keyword_id: z.string(),
  keyword_text: z.string(),
  last_sync_at: z.iso.datetime().nullish(),
  match_type: z.string(),
  max_cpc: z.number().nullish(),
  quality_score: z.int().nullish(),
  status: z.string(),
});

/**
 * GoogleAdsMetricsDaily
 *
 * Schema para métricas diárias agregadas
 */
export const zGoogleAdsMetricsDaily = z.object({
  average_cpc: z.number().nullish(),
  average_position: z.number().nullish(),
  clicks: z.int().optional().default(0),
  conversion_value: z.number().optional().default(0),
  conversions: z.number().optional().default(0),
  cost: z.number().optional().default(0),
  cost_per_conversion: z.number().nullish(),
  ctr: z.number().nullish(),
  date: z.iso.date(),
  impression_share: z.number().nullish(),
  impressions: z.int().optional().default(0),
});

/**
 * GoogleAdsMetrics
 *
 * Schema para métricas agregadas por período
 */
export const zGoogleAdsMetrics = z.object({
  average_cost_per_conversion: z.number().nullish(),
  average_cpc: z.number().nullish(),
  average_ctr: z.number().nullish(),
  average_impression_share: z.number().nullish(),
  average_position: z.number().nullish(),
  daily_metrics: z.array(zGoogleAdsMetricsDaily).optional().default([]),
  end_date: z.string(),
  start_date: z.string(),
  total_clicks: z.int().optional().default(0),
  total_conversion_value: z.number().optional().default(0),
  total_conversions: z.number().optional().default(0),
  total_cost: z.number().optional().default(0),
  total_impressions: z.int().optional().default(0),
});

/**
 * GoogleAdsPerformanceInsights
 *
 * Schema para insights de performance
 */
export const zGoogleAdsPerformanceInsights = z.object({
  average_conversion_rate: z.number(),
  average_cpc: z.number(),
  average_ctr: z.number(),
  roas: z.number(),
  top_performing_campaigns: z.array(
    z.record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    ),
  ),
  total_clicks: z.int(),
  total_conversions: z.number(),
  total_cost: z.number(),
  total_impressions: z.int(),
});

/**
 * GoogleAdsConnectionStatus
 *
 * Schema para status da conexão
 */
export const zGoogleAdsConnectionStatus = z.object({
  account_count: z.int().optional().default(0),
  error_message: z.string().nullish(),
  is_connected: z.boolean(),
  last_sync_at: z.iso.datetime().nullish(),
});

/**
 * GoogleAdsSyncResponse
 */
export const zGoogleAdsSyncResponse = z.object({
  message: z.string(),
  task_id: z.string().nullish(),
});

/**
 * GoogleAdsCompleteAdData
 */
export const zGoogleAdsCompleteAdData = z.object({
  ad_id: z.string(),
  ad_type: z.string(),
  campaign_id: z.int(),
  clicks: z.int(),
  conversion_value: z.number(),
  conversions: z.number(),
  cost_micros: z.int(),
  ctr: z.number(),
  date: z.string(),
  description: z.string().nullish(),
  display_url: z.string().nullish(),
  final_url: z.string().nullish(),
  headline_1: z.string().nullish(),
  headline_2: z.string().nullish(),
  impressions: z.int(),
});

/**
 * GoogleAdsCompleteCampaignData
 */
export const zGoogleAdsCompleteCampaignData = z.object({
  average_cpc: z.number(),
  bidding_strategy: z.string(),
  budget_amount: z.number(),
  campaign_id: z.string(),
  campaign_name: z.string(),
  channel_type: z.string(),
  clicks: z.int(),
  conversion_value: z.number(),
  conversions: z.int(),
  cost: z.number(),
  cost_per_conversion: z.number(),
  ctr: z.number(),
  impressions: z.int(),
  search_impression_share: z.number(),
  status: z.string(),
  video_view_rate: z.number().nullish(),
  video_views: z.int().nullish(),
  view_through_conversions: z.int(),
});

/**
 * GoogleAdsCompleteDemographicData
 */
export const zGoogleAdsCompleteDemographicData = z.object({
  age_range: z.string(),
  campaign_id: z.int(),
  clicks: z.int(),
  conversion_rate: z.number(),
  conversions: z.number(),
  cost_micros: z.int(),
  date: z.string(),
  gender: z.string(),
  household_income: z.string(),
  impressions: z.int(),
  parental_status: z.string(),
});

/**
 * GoogleAdsCompleteExtensionData
 */
export const zGoogleAdsCompleteExtensionData = z.object({
  campaign_id: z.int(),
  clicks: z.int(),
  cost_micros: z.int(),
  date: z.string(),
  extension_text: z.string(),
  extension_type: z.string(),
  extension_url: z.string().nullish(),
  impressions: z.int(),
});

/**
 * GoogleAdsCompleteGeographicData
 */
export const zGoogleAdsCompleteGeographicData = z.object({
  campaign_id: z.int(),
  city_name: z.string(),
  clicks: z.int(),
  conversions: z.number(),
  cost_micros: z.int(),
  cost_per_conversion: z.number(),
  country_code: z.string(),
  country_name: z.string().nullish(),
  date: z.string(),
  impressions: z.int(),
  region_code: z.string().nullish(),
  region_name: z.string().nullish(),
});

/**
 * GoogleAdsCompleteData
 */
export const zGoogleAdsCompleteData = z.object({
  ads: z.array(zGoogleAdsCompleteAdData).optional().default([]),
  campaigns: z.array(zGoogleAdsCompleteCampaignData).optional().default([]),
  demographics: z
    .array(zGoogleAdsCompleteDemographicData)
    .optional()
    .default([]),
  extensions: z.array(zGoogleAdsCompleteExtensionData).optional().default([]),
  geographic: z.array(zGoogleAdsCompleteGeographicData).optional().default([]),
});

/**
 * GoogleAdsCompleteSyncResponse
 *
 * Response completa com todas as métricas avançadas
 */
export const zGoogleAdsCompleteSyncResponse = z.object({
  data: zGoogleAdsCompleteData.nullish(),
  end_date: z.iso.date(),
  message: z.string(),
  start_date: z.string(),
  success: z.boolean(),
  sync_timestamp: z.iso.datetime(),
});

/**
 * MetaAdsAccount
 */
export const zMetaAdsAccount = z.object({
  created_at: z.iso.datetime(),
  currency_code: z.string().nullish(),
  external_account_id: z.string(),
  id: z.uuid(),
  integration_id: z.int(),
  is_active: z.boolean(),
  last_sync_at: z.iso.datetime().nullish(),
  name: z.string().nullish(),
  source: z.string(),
  timezone: z.string().nullish(),
  updated_at: z.iso.datetime().nullish(),
});

/**
 * MetaAdsAdPerformanceItem
 *
 * MetaAdsAdPerformanceItem
 */
export const zMetaAdsAdPerformanceItem = z.object({
  ad_name: z.string(),
  adset_name: z.string(),
  campaign_name: z.string(),
  compras: z.int(),
  cost_per_result: z.union([z.number(), z.int()]),
  cpc: z.union([z.number(), z.int()]),
  cpm: z.union([z.number(), z.int()]),
  custoPagDestino: z.union([z.number(), z.int()]),
  impressions: z.int(),
  investimento: z.union([z.number(), z.int()]),
  link_ctr: z.union([z.number(), z.int()]),
  pagDestino: z.int(),
  reach: z.int(),
  receita: z.union([z.number(), z.int()]),
  results: z.int(),
  roas: z.union([z.number(), z.int()]),
  spend: z.union([z.number(), z.int()]),
  thumbnail_url: z.string(),
  ticketMedio: z.union([z.number(), z.int()]),
  txConversao: z.union([z.number(), z.int()]),
});

/**
 * MetaAdsAdPerformanceTotalRow
 */
export const zMetaAdsAdPerformanceTotalRow = z.object({
  ad_name: z.string(),
  adset_name: z.string(),
  campaign_name: z.string(),
  compras: z.int(),
  cost_per_result: z.union([z.number(), z.int()]),
  cpc: z.union([z.number(), z.int()]),
  cpm: z.union([z.number(), z.int()]),
  custoPagDestino: z.union([z.number(), z.int()]),
  impressions: z.int(),
  investimento: z.union([z.number(), z.int()]),
  link_ctr: z.union([z.number(), z.int()]),
  pagDestino: z.int(),
  reach: z.int().optional(),
  receita: z.union([z.number(), z.int()]),
  results: z.int(),
  roas: z.union([z.number(), z.int()]),
  spend: z.union([z.number(), z.int()]),
  thumbnail_url: z.string(),
  ticketMedio: z.union([z.number(), z.int()]),
  txConversao: z.union([z.number(), z.int()]),
});

/**
 * MetaAdsAdPerformanceResponse
 *
 * MetaAdsAdPerformanceResponse
 */
export const zMetaAdsAdPerformanceResponse = z.object({
  current_page: z.int(),
  results: z.array(zMetaAdsAdPerformanceItem),
  total_pages: z.int(),
  total_results: z.int(),
  total_row: zMetaAdsAdPerformanceTotalRow.nullish(),
});

/**
 * MetaAdsAuthUrlResponse
 */
export const zMetaAdsAuthUrlResponse = z.object({
  auth_url: z.string(),
  state: z.string(),
});

/**
 * MetaAdsCallbackResponse
 */
export const zMetaAdsCallbackResponse = z.object({
  message: z.string().nullish(),
  success: z.boolean(),
});

/**
 * MetaAdsCampaignSummary
 */
export const zMetaAdsCampaignSummary = z.object({
  avg_ctr: z.number(),
  campaign_id: z.string().nullish(),
  days_active: z.int(),
  total_clicks: z.int(),
  total_cost: z.number(),
  total_impressions: z.int(),
});

/**
 * MetaAdsClearDataResponse
 */
export const zMetaAdsClearDataResponse = z.object({
  deleted_records: z.int(),
  message: z.string(),
  success: z.boolean(),
});

/**
 * MetaAdsCreative
 */
export const zMetaAdsCreative = z.object({
  account_id: z.uuid(),
  ad_id: z.string().nullish(),
  ad_name: z.string().nullish(),
  adset_id: z.string().nullish(),
  call_to_action: z.string().nullish(),
  campaign_id: z.string().nullish(),
  clicks: z.int().nullish(),
  conversion_value: z.number().nullish(),
  conversions: z.int().nullish(),
  cost: z.number().nullish(),
  cost_per_conversion: z.number().nullish(),
  cpm: z.number().nullish(),
  creative_id: z.string().nullish(),
  creative_type: z.string().nullish(),
  ctr: z.number().nullish(),
  date: z.iso.date(),
  headline: z.string().nullish(),
  id: z.uuid(),
  impressions: z.int().nullish(),
  relevance_score: z.number().nullish(),
  text: z.string().nullish(),
});

/**
 * MetaAdsMetrics
 */
export const zMetaAdsMetrics = z.object({
  account_id: z.uuid(),
  ad_id: z.string().nullish(),
  add_to_cart: z.int().nullish(),
  adset_id: z.string().nullish(),
  campaign_id: z.string().nullish(),
  checkout_initiated: z.int().nullish(),
  clicks: z.int().nullish(),
  comments: z.int().nullish(),
  conv_value: z.number().nullish(),
  conversion_rate: z.number().nullish(),
  conversions: z.int().nullish(),
  cost: z.number().nullish(),
  cost_per_conversion: z.number().nullish(),
  cost_per_lead: z.number().nullish(),
  cost_per_purchase: z.number().nullish(),
  cpc: z.number().nullish(),
  cpm: z.number().nullish(),
  cpp: z.number().nullish(),
  ctr: z.number().nullish(),
  date: z.iso.date(),
  frequency: z.number().nullish(),
  id: z.uuid(),
  impressions: z.int().nullish(),
  leads: z.int().nullish(),
  link_clicks: z.int().nullish(),
  link_ctr: z.number().nullish(),
  post_engagements: z.int().nullish(),
  purchase_value: z.number().nullish(),
  purchases: z.int().nullish(),
  reach: z.int().nullish(),
  reactions: z.int().nullish(),
  roas: z.number().nullish(),
  saves: z.int().nullish(),
  shares: z.int().nullish(),
  video_100_percent_complete_views: z.int().nullish(),
  video_25_percent_complete_views: z.int().nullish(),
  video_50_percent_complete_views: z.int().nullish(),
  video_75_percent_complete_views: z.int().nullish(),
  video_play_actions: z.int().nullish(),
  video_views: z.int().nullish(),
});

/**
 * MetaAdsDemographics
 */
export const zMetaAdsDemographics = z.object({
  account_id: z.uuid(),
  adset_id: z.string().nullish(),
  age: z.string().nullish(),
  campaign_id: z.string().nullish(),
  clicks: z.int().nullish(),
  conversion_value: z.number().nullish(),
  conversions: z.int().nullish(),
  cost: z.number().nullish(),
  cost_per_conversion: z.number().nullish(),
  cpm: z.number().nullish(),
  ctr: z.number().nullish(),
  date: z.iso.date(),
  gender: z.string().nullish(),
  id: z.uuid(),
  impressions: z.int().nullish(),
});

/**
 * MetaAdsInterests
 */
export const zMetaAdsInterests = z.object({
  account_id: z.uuid(),
  adset_id: z.string().nullish(),
  behavior_id: z.string().nullish(),
  behavior_name: z.string().nullish(),
  campaign_id: z.string().nullish(),
  clicks: z.int().nullish(),
  conversion_value: z.number().nullish(),
  conversions: z.int().nullish(),
  cost: z.number().nullish(),
  ctr: z.number().nullish(),
  date: z.iso.date(),
  id: z.uuid(),
  impressions: z.int().nullish(),
  interest_id: z.string().nullish(),
  interest_name: z.string().nullish(),
});

/**
 * MetaAdsPlacement
 */
export const zMetaAdsPlacement = z.object({
  account_id: z.uuid(),
  adset_id: z.string().nullish(),
  campaign_id: z.string().nullish(),
  clicks: z.int().nullish(),
  conversion_value: z.number().nullish(),
  conversions: z.int().nullish(),
  cost: z.number().nullish(),
  cpm: z.number().nullish(),
  ctr: z.number().nullish(),
  date: z.iso.date(),
  device_platform: z.string().nullish(),
  id: z.uuid(),
  impressions: z.int().nullish(),
  platform_position: z.string().nullish(),
  publisher_platform: z.string().nullish(),
});

/**
 * MetaAdsCompleteResponse
 *
 * Resposta completa com todos os dados do Meta Ads
 */
export const zMetaAdsCompleteResponse = z.object({
  creative: z.array(zMetaAdsCreative),
  daily_metrics: z.array(zMetaAdsMetrics),
  demographics: z.array(zMetaAdsDemographics),
  end_date: z.iso.date(),
  interests: z.array(zMetaAdsInterests),
  placement: z.array(zMetaAdsPlacement),
  start_date: z.iso.date(),
  total_records: z.int(),
});

/**
 * MetaAdsConnectionStatus
 */
export const zMetaAdsConnectionStatus = z.object({
  account_name: z.string().nullish(),
  error_message: z.string().nullish(),
  is_connected: z.boolean(),
  last_sync: z.iso.datetime().nullish(),
});

/**
 * MetaAdsFeaturedAdsetItem
 *
 * MetaAdsFeaturedAdsetItem
 */
export const zMetaAdsFeaturedAdsetItem = z.object({
  adset_name: z.string(),
  alcance: z.int().gte(0),
  clicks: z.int().gte(0),
  cliquesLink: z.int().gte(0),
  compras: z.int().gte(0),
  connectRate: z.union([z.number(), z.int()]),
  cost_per_result: z.union([z.number(), z.int()]),
  cpc: z.union([z.number(), z.int()]),
  cpcMedio: z.union([z.number(), z.int()]),
  cpm: z.union([z.number(), z.int()]),
  ctr: z.union([z.number(), z.int()]),
  ctrTodos: z.union([z.number(), z.int()]),
  custoPagDestino: z.union([z.number(), z.int()]),
  delta: z.number().nullable(),
  frequencia: z.union([z.number(), z.int()]),
  impressions: z.int().gte(0),
  investimento: z.union([z.number(), z.int()]),
  link_ctr: z.union([z.number(), z.int()]),
  pagDestino: z.int().gte(0),
  reach: z.int().gte(0),
  receita: z.union([z.number(), z.int()]),
  results: z.int().gte(0),
  roas: z.union([z.number(), z.int()]),
  spend: z.union([z.number(), z.int()]),
  txConversao: z.union([z.number(), z.int()]),
});

/**
 * MetaAdsFeaturedAdsetTotalRow
 */
export const zMetaAdsFeaturedAdsetTotalRow = z.object({
  adset_name: z.string(),
  alcance: z.int().gte(0).optional(),
  clicks: z.int().gte(0),
  cliquesLink: z.int().gte(0),
  compras: z.int().gte(0),
  connectRate: z.union([z.number(), z.int()]),
  cost_per_result: z.union([z.number(), z.int()]),
  cpc: z.union([z.number(), z.int()]),
  cpcMedio: z.union([z.number(), z.int()]),
  cpm: z.union([z.number(), z.int()]),
  ctr: z.union([z.number(), z.int()]),
  ctrTodos: z.union([z.number(), z.int()]),
  custoPagDestino: z.union([z.number(), z.int()]),
  delta: z.number().nullable(),
  frequencia: z.union([z.number(), z.int()]).optional(),
  impressions: z.int().gte(0),
  investimento: z.union([z.number(), z.int()]),
  link_ctr: z.union([z.number(), z.int()]),
  pagDestino: z.int().gte(0),
  reach: z.int().gte(0).optional(),
  receita: z.union([z.number(), z.int()]),
  results: z.int().gte(0),
  roas: z.union([z.number(), z.int()]),
  spend: z.union([z.number(), z.int()]),
  txConversao: z.union([z.number(), z.int()]),
});

/**
 * MetaAdsFeaturedAdsetsResponse
 *
 * MetaAdsFeaturedAdsetsResponse
 */
export const zMetaAdsFeaturedAdsetsResponse = z.object({
  current_page: z.int().gte(1),
  page_size: z.int().gte(1),
  results: z.array(zMetaAdsFeaturedAdsetItem),
  total_pages: z.int().gte(0),
  total_results: z.int().gte(0),
  total_row: zMetaAdsFeaturedAdsetTotalRow.nullish(),
});

/**
 * MetaAdsHourlyPerformanceItem
 *
 * MetaAdsHourlyPerformanceItem
 */
export const zMetaAdsHourlyPerformanceItem = z.object({
  hour: z.int().gte(0).lte(23),
  impressions: z.int().gte(0),
  reach: z.int().gte(0).nullable(),
  total_impressions: z.int().gte(0),
  total_reach: z.int().gte(0).nullable(),
});

/**
 * MetaAdsPerformanceInsights
 *
 * Insights calculados de performance
 */
export const zMetaAdsPerformanceInsights = z.object({
  best_age_group: z.string().nullish(),
  best_device: z.string().nullish(),
  best_gender: z.string().nullish(),
  best_platform: z.string().nullish(),
  conversion_trend: z.string(),
  cost_per_conversion: z.number(),
  cost_trend: z.string(),
  engagement_rate: z.number(),
  overall_cpc: z.number(),
  overall_cpm: z.number(),
  overall_ctr: z.number(),
  overall_roas: z.number(),
  performance_trend: z.string(),
  top_creative: z.string().nullish(),
  top_demographic: z.string().nullish(),
  top_interest: z.string().nullish(),
  top_placement: z.string().nullish(),
  total_clicks: z.int(),
  total_conversions: z.int(),
  total_cost: z.number(),
  total_impressions: z.int(),
  total_revenue: z.number(),
  total_video_views: z.int(),
  video_completion_rate: z.number(),
});

/**
 * MetaAdsPlatformReachItem
 *
 * MetaAdsPlatformReachItem
 */
export const zMetaAdsPlatformReachItem = z.object({
  platform: z.string(),
  total_reach: z.int().gte(0),
});

/**
 * DateRange
 */
export const zDateRange = z.object({
  end: z.iso.date().nullish(),
  start: z.iso.date().nullish(),
});

/**
 * MetaAdsTotals
 */
export const zMetaAdsTotals = z.object({
  clicks: z.int().optional().default(0),
  conversions: z.int().optional().default(0),
  cost: z.number().optional().default(0),
  impressions: z.int().optional().default(0),
});

/**
 * MetaAdsSummaryResponse
 */
export const zMetaAdsSummaryResponse = z.object({
  account_id: z.uuid(),
  date_range: zDateRange,
  total_records: z.int(),
  totals: zMetaAdsTotals,
});

/**
 * MetaAdsSyncRequest
 */
export const zMetaAdsSyncRequest = z.object({
  account_id: z.uuid(),
  end_date: z.iso.date().nullish(),
  force: z.boolean().optional().default(false),
  include_creative: z.boolean().optional().default(true),
  include_demographics: z.boolean().optional().default(true),
  include_interests: z.boolean().optional().default(true),
  include_placement: z.boolean().optional().default(true),
  start_date: z.iso.date().nullish(),
});

/**
 * MetaAdsSyncResponse
 */
export const zMetaAdsSyncResponse = z.object({
  creative_synced: z.int().nullish(),
  demographics_synced: z.int().nullish(),
  end_date: z.iso.date(),
  interests_synced: z.int().nullish(),
  message: z.string(),
  metrics_synced: z.int().nullish(),
  placement_synced: z.int().nullish(),
  start_date: z.iso.date(),
  success: z.boolean(),
  synced_records: z.int(),
});

/**
 * MetaAdsSampleMetric
 */
export const zMetaAdsSampleMetric = z.object({
  clicks: z.int(),
  cost: z.number(),
  date: z.string(),
  impressions: z.int(),
});

/**
 * MetaAdsTestDataResponse
 */
export const zMetaAdsTestDataResponse = z.object({
  account_id: z.string().nullish(),
  account_name: z.string().nullish(),
  error: z.string().nullish(),
  metrics_count: z.int().optional().default(0),
  sample_metrics: z.array(zMetaAdsSampleMetric).optional().default([]),
});

/**
 * MetaAdsInstagramKpiPeriod
 *
 * MetaAdsInstagramKpiPeriod
 */
export const zMetaAdsInstagramKpiPeriod = z.object({
  cliques: z.int().gte(0),
  compras: z.union([z.number(), z.int()]),
  cpa: z.union([z.number(), z.int()]),
  cpc: z.union([z.number(), z.int()]),
  cpm: z.union([z.number(), z.int()]),
  cps: z.union([z.number(), z.int()]),
  ctr: z.union([z.number(), z.int()]),
  impressoes: z.int().gte(0),
  investimento: z.union([z.number(), z.int()]),
  receita: z.union([z.number(), z.int()]),
  roas: z.union([z.number(), z.int()]),
  sessoes: z.int().gte(0),
  taxaConversao: z.union([z.number(), z.int()]),
  ticketMedio: z.union([z.number(), z.int()]),
});

/**
 * MetaAdsInstagramKpiResponse
 *
 * MetaAdsInstagramKpiResponse
 */
export const zMetaAdsInstagramKpiResponse = z.object({
  current_period: zMetaAdsInstagramKpiPeriod,
  previous_period: zMetaAdsInstagramKpiPeriod,
});

/**
 * MetaAdsInstagramTimeseriesDay
 */
export const zMetaAdsInstagramTimeseriesDay = z.object({
  date: z.string(),
  investimento: z.number(),
  receita: z.number(),
  roas: z.number(),
  cpcMedio: z.number(),
  cps: z.number(),
  sessoes: z.int().gte(0),
  taxaConversao: z.number(),
  pedidos: z.number().gte(0),
  ticketMedio: z.number(),
});

/**
 * MetaAdsInstagramTimeseriesResponse
 */
export const zMetaAdsInstagramTimeseriesResponse = z.object({
  start_date: z.string(),
  end_date: z.string(),
  has_data: z.boolean(),
  total_days: z.int().gte(0),
  daily_data: z.array(zMetaAdsInstagramTimeseriesDay),
});

/**
 * MetaAdsManagerTotalResponse
 *
 * MetaAdsManagerTotalResponse
 */
export const zMetaAdsManagerTotalResponse = z.object({
  cpa: z.union([z.number(), z.int()]),
  cpa_change_percentage: z.union([z.number(), z.int()]),
  cpa_data_type: z.string(),
  cpa_trend_indicator: z.string(),
  cpc_link: z.union([z.number(), z.int()]),
  cpc_link_change_percentage: z.union([z.number(), z.int()]),
  cpc_link_data_type: z.string(),
  cpc_link_trend_indicator: z.string(),
  cpm: z.union([z.number(), z.int()]),
  cpm_change_percentage: z.union([z.number(), z.int()]),
  cpm_data_type: z.string(),
  cpm_trend_indicator: z.string(),
  ctr_link: z.union([z.number(), z.int()]),
  ctr_link_change_percentage: z.union([z.number(), z.int()]),
  ctr_link_data_type: z.string(),
  ctr_link_trend_indicator: z.string(),
  currency_symbol: z.string(),
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]),
  investment_data_type: z.string(),
  investment_projection: z.union([z.number(), z.int()]),
  investment_projection_change_percentage: z.union([z.number(), z.int()]),
  investment_projection_data_type: z.string(),
  investment_projection_trend_indicator: z.string(),
  investment_trend_indicator: z.string(),
  percentage_symbol: z.string(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]),
  revenue_data_type: z.string(),
  revenue_projection: z.union([z.number(), z.int()]),
  revenue_projection_change_percentage: z.union([z.number(), z.int()]),
  revenue_projection_data_type: z.string(),
  revenue_projection_trend_indicator: z.string(),
  revenue_trend_indicator: z.string(),
  roas: z.union([z.number(), z.int()]),
  roas_change_percentage: z.union([z.number(), z.int()]),
  roas_data_type: z.string(),
  roas_trend_indicator: z.string(),
});

/**
 * InstagramLegacyNamedValue
 *
 * InstagramLegacyNamedValue
 */
export const zInstagramLegacyNamedValue = z.object({
  color: z.string(),
  name: z.string(),
  value: z.union([z.number(), z.int()]),
});

/**
 * InstagramLegacyCityValue
 *
 * InstagramLegacyCityValue
 */
export const zInstagramLegacyCityValue = z.object({
  cidade: z.string(),
  seguidores: z.int().gte(0),
});

/**
 * InstagramDemographicsResponse
 *
 * InstagramDemographicsResponse
 */
export const zInstagramDemographicsResponse = z.object({
  age: z.array(zInstagramLegacyNamedValue),
  city: z.array(zInstagramLegacyCityValue),
  gender: z.array(zInstagramLegacyNamedValue),
  has_data: z.boolean(),
  total_followers: z.int().gte(0),
  snapshot_at: z.iso.datetime().nullish(),
});

/**
 * InstagramEngagementResponse
 *
 * InstagramEngagementResponse
 */
export const zInstagramEngagementResponse = z.object({
  engagement_by_followers: z.union([z.number(), z.int()]),
  engagement_by_impressions: z.union([z.number(), z.int()]).nullish(),
  engagement_by_reach: z.union([z.number(), z.int()]),
  follower_count: z.int().gte(0),
  total_comments: z.int().gte(0),
  total_impressions: z.int().gte(0),
  total_interactions: z.int().gte(0),
  total_likes: z.int().gte(0),
  total_reach: z.int().gte(0),
  total_saves: z.int().gte(0),
});

/**
 * InstagramKpiSummary
 *
 * InstagramKpiSummary
 */
export const zInstagramKpiSummary = z.object({
  change: z.union([z.number(), z.int()]),
  trend: z.string(),
  value: z.union([z.number(), z.int()]),
});

/**
 * InstagramKpisCompleteResponse
 *
 * InstagramKpisCompleteResponse
 */
export const zInstagramKpisCompleteResponse = z.object({
  alcance: zInstagramKpiSummary,
  cliquesLinkBio: zInstagramKpiSummary,
  cliquesSite: zInstagramKpiSummary,
  comentarios: zInstagramKpiSummary,
  compartilhamentos: zInstagramKpiSummary,
  curtidas: zInstagramKpiSummary,
  has_data: z.boolean(),
  impressoes: zInstagramKpiSummary,
  novosSeguidores: zInstagramKpiSummary,
  reelsComments: zInstagramKpiSummary,
  reelsCount: zInstagramKpiSummary,
  reelsInteractions: zInstagramKpiSummary,
  reelsLikes: zInstagramKpiSummary,
  reelsReach90d: zInstagramKpiSummary,
  reelsSaves: zInstagramKpiSummary,
  reelsShares: zInstagramKpiSummary,
  salvos: zInstagramKpiSummary,
  seguidores: zInstagramKpiSummary,
  seguindo: zInstagramKpiSummary,
  sessoes: zInstagramKpiSummary,
  taxaEngajamento: zInstagramKpiSummary,
  totalPostsPublicados: zInstagramKpiSummary,
  visitasAoPerfil: zInstagramKpiSummary,
});

/**
 * InstagramPostItem
 *
 * InstagramPostItem
 */
export const zInstagramPostItem = z.object({
  caption: z.string().nullish(),
  comments: z.int().nullish().default(0),
  date: z.string().nullish(),
  id: z.string().nullish(),
  interactionRate: z.union([z.number(), z.int()]).nullish(),
  interactions: z.int().nullish().default(0),
  likes: z.int().nullish().default(0),
  mediaType: z.string().nullish(),
  permalink: z.string().nullish().default(""),
  reach: z.int().nullish().default(0),
  saves: z.int().nullish().default(0),
  shares: z.int().nullish().default(0),
  thumbnail: z.string().nullish(),
  views: z.int().nullish().default(0),
});

/**
 * InstagramPostsTotalRow
 *
 * InstagramPostsTotalRow
 */
export const zInstagramPostsTotalRow = z.object({
  caption: z.string().nullish().default("Total geral"),
  comments: z.int().nullish().default(0),
  date: z.string().nullish().default(""),
  interactionRate: z.union([z.number(), z.int()]).nullish(),
  interactions: z.int().nullish().default(0),
  likes: z.int().nullish().default(0),
  mediaType: z.string().nullish().default(""),
  reach: z.int().nullish().default(0),
  saves: z.int().nullish().default(0),
  shares: z.int().nullish().default(0),
  thumbnail: z.string().nullish().default(""),
  views: z.int().nullish().default(0),
});

/**
 * InstagramPostsResponse
 *
 * InstagramPostsResponse
 */
export const zInstagramPostsResponse = z.object({
  page: z.int(),
  page_size: z.int(),
  results: z.array(zInstagramPostItem),
  total: z.int(),
  total_pages: z.int(),
  total_row: zInstagramPostsTotalRow,
});

/**
 * InstagramProfileMetricsResponse
 *
 * InstagramProfileMetricsResponse
 */
export const zInstagramProfileMetricsResponse = z.object({
  has_data: z.boolean(),
  profile_links_taps: z.int().gte(0),
  profile_views: z.int().gte(0),
  website_clicks: z.int().gte(0),
});

/**
 * InstagramStoryItem
 *
 * InstagramStoryItem
 */
export const zInstagramStoryItem = z.object({
  date: z.string(),
  exits: z.int().gte(0),
  impressions: z.int().gte(0),
  reach: z.int().gte(0),
  replies: z.int().gte(0),
  retention_rate: z.union([z.number(), z.int()]),
  story_id: z.string(),
  taps_back: z.int().gte(0),
  taps_forward: z.int().gte(0),
});

/**
 * InstagramStoriesResponse
 *
 * InstagramStoriesResponse
 */
export const zInstagramStoriesResponse = z.object({
  page: z.int().gte(1),
  page_size: z.int().gte(1),
  results: z.array(zInstagramStoryItem),
  total: z.int().gte(0),
  total_pages: z.int().gte(0),
  total_row: zInstagramStoryItem,
});

/**
 * InstagramTimeseriesCompletePoint
 *
 * InstagramTimeseriesCompletePoint
 */
export const zInstagramTimeseriesCompletePoint = z.object({
  alcance: z.number(),
  data: z.string(),
  date: z.string(),
  impressoes: z.number(),
  label: z.string(),
  novosSeguidores: z.number(),
  visitasPerfil: z.number(),
});

/**
 * InstagramTimeseriesCompleteResponse
 *
 * InstagramTimeseriesCompleteResponse
 */
export const zInstagramTimeseriesCompleteResponse = z.object({
  daily_data: z.array(zInstagramTimeseriesCompletePoint),
  end_date: z.string(),
  has_data: z.boolean(),
  start_date: z.string(),
  total_days: z.int().gte(0),
});

/**
 * InstagramAccountWarning
 *
 * InstagramAccountWarning
 */
export const zInstagramAccountWarning = z.object({
  details: z.string().nullish(),
  message: z.string(),
  type: z.string(),
});

/**
 * InstagramDatePeriod
 *
 * InstagramDatePeriod
 */
export const zInstagramDatePeriod = z.object({
  end_date: z.string(),
  start_date: z.string(),
});

/**
 * InstagramRawValues
 *
 * InstagramRawValues
 */
export const zInstagramRawValues = z.object({
  current: z.union([z.number(), z.int()]),
  previous: z.union([z.number(), z.int()]),
});

/**
 * InstagramCardSupportingValues
 *
 * InstagramCardSupportingValues
 */
export const zInstagramCardSupportingValues = z.object({
  interactions: z.int().gte(0),
  reach: z.int().gte(0),
});

/**
 * InstagramCardSupporting
 *
 * InstagramCardSupporting
 */
export const zInstagramCardSupporting = z.object({
  current: zInstagramCardSupportingValues,
  previous: zInstagramCardSupportingValues,
});

/**
 * InstagramCardMetricResponse
 *
 * InstagramCardMetricResponse
 */
export const zInstagramCardMetricResponse = z.object({
  account_id: z.string().nullish(),
  account_warning: zInstagramAccountWarning.nullish(),
  change: z.union([z.number(), z.int()]),
  current_period: zInstagramDatePeriod,
  customer_uuid: z.string(),
  has_data: z.boolean(),
  label: z.string(),
  metric: z.string(),
  previous_period: zInstagramDatePeriod,
  previous_value: z.union([z.number(), z.int()]),
  raw_values: zInstagramRawValues,
  supporting: zInstagramCardSupporting.nullish(),
  trend: z.string(),
  value: z.union([z.number(), z.int()]),
});

/**
 * InstagramAgeDemographicItem
 *
 * InstagramAgeDemographicItem
 */
export const zInstagramAgeDemographicItem = z.object({
  age_range: z.string(),
  color: z.string(),
  count: z.int().gte(0),
  item_type: z.string().nullish().default("age"),
  percentage: z.union([z.number(), z.int()]),
});

/**
 * InstagramDemographicDimensionResponseInstagramAgeDemographicItem
 *
 * InstagramDemographicDimensionResponseInstagramAgeDemographicItem
 */
export const zInstagramDemographicDimensionResponseInstagramAgeDemographicItem =
  z.object({
    account_id: z.string().nullish(),
    customer_uuid: z.string(),
    end_date: z.string(),
    has_data: z.boolean(),
    items: z.array(zInstagramAgeDemographicItem),
    metric: z.string(),
    start_date: z.string(),
    total: z.int().gte(0),
    snapshot_at: z.iso.datetime().nullish(),
  });

/**
 * InstagramCityDemographicItem
 *
 * InstagramCityDemographicItem
 */
export const zInstagramCityDemographicItem = z.object({
  city: z.string(),
  count: z.int().gte(0),
  item_type: z.string().nullish().default("city"),
});

/**
 * InstagramDemographicDimensionResponseInstagramCityDemographicItem
 *
 * InstagramDemographicDimensionResponseInstagramCityDemographicItem
 */
export const zInstagramDemographicDimensionResponseInstagramCityDemographicItem =
  z.object({
    account_id: z.string().nullish(),
    customer_uuid: z.string(),
    end_date: z.string(),
    has_data: z.boolean(),
    items: z.array(zInstagramCityDemographicItem),
    metric: z.string(),
    start_date: z.string(),
    total: z.int().gte(0),
    snapshot_at: z.iso.datetime().nullish(),
  });

/**
 * InstagramGenderDemographicItem
 *
 * InstagramGenderDemographicItem
 */
export const zInstagramGenderDemographicItem = z.object({
  color: z.string(),
  count: z.int().gte(0),
  gender: z.string(),
  item_type: z.string().nullish().default("gender"),
  percentage: z.union([z.number(), z.int()]),
});

/**
 * InstagramDemographicDimensionResponseInstagramGenderDemographicItem
 *
 * InstagramDemographicDimensionResponseInstagramGenderDemographicItem
 */
export const zInstagramDemographicDimensionResponseInstagramGenderDemographicItem =
  z.object({
    account_id: z.string().nullish(),
    customer_uuid: z.string(),
    end_date: z.string(),
    has_data: z.boolean(),
    items: z.array(zInstagramGenderDemographicItem),
    metric: z.string(),
    start_date: z.string(),
    total: z.int().gte(0),
    snapshot_at: z.iso.datetime().nullish(),
  });

/**
 * InstagramTimeseriesPoint
 *
 * InstagramTimeseriesPoint
 */
export const zInstagramTimeseriesPoint = z.object({
  date: z.string(),
  label: z.string(),
  value: z.union([z.number(), z.int()]),
});

/**
 * InstagramTimeseriesMetricResponse
 *
 * InstagramTimeseriesMetricResponse
 */
export const zInstagramTimeseriesMetricResponse = z.object({
  account_id: z.string().nullish(),
  customer_uuid: z.string(),
  end_date: z.string(),
  has_data: z.boolean(),
  label: z.string(),
  metric: z.string(),
  points: z.array(zInstagramTimeseriesPoint),
  start_date: z.string(),
  total_points: z.int().gte(0),
});

/**
 * InstagramAccount
 */
export const zInstagramAccount = z.object({
  account_id: z.string(),
  account_type: z.string().nullish(),
  biography: z.string().nullish(),
  created_at: z.iso.datetime(),
  external_account_id: z.string(),
  followers_count: z.int().nullish(),
  follows_count: z.int().nullish(),
  id: z.uuid(),
  integration_id: z.int(),
  is_active: z.boolean(),
  last_sync_at: z.iso.datetime().nullish(),
  media_count: z.int().nullish(),
  name: z.string().nullish(),
  profile_picture_url: z.string().nullish(),
  source: z.string(),
  updated_at: z.iso.datetime().nullish(),
  username: z.string().nullish(),
  website: z.string().nullish(),
});

/**
 * InstagramAudienceInsights
 */
export const zInstagramAudienceInsights = z.object({
  account_id: z.uuid(),
  age_range: z.string().nullish(),
  city: z.string().nullish(),
  country: z.string().nullish(),
  date: z.iso.date(),
  follower_count: z.int().nullish(),
  follower_percentage: z.number().nullish(),
  gender: z.string().nullish(),
  id: z.uuid(),
  online_days: z.string().nullish(),
  online_hours: z.string().nullish(),
});

/**
 * InstagramAuthUrlResponse
 */
export const zInstagramAuthUrlResponse = z.object({
  auth_url: z.string(),
  state: z.string(),
});

/**
 * InstagramCallbackResponse
 */
export const zInstagramCallbackResponse = z.object({
  message: z.string().nullish(),
  success: z.boolean(),
});

/**
 * InstagramClearDataResponse
 */
export const zInstagramClearDataResponse = z.object({
  deleted_records: z.int(),
  message: z.string(),
  success: z.boolean(),
});

/**
 * InstagramDailyMetrics
 */
export const zInstagramDailyMetrics = z.object({
  account_id: z.uuid(),
  date: z.iso.date(),
  email_contacts: z.int().nullish(),
  followers_count: z.int().nullish(),
  following_count: z.int().nullish(),
  get_directions_clicks: z.int().nullish(),
  id: z.uuid(),
  impressions: z.int().nullish(),
  media_count: z.int().nullish(),
  phone_call_clicks: z.int().nullish(),
  profile_visits: z.int().nullish(),
  reach: z.int().nullish(),
  text_message_clicks: z.int().nullish(),
  website_clicks: z.int().nullish(),
});

/**
 * InstagramHashtagMetrics
 */
export const zInstagramHashtagMetrics = z.object({
  account_id: z.uuid(),
  avg_comments: z.int().nullish(),
  avg_engagement_rate: z.number().nullish(),
  avg_likes: z.int().nullish(),
  date: z.iso.date(),
  hashtag: z.string(),
  id: z.uuid(),
  post_count: z.int().nullish(),
  total_engagement: z.int().nullish(),
  total_impressions: z.int().nullish(),
  total_reach: z.int().nullish(),
});

/**
 * InstagramPostMetrics
 */
export const zInstagramPostMetrics = z.object({
  account_id: z.uuid(),
  caption: z.string().nullish(),
  comments: z.int().nullish(),
  date: z.iso.date(),
  engagement_rate: z.number().nullish(),
  hashtags: z.string().nullish(),
  id: z.uuid(),
  impressions: z.int().nullish(),
  likes: z.int().nullish(),
  media_id: z.string(),
  media_type: z.string().nullish(),
  mentions: z.string().nullish(),
  permalink: z.string().nullish(),
  reach: z.int().nullish(),
  saves: z.int().nullish(),
  shares: z.int().nullish(),
  video_play_time: z.int().nullish(),
  video_views: z.int().nullish(),
});

/**
 * InstagramReelMetrics
 */
export const zInstagramReelMetrics = z.object({
  account_id: z.uuid(),
  caption: z.string().nullish(),
  comments: z.int().nullish(),
  date: z.iso.date(),
  duration: z.int().nullish(),
  follows: z.int().nullish(),
  hashtags: z.string().nullish(),
  id: z.uuid(),
  impressions: z.int().nullish(),
  likes: z.int().nullish(),
  media_id: z.string(),
  plays: z.int().nullish(),
  profile_visits: z.int().nullish(),
  reach: z.int().nullish(),
  reel_100_percent_views: z.int().nullish(),
  reel_25_percent_views: z.int().nullish(),
  reel_50_percent_views: z.int().nullish(),
  reel_75_percent_views: z.int().nullish(),
  saves: z.int().nullish(),
  shares: z.int().nullish(),
});

/**
 * InstagramStoryMetrics
 */
export const zInstagramStoryMetrics = z.object({
  account_id: z.uuid(),
  back_navigations: z.int().nullish(),
  date: z.iso.date(),
  duration: z.int().nullish(),
  exits: z.int().nullish(),
  forwards: z.int().nullish(),
  id: z.uuid(),
  impressions: z.int().nullish(),
  media_id: z.string(),
  reach: z.int().nullish(),
  replies: z.int().nullish(),
  shares: z.int().nullish(),
  story_type: z.string().nullish(),
  website_clicks: z.int().nullish(),
});

/**
 * InstagramCompleteResponse
 *
 * Resposta completa com todos os dados do Instagram
 */
export const zInstagramCompleteResponse = z.object({
  audience_insights: z.array(zInstagramAudienceInsights),
  daily_metrics: z.array(zInstagramDailyMetrics),
  end_date: z.iso.date(),
  hashtag_metrics: z.array(zInstagramHashtagMetrics),
  posts: z.array(zInstagramPostMetrics),
  reels: z.array(zInstagramReelMetrics),
  start_date: z.iso.date(),
  stories: z.array(zInstagramStoryMetrics),
  total_records: z.int(),
});

/**
 * InstagramConnectionStatus
 *
 * Status da conexão Instagram
 */
export const zInstagramConnectionStatus = z.object({
  account_id: z.string().nullish(),
  account_name: z.string().nullish(),
  error_message: z.string().nullish(),
  is_connected: z.boolean(),
  last_sync: z.iso.datetime().nullish(),
});

/**
 * InstagramEngagementTrend
 */
export const zInstagramEngagementTrend = z.object({
  avg_comments: z.int(),
  avg_engagement_rate: z.number(),
  avg_likes: z.int(),
  period: z.string(),
  post_count: z.int(),
});

/**
 * InstagramPerformanceInsights
 *
 * Insights calculados de performance Instagram
 */
export const zInstagramPerformanceInsights = z.object({
  avg_engagement_rate: z.number(),
  avg_hashtag_reach: z.number(),
  avg_reel_completion_rate: z.number().nullable(),
  avg_story_completion_rate: z.number(),
  best_performing_post: z.string().nullish(),
  best_posting_day: z.string(),
  best_posting_time: z.string(),
  engagement_growth_rate: z.number(),
  engagement_trend: z.string(),
  follower_growth_rate: z.number(),
  follower_trend: z.string(),
  followers_count: z.int(),
  following_count: z.int(),
  hashtag_engagement_rate: z.number(),
  most_engaging_story: z.string().nullish(),
  reach_growth_rate: z.number(),
  reach_trend: z.string(),
  reel_discovery_rate: z.number().nullable(),
  story_engagement_rate: z.number(),
  top_age_group: z.string(),
  top_city: z.string(),
  top_country: z.string(),
  top_gender: z.string(),
  top_hashtags: z.array(z.string()),
  top_post_type: z.string(),
  top_reel: z.string().nullish(),
  total_comments: z.int(),
  total_likes: z.int(),
  total_posts: z.int(),
  total_saves: z.int(),
  total_shares: z.int(),
});

/**
 * InstagramSummaryDateRange
 */
export const zInstagramSummaryDateRange = z.object({
  end: z.iso.date().nullish(),
  start: z.iso.date().nullish(),
});

/**
 * InstagramSummaryTotals
 */
export const zInstagramSummaryTotals = z.object({
  avg_followers: z.int().optional().default(0),
  total_impressions: z.int().optional().default(0),
  total_profile_visits: z.int().optional().default(0),
  total_reach: z.int().optional().default(0),
});

/**
 * InstagramSummaryResponse
 */
export const zInstagramSummaryResponse = z.object({
  account_id: z.string(),
  date_range: zInstagramSummaryDateRange,
  total_records: z.int(),
  totals: zInstagramSummaryTotals,
});

/**
 * InstagramSyncRequest
 */
export const zInstagramSyncRequest = z.object({
  account_id: z.uuid(),
  end_date: z.iso.date().nullish(),
  force: z.boolean().optional().default(false),
  include_audience: z.boolean().optional().default(true),
  include_hashtags: z.boolean().optional().default(true),
  include_posts: z.boolean().optional().default(true),
  include_reels: z.boolean().optional().default(true),
  include_stories: z.boolean().optional().default(true),
  start_date: z.iso.date().nullish(),
});

/**
 * InstagramSyncResponse
 */
export const zInstagramSyncResponse = z.object({
  audience_synced: z.int().nullish(),
  daily_metrics_synced: z.int().nullish(),
  end_date: z.iso.date(),
  hashtags_synced: z.int().nullish(),
  message: z.string(),
  posts_synced: z.int().nullish(),
  reels_synced: z.int().nullish(),
  start_date: z.iso.date(),
  stories_synced: z.int().nullish(),
  success: z.boolean(),
  synced_records: z.int(),
});

/**
 * InstagramTopPost
 */
export const zInstagramTopPost = z.object({
  caption: z.string().nullish(),
  comments: z.int().nullish(),
  date: z.iso.date(),
  engagement_rate: z.number().nullish(),
  impressions: z.int().nullish(),
  likes: z.int().nullish(),
  media_id: z.string(),
  media_type: z.string().nullish(),
  reach: z.int().nullish(),
  saves: z.int().nullish(),
  shares: z.int().nullish(),
});

/**
 * SearchConsoleAccount
 */
export const zSearchConsoleAccount = z.object({
  created_at: z.iso.datetime(),
  external_account_id: z.string(),
  id: z.uuid(),
  integration_id: z.int(),
  is_active: z.boolean(),
  last_sync_at: z.iso.datetime().nullish(),
  name: z.string().nullish(),
  site_url: z.string().nullish(),
  source: z.string(),
  updated_at: z.iso.datetime().nullish(),
});

/**
 * SearchConsoleAuthUrlResponse
 */
export const zSearchConsoleAuthUrlResponse = z.object({
  auth_url: z.string(),
  state: z.string(),
});

/**
 * SearchConsoleCallbackResponse
 */
export const zSearchConsoleCallbackResponse = z.object({
  message: z.string().nullish(),
  success: z.boolean(),
});

/**
 * SearchConsoleClearDataResponse
 */
export const zSearchConsoleClearDataResponse = z.object({
  deleted_records: z.int(),
  message: z.string(),
  success: z.boolean(),
});

/**
 * SearchConsoleCoreWebVitals
 */
export const zSearchConsoleCoreWebVitals = z.object({
  account_id: z.uuid(),
  origin: z.string(),
  metric: z.enum(["LCP", "INP", "CLS"]),
  p75: z.number(),
  status: z.enum(["good", "needs_improvement", "poor"]),
  good_share: z.number(),
  needs_improvement_share: z.number(),
  poor_share: z.number(),
  first_date: z.iso.date().nullable(),
  last_date: z.iso.date().nullable(),
});

/**
 * SearchConsoleMetrics
 */
export const zSearchConsoleMetrics = z.object({
  account_id: z.uuid(),
  clicks: z.int().nullish(),
  country: z.string().nullish(),
  ctr: z.number().nullish(),
  date: z.iso.date(),
  device: z.string().nullish(),
  id: z.uuid(),
  impressions: z.int().nullish(),
  page: z.string().nullish(),
  position: z.number().nullish(),
  query: z.string().nullish(),
  site_url: z.string().nullish(),
});

/**
 * SearchConsoleIndexCoverage
 */
export const zSearchConsoleIndexCoverage = z.object({
  account_id: z.uuid(),
  id: z.uuid(),
  site_url: z.string(),
  date: z.iso.date(),
  page_url: z.string(),
  impressions: z.int(),
  verdict: z.string(),
  coverage_state: z.string().nullable(),
  indexing_state: z.string().nullable(),
  robots_txt_state: z.string().nullable(),
  page_fetch_state: z.string().nullable(),
  last_crawl_time: z.iso.datetime().nullable(),
  google_canonical: z.string().nullable(),
  user_canonical: z.string().nullable(),
});

/**
 * SearchConsoleRichResults
 */
export const zSearchConsoleRichResults = z.object({
  account_id: z.uuid(),
  id: z.uuid(),
  site_url: z.string(),
  date: z.iso.date(),
  page_url: z.string(),
  feature_type: z.string(),
  status: z.enum(["PASS", "FAIL"]),
  valid_items: z.int(),
  warning_items: z.int(),
  error_items: z.int(),
});

/**
 * SearchConsoleCompleteResponse
 *
 * Resposta completa com todos os dados do Search Console
 */
export const zSearchConsoleCompleteResponse = z.object({
  core_web_vitals: z.array(zSearchConsoleCoreWebVitals),
  daily_metrics: z.array(zSearchConsoleMetrics),
  end_date: z.iso.date(),
  index_coverage: z.array(zSearchConsoleIndexCoverage),
  rich_results: z.array(zSearchConsoleRichResults),
  start_date: z.iso.date(),
  total_records: z.int(),
});

/**
 * SearchConsoleConnectionStatus
 */
export const zSearchConsoleConnectionStatus = z.object({
  error_message: z.string().nullish(),
  is_connected: z.boolean(),
  last_sync: z.iso.datetime().nullish(),
  site_url: z.string().nullish(),
});

/**
 * SearchConsolePerformanceInsights
 *
 * Insights calculados de performance SEO
 */
export const zSearchConsolePerformanceInsights = z.object({
  average_ctr: z.number(),
  average_position: z.number(),
  clicks_trend: z.string(),
  coverage_rate: z.number(),
  ctr_trend: z.string(),
  cwv_overall_score: z.string(),
  desktop_impressions: z.int(),
  error_pages: z.int(),
  excluded_pages: z.int(),
  impressions_trend: z.string(),
  indexed_pages: z.int(),
  mobile_impressions: z.int(),
  position_trend: z.string(),
  rich_results_total: z.int(),
  rich_results_types: z.array(z.string()),
  structured_data_coverage: z.number(),
  tablet_impressions: z.int(),
  top_countries: z.array(z.string()),
  top_pages: z.array(z.string()),
  top_queries: z.array(z.string()),
  total_clicks: z.int(),
  total_impressions: z.int(),
});

/**
 * SearchConsoleTotals
 */
export const zSearchConsoleTotals = z.object({
  avg_ctr: z.number().optional().default(0),
  avg_position: z.number().optional().default(0),
  clicks: z.int().optional().default(0),
  impressions: z.int().optional().default(0),
});

/**
 * SearchConsoleSummaryResponse
 */
export const zSearchConsoleSummaryResponse = z.object({
  account_id: z.uuid(),
  date_range: zDateRange,
  total_records: z.int(),
  totals: zSearchConsoleTotals,
});

/**
 * SearchConsoleSyncRequest
 */
export const zSearchConsoleSyncRequest = z.object({
  account_id: z.uuid(),
  end_date: z.iso.date().nullish(),
  force: z.boolean().optional().default(false),
  include_core_web_vitals: z.boolean().optional().default(true),
  include_index_coverage: z.boolean().optional().default(true),
  include_rich_results: z.boolean().optional().default(true),
  start_date: z.iso.date().nullish(),
});

/**
 * SearchConsoleSyncResponse
 */
export const zSearchConsoleSyncResponse = z.object({
  core_web_vitals_synced: z.int().nullish(),
  end_date: z.iso.date(),
  index_coverage_synced: z.int().nullish(),
  message: z.string(),
  metrics_synced: z.int().nullish(),
  rich_results_synced: z.int().nullish(),
  start_date: z.iso.date(),
  success: z.boolean(),
  synced_records: z.int(),
});

/**
 * SearchConsoleTopPage
 */
export const zSearchConsoleTopPage = z.object({
  avg_ctr: z.number(),
  avg_position: z.number(),
  page: z.string().nullish(),
  total_clicks: z.int(),
  total_impressions: z.int(),
});

/**
 * SearchConsoleTopQuery
 */
export const zSearchConsoleTopQuery = z.object({
  avg_ctr: z.number(),
  avg_position: z.number(),
  query: z.string().nullish(),
  total_clicks: z.int(),
  total_impressions: z.int(),
});

/**
 * SEOClicksPositionCard
 */
export const zSeoClicksPositionCard = z.object({
  average_position: z.union([z.number(), z.int(), z.string()]).nullish(),
  average_position_change_percentage: z.union([z.number(), z.int()]),
  average_position_data_type: z.string(),
  average_position_trend_indicator: z.string(),
  clicks: z.union([z.number(), z.int(), z.string()]).nullish(),
  clicks_change_percentage: z.union([z.number(), z.int()]),
  clicks_data_type: z.string(),
  clicks_trend_indicator: z.string(),
});

/**
 * SEOClicksPositionChartData
 *
 * SEOClicksPositionChartData
 */
export const zSeoClicksPositionChartData = z.object({
  clicks: z.int(),
  clicks_change_percentage: z.union([z.number(), z.int()]),
  clicks_trend_indicator: z.string(),
  data: z.string(),
  posicaoMedia: z.union([z.number(), z.int()]),
  posicaoMedia_change_percentage: z.union([z.number(), z.int()]),
  posicaoMedia_trend_indicator: z.string(),
});

/**
 * SEOChannelItem
 */
export const zSeoChannelItem = z.object({
  grupoCanal: z.string(),
  pedidos: z.union([z.number(), z.int(), z.string()]).nullish(),
  pedidosChange: z.union([z.number(), z.int()]),
  pedidos_data_type: z.string(),
  pedidos_trend_indicator: z.string(),
  receitaTotal: z.union([z.number(), z.int(), z.string()]).nullish(),
  receitaTotalChange: z.union([z.number(), z.int()]),
  receitaTotal_data_type: z.string(),
  receitaTotal_trend_indicator: z.string(),
  sessoes: z.union([z.number(), z.int(), z.string()]).nullish(),
  sessoes_data_type: z.string(),
  sessoes_trend_indicator: z.string(),
  ticketMedio: z.union([z.number(), z.int(), z.string()]).nullish(),
  ticketMedioChange: z.union([z.number(), z.int()]),
  ticketMedio_data_type: z.string(),
  ticketMedio_trend_indicator: z.string(),
  txConversao: z.union([z.number(), z.int(), z.string()]).nullish(),
  txConversao_data_type: z.string(),
  txConversao_trend_indicator: z.string(),
});

/**
 * SEOChannelTable
 */
export const zSeoChannelTable = z.object({
  data: z.array(zSeoChannelItem),
  pagination: z.record(z.string(), z.int()),
});

/**
 * SEODeviceChartItem
 *
 * SEODeviceChartItem
 */
export const zSeoDeviceChartItem = z.object({
  data_type: z.string().nullish(),
  fill: z.string(),
  name: z.string(),
  trend_indicator: z.string().nullish(),
  value: z.union([z.number(), z.int()]),
});

/**
 * SEODeviceTableItem
 */
export const zSeoDeviceTableItem = z.object({
  categoria: z.string(),
  categoria_data_type: z.string().nullish().default("TEXT"),
  clicks: z.union([z.number(), z.int(), z.string()]).nullish(),
  clicks_change_percentage: z.union([z.number(), z.int()]).nullish(),
  clicks_data_type: z.string().nullish(),
  clicks_trend_indicator: z.string().nullish(),
  impressoes: z.union([z.number(), z.int(), z.string()]).nullish(),
  impressoes_change_percentage: z.union([z.number(), z.int()]).nullish(),
  impressoes_data_type: z.string().nullish(),
  impressoes_trend_indicator: z.string().nullish(),
  posicaoMedia: z.union([z.number(), z.int(), z.string()]).nullish(),
  posicaoMedia_change_percentage: z.union([z.number(), z.int()]).nullish(),
  posicaoMedia_data_type: z.string().nullish(),
  posicaoMedia_trend_indicator: z.string().nullish(),
  siteCTR: z.union([z.number(), z.int(), z.string()]).nullish(),
  siteCTR_change_percentage: z.union([z.number(), z.int()]).nullish(),
  siteCTR_data_type: z.string().nullish(),
  siteCTR_trend_indicator: z.string().nullish(),
});

/**
 * SEODeviceTable
 */
export const zSeoDeviceTable = z.object({
  data: z.array(zSeoDeviceTableItem),
  pagination: z.record(z.string(), z.int()),
});

/**
 * SEOImpressionsCTRChartData
 *
 * SEOImpressionsCTRChartData
 */
export const zSeoImpressionsCtrChartData = z.object({
  ctr: z.union([z.number(), z.int()]),
  ctr_change_percentage: z.union([z.number(), z.int()]),
  ctr_trend_indicator: z.string(),
  data: z.string(),
  impressions: z.int(),
  impressions_change_percentage: z.union([z.number(), z.int()]),
  impressions_trend_indicator: z.string(),
});

/**
 * SEOMetricBase
 */
export const zSeoMetricBase = z.object({
  change_percentage: z.union([z.number(), z.int()]),
  data_type: z.string(),
  trend_indicator: z.string(),
  valor: z.union([z.number(), z.int(), z.string()]).nullish(),
});

/**
 * SEOKeywordItem
 *
 * SEOKeywordItem
 */
export const zSeoKeywordItem = z.object({
  clicks: z.int(),
  clicks_change_percentage: z.union([z.number(), z.int()]),
  clicks_data_type: z.string(),
  clicks_trend_indicator: z.string(),
  impressoes: z.int(),
  impressoes_change_percentage: z.union([z.number(), z.int()]),
  impressoes_data_type: z.string(),
  impressoes_trend_indicator: z.string(),
  posicaoMedia: z.union([z.number(), z.int()]),
  posicaoMedia_change_percentage: z.union([z.number(), z.int()]),
  posicaoMedia_data_type: z.string(),
  posicaoMedia_trend_indicator: z.string(),
  query: z.string(),
  siteCTR: z.union([z.number(), z.int()]),
  siteCTR_change_percentage: z.union([z.number(), z.int()]),
  siteCTR_data_type: z.string(),
  siteCTR_trend_indicator: z.string(),
});

/**
 * SEOKeywordTable
 *
 * SEOKeywordTable
 */
export const zSeoKeywordTable = z.object({
  data: z.array(zSeoKeywordItem),
  pagination: z.record(z.string(), z.int()),
  total_row: zSeoKeywordItem.nullish(),
});

/**
 * SEOOrganicMetric
 */
export const zSeoOrganicMetric = z.object({
  change_percentage: z.union([z.number(), z.int()]),
  data_type: z.string(),
  pedidos_totais: z.union([z.int(), z.string()]).nullish(),
  pedidos_totais_change_percentage: z.union([z.number(), z.int()]),
  representatividade: z.union([z.number(), z.int()]),
  representatividade_change_percentage: z.union([z.number(), z.int()]),
  sessoes_totais: z.union([z.int(), z.string()]).nullish(),
  sessoes_totais_change_percentage: z.union([z.number(), z.int()]),
  trend_indicator: z.string(),
  valor: z.union([z.number(), z.int(), z.string()]).nullish(),
});

/**
 * SEOSessionsChartData
 *
 * SEOSessionsChartData
 */
export const zSeoSessionsChartData = z.object({
  data: z.string(),
  sessoes: z.int(),
  sessoesOrganicas: z.int(),
});

/**
 * SEOSessionsOrganicCard
 */
export const zSeoSessionsOrganicCard = z.object({
  organic_sessions: z.union([z.number(), z.int(), z.string()]).nullish(),
  organic_sessions_change_percentage: z.union([z.number(), z.int()]),
  organic_sessions_data_type: z.string(),
  organic_sessions_trend_indicator: z.string(),
  sessions: z.union([z.number(), z.int(), z.string()]).nullish(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string(),
  sessions_trend_indicator: z.string(),
});

/**
 * SEOTaxaConversaoMetric
 */
export const zSeoTaxaConversaoMetric = z.object({
  change_percentage: z.union([z.number(), z.int()]),
  data_type: z.string(),
  taxa_conversao_geral: z.union([z.number(), z.string()]).nullish(),
  taxa_conversao_geral_change_percentage: z.union([z.number(), z.int()]),
  trend_indicator: z.string(),
  valor: z.union([z.number(), z.int(), z.string()]).nullish(),
});

/**
 * SEOBrandTermsInUse
 */
export const zSeoBrandTermsInUse = z.object({
  terms: z.array(z.string()),
  source: z.enum(["explicit", "configured", "derived", "none"]),
});

/**
 * SEOCardsData
 */
export const zSeoCardsData = z.object({
  clicks_e_posicao_media: zSeoClicksPositionCard,
  clicks_position_chart_data: z.array(zSeoClicksPositionChartData),
  comparacao_canais_table: zSeoChannelTable,
  device_charts: z.record(z.string(), z.array(zSeoDeviceChartItem)),
  device_table: zSeoDeviceTable,
  impressions_ctr_chart_data: z.array(zSeoImpressionsCtrChartData),
  impressoes_marca_search_console: zSeoMetricBase,
  impressoes_search_console: zSeoMetricBase,
  palavras_chaves_table: zSeoKeywordTable,
  pedidos_organicos: zSeoOrganicMetric,
  sessoes_chart_data: z.array(zSeoSessionsChartData),
  sessoes_e_sessoes_organicas: zSeoSessionsOrganicCard,
  sessoes_organicas: zSeoOrganicMetric,
  taxa_conversao_organica: zSeoTaxaConversaoMetric,
  total_clicks_marca_search_console: zSeoMetricBase,
  total_clicks_search_console: zSeoMetricBase,
  palavras_chaves_marca_table: zSeoKeywordTable,
  termos_de_marca: zSeoBrandTermsInUse,
});

/**
 * SEOCardsResponse
 */
export const zSeoCardsResponse = z.object({
  comparison_period: z.record(z.string(), z.string()),
  data: zSeoCardsData,
});

/**
 * SEODevicesResponse
 */
export const zSeoDevicesResponse = z.object({
  charts: z.record(z.string(), z.array(zSeoDeviceChartItem)),
  comparison_period: z.record(z.string(), z.string()),
  table: zSeoDeviceTable,
});

/**
 * SEOBrandTermsResponse
 */
export const zSeoBrandTermsResponse = z.object({
  terms: z.array(z.string()),
  in_use: zSeoBrandTermsInUse,
});

/**
 * AnalyticsOverviewChanges
 *
 * AnalyticsOverviewChanges
 */
export const zAnalyticsOverviewChanges = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  conversion_rate: z.union([z.number(), z.int()]),
  investment: z.union([z.number(), z.int()]),
  marketing_percentage: z.union([z.number(), z.int()]),
  revenue: z.union([z.number(), z.int()]),
  roas: z.union([z.number(), z.int()]),
  sessions: z.union([z.number(), z.int()]),
  transactions: z.union([z.number(), z.int()]),
});

/**
 * AnalyticsOverviewResponse
 *
 * AnalyticsOverviewResponse
 */
export const zAnalyticsOverviewResponse = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  avg_purchase_revenue: z.union([z.number(), z.int()]),
  changes: zAnalyticsOverviewChanges,
  checkouts: z.int(),
  conversion_rate: z.union([z.number(), z.int()]),
  currency_symbol: z.string(),
  ecommerce_purchases: z.int(),
  first_time_purchasers: z.int(),
  investment_projection: z.union([z.number(), z.int()]),
  marketing_percentage: z.union([z.number(), z.int()]),
  orders: z.int(),
  percentage_symbol: z.string(),
  purchase_revenue: z.union([z.number(), z.int()]),
  revenue_projection: z.union([z.number(), z.int()]),
  roas: z.union([z.number(), z.int()]),
  sessions: z.int(),
  total_investment: z.union([z.number(), z.int()]),
  total_purchasers: z.int(),
  total_revenue: z.union([z.number(), z.int()]),
  total_sessions: z.int(),
  total_transactions: z.int(),
});

/**
 * ChannelAnalysisDailyRow
 *
 * ChannelAnalysisDailyRow
 */
export const zChannelAnalysisDailyRow = z.object({
  conversion_rate: z.union([z.number(), z.int()]),
  cps: z.union([z.number(), z.int()]).nullish(),
  date: z.string(),
  date_label: z.string(),
  investment: z.union([z.number(), z.int()]).nullish(),
  orders: z.int(),
  revenue: z.union([z.number(), z.int()]),
  revenue_percent: z.union([z.number(), z.int()]),
  roas: z.union([z.number(), z.int()]).nullish(),
  sessions: z.int(),
  sessions_percent: z.union([z.number(), z.int()]),
});

/**
 * ChannelAnalysisTotals
 *
 * ChannelAnalysisTotals
 */
export const zChannelAnalysisTotals = z.object({
  conversion_rate: z.union([z.number(), z.int()]),
  cps: z.union([z.number(), z.int()]).nullish(),
  investment: z.union([z.number(), z.int()]).nullish(),
  orders: z.int(),
  revenue: z.union([z.number(), z.int()]),
  revenue_percent: z.union([z.number(), z.int()]).nullish(),
  roas: z.union([z.number(), z.int()]).nullish(),
  sessions: z.int(),
  sessions_percent: z.union([z.number(), z.int()]).nullish(),
});

/**
 * ChannelDailyAnalysisChannel
 *
 * ChannelDailyAnalysisChannel
 */
export const zChannelDailyAnalysisChannel = z.object({
  daily_data: z.array(zChannelAnalysisDailyRow),
  description: z.string(),
  has_investment: z.boolean(),
  key: z.string(),
  name: z.string(),
  totals: zChannelAnalysisTotals,
});

/**
 * ChannelAnalysisDateRange
 *
 * ChannelAnalysisDateRange
 */
export const zChannelAnalysisDateRange = z.object({
  end_date: z.string(),
  start_date: z.string(),
});

/**
 * ChannelDailyAnalysisResponse
 *
 * ChannelDailyAnalysisResponse
 */
export const zChannelDailyAnalysisResponse = z.object({
  channels: z.array(zChannelDailyAnalysisChannel),
  date_range: zChannelAnalysisDateRange,
});

/**
 * ComparisonPeriod
 *
 * ComparisonPeriod
 */
export const zComparisonPeriod = z.object({
  end_date: z.iso.date(),
  label: z.string(),
  start_date: z.iso.date(),
});

/**
 * DataType
 *
 * DataType
 */
export const zDataType = z.enum([
  "NUMBER",
  "PERCENT",
  "CURRENCY",
  "DURATION",
  "TEXT",
]);

/**
 * TrendIndicator
 *
 * TrendIndicator
 */
export const zTrendIndicator = z.enum(["up", "down", "neutral"]);

/**
 * ChannelGroupingCardItem
 *
 * ChannelGroupingCardItem
 */
export const zChannelGroupingCardItem = z.object({
  avg_order_value: z.union([z.number(), z.int()]),
  avg_order_value_change_percentage: z.union([z.number(), z.int()]),
  avg_order_value_data_type: zDataType.nullish(),
  avg_order_value_trend_indicator: zTrendIndicator,
  channel_group: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: zDataType.nullish(),
  conversion_rate_trend_indicator: zTrendIndicator,
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]),
  revenue_data_type: zDataType.nullish(),
  revenue_trend_indicator: zTrendIndicator,
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: zDataType.nullish(),
  sessions_trend_indicator: zTrendIndicator,
  transactions: z.int(),
  transactions_change_percentage: z.union([z.number(), z.int()]),
  transactions_data_type: zDataType.nullish(),
  transactions_trend_indicator: zTrendIndicator,
  users: z.int(),
  users_change_percentage: z.union([z.number(), z.int()]),
  users_data_type: zDataType.nullish(),
  users_trend_indicator: zTrendIndicator,
});

/**
 * ChannelGroupingCardTotals
 *
 * ChannelGroupingCardTotals
 */
export const zChannelGroupingCardTotals = z.object({
  total_avg_order_value: z.union([z.number(), z.int()]),
  total_avg_order_value_change: z.union([z.number(), z.int()]),
  total_conversion_rate: z.union([z.number(), z.int()]),
  total_conversion_rate_change: z.union([z.number(), z.int()]),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change: z.union([z.number(), z.int()]),
  total_revenue_trend: zTrendIndicator,
  total_sessions: z.int(),
  total_sessions_change: z.union([z.number(), z.int()]),
  total_sessions_trend: zTrendIndicator,
  total_transactions: z.int(),
  total_transactions_change: z.union([z.number(), z.int()]),
  total_transactions_trend: zTrendIndicator,
  total_users: z.int(),
  total_users_change: z.union([z.number(), z.int()]),
  total_users_trend: zTrendIndicator,
});

/**
 * ChannelGroupingCardResponse
 *
 * ChannelGroupingCardResponse
 */
export const zChannelGroupingCardResponse = z.object({
  comparison_period: zComparisonPeriod,
  currency_symbol: z.string().nullish().default("R$"),
  data: z.array(zChannelGroupingCardItem),
  percentage_symbol: z.string().nullish().default("%"),
  summary: zChannelGroupingCardTotals,
});

/**
 * ChannelAnalysisMonthlyRow
 *
 * ChannelAnalysisMonthlyRow
 */
export const zChannelAnalysisMonthlyRow = z.object({
  conversion_rate: z.union([z.number(), z.int()]),
  cps: z.union([z.number(), z.int()]).nullish(),
  investment: z.union([z.number(), z.int()]).nullish(),
  month_key: z.string(),
  month_label: z.string(),
  orders: z.int(),
  revenue: z.union([z.number(), z.int()]),
  revenue_percent: z.union([z.number(), z.int()]).nullish(),
  roas: z.union([z.number(), z.int()]).nullish(),
  sessions: z.int(),
  sessions_percent: z.union([z.number(), z.int()]).nullish(),
});

/**
 * ChannelMonthlyAnalysisChannel
 *
 * ChannelMonthlyAnalysisChannel
 */
export const zChannelMonthlyAnalysisChannel = z.object({
  description: z.string(),
  has_investment: z.boolean(),
  key: z.string(),
  monthly_data: z.array(zChannelAnalysisMonthlyRow),
  name: z.string(),
  totals: zChannelAnalysisTotals,
});

/**
 * ChannelMonthlyAnalysisResponse
 *
 * ChannelMonthlyAnalysisResponse
 */
export const zChannelMonthlyAnalysisResponse = z.object({
  channels: z.array(zChannelMonthlyAnalysisChannel),
});

/**
 * SourceAnalysisCardMetrics
 *
 * SourceAnalysisCardMetrics
 */
export const zSourceAnalysisCardMetrics = z.object({
  avg_order_value: z.union([z.number(), z.int()]),
  avg_order_value_change_percentage: z.union([z.number(), z.int()]),
  avg_order_value_data_type: z.string(),
  avg_order_value_trend_indicator: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string(),
  conversion_rate_trend_indicator: z.string(),
  cps: z.union([z.number(), z.int()]),
  cps_change_percentage: z.union([z.number(), z.int()]),
  cps_data_type: z.string(),
  cps_trend_indicator: z.string(),
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]),
  investment_data_type: z.string(),
  investment_trend_indicator: z.string(),
  marketing_percentage: z.union([z.number(), z.int()]),
  marketing_percentage_change_percentage: z.union([z.number(), z.int()]),
  marketing_percentage_data_type: z.string(),
  marketing_percentage_trend_indicator: z.string(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]),
  revenue_data_type: z.string(),
  revenue_trend_indicator: z.string(),
  roas: z.union([z.number(), z.int()]),
  roas_change_percentage: z.union([z.number(), z.int()]),
  roas_data_type: z.string(),
  roas_trend_indicator: z.string(),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string(),
  sessions_total_percentage: z.union([z.number(), z.int()]),
  sessions_total_percentage_change_percentage: z.union([z.number(), z.int()]),
  sessions_total_percentage_data_type: z.string(),
  sessions_total_percentage_trend_indicator: z.string(),
  sessions_trend_indicator: z.string(),
  transactions: z.int(),
  transactions_change_percentage: z.union([z.number(), z.int()]),
  transactions_data_type: z.string(),
  transactions_trend_indicator: z.string(),
});

/**
 * SourceAnalysisCardResponse
 *
 * SourceAnalysisCardResponse
 */
export const zSourceAnalysisCardResponse = z.object({
  currency_symbol: z.string(),
  google_ads: zSourceAnalysisCardMetrics,
  meta_ads: zSourceAnalysisCardMetrics,
  percentage_symbol: z.string(),
});

/**
 * AcquisitionTableItem
 *
 * AcquisitionTableItem
 */
export const zAcquisitionTableItem = z.object({
  arpu: z.union([z.number(), z.int()]).nullish(),
  arpu_delta: z.union([z.number(), z.int()]).nullish(),
  average_engagement_time: z.union([z.number(), z.int()]).nullish(),
  average_order_value: z.union([z.number(), z.int()]).nullish(),
  average_order_value_change_percentage: z
    .union([z.number(), z.int()])
    .nullish(),
  average_order_value_data_type: z.string().nullish().default("CURRENCY"),
  average_order_value_trend_indicator: z.string().nullish(),
  avg_ticket: z.union([z.number(), z.int()]).nullish(),
  avg_ticket_data_type: z.string().nullish(),
  campaign: z.string().nullish(),
  campaign_data_type: z.string().nullish(),
  carts: z.int().nullish(),
  carts_change_percentage: z.union([z.number(), z.int()]).nullish(),
  carts_data_type: z.string().nullish().default("NUMBER"),
  carts_trend_indicator: z.string().nullish(),
  channel: z.string().nullish(),
  channel_data_type: z.string().nullish(),
  channel_group: z.string().nullish(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string(),
  engaged_sessions: z.int().nullish(),
  engaged_sessions_delta: z.union([z.number(), z.int()]).nullish(),
  engagement_rate: z.union([z.number(), z.int()]).nullish(),
  engagement_rate_delta: z.union([z.number(), z.int()]).nullish(),
  event_count: z.int().nullish(),
  events_per_session: z.union([z.number(), z.int()]).nullish(),
  events_per_session_delta: z.union([z.number(), z.int()]).nullish(),
  key_events: z.int().nullish(),
  new_users: z.int().nullish(),
  new_users_delta: z.union([z.number(), z.int()]).nullish(),
  new_vs_returning: z.string().nullish(),
  orders: z.int(),
  orders_change_percentage: z.union([z.number(), z.int()]),
  orders_data_type: z.string().nullish().default("NUMBER"),
  orders_trend_indicator: z.string(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]),
  revenue_data_type: z.string().nullish().default("CURRENCY"),
  revenue_trend_indicator: z.string(),
  session_value: z.union([z.number(), z.int()]).nullish(),
  session_value_delta: z.union([z.number(), z.int()]).nullish(),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string(),
  source_medium: z.string().nullish(),
  source_medium_data_type: z.string().nullish(),
  total_users: z.int().nullish(),
  total_users_delta: z.union([z.number(), z.int()]).nullish(),
  age: z.string().nullish(),
  age_data_type: z.string().nullish(),
  sessions_per_user: z.union([z.number(), z.int()]).nullish(),
  sessions_per_user_delta: z.union([z.number(), z.int()]).nullish(),
});

/**
 * Pagination
 *
 * Pagination
 */
export const zPagination = z.object({
  page: z.int().gte(1),
  page_size: z.int().gte(1),
  total: z.int().gte(0),
  total_pages: z.int().gte(0),
});

/**
 * AcquisitionTableResponse
 *
 * AcquisitionTableResponse
 */
export const zAcquisitionTableResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zAcquisitionTableItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
  total_row: zAcquisitionTableItem.nullish(),
});

/**
 * AcquisitionChannelGroupingItem
 *
 * AcquisitionChannelGroupingItem
 */
export const zAcquisitionChannelGroupingItem = z.object({
  arpu: z.union([z.number(), z.int()]),
  arpu_delta: z.union([z.number(), z.int()]).nullish(),
  avg_order_value: z.union([z.number(), z.int()]),
  avg_order_value_delta: z.union([z.number(), z.int()]).nullish(),
  carts: z.union([z.number(), z.int()]),
  carts_delta: z.union([z.number(), z.int()]).nullish(),
  channel: z.string().nullish(),
  channel_group: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_delta: z.union([z.number(), z.int()]).nullish(),
  orders: z.union([z.number(), z.int()]),
  orders_delta: z.union([z.number(), z.int()]).nullish(),
  revenue: z.union([z.number(), z.int()]).nullish(),
  revenue_delta: z.union([z.number(), z.int()]).nullish(),
  session_value: z.union([z.number(), z.int()]),
  session_value_delta: z.union([z.number(), z.int()]).nullish(),
  sessions: z.union([z.number(), z.int()]),
  sessions_delta: z.union([z.number(), z.int()]).nullish(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_delta: z.union([z.number(), z.int()]).nullish(),
  total_users: z.union([z.number(), z.int()]),
  total_users_delta: z.union([z.number(), z.int()]).nullish(),
});

/**
 * AcquisitionChannelGroupingResponse
 *
 * AcquisitionChannelGroupingResponse
 */
export const zAcquisitionChannelGroupingResponse = z.object({
  items: z.array(zAcquisitionChannelGroupingItem),
  pagination: zPagination,
  total_row: zAcquisitionChannelGroupingItem,
});

/**
 * AcquisitionDashboardSeriesItem
 *
 * AcquisitionDashboardSeriesItem
 */
export const zAcquisitionDashboardSeriesItem = z.object({
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string(),
  date: z.string(),
  date_label: z.string(),
  google_investment: z.union([z.number(), z.int()]),
  google_investment_change_percentage: z.union([z.number(), z.int()]),
  google_investment_data_type: z.string().nullish().default("CURRENCY"),
  google_investment_trend_indicator: z.string(),
  meta_investment: z.union([z.number(), z.int()]),
  meta_investment_change_percentage: z.union([z.number(), z.int()]),
  meta_investment_data_type: z.string().nullish().default("CURRENCY"),
  meta_investment_trend_indicator: z.string(),
  orders: z.int(),
  orders_change_percentage: z.union([z.number(), z.int()]),
  orders_data_type: z.string().nullish().default("NUMBER"),
  orders_trend_indicator: z.string(),
  roas: z.union([z.number(), z.int()]),
  roas_change_percentage: z.union([z.number(), z.int()]),
  roas_data_type: z.string().nullish().default("NUMBER"),
  roas_trend_indicator: z.string(),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string(),
  total_investment: z.union([z.number(), z.int()]),
  total_investment_change_percentage: z.union([z.number(), z.int()]),
  total_investment_data_type: z.string().nullish().default("CURRENCY"),
  total_investment_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string(),
});

/**
 * AcquisitionDashboardChart
 *
 * AcquisitionDashboardChart
 */
export const zAcquisitionDashboardChart = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  percentage_symbol: z.string().nullish().default("%"),
  series: z.array(zAcquisitionDashboardSeriesItem),
});

/**
 * AcquisitionDashboardKPIs
 *
 * AcquisitionDashboardKPIs
 */
export const zAcquisitionDashboardKpis = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z.union([z.number(), z.int()]),
  average_order_value_data_type: z.string().nullish().default("CURRENCY"),
  average_order_value_trend_indicator: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string(),
  currency_symbol: z.string().nullish().default("R$"),
  engaged_sessions: z.int(),
  engaged_sessions_change_percentage: z.union([z.number(), z.int()]),
  engaged_sessions_data_type: z.string().nullish().default("NUMBER"),
  engaged_sessions_trend_indicator: z.string(),
  engagement_rate: z.union([z.number(), z.int()]),
  engagement_rate_change_percentage: z.union([z.number(), z.int()]),
  engagement_rate_data_type: z.string().nullish().default("PERCENT"),
  engagement_rate_trend_indicator: z.string(),
  orders: z.int(),
  orders_change_percentage: z.union([z.number(), z.int()]),
  orders_data_type: z.string().nullish().default("NUMBER"),
  orders_trend_indicator: z.string(),
  percentage_symbol: z.string().nullish().default("%"),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string(),
  total_users: z.int(),
  total_users_change_percentage: z.union([z.number(), z.int()]),
  total_users_data_type: z.string().nullish().default("NUMBER"),
  total_users_trend_indicator: z.string(),
});

/**
 * AcquisitionDashboardResponse
 *
 * AcquisitionDashboardResponse
 */
export const zAcquisitionDashboardResponse = z.object({
  chart: zAcquisitionDashboardChart,
  kpis: zAcquisitionDashboardKpis,
});

/**
 * AcquisitionDrilldownItem
 *
 * AcquisitionDrilldownItem
 */
export const zAcquisitionDrilldownItem = z.object({
  avg_order_value: z.union([z.number(), z.int()]),
  avg_order_value_delta: z.union([z.number(), z.int()]).nullish(),
  avg_order_value_trend: z.string().nullish(),
  carts: z.int(),
  carts_delta: z.union([z.number(), z.int()]).nullish(),
  carts_trend: z.string().nullish(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_delta: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_trend: z.string().nullish(),
  dimension: z.string(),
  dimension_key: z.string().nullish(),
  orders: z.int(),
  orders_delta: z.union([z.number(), z.int()]).nullish(),
  orders_trend: z.string().nullish(),
  sessions: z.int(),
  sessions_delta: z.union([z.number(), z.int()]).nullish(),
  sessions_trend: z.string().nullish(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_delta: z.union([z.number(), z.int()]).nullish(),
  total_revenue_trend: z.string().nullish(),
});

/**
 * AcquisitionDrilldownResponse
 *
 * AcquisitionDrilldownResponse
 */
export const zAcquisitionDrilldownResponse = z.object({
  dimension: z.string(),
  dimension_label: z.string(),
  filters_applied: z.record(z.string(), z.string()).nullish(),
  items: z.array(zAcquisitionDrilldownItem),
  pagination: zPagination,
  total_row: zAcquisitionDrilldownItem,
});

/**
 * AcquisitionTimelinePoint
 *
 * AcquisitionTimelinePoint
 */
export const zAcquisitionTimelinePoint = z.object({
  avg_ticket: z.union([z.number(), z.int()]).nullish(),
  conversion_rate: z.union([z.number(), z.int()]),
  date_label: z.string(),
  google_investment: z.union([z.number(), z.int()]).nullish().default(0),
  meta_investment: z.union([z.number(), z.int()]).nullish().default(0),
  orders: z.int(),
  revenue: z.union([z.number(), z.int()]).nullish(),
  roas: z.union([z.number(), z.int()]).nullish().default(0),
  sessions: z.int(),
  total_investment: z.union([z.number(), z.int()]).nullish().default(0),
  total_revenue: z.union([z.number(), z.int()]),
});

/**
 * AcquisitionTimelineResponse
 *
 * AcquisitionTimelineResponse
 */
export const zAcquisitionTimelineResponse = z.object({
  currency_symbol: z.string().nullish(),
  percentage_symbol: z.string().nullish(),
  series: z.array(zAcquisitionTimelinePoint),
});

/**
 * AcquisitionKPIs
 *
 * AcquisitionKPIs
 */
export const zAcquisitionKpis = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z.union([z.number(), z.int()]),
  average_order_value_data_type: z.string().nullish().default("CURRENCY"),
  average_order_value_trend_indicator: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string(),
  currency_symbol: z.string().nullish().default("R$"),
  engaged_sessions: z.int(),
  engaged_sessions_change_percentage: z.union([z.number(), z.int()]),
  engaged_sessions_data_type: z.string().nullish().default("NUMBER"),
  engaged_sessions_trend_indicator: z.string(),
  engagement_rate: z.union([z.number(), z.int()]),
  engagement_rate_change_percentage: z.union([z.number(), z.int()]),
  engagement_rate_data_type: z.string().nullish().default("PERCENT"),
  engagement_rate_trend_indicator: z.string(),
  event_count: z.int(),
  event_count_change_percentage: z.union([z.number(), z.int()]),
  event_count_data_type: z.string().nullish().default("NUMBER"),
  event_count_trend_indicator: z.string(),
  orders: z.int(),
  orders_change_percentage: z.union([z.number(), z.int()]),
  orders_data_type: z.string().nullish().default("NUMBER"),
  orders_trend_indicator: z.string(),
  percentage_symbol: z.string().nullish().default("%"),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string(),
  total_users: z.int(),
  total_users_change_percentage: z.union([z.number(), z.int()]),
  total_users_data_type: z.string().nullish().default("NUMBER"),
  total_users_trend_indicator: z.string(),
});

/**
 * AcquisitionFullResponse
 *
 * AcquisitionFullResponse
 */
export const zAcquisitionFullResponse = z.object({
  campaigns: zAcquisitionTableResponse,
  channel_grouping: zAcquisitionTableResponse,
  chart: zAcquisitionTimelineResponse,
  first_user_medium_events: zAcquisitionTableResponse,
  kpis: zAcquisitionKpis,
  new_vs_returning: zAcquisitionTableResponse,
  source_medium: zAcquisitionTableResponse,
});

/**
 * AcquisitionGeoStateItem
 */
export const zAcquisitionGeoStateItem = z.object({
  region: z.string(),
  sessions: z.number(),
  sessions_change_percentage: z.number(),
  total_users: z.number(),
  total_users_change_percentage: z.number(),
  orders: z.number(),
  orders_change_percentage: z.number(),
  total_revenue: z.number(),
  total_revenue_change_percentage: z.number(),
  ticket_medio: z.number(),
  ticket_medio_change_percentage: z.number(),
  conversion_rate: z.number(),
  conversion_rate_change_percentage: z.number(),
  arpu: z.number(),
  arpu_change_percentage: z.number(),
  session_value: z.number(),
  session_value_change_percentage: z.number(),
});

/**
 * AcquisitionGeoCityItem
 */
export const zAcquisitionGeoCityItem = z.object({
  city: z.string(),
  sessions: z.number(),
  sessions_change_percentage: z.number(),
  total_users: z.number(),
  total_users_change_percentage: z.number(),
  orders: z.number(),
  orders_change_percentage: z.number(),
  total_revenue: z.number(),
  total_revenue_change_percentage: z.number(),
  ticket_medio: z.number(),
  ticket_medio_change_percentage: z.number(),
  conversion_rate: z.number(),
  conversion_rate_change_percentage: z.number(),
  arpu: z.number(),
  arpu_change_percentage: z.number(),
  session_value: z.number(),
  session_value_change_percentage: z.number(),
});

/**
 * AcquisitionGeoTablesResponse
 */
export const zAcquisitionGeoTablesResponse = z.object({
  states: z.object({
    items: z.array(zAcquisitionGeoStateItem),
    total_row: zAcquisitionGeoStateItem.nullable(),
    pagination: zPagination,
  }),
  cities: z.object({
    items: z.array(zAcquisitionGeoCityItem),
    total_row: zAcquisitionGeoCityItem.nullable(),
    pagination: zPagination,
  }),
  currency_symbol: z.string(),
  percentage_symbol: z.string(),
});

/**
 * AcquisitionGeoUsersItem
 *
 * AcquisitionGeoUsersItem
 */
export const zAcquisitionGeoUsersItem = z.object({
  novosUsuarios: z.int(),
  novosUsuariosChange: z.union([z.number(), z.int()]).nullish(),
  novosUsuarios_data_type: z.string().nullish().default("NUMBER"),
  novosUsuarios_trend_indicator: z.string().nullish(),
  origem: z.string().nullish(),
  origem_data_type: z.string().nullish(),
  pedidos: z.int(),
  pedidosChange: z.union([z.number(), z.int()]).nullish(),
  pedidos_data_type: z.string().nullish().default("NUMBER"),
  pedidos_trend_indicator: z.string().nullish(),
  receitaChange: z.union([z.number(), z.int()]).nullish(),
  receitaTotal: z.union([z.number(), z.int()]),
  receitaTotal_data_type: z.string().nullish().default("CURRENCY"),
  receita_trend_indicator: z.string().nullish(),
  regiao: z.string(),
  regiao_data_type: z.string().nullish().default("TEXT"),
  sessoes: z.int(),
  sessoesChange: z.union([z.number(), z.int()]).nullish(),
  sessoes_data_type: z.string().nullish().default("NUMBER"),
  sessoes_trend_indicator: z.string().nullish(),
  tm: z.union([z.number(), z.int()]),
  tmChange: z.union([z.number(), z.int()]).nullish(),
  tm_data_type: z.string().nullish().default("CURRENCY"),
  tm_trend_indicator: z.string().nullish(),
  txConversao: z.union([z.number(), z.int()]),
  txConversaoChange: z.union([z.number(), z.int()]).nullish(),
  txConversao_data_type: z.string().nullish().default("PERCENT"),
  txConversao_trend_indicator: z.string().nullish(),
  usuariosRetornam: z.int(),
  usuariosRetornamChange: z.union([z.number(), z.int()]).nullish(),
  usuariosRetornam_data_type: z.string().nullish().default("NUMBER"),
  usuariosRetornam_trend_indicator: z.string().nullish(),
});

/**
 * AcquisitionGeoUsersTableResponse
 *
 * AcquisitionGeoUsersTableResponse
 */
export const zAcquisitionGeoUsersTableResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zAcquisitionGeoUsersItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
  total_row: zAcquisitionGeoUsersItem.nullish(),
});

/**
 * AcquisitionGeoUsersFullResponse
 *
 * AcquisitionGeoUsersFullResponse
 */
export const zAcquisitionGeoUsersFullResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  new_users_by_region: zAcquisitionGeoUsersTableResponse,
  new_users_by_region_source: zAcquisitionGeoUsersTableResponse,
  percentage_symbol: z.string().nullish().default("%"),
  returning_users_by_region: zAcquisitionGeoUsersTableResponse,
  returning_users_by_region_source: zAcquisitionGeoUsersTableResponse,
});

/**
 * AcquisitionKPIsResponse
 *
 * AcquisitionKPIsResponse
 */
export const zAcquisitionKpisResponse = z.object({
  kpis: zAcquisitionKpis,
});

/**
 * AcquisitionOrderItem
 */
export const zAcquisitionOrderItem = z.object({
  transaction_id: z.string(),
  transaction_id_data_type: z.string().nullish().default("TEXT"),
  date: z.string(),
  date_data_type: z.string().nullish().default("DATE"),
  channel_group: z.string(),
  source_medium: z.string(),
  campaign: z.string(),
  device: z.string(),
  region: z.string(),
  city: z.string(),
  items: z.number(),
  items_data_type: z.string().nullish().default("NUMBER"),
  revenue: z.number(),
  revenue_data_type: z.string().nullish().default("CURRENCY"),
});

/**
 * AcquisitionOrdersResponse
 */
export const zAcquisitionOrdersResponse = z.object({
  items: z.array(zAcquisitionOrderItem),
  total_row: zAcquisitionOrderItem.nullable(),
  pagination: zPagination,
  currency_symbol: z.string(),
  percentage_symbol: z.string(),
});

/**
 * CampaignFilterFieldResponse
 */
export const zCampaignFilterFieldResponse = z.object({
  field: z.string(),
  label: z.string(),
  platform: z.string(),
});

/**
 * CampaignFiltersResponse
 */
export const zCampaignFiltersResponse = z.object({
  exclude: z.array(z.string()).optional(),
  field: z.string(),
  include: z.array(z.string()).optional(),
  platform: z.string(),
});

/**
 * CampaignsCardPagesItem
 *
 * CampaignsCardPagesItem
 */
export const zCampaignsCardPagesItem = z.object({
  campanha_sessao: z.string(),
  campanha_sessao_data_type: z.string().nullish().default("TEXT"),
  pedidos: z.int(),
  pedidos_data_type: z.string().nullish().default("NUMBER"),
  pedidos_percent_change: z.union([z.number(), z.int()]),
  pedidos_trend_indicator: z.string(),
  receita_total: z.union([z.number(), z.int()]),
  receita_total_data_type: z.string().nullish().default("CURRENCY"),
  receita_total_percent_change: z.union([z.number(), z.int()]),
  receita_total_trend_indicator: z.string(),
  sessoes: z.int(),
  sessoes_data_type: z.string().nullish().default("NUMBER"),
  sessoes_percent_change: z.union([z.number(), z.int()]),
  sessoes_trend_indicator: z.string(),
  taxa_conversao: z.union([z.number(), z.int()]),
  taxa_conversao_data_type: z.string().nullish().default("PERCENT"),
  taxa_conversao_percent_change: z.union([z.number(), z.int()]),
  taxa_conversao_trend_indicator: z.string(),
  ticket_medio: z.union([z.number(), z.int()]),
  ticket_medio_data_type: z.string().nullish().default("CURRENCY"),
  ticket_medio_percent_change: z.union([z.number(), z.int()]),
  ticket_medio_trend_indicator: z.string(),
  usuarios: z.int(),
  usuarios_data_type: z.string().nullish().default("NUMBER"),
  usuarios_percent_change: z.union([z.number(), z.int()]),
  usuarios_trend_indicator: z.string(),
});

/**
 * CampaignsCardPagesPagination
 *
 * CampaignsCardPagesPagination
 */
export const zCampaignsCardPagesPagination = z.object({
  current_page: z.int(),
  page_size: z.int(),
  total_items: z.int(),
  total_pages: z.int(),
});

/**
 * CampaignsCardPagesResponse
 *
 * CampaignsCardPagesResponse
 */
export const zCampaignsCardPagesResponse = z.object({
  data: z.array(zCampaignsCardPagesItem),
  pagination: zCampaignsCardPagesPagination,
  total: zCampaignsCardPagesItem,
});

/**
 * UtmAdContentTableRow
 *
 * UtmAdContentTableRow
 */
export const zUtmAdContentTableRow = z.object({
  conteudo: z.string(),
  conteudo_data_type: z.string(),
  pedidos: z.int(),
  pedidos_change_percentage: z.union([z.number(), z.int()]),
  pedidos_data_type: z.string(),
  pedidos_trend_indicator: z.string(),
  receita_total: z.union([z.number(), z.int()]),
  receita_total_change_percentage: z.union([z.number(), z.int()]),
  receita_total_data_type: z.string(),
  receita_total_trend_indicator: z.string(),
  sessoes: z.int(),
  sessoes_change_percentage: z.union([z.number(), z.int()]),
  sessoes_data_type: z.string(),
  sessoes_trend_indicator: z.string(),
  taxa_conversao: z.union([z.number(), z.int()]),
  taxa_conversao_change_percentage: z.union([z.number(), z.int()]),
  taxa_conversao_data_type: z.string(),
  taxa_conversao_trend_indicator: z.string(),
  ticket_medio: z.union([z.number(), z.int()]),
  ticket_medio_change_percentage: z.union([z.number(), z.int()]),
  ticket_medio_data_type: z.string(),
  ticket_medio_trend_indicator: z.string(),
  usuarios_ativos: z.int(),
  usuarios_ativos_change_percentage: z.union([z.number(), z.int()]),
  usuarios_ativos_data_type: z.string(),
  usuarios_ativos_trend_indicator: z.string(),
});

/**
 * UtmTablePagination
 *
 * UtmTablePagination
 */
export const zUtmTablePagination = z.object({
  current_page: z.int(),
  page: z.int().nullish(),
  page_size: z.int(),
  total_items: z.int(),
  total_pages: z.int(),
});

/**
 * UtmAdContentTableResponse
 *
 * UtmAdContentTableResponse
 */
export const zUtmAdContentTableResponse = z.object({
  items: z.array(zUtmAdContentTableRow),
  pagination: zUtmTablePagination,
  total: zUtmAdContentTableRow,
});

/**
 * UtmCampaignTableRow
 *
 * UtmCampaignTableRow
 */
export const zUtmCampaignTableRow = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z.union([z.number(), z.int()]),
  average_order_value_data_type: z.string(),
  average_order_value_trend_indicator: z.string(),
  campaign: z.string(),
  campaign_data_type: z.string(),
  campanha: z.string(),
  campanha_data_type: z.string(),
  clicks: z.int(),
  contagemEventos: z.int(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string(),
  conversion_rate_trend_indicator: z.string(),
  eventCount: z.int(),
  eventCountPerUser: z.union([z.number(), z.int()]).nullish(),
  eventosPrincipais: z.int(),
  eventosPrincipais_change_percentage: z.union([z.number(), z.int()]),
  eventosPrincipais_trend_indicator: z.string(),
  keyEvents: z.int(),
  pedidos: z.int(),
  pedidos_change_percentage: z.union([z.number(), z.int()]),
  pedidos_data_type: z.string(),
  pedidos_trend_indicator: z.string(),
  receita_total: z.union([z.number(), z.int()]),
  receita_total_change_percentage: z.union([z.number(), z.int()]),
  receita_total_data_type: z.string(),
  receita_total_trend_indicator: z.string(),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string(),
  sessions_trend_indicator: z.string(),
  sessoes: z.int(),
  sessoes_change_percentage: z.union([z.number(), z.int()]),
  sessoes_data_type: z.string(),
  sessoes_trend_indicator: z.string(),
  taxa_conversao: z.union([z.number(), z.int()]),
  taxa_conversao_change_percentage: z.union([z.number(), z.int()]),
  taxa_conversao_data_type: z.string(),
  taxa_conversao_trend_indicator: z.string(),
  ticket_medio: z.union([z.number(), z.int()]),
  ticket_medio_change_percentage: z.union([z.number(), z.int()]),
  ticket_medio_data_type: z.string(),
  ticket_medio_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string(),
  total_revenue_trend_indicator: z.string(),
  total_users: z.int(),
  total_users_change_percentage: z.union([z.number(), z.int()]),
  total_users_data_type: z.string(),
  total_users_trend_indicator: z.string(),
  transactions: z.int(),
  transactions_change_percentage: z.union([z.number(), z.int()]),
  transactions_data_type: z.string(),
  transactions_trend_indicator: z.string(),
  usuarios_ativos: z.int(),
  usuarios_ativos_change_percentage: z.union([z.number(), z.int()]),
  usuarios_ativos_data_type: z.string(),
  usuarios_ativos_trend_indicator: z.string(),
});

/**
 * UtmCampaignTableResponse
 *
 * UtmCampaignTableResponse
 */
export const zUtmCampaignTableResponse = z.object({
  items: z.array(zUtmCampaignTableRow),
  pagination: zUtmTablePagination,
  total: zUtmCampaignTableRow,
});

/**
 * UtmCardMetric
 */
export const zUtmCardMetric = z.object({
  change_percentage: z.union([z.number(), z.int()]),
  data_type: z.string(),
  trend_indicator: z.string(),
  value: z.union([z.number(), z.int(), z.string()]).nullable(),
});

/**
 * UtmCardsResponse
 */
export const zUtmCardsResponse = z.object({
  cps_geral: zUtmCardMetric,
  currency_symbol: z.string(),
  media_itens_pedido: zUtmCardMetric,
  pedidos: zUtmCardMetric,
  percentage_symbol: z.string(),
  receita_total: zUtmCardMetric,
  sessoes: zUtmCardMetric,
  taxa_conversao: zUtmCardMetric,
  ticket_medio: zUtmCardMetric,
  valor_medio_unitario: zUtmCardMetric,
});

/**
 * UtmMediumTableRow
 *
 * UtmMediumTableRow
 */
export const zUtmMediumTableRow = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z.union([z.number(), z.int()]),
  average_order_value_data_type: z.string(),
  average_order_value_trend_indicator: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string(),
  conversion_rate_trend_indicator: z.string(),
  eventosPrincipais: z.int(),
  eventosPrincipais_change_percentage: z.union([z.number(), z.int()]),
  eventosPrincipais_data_type: z.string(),
  eventosPrincipais_trend_indicator: z.string(),
  keyEvents: z.int(),
  medium: z.string(),
  medium_data_type: z.string(),
  meio: z.string(),
  meio_data_type: z.string(),
  pedidos: z.int(),
  pedidos_change_percentage: z.union([z.number(), z.int()]),
  pedidos_data_type: z.string(),
  pedidos_trend_indicator: z.string(),
  receita_total: z.union([z.number(), z.int()]),
  receita_total_change_percentage: z.union([z.number(), z.int()]),
  receita_total_data_type: z.string(),
  receita_total_trend_indicator: z.string(),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string(),
  sessions_trend_indicator: z.string(),
  sessoes: z.int(),
  sessoes_change_percentage: z.union([z.number(), z.int()]),
  sessoes_data_type: z.string(),
  sessoes_trend_indicator: z.string(),
  taxa_conversao: z.union([z.number(), z.int()]),
  taxa_conversao_change_percentage: z.union([z.number(), z.int()]),
  taxa_conversao_data_type: z.string(),
  taxa_conversao_trend_indicator: z.string(),
  ticket_medio: z.union([z.number(), z.int()]),
  ticket_medio_change_percentage: z.union([z.number(), z.int()]),
  ticket_medio_data_type: z.string(),
  ticket_medio_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string(),
  total_revenue_trend_indicator: z.string(),
  total_users: z.int(),
  total_users_change_percentage: z.union([z.number(), z.int()]),
  total_users_data_type: z.string(),
  total_users_trend_indicator: z.string(),
  transactions: z.int(),
  transactions_change_percentage: z.union([z.number(), z.int()]),
  transactions_data_type: z.string(),
  transactions_trend_indicator: z.string(),
  usuarios_ativos: z.int(),
  usuarios_ativos_change_percentage: z.union([z.number(), z.int()]),
  usuarios_ativos_data_type: z.string(),
  usuarios_ativos_trend_indicator: z.string(),
});

/**
 * UtmMediumTableResponse
 *
 * UtmMediumTableResponse
 */
export const zUtmMediumTableResponse = z.object({
  items: z.array(zUtmMediumTableRow),
  pagination: zUtmTablePagination,
  total: zUtmMediumTableRow,
});

/**
 * UtmSourceTableRow
 *
 * UtmSourceTableRow
 */
export const zUtmSourceTableRow = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z.union([z.number(), z.int()]),
  average_order_value_data_type: z.string(),
  average_order_value_trend_indicator: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string(),
  conversion_rate_trend_indicator: z.string(),
  eventosPrincipais: z.int(),
  eventosPrincipais_change_percentage: z.union([z.number(), z.int()]),
  eventosPrincipais_data_type: z.string(),
  eventosPrincipais_trend_indicator: z.string(),
  keyEvents: z.int(),
  origem: z.string(),
  origem_data_type: z.string(),
  pedidos: z.int(),
  pedidos_change_percentage: z.union([z.number(), z.int()]),
  pedidos_data_type: z.string(),
  pedidos_trend_indicator: z.string(),
  receita_total: z.union([z.number(), z.int()]),
  receita_total_change_percentage: z.union([z.number(), z.int()]),
  receita_total_data_type: z.string(),
  receita_total_trend_indicator: z.string(),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string(),
  sessions_trend_indicator: z.string(),
  sessoes: z.int(),
  sessoes_change_percentage: z.union([z.number(), z.int()]),
  sessoes_data_type: z.string(),
  sessoes_trend_indicator: z.string(),
  source: z.string(),
  source_data_type: z.string(),
  taxa_conversao: z.union([z.number(), z.int()]),
  taxa_conversao_change_percentage: z.union([z.number(), z.int()]),
  taxa_conversao_data_type: z.string(),
  taxa_conversao_trend_indicator: z.string(),
  ticket_medio: z.union([z.number(), z.int()]),
  ticket_medio_change_percentage: z.union([z.number(), z.int()]),
  ticket_medio_data_type: z.string(),
  ticket_medio_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string(),
  total_revenue_trend_indicator: z.string(),
  total_users: z.int(),
  total_users_change_percentage: z.union([z.number(), z.int()]),
  total_users_data_type: z.string(),
  total_users_trend_indicator: z.string(),
  transactions: z.int(),
  transactions_change_percentage: z.union([z.number(), z.int()]),
  transactions_data_type: z.string(),
  transactions_trend_indicator: z.string(),
  usuarios_ativos: z.int(),
  usuarios_ativos_change_percentage: z.union([z.number(), z.int()]),
  usuarios_ativos_data_type: z.string(),
  usuarios_ativos_trend_indicator: z.string(),
});

/**
 * UtmSourceTableResponse
 *
 * UtmSourceTableResponse
 */
export const zUtmSourceTableResponse = z.object({
  items: z.array(zUtmSourceTableRow),
  pagination: zUtmTablePagination,
  total: zUtmSourceTableRow,
});

/**
 * CampaignFiltersUpdate
 */
export const zCampaignFiltersUpdate = z.object({
  exclude: z.array(z.string()).optional(),
  field: z.string(),
  include: z.array(z.string()).optional(),
});

/**
 * ConversionRateCardsKpisResponse
 *
 * ConversionRateCardsKpisResponse
 */
export const zConversionRateCardsKpisResponse = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z
    .union([z.number(), z.int()])
    .nullish(),
  average_order_value_data_type: z.string().nullish().default("CURRENCY"),
  average_order_value_trend_indicator: z.string().nullish(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string().nullish(),
  currency_symbol: z.string().nullish().default("R$"),
  engaged_sessions: z.int(),
  engaged_sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  engaged_sessions_data_type: z.string().nullish().default("NUMBER"),
  engaged_sessions_trend_indicator: z.string().nullish(),
  engagement_rate: z.union([z.number(), z.int()]),
  engagement_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  engagement_rate_data_type: z.string().nullish().default("PERCENT"),
  engagement_rate_trend_indicator: z.string().nullish(),
  orders: z.int(),
  orders_change_percentage: z.union([z.number(), z.int()]).nullish(),
  orders_data_type: z.string().nullish().default("NUMBER"),
  orders_trend_indicator: z.string().nullish(),
  percentage_symbol: z.string().nullish().default("%"),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string().nullish(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string().nullish(),
  total_users: z.int(),
  total_users_change_percentage: z.union([z.number(), z.int()]).nullish(),
  total_users_data_type: z.string().nullish().default("NUMBER"),
  total_users_trend_indicator: z.string().nullish(),
});

/**
 * ConversionRateDashboardSeriesItem
 *
 * ConversionRateDashboardSeriesItem
 */
export const zConversionRateDashboardSeriesItem = z.object({
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string(),
  date: z.string(),
  date_label: z.string(),
  previous_conversion_rate: z.union([z.number(), z.int()]),
});

/**
 * ConversionRateDashboardChart
 *
 * ConversionRateDashboardChart
 */
export const zConversionRateDashboardChart = z.object({
  percentage_symbol: z.string().nullish().default("%"),
  series: z.array(zConversionRateDashboardSeriesItem),
});

/**
 * ConversionRateDashboardKPIs
 *
 * ConversionRateDashboardKPIs
 */
export const zConversionRateDashboardKpis = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z.union([z.number(), z.int()]),
  average_order_value_data_type: z.string().nullish().default("CURRENCY"),
  average_order_value_trend_indicator: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string(),
  currency_symbol: z.string().nullish().default("R$"),
  engaged_sessions: z.int(),
  engaged_sessions_change_percentage: z.union([z.number(), z.int()]),
  engaged_sessions_data_type: z.string().nullish().default("NUMBER"),
  engaged_sessions_trend_indicator: z.string(),
  engagement_rate: z.union([z.number(), z.int()]),
  engagement_rate_change_percentage: z.union([z.number(), z.int()]),
  engagement_rate_data_type: z.string().nullish().default("PERCENT"),
  engagement_rate_trend_indicator: z.string(),
  orders: z.int(),
  orders_change_percentage: z.union([z.number(), z.int()]),
  orders_data_type: z.string().nullish().default("NUMBER"),
  orders_trend_indicator: z.string(),
  percentage_symbol: z.string().nullish().default("%"),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string(),
  total_users: z.int(),
  total_users_change_percentage: z.union([z.number(), z.int()]),
  total_users_data_type: z.string().nullish().default("NUMBER"),
  total_users_trend_indicator: z.string(),
});

/**
 * ConversionRateDashboardResponse
 *
 * ConversionRateDashboardResponse
 */
export const zConversionRateDashboardResponse = z.object({
  chart: zConversionRateDashboardChart,
  kpis: zConversionRateDashboardKpis,
});

/**
 * ConversionRateDemographicsV2Item
 *
 * ConversionRateDemographicsV2Item
 */
export const zConversionRateDemographicsV2Item = z.object({
  age: z.string().nullish(),
  arpu: z.union([z.number(), z.int()]),
  arpu_change_percentage: z.union([z.number(), z.int()]).nullish(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string().nullish(),
  gender: z.string().nullish(),
  orders: z.union([z.number(), z.int()]),
  orders_change_percentage: z.union([z.number(), z.int()]).nullish(),
  orders_data_type: z.string().nullish().default("NUMBER"),
  orders_trend_indicator: z.string().nullish(),
  session_value: z.union([z.number(), z.int()]),
  session_value_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string().nullish(),
  ticket_medio: z.union([z.number(), z.int()]),
  ticket_medio_change_percentage: z.union([z.number(), z.int()]).nullish(),
  ticket_medio_data_type: z.string().nullish().default("CURRENCY"),
  ticket_medio_trend_indicator: z.string().nullish(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string().nullish(),
  total_users: z.union([z.number(), z.int()]),
  total_users_change_percentage: z.union([z.number(), z.int()]).nullish(),
  total_users_data_type: z.string().nullish().default("NUMBER"),
  total_users_trend_indicator: z.string().nullish(),
});

/**
 * ConversionRateDemographicsV2Table
 *
 * ConversionRateDemographicsV2Table
 */
export const zConversionRateDemographicsV2Table = z.object({
  items: z.array(zConversionRateDemographicsV2Item),
  pagination: zPagination,
  total_row: zConversionRateDemographicsV2Item.nullish(),
});

/**
 * ConversionRateDemographicsV2Response
 *
 * ConversionRateDemographicsV2Response
 */
export const zConversionRateDemographicsV2Response = z.object({
  ages: zConversionRateDemographicsV2Table,
  currency_symbol: z.string().nullish().default("R$"),
  genders: zConversionRateDemographicsV2Table,
  percentage_symbol: z.string().nullish().default("%"),
});

/**
 * AnalyticsItemChanges
 *
 * AnalyticsItemChanges
 */
export const zAnalyticsItemChanges = z.object({
  cart_rate: z.union([z.number(), z.int()]).nullish(),
  conversion_rate: z.union([z.number(), z.int()]).nullish(),
  items_added_to_cart: z.union([z.number(), z.int()]).nullish(),
  items_purchased: z.union([z.number(), z.int()]).nullish(),
  items_viewed: z.union([z.number(), z.int()]).nullish(),
  purchase_revenue: z.union([z.number(), z.int()]).nullish(),
  session_conversion_rate: z.union([z.number(), z.int()]).nullish(),
  sessions: z.union([z.number(), z.int()]).nullish(),
});

/**
 * ConversionRateFullTableItem
 *
 * ConversionRateFullTableItem
 */
export const zConversionRateFullTableItem = z.object({
  campaign: z.string().nullish(),
  campaign_data_type: z.string().nullish().default("TEXT"),
  cart_rate: z.union([z.number(), z.int()]).nullish(),
  cart_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  cart_rate_trend_indicator: z.string().nullish(),
  changes: zAnalyticsItemChanges.nullish(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string().nullish(),
  item_category: z.string().nullish(),
  item_category_data_type: z.string().nullish().default("TEXT"),
  item_name: z.string().nullish(),
  item_name_data_type: z.string().nullish().default("TEXT"),
  items_added_to_cart: z.int().nullish(),
  items_added_to_cart_change_percentage: z
    .union([z.number(), z.int()])
    .nullish(),
  items_added_to_cart_data_type: z.string().nullish().default("NUMBER"),
  items_added_to_cart_trend_indicator: z.string().nullish(),
  items_purchased: z.int().nullish(),
  items_purchased_change_percentage: z.union([z.number(), z.int()]).nullish(),
  items_purchased_data_type: z.string().nullish().default("NUMBER"),
  items_purchased_trend_indicator: z.string().nullish(),
  items_viewed: z.int().nullish(),
  items_viewed_change_percentage: z.union([z.number(), z.int()]).nullish(),
  items_viewed_data_type: z.string().nullish().default("NUMBER"),
  items_viewed_trend_indicator: z.string().nullish(),
  orders: z.int().nullish(),
  orders_change_percentage: z.union([z.number(), z.int()]).nullish(),
  purchase_revenue: z.union([z.number(), z.int()]).nullish(),
  purchase_revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  purchase_revenue_data_type: z.string().nullish().default("CURRENCY"),
  purchase_revenue_trend_indicator: z.string().nullish(),
  session_conversion_rate: z.union([z.number(), z.int()]).nullish(),
  session_conversion_rate_data_type: z.string().nullish(),
  session_conversion_rate_trend_indicator: z.string().nullish(),
  sessions: z.int().nullish(),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  source_medium: z.string().nullish(),
  source_medium_data_type: z.string().nullish().default("TEXT"),
  ticket_medio: z.union([z.number(), z.int()]).nullish(),
  ticket_medio_change_percentage: z.union([z.number(), z.int()]).nullish(),
  total_revenue: z.union([z.number(), z.int()]).nullish(),
  total_revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string().nullish(),
  total_users: z.int().nullish(),
  total_users_change_percentage: z.union([z.number(), z.int()]).nullish(),
});

/**
 * ConversionRateFullTableResponse
 *
 * ConversionRateFullTableResponse
 */
export const zConversionRateFullTableResponse = z.object({
  items: z.array(zConversionRateFullTableItem),
  pagination: zPagination,
  total_row: zConversionRateFullTableItem.nullish(),
});

/**
 * ConversionRateFullResponse
 *
 * ConversionRateFullResponse
 */
export const zConversionRateFullResponse = z.object({
  campaigns: zConversionRateFullTableResponse,
  categories: zConversionRateFullTableResponse,
  chart: zConversionRateDashboardChart,
  currency_symbol: z.string().nullish().default("R$"),
  kpis: zConversionRateDashboardKpis,
  percentage_symbol: z.string().nullish().default("%"),
  products: zConversionRateFullTableResponse,
  sources: zConversionRateFullTableResponse,
});

/**
 * UtmCampaignsConversionItem
 *
 * UtmCampaignsConversionItem
 */
export const zUtmCampaignsConversionItem = z.object({
  campaign: z.string(),
  campaign_data_type: z.string().nullish().default("TEXT"),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string().nullish(),
  orders: z.union([z.number(), z.int()]),
  orders_change_percentage: z.union([z.number(), z.int()]).nullish(),
  orders_data_type: z.string().nullish().default("NUMBER"),
  orders_trend_indicator: z.string().nullish(),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string().nullish(),
  ticket_medio: z.union([z.number(), z.int()]),
  ticket_medio_change_percentage: z.union([z.number(), z.int()]).nullish(),
  ticket_medio_data_type: z.string().nullish().default("CURRENCY"),
  ticket_medio_trend_indicator: z.string().nullish(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string().nullish(),
  total_users: z.union([z.number(), z.int()]),
  total_users_change_percentage: z.union([z.number(), z.int()]).nullish(),
  total_users_data_type: z.string().nullish().default("NUMBER"),
  total_users_trend_indicator: z.string().nullish(),
});

/**
 * UtmCampaignsConversionSummary
 *
 * UtmCampaignsConversionSummary
 */
export const zUtmCampaignsConversionSummary = z.object({
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  orders_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  ticket_medio_change_percentage: z.union([z.number(), z.int()]).nullish(),
  total_revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  total_users_change_percentage: z.union([z.number(), z.int()]).nullish(),
});

/**
 * UtmCampaignsConversionTotalRow
 *
 * UtmCampaignsConversionTotalRow
 */
export const zUtmCampaignsConversionTotalRow = z.object({
  campaign: z.string().nullish().default("Total Geral"),
  conversion_rate: z.union([z.number(), z.int()]),
  orders: z.union([z.number(), z.int()]),
  sessions: z.union([z.number(), z.int()]),
  ticket_medio: z.union([z.number(), z.int()]),
  total_revenue: z.union([z.number(), z.int()]),
  total_users: z.union([z.number(), z.int()]),
});

/**
 * UtmCampaignsConversionResponse
 *
 * UtmCampaignsConversionResponse
 */
export const zUtmCampaignsConversionResponse = z.object({
  items: z.array(zUtmCampaignsConversionItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
  summary: zUtmCampaignsConversionSummary,
  total_row: zUtmCampaignsConversionTotalRow,
});

/**
 * DailyControlCardItem
 *
 * DailyControlCardItem
 */
export const zDailyControlCardItem = z.object({
  cps: z.union([z.number(), z.int()]),
  cps_change_percentage: z.union([z.number(), z.int()]),
  cps_data_type: z.string(),
  cps_trend_indicator: z.string(),
  currency_symbol: z.string(),
  data: z.string(),
  date: z.string(),
  google_investment: z.union([z.number(), z.int()]),
  google_investment_change_percentage: z.union([z.number(), z.int()]),
  google_investment_data_type: z.string(),
  google_investment_trend_indicator: z.string(),
  marketing_percentage: z.union([z.number(), z.int()]),
  marketing_percentage_change_percentage: z.union([z.number(), z.int()]),
  marketing_percentage_data_type: z.string(),
  marketing_percentage_trend_indicator: z.string(),
  meta_investment: z.union([z.number(), z.int()]),
  meta_investment_change_percentage: z.union([z.number(), z.int()]),
  meta_investment_data_type: z.string(),
  meta_investment_trend_indicator: z.string(),
  percentage_symbol: z.string(),
  roas: z.union([z.number(), z.int()]),
  roas_change_percentage: z.union([z.number(), z.int()]),
  roas_data_type: z.string(),
  roas_trend_indicator: z.string(),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string(),
  sessions_trend_indicator: z.string(),
  tm: z.union([z.number(), z.int()]),
  tm_change_percentage: z.union([z.number(), z.int()]),
  tm_data_type: z.string(),
  tm_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string(),
  total_revenue_trend_indicator: z.string(),
  transactions: z.int(),
  transactions_change_percentage: z.union([z.number(), z.int()]),
  transactions_data_type: z.string(),
  transactions_trend_indicator: z.string(),
  tx_conversion: z.union([z.number(), z.int()]),
  tx_conversion_change_percentage: z.union([z.number(), z.int()]),
  tx_conversion_data_type: z.string(),
  tx_conversion_trend_indicator: z.string(),
});

/**
 * DailyControlCardTotalRow
 *
 * DailyControlCardTotalRow
 */
export const zDailyControlCardTotalRow = z.object({
  cps: z.union([z.number(), z.int()]),
  currency_symbol: z.string(),
  data: z.string(),
  google_investment: z.union([z.number(), z.int()]),
  marketing_percentage: z.union([z.number(), z.int()]),
  meta_investment: z.union([z.number(), z.int()]),
  percentage_symbol: z.string(),
  roas: z.union([z.number(), z.int()]),
  sessions: z.int(),
  tm: z.union([z.number(), z.int()]),
  total_revenue: z.union([z.number(), z.int()]),
  transactions: z.int(),
  tx_conversion: z.union([z.number(), z.int()]),
});

/**
 * DailyControlCardResponse
 *
 * DailyControlCardResponse
 */
export const zDailyControlCardResponse = z.object({
  currency_symbol: z.string(),
  items: z.array(zDailyControlCardItem),
  pagination: zPagination,
  percentage_symbol: z.string(),
  total_row: zDailyControlCardTotalRow,
});

/**
 * SalesFunnelChanges
 *
 * SalesFunnelChanges
 */
export const zSalesFunnelChanges = z.object({
  add_to_carts: z.union([z.number(), z.int()]),
  cart_to_purchase_rate: z.union([z.number(), z.int()]).nullish(),
  connect_rate: z.union([z.number(), z.int()]),
  cpc: z.union([z.number(), z.int()]),
  cpc_google: z.union([z.number(), z.int()]),
  cpm: z.union([z.number(), z.int()]),
  cps_geral: z.union([z.number(), z.int()]),
  ctr: z.union([z.number(), z.int()]),
  ctr_google: z.union([z.number(), z.int()]).nullish(),
  ecommerce_purchases: z.union([z.number(), z.int()]),
  investment: z.union([z.number(), z.int()]),
  roas: z.union([z.number(), z.int()]),
  sessions: z.union([z.number(), z.int()]),
  sessions_to_cart_rate: z.union([z.number(), z.int()]),
  total_revenue: z.union([z.number(), z.int()]),
});

/**
 * SalesFunnelCardResponse
 *
 * SalesFunnelCardResponse
 */
export const zSalesFunnelCardResponse = z.object({
  add_to_carts: z.int(),
  add_to_carts_change_percentage: z.union([z.number(), z.int()]),
  add_to_carts_data_type: z.string(),
  add_to_carts_trend_indicator: z.string(),
  cart_to_purchase_rate: z.union([z.number(), z.int()]),
  cart_to_purchase_rate_change_percentage: z.union([z.number(), z.int()]),
  cart_to_purchase_rate_data_type: z.string(),
  cart_to_purchase_rate_trend_indicator: z.string(),
  changes: zSalesFunnelChanges,
  connect_rate: z.union([z.number(), z.int()]),
  connect_rate_change_percentage: z.union([z.number(), z.int()]),
  connect_rate_data_type: z.string(),
  connect_rate_trend_indicator: z.string(),
  cpc: z.union([z.number(), z.int()]),
  cpc_change_percentage: z.union([z.number(), z.int()]),
  cpc_data_type: z.string(),
  cpc_google: z.union([z.number(), z.int()]),
  cpc_google_change_percentage: z.union([z.number(), z.int()]),
  cpc_google_data_type: z.string(),
  cpc_google_trend_indicator: z.string(),
  cpc_trend_indicator: z.string(),
  cpm: z.union([z.number(), z.int()]),
  cpm_change_percentage: z.union([z.number(), z.int()]),
  cpm_data_type: z.string(),
  cpm_trend_indicator: z.string(),
  cps_geral: z.union([z.number(), z.int()]),
  cps_geral_change_percentage: z.union([z.number(), z.int()]),
  cps_geral_data_type: z.string(),
  cps_geral_trend_indicator: z.string(),
  ctr: z.union([z.number(), z.int()]),
  ctr_change_percentage: z.union([z.number(), z.int()]),
  ctr_data_type: z.string(),
  ctr_google: z.union([z.number(), z.int()]),
  ctr_google_change_percentage: z.union([z.number(), z.int()]),
  ctr_google_data_type: z.string(),
  ctr_google_trend_indicator: z.string(),
  ctr_trend_indicator: z.string(),
  currency_symbol: z.string(),
  ecommerce_purchases: z.int(),
  ecommerce_purchases_change_percentage: z.union([z.number(), z.int()]),
  ecommerce_purchases_data_type: z.string(),
  ecommerce_purchases_trend_indicator: z.string(),
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]),
  investment_data_type: z.string(),
  investment_trend_indicator: z.string(),
  percentage_symbol: z.string(),
  roas: z.union([z.number(), z.int()]),
  roas_change_percentage: z.union([z.number(), z.int()]),
  roas_data_type: z.string(),
  roas_trend_indicator: z.string(),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string(),
  sessions_to_cart_rate: z.union([z.number(), z.int()]),
  sessions_to_cart_rate_change_percentage: z.union([z.number(), z.int()]),
  sessions_to_cart_rate_data_type: z.string(),
  sessions_to_cart_rate_trend_indicator: z.string(),
  sessions_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string(),
  total_revenue_trend_indicator: z.string(),
});

/**
 * SalesFunnelStage1Row
 */
export const zSalesFunnelStage1Row = z.object({
  stage: z.string(),
  stage_label: z.string(),
  platform: z.string(),
  platform_label: z.string(),
  campaigns: z.int(),
  campaigns_data_type: z.string().nullish().default("NUMBER"),
  investment: z.number(),
  investment_change_percentage: z.number(),
  investment_data_type: z.string().nullish().default("CURRENCY"),
  investment_share: z.number(),
  investment_share_data_type: z.string().nullish().default("PERCENT"),
  impressions: z.number(),
  impressions_change_percentage: z.number(),
  impressions_data_type: z.string().nullish().default("NUMBER"),
  clicks: z.number(),
  clicks_change_percentage: z.number(),
  clicks_data_type: z.string().nullish().default("NUMBER"),
  cpc: z.number(),
  cpc_change_percentage: z.number(),
  cpc_data_type: z.string().nullish().default("CURRENCY"),
  cpm: z.number(),
  cpm_change_percentage: z.number(),
  cpm_data_type: z.string().nullish().default("CURRENCY"),
  ctr: z.number(),
  ctr_change_percentage: z.number(),
  ctr_data_type: z.string().nullish().default("PERCENT"),
  connect_rate: z.number().nullable(),
  connect_rate_data_type: z.string().nullish().default("PERCENT"),
});

/**
 * SalesFunnelStage1Block
 */
export const zSalesFunnelStage1Block = z.object({
  platform: z.string(),
  platform_label: z.string(),
  stages: z.array(zSalesFunnelStage1Row),
  total_row: zSalesFunnelStage1Row.nullable(),
});

/**
 * SalesFunnelStage1Response
 */
export const zSalesFunnelStage1Response = z.object({
  platforms: z.array(zSalesFunnelStage1Block),
  combined: zSalesFunnelStage1Block,
  currency_symbol: z.string().nullish().default("R$"),
  percentage_symbol: z.string().nullish().default("%"),
});

/**
 * AdsDashboardChartDataPoint
 *
 * AdsDashboardChartDataPoint
 */
export const zAdsDashboardChartDataPoint = z.object({
  cpc: z.union([z.number(), z.int()]).nullish(),
  cps: z.union([z.number(), z.int()]).nullish(),
  date: z.string(),
  investimento: z.union([z.number(), z.int()]).nullish(),
  pedidos: z.union([z.number(), z.int()]).nullish(),
  receita: z.union([z.number(), z.int()]).nullish(),
  roas: z.union([z.number(), z.int()]).nullish(),
  sessoes: z.union([z.number(), z.int()]).nullish(),
  taxaConversao: z.union([z.number(), z.int()]).nullish(),
  ticketMedio: z.union([z.number(), z.int()]).nullish(),
});

/**
 * AdsDashboardPeriod
 *
 * AdsDashboardPeriod
 */
export const zAdsDashboardPeriod = z.object({
  comparison: z.string().nullish(),
  end: z.string(),
  start: z.string(),
});

/**
 * AdsDashboardChartResponse
 *
 * AdsDashboardChartResponse
 */
export const zAdsDashboardChartResponse = z.object({
  chart: z.string(),
  data: z.array(zAdsDashboardChartDataPoint),
  period: zAdsDashboardPeriod,
  platform: z.string(),
});

/**
 * AdsDashboardKPIResponse
 *
 * AdsDashboardKPIResponse
 */
export const zAdsDashboardKpiResponse = z.object({
  change_percentage: z.union([z.number(), z.int()]).nullish(),
  label: z.string(),
  metric: z.string(),
  period: zAdsDashboardPeriod,
  platform: z.string(),
  previous_period: zAdsDashboardPeriod,
  previous_value: z.union([z.number(), z.int()]),
  trend: z.string(),
  unit: z.string(),
  value: z.union([z.number(), z.int()]),
});

/**
 * CampaignTableItem
 *
 * CampaignTableItem
 */
export const zCampaignTableItem = z.object({
  alcance: z.union([z.number(), z.int()]).nullish(),
  campanha: z.string(),
  cliques: z.union([z.number(), z.int()]),
  cliquesLink: z.union([z.number(), z.int()]).nullish(),
  compras: z.union([z.number(), z.int()]),
  connectRate: z.union([z.number(), z.int()]).nullish(),
  cpa: z.union([z.number(), z.int()]),
  cpcMedio: z.union([z.number(), z.int()]),
  cpm: z.union([z.number(), z.int()]).nullish(),
  ctr: z.union([z.number(), z.int()]),
  ctrTodos: z.union([z.number(), z.int()]).nullish(),
  custoPagDestino: z.union([z.number(), z.int()]).nullish(),
  delta: z.union([z.number(), z.int()]).nullish(),
  frequencia: z.union([z.number(), z.int()]).nullish(),
  impressoes: z.union([z.number(), z.int()]),
  investimento: z.union([z.number(), z.int()]),
  pagDestino: z.union([z.number(), z.int()]).nullish(),
  receita: z.union([z.number(), z.int()]),
  roas: z.union([z.number(), z.int()]),
  table: z.string().nullish().default("campaigns"),
  ticketMedio: z.union([z.number(), z.int()]).nullish(),
  txConversao: z.union([z.number(), z.int()]),
});

/**
 * AdsDashboardPagination
 *
 * AdsDashboardPagination
 */
export const zAdsDashboardPagination = z.object({
  current_page: z.int(),
  page_size: z.int(),
  total_items: z.int(),
  total_pages: z.int(),
});

/**
 * AdsDashboardTableResponseCampaignTableItem
 *
 * AdsDashboardTableResponseCampaignTableItem
 */
export const zAdsDashboardTableResponseCampaignTableItem = z.object({
  items: z.array(zCampaignTableItem),
  pagination: zAdsDashboardPagination,
  period: zAdsDashboardPeriod,
  platform: z.string(),
  table: z.string(),
  total_row: zCampaignTableItem.nullish(),
});

/**
 * CreativeTypeTableItem
 *
 * CreativeTypeTableItem
 */
export const zCreativeTypeTableItem = z.object({
  cliques: z.union([z.number(), z.int()]).nullish(),
  compras: z.union([z.number(), z.int()]).nullish(),
  cpa: z.union([z.number(), z.int()]).nullish(),
  cpcMedio: z.union([z.number(), z.int()]).nullish(),
  creativeType: z.string(),
  ctr: z.union([z.number(), z.int()]).nullish(),
  delta: z.union([z.number(), z.int()]).nullish(),
  impressoes: z.union([z.number(), z.int()]).nullish(),
  investimento: z.union([z.number(), z.int()]).nullish(),
  receita: z.union([z.number(), z.int()]).nullish(),
  roas: z.union([z.number(), z.int()]).nullish(),
  table: z.string().nullish().default("creative-type"),
  ticketMedio: z.union([z.number(), z.int()]).nullish(),
  txConversao: z.union([z.number(), z.int()]).nullish(),
});

/**
 * AdsDashboardTableResponseCreativeTypeTableItem
 *
 * AdsDashboardTableResponseCreativeTypeTableItem
 */
export const zAdsDashboardTableResponseCreativeTypeTableItem = z.object({
  items: z.array(zCreativeTypeTableItem),
  pagination: zAdsDashboardPagination,
  period: zAdsDashboardPeriod,
  platform: z.string(),
  table: z.string(),
  total_row: zCreativeTypeTableItem.nullish(),
});

/**
 * DemographicsTableItem
 *
 * DemographicsTableItem
 */
export const zDemographicsTableItem = z.object({
  compras: z.union([z.number(), z.int()]),
  custoPagDestino: z.union([z.number(), z.int()]),
  delta: z.union([z.number(), z.int()]).nullish(),
  genero: z.string(),
  idade: z.string(),
  investimento: z.union([z.number(), z.int()]),
  pagDestino: z.union([z.number(), z.int()]),
  receita: z.union([z.number(), z.int()]),
  roas: z.union([z.number(), z.int()]),
  table: z.string().nullish().default("demographics"),
  txConversao: z.union([z.number(), z.int()]),
});

/**
 * AdsDashboardTableResponseDemographicsTableItem
 *
 * AdsDashboardTableResponseDemographicsTableItem
 */
export const zAdsDashboardTableResponseDemographicsTableItem = z.object({
  items: z.array(zDemographicsTableItem),
  pagination: zAdsDashboardPagination,
  period: zAdsDashboardPeriod,
  platform: z.string(),
  table: z.string(),
});

/**
 * HourlyTableItem
 *
 * HourlyTableItem
 */
export const zHourlyTableItem = z.object({
  delta: z.union([z.number(), z.int()]).nullish(),
  deltaInvestimento: z.union([z.number(), z.int()]).nullish(),
  hora: z.string(),
  investimento: z.union([z.number(), z.int()]),
  pagDestino: z.union([z.number(), z.int()]),
  receita: z.union([z.number(), z.int()]),
  roas: z.union([z.number(), z.int()]),
  table: z.string().nullish().default("hourly"),
  ticketMedio: z.union([z.number(), z.int()]),
  txConversao: z.union([z.number(), z.int()]),
});

/**
 * AdsDashboardTableResponseHourlyTableItem
 *
 * AdsDashboardTableResponseHourlyTableItem
 */
export const zAdsDashboardTableResponseHourlyTableItem = z.object({
  items: z.array(zHourlyTableItem),
  pagination: zAdsDashboardPagination,
  period: zAdsDashboardPeriod,
  platform: z.string(),
  table: z.string(),
});

/**
 * PositioningTableItem
 *
 * PositioningTableItem
 */
export const zPositioningTableItem = z.object({
  compras: z.union([z.number(), z.int()]),
  custoPagDestino: z.union([z.number(), z.int()]),
  delta: z.union([z.number(), z.int()]).nullish(),
  investimento: z.union([z.number(), z.int()]),
  pagDestino: z.union([z.number(), z.int()]),
  posicionamento: z.string(),
  receita: z.union([z.number(), z.int()]),
  roas: z.union([z.number(), z.int()]),
  table: z.string().nullish().default("positioning"),
  txConversao: z.union([z.number(), z.int()]),
});

/**
 * AdsDashboardTableResponsePositioningTableItem
 *
 * AdsDashboardTableResponsePositioningTableItem
 */
export const zAdsDashboardTableResponsePositioningTableItem = z.object({
  items: z.array(zPositioningTableItem),
  pagination: zAdsDashboardPagination,
  period: zAdsDashboardPeriod,
  platform: z.string(),
  table: z.string(),
});

/**
 * ProductTableItem
 *
 * ProductTableItem
 */
export const zProductTableItem = z.object({
  cliques: z.union([z.number(), z.int()]),
  compras: z.union([z.number(), z.int()]).nullish(),
  cpa: z.union([z.number(), z.int()]).nullish(),
  cpcMedio: z.union([z.number(), z.int()]).nullish(),
  ctr: z.union([z.number(), z.int()]).nullish(),
  delta: z.union([z.number(), z.int()]).nullish(),
  deltaRoas: z.union([z.number(), z.int()]).nullish(),
  impressoes: z.union([z.number(), z.int()]),
  investimento: z.union([z.number(), z.int()]),
  produto: z.string(),
  roas: z.union([z.number(), z.int()]).nullish(),
  table: z.string().nullish().default("products"),
  txConversao: z.union([z.number(), z.int()]).nullish(),
  valorCompras: z.union([z.number(), z.int()]).nullish(),
});

/**
 * AdsDashboardTableResponseProductTableItem
 *
 * AdsDashboardTableResponseProductTableItem
 */
export const zAdsDashboardTableResponseProductTableItem = z.object({
  items: z.array(zProductTableItem),
  pagination: zAdsDashboardPagination,
  period: zAdsDashboardPeriod,
  platform: z.string(),
  table: z.string(),
  total_row: zProductTableItem.nullish(),
});

/**
 * SearchTermTableItem
 *
 * SearchTermTableItem
 */
export const zSearchTermTableItem = z.object({
  cliques: z.union([z.number(), z.int()]),
  compras: z.union([z.number(), z.int()]),
  cpa: z.union([z.number(), z.int()]),
  cpcMedio: z.union([z.number(), z.int()]),
  ctr: z.union([z.number(), z.int()]),
  deltaReceita: z.union([z.number(), z.int()]),
  deltaRoas: z.union([z.number(), z.int()]),
  impressoes: z.union([z.number(), z.int()]),
  investimento: z.union([z.number(), z.int()]),
  receita: z.union([z.number(), z.int()]),
  roas: z.union([z.number(), z.int()]),
  table: z.string().nullish().default("search-terms"),
  termo: z.string(),
  txConversao: z.union([z.number(), z.int()]),
});

/**
 * AdsDashboardTableResponseSearchTermTableItem
 *
 * AdsDashboardTableResponseSearchTermTableItem
 */
export const zAdsDashboardTableResponseSearchTermTableItem = z.object({
  items: z.array(zSearchTermTableItem),
  pagination: zAdsDashboardPagination,
  period: zAdsDashboardPeriod,
  platform: z.string(),
  table: z.string(),
  total_row: zSearchTermTableItem.nullish(),
});

/**
 * UrlDestinationTableItem
 *
 * UrlDestinationTableItem
 */
export const zUrlDestinationTableItem = z.object({
  cliques: z.union([z.number(), z.int()]).nullish(),
  compras: z.union([z.number(), z.int()]).nullish(),
  cpa: z.union([z.number(), z.int()]).nullish(),
  cpcMedio: z.union([z.number(), z.int()]).nullish(),
  ctr: z.union([z.number(), z.int()]).nullish(),
  delta: z.union([z.number(), z.int()]).nullish(),
  impressoes: z.union([z.number(), z.int()]).nullish(),
  investimento: z.union([z.number(), z.int()]).nullish(),
  receita: z.union([z.number(), z.int()]).nullish(),
  roas: z.union([z.number(), z.int()]).nullish(),
  table: z.string().nullish().default("url-destination"),
  ticketMedio: z.union([z.number(), z.int()]).nullish(),
  txConversao: z.union([z.number(), z.int()]).nullish(),
  urlDestino: z.string(),
});

/**
 * AdsDashboardTableResponseUrlDestinationTableItem
 *
 * AdsDashboardTableResponseUrlDestinationTableItem
 */
export const zAdsDashboardTableResponseUrlDestinationTableItem = z.object({
  items: z.array(zUrlDestinationTableItem),
  pagination: zAdsDashboardPagination,
  period: zAdsDashboardPeriod,
  platform: z.string(),
  table: z.string(),
  total_row: zUrlDestinationTableItem.nullish(),
});

/**
 * BenchmarkAvailableMonthsResponse
 *
 * BenchmarkAvailableMonthsResponse
 */
export const zBenchmarkAvailableMonthsResponse = z.object({
  anos_meses: z.array(z.string()),
  ok: z.boolean(),
});

/**
 * BenchmarkMetrics
 *
 * BenchmarkMetrics
 */
export const zBenchmarkMetrics = z.object({
  carrinhos: z.union([z.number(), z.int()]).nullish(),
  cps: z.union([z.number(), z.int()]).nullish(),
  funil_carrinho_pedido: z.union([z.number(), z.int()]).nullish(),
  funil_sessao_carrinho: z.union([z.number(), z.int()]).nullish(),
  google_cpa: z.union([z.number(), z.int()]).nullish(),
  google_cpc: z.union([z.number(), z.int()]).nullish(),
  google_ctr: z.union([z.number(), z.int()]).nullish(),
  google_investimento: z.union([z.number(), z.int()]).nullish(),
  google_receita: z.union([z.number(), z.int()]).nullish(),
  google_roas: z.union([z.number(), z.int()]).nullish(),
  meta_cpc: z.union([z.number(), z.int()]).nullish(),
  meta_cpm: z.union([z.number(), z.int()]).nullish(),
  meta_ctr: z.union([z.number(), z.int()]).nullish(),
  meta_investimento: z.union([z.number(), z.int()]).nullish(),
  meta_receita: z.union([z.number(), z.int()]).nullish(),
  meta_roas: z.union([z.number(), z.int()]).nullish(),
  pedidos: z.union([z.number(), z.int()]).nullish(),
  receita: z.union([z.number(), z.int()]).nullish(),
  roas: z.union([z.number(), z.int()]).nullish(),
  sessoes: z.union([z.number(), z.int()]).nullish(),
  taxa_conversao: z.union([z.number(), z.int()]).nullish(),
  ticket_medio: z.union([z.number(), z.int()]).nullish(),
});

/**
 * RangeValue
 *
 * RangeValue
 */
export const zRangeValue = z.object({
  max: z.union([z.number(), z.int()]).nullish(),
  min: z.union([z.number(), z.int()]).nullish(),
});

/**
 * RankingItem
 *
 * RankingItem
 */
export const zRankingItem = z.object({
  is_current_account: z.boolean().nullish().default(false),
  nome: z.string(),
  receita: z.union([z.number(), z.int()]).nullish(),
  roas: z.union([z.number(), z.int()]).nullish(),
});

/**
 * BenchmarkDataResponse
 *
 * BenchmarkDataResponse
 */
export const zBenchmarkDataResponse = z.object({
  atualizado_em: z.string().nullish(),
  media: zBenchmarkMetrics.nullish(),
  media_anterior: zBenchmarkMetrics.nullish(),
  ok: z.boolean(),
  qtd_lojas_media: z.int().nullish().default(0),
  qtd_lojas_segmento: z.int().nullish().default(0),
  ranges: z.record(z.string(), zRangeValue).nullish(),
  ranking: z.array(zRankingItem).nullish(),
  selected_account: zBenchmarkMetrics.nullish(),
  selected_account_anterior: zBenchmarkMetrics.nullish(),
  selected_account_in_segment: z.boolean().nullish().default(false),
  selected_account_name: z.string().nullish(),
  selected_account_no_data: z.boolean().nullish().default(false),
  selected_account_other_segment: z.boolean().nullish().default(false),
  selected_account_real_segment: z.string().nullish(),
  sem_dados: z.boolean().nullish().default(false),
});

/**
 * BenchmarkFinalizeUpdateResponse
 *
 * BenchmarkFinalizeUpdateResponse
 */
export const zBenchmarkFinalizeUpdateResponse = z.object({
  ok: z.boolean(),
});

/**
 * Loja
 *
 * Loja
 */
export const zLoja = z.object({
  motivo: z.string(),
  nome: z.string(),
  participa: z.boolean(),
  segmento: z.string().nullable(),
  status_ga4: z.string(),
  status_google: z.string(),
  status_meta: z.string(),
});

/**
 * BenchmarkParticipationReportResponse
 *
 * BenchmarkParticipationReportResponse
 */
export const zBenchmarkParticipationReportResponse = z.object({
  lojas: z.array(zLoja),
  ok: z.boolean(),
});

/**
 * BenchmarkSegmentsResponse
 *
 * BenchmarkSegmentsResponse
 */
export const zBenchmarkSegmentsResponse = z.object({
  ok: z.boolean(),
  segmentos: z.array(z.string()),
});

/**
 * BenchmarkSyncAccountResponse
 *
 * BenchmarkSyncAccountResponse
 */
export const zBenchmarkSyncAccountResponse = z.object({
  ok: z.boolean(),
});

/**
 * BenchmarkUpdateAccountResponse
 *
 * BenchmarkUpdateAccountResponse
 */
export const zBenchmarkUpdateAccountResponse = z.object({
  ok: z.boolean(),
  status_ga4: z.string(),
  status_google: z.string(),
  status_meta: z.string(),
});

/**
 * Projeto
 *
 * Projeto
 */
export const zProjeto = z.object({
  id: z.string(),
  nome: z.string(),
});

/**
 * BenchmarkUpdateQueueResponse
 *
 * BenchmarkUpdateQueueResponse
 */
export const zBenchmarkUpdateQueueResponse = z.object({
  ok: z.boolean(),
  projetos: z.array(zProjeto),
});

/**
 * AdsChartData
 *
 * AdsChartData
 */
export const zAdsChartData = z.object({
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]),
  investment_data_type: zDataType.nullish(),
  investment_trend_indicator: zTrendIndicator,
  month_label: z.string(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]),
  revenue_data_type: zDataType.nullish(),
  revenue_trend_indicator: zTrendIndicator,
});

/**
 * AdsTableData
 *
 * AdsTableData
 */
export const zAdsTableData = z.object({
  accesses: z.union([z.number(), z.int()]).nullish().default(0),
  accesses_change_percentage: z
    .union([z.number(), z.int()])
    .nullish()
    .default(0),
  accesses_data_type: zDataType.nullish(),
  accesses_trend_indicator: zTrendIndicator.nullish(),
  average_order_value: z.union([z.number(), z.int()]).nullish().default(0),
  average_order_value_change_percentage: z
    .union([z.number(), z.int()])
    .nullish()
    .default(0),
  average_order_value_data_type: zDataType.nullish(),
  average_order_value_trend_indicator: zTrendIndicator.nullish(),
  clicks: z.union([z.number(), z.int()]).nullish().default(0),
  clicks_change_percentage: z.union([z.number(), z.int()]).nullish().default(0),
  clicks_data_type: zDataType.nullish(),
  clicks_trend_indicator: zTrendIndicator.nullish(),
  conversion_rate: z.union([z.number(), z.int()]).nullish().default(0),
  conversion_rate_change_percentage: z
    .union([z.number(), z.int()])
    .nullish()
    .default(0),
  conversion_rate_data_type: zDataType.nullish(),
  conversion_rate_trend_indicator: zTrendIndicator.nullish(),
  conversions: z.union([z.number(), z.int()]).nullish().default(0),
  conversions_change_percentage: z
    .union([z.number(), z.int()])
    .nullish()
    .default(0),
  conversions_data_type: zDataType.nullish(),
  conversions_trend_indicator: zTrendIndicator.nullish(),
  cpa: z.union([z.number(), z.int()]).nullish().default(0),
  cpa_change_percentage: z.union([z.number(), z.int()]).nullish().default(0),
  cpa_data_type: zDataType.nullish(),
  cpa_trend_indicator: zTrendIndicator.nullish(),
  investment: z.union([z.number(), z.int()]).nullish().default(0),
  investment_change_percentage: z
    .union([z.number(), z.int()])
    .nullish()
    .default(0),
  investment_data_type: zDataType.nullish(),
  investment_trend_indicator: zTrendIndicator.nullish(),
  month_label: z.string(),
  period_display_label: z.string(),
  period_label: z.string(),
  period_start: z.iso.date(),
  revenue: z.union([z.number(), z.int()]).nullish().default(0),
  revenue_change_percentage: z
    .union([z.number(), z.int()])
    .nullish()
    .default(0),
  revenue_data_type: zDataType.nullish(),
  revenue_trend_indicator: zTrendIndicator.nullish(),
  roas: z.union([z.number(), z.int()]).nullish().default(0),
  roas_change_percentage: z.union([z.number(), z.int()]).nullish().default(0),
  roas_data_type: zDataType.nullish(),
  roas_trend_indicator: zTrendIndicator.nullish(),
  website_purchases: z.union([z.number(), z.int()]).nullish().default(0),
  website_purchases_change_percentage: z
    .union([z.number(), z.int()])
    .nullish()
    .default(0),
  website_purchases_data_type: zDataType.nullish(),
  website_purchases_trend_indicator: zTrendIndicator.nullish(),
});

/**
 * AdsPaginationData
 *
 * AdsPaginationData
 */
export const zAdsPaginationData = z.object({
  page: z.int().gte(1),
  page_size: z.int().gte(1),
  total: z.int().gte(0),
  total_pages: z.int().gte(0),
});

/**
 * AdsPlatformData
 *
 * AdsPlatformData
 */
export const zAdsPlatformData = z.object({
  chart: z.array(zAdsChartData),
  items: z.array(zAdsTableData),
  pagination: zAdsPaginationData,
});

/**
 * HistoricalAdsPerformanceResponse
 *
 * HistoricalAdsPerformanceResponse
 */
export const zHistoricalAdsPerformanceResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  google_ads: zAdsPlatformData,
  granularity: z.string(),
  meta_ads: zAdsPlatformData,
  percentage_symbol: z.string().nullish().default("%"),
});

/**
 * HistoricalAdsChartItem
 *
 * HistoricalAdsChartItem
 */
export const zHistoricalAdsChartItem = z.object({
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]),
  investment_data_type: zDataType.nullish(),
  investment_trend_indicator: zTrendIndicator,
  month_label: z.string(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]),
  revenue_data_type: zDataType.nullish(),
  revenue_trend_indicator: zTrendIndicator,
});

/**
 * HistoricalGoogleAdsChartResponse
 *
 * HistoricalGoogleAdsChartResponse
 */
export const zHistoricalGoogleAdsChartResponse = z.object({
  chart: z.array(zHistoricalAdsChartItem),
  currency_symbol: z.string().nullish().default("R$"),
  granularity: z.string(),
  percentage_symbol: z.string().nullish().default("%"),
});

/**
 * HistoricalGoogleAdsTableItem
 *
 * HistoricalGoogleAdsTableItem
 */
export const zHistoricalGoogleAdsTableItem = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z.union([z.number(), z.int()]),
  average_order_value_data_type: zDataType.nullish(),
  average_order_value_trend_indicator: zTrendIndicator,
  clicks: z.union([z.number(), z.int()]),
  clicks_change_percentage: z.union([z.number(), z.int()]),
  clicks_data_type: zDataType.nullish(),
  clicks_trend_indicator: zTrendIndicator,
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: zDataType.nullish(),
  conversion_rate_trend_indicator: zTrendIndicator,
  conversions: z.union([z.number(), z.int()]),
  conversions_change_percentage: z.union([z.number(), z.int()]),
  conversions_data_type: zDataType.nullish(),
  conversions_trend_indicator: zTrendIndicator,
  cpa: z.union([z.number(), z.int()]),
  cpa_change_percentage: z.union([z.number(), z.int()]),
  cpa_data_type: zDataType.nullish(),
  cpa_trend_indicator: zTrendIndicator,
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]),
  investment_data_type: zDataType.nullish(),
  investment_trend_indicator: zTrendIndicator,
  month_label: z.string(),
  period_display_label: z.string(),
  period_label: z.string(),
  period_start: z.iso.date(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]),
  revenue_data_type: zDataType.nullish(),
  revenue_trend_indicator: zTrendIndicator,
  roas: z.union([z.number(), z.int()]),
  roas_change_percentage: z.union([z.number(), z.int()]),
  roas_data_type: zDataType.nullish(),
  roas_trend_indicator: zTrendIndicator,
});

/**
 * HistoricalGoogleAdsTableResponse
 *
 * HistoricalGoogleAdsTableResponse
 */
export const zHistoricalGoogleAdsTableResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  granularity: z.string(),
  items: z.array(zHistoricalGoogleAdsTableItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
});

/**
 * HistoricalMetaAdsChartResponse
 *
 * HistoricalMetaAdsChartResponse
 */
export const zHistoricalMetaAdsChartResponse = z.object({
  chart: z.array(zHistoricalAdsChartItem),
  currency_symbol: z.string().nullish().default("R$"),
  granularity: z.string(),
  percentage_symbol: z.string().nullish().default("%"),
});

/**
 * HistoricalMetaAdsTableItem
 *
 * HistoricalMetaAdsTableItem
 */
export const zHistoricalMetaAdsTableItem = z.object({
  accesses: z.union([z.number(), z.int()]),
  accesses_change_percentage: z.union([z.number(), z.int()]),
  accesses_data_type: zDataType.nullish(),
  accesses_trend_indicator: zTrendIndicator,
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z.union([z.number(), z.int()]),
  average_order_value_data_type: zDataType.nullish(),
  average_order_value_trend_indicator: zTrendIndicator,
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: zDataType.nullish(),
  conversion_rate_trend_indicator: zTrendIndicator,
  cpa: z.union([z.number(), z.int()]),
  cpa_change_percentage: z.union([z.number(), z.int()]),
  cpa_data_type: zDataType.nullish(),
  cpa_trend_indicator: zTrendIndicator,
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]),
  investment_data_type: zDataType.nullish(),
  investment_trend_indicator: zTrendIndicator,
  month_label: z.string(),
  period_display_label: z.string(),
  period_label: z.string(),
  period_start: z.iso.date(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]),
  revenue_data_type: zDataType.nullish(),
  revenue_trend_indicator: zTrendIndicator,
  roas: z.union([z.number(), z.int()]),
  roas_change_percentage: z.union([z.number(), z.int()]),
  roas_data_type: zDataType.nullish(),
  roas_trend_indicator: zTrendIndicator,
  website_purchases: z.union([z.number(), z.int()]),
  website_purchases_change_percentage: z.union([z.number(), z.int()]),
  website_purchases_data_type: zDataType.nullish(),
  website_purchases_trend_indicator: zTrendIndicator,
});

/**
 * HistoricalMetaAdsTableResponse
 *
 * HistoricalMetaAdsTableResponse
 */
export const zHistoricalMetaAdsTableResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  granularity: z.string(),
  items: z.array(zHistoricalMetaAdsTableItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
});

/**
 * MediaPerformanceAovConversionItem
 *
 * MediaPerformanceAovConversionItem
 */
export const zMediaPerformanceAovConversionItem = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z
    .union([z.number(), z.int()])
    .nullish(),
  average_order_value_data_type: z.string().nullish().default("CURRENCY"),
  average_order_value_trend_indicator: z.string().nullish(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string().nullish(),
  month: z.string(),
  month_label: z.string(),
});

/**
 * MediaPerformanceAovConversionSummary
 *
 * MediaPerformanceAovConversionSummary
 */
export const zMediaPerformanceAovConversionSummary = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z
    .union([z.number(), z.int()])
    .nullish(),
  average_order_value_data_type: z.string().nullish().default("CURRENCY"),
  average_order_value_trend_indicator: z.string().nullish(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceAovConversionResponse
 *
 * MediaPerformanceAovConversionResponse
 */
export const zMediaPerformanceAovConversionResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  percentage_symbol: z.string().nullish().default("%"),
  series: z.array(zMediaPerformanceAovConversionItem),
  summary: zMediaPerformanceAovConversionSummary,
});

/**
 * MediaPerformanceCardsResponse
 *
 * MediaPerformanceCardsResponse
 */
export const zMediaPerformanceCardsResponse = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z.union([z.number(), z.int()]),
  average_order_value_data_type: z.string().nullish().default("CURRENCY"),
  average_order_value_trend_indicator: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string(),
  currency_symbol: z.string().nullish().default("R$"),
  engaged_sessions: z.int(),
  engaged_sessions_change_percentage: z.union([z.number(), z.int()]),
  engaged_sessions_data_type: z.string().nullish().default("NUMBER"),
  engaged_sessions_trend_indicator: z.string(),
  engagement_rate: z.union([z.number(), z.int()]),
  engagement_rate_change_percentage: z.union([z.number(), z.int()]),
  engagement_rate_data_type: z.string().nullish().default("PERCENT"),
  engagement_rate_trend_indicator: z.string(),
  orders: z.int(),
  orders_change_percentage: z.union([z.number(), z.int()]),
  orders_data_type: z.string().nullish().default("NUMBER"),
  orders_trend_indicator: z.string(),
  percentage_symbol: z.string().nullish().default("%"),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string(),
  total_users: z.int(),
  total_users_change_percentage: z.union([z.number(), z.int()]),
  total_users_data_type: z.string().nullish().default("NUMBER"),
  total_users_trend_indicator: z.string(),
});

/**
 * ChannelGroupsItem
 *
 * ChannelGroupsItem
 */
export const zChannelGroupsItem = z.object({
  channel_group: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  revenue_share_percentage: z.union([z.number(), z.int()]),
  sessions: z.union([z.number(), z.int()]),
  sessions_share_percentage: z.union([z.number(), z.int()]),
  total_revenue: z.union([z.number(), z.int()]),
  transactions: z.union([z.number(), z.int()]),
});

/**
 * ChannelGroupsSummary
 *
 * ChannelGroupsSummary
 */
export const zChannelGroupsSummary = z.object({
  revenue_change_percentage: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]),
});

/**
 * ChannelGroupsTotalRow
 *
 * ChannelGroupsTotalRow
 */
export const zChannelGroupsTotalRow = z.object({
  channel_group: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  revenue_share_percentage: z.union([z.number(), z.int()]),
  sessions: z.union([z.number(), z.int()]),
  sessions_share_percentage: z.union([z.number(), z.int()]),
  total_revenue: z.union([z.number(), z.int()]),
});

/**
 * ChannelGroupsResponse
 *
 * ChannelGroupsResponse
 */
export const zChannelGroupsResponse = z.object({
  items: z.array(zChannelGroupsItem),
  percentage_symbol: z.string().nullish().default("%"),
  summary: zChannelGroupsSummary,
  total_row: zChannelGroupsTotalRow,
});

/**
 * GeneralPerformanceResponse
 *
 * GeneralPerformanceResponse
 */
export const zGeneralPerformanceResponse = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z.union([z.number(), z.int()]),
  average_order_value_data_type: z.string().nullish().default("CURRENCY"),
  average_order_value_trend_indicator: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string(),
  engaged_sessions: z.int(),
  engaged_sessions_change_percentage: z.union([z.number(), z.int()]),
  engaged_sessions_data_type: z.string().nullish().default("NUMBER"),
  engaged_sessions_trend_indicator: z.string(),
  engagement_rate: z.union([z.number(), z.int()]),
  engagement_rate_change_percentage: z.union([z.number(), z.int()]),
  engagement_rate_data_type: z.string().nullish().default("PERCENT"),
  engagement_rate_trend_indicator: z.string(),
  orders: z.int(),
  orders_change_percentage: z.union([z.number(), z.int()]),
  orders_data_type: z.string().nullish().default("NUMBER"),
  orders_trend_indicator: z.string(),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string(),
  total_users: z.int(),
  total_users_change_percentage: z.union([z.number(), z.int()]),
  total_users_data_type: z.string().nullish().default("NUMBER"),
  total_users_trend_indicator: z.string(),
});

/**
 * MediaPerformanceInvestmentCpsItem
 *
 * MediaPerformanceInvestmentCpsItem
 */
export const zMediaPerformanceInvestmentCpsItem = z.object({
  cps: z.union([z.number(), z.int()]),
  cps_change_percentage: z.union([z.number(), z.int()]).nullish(),
  cps_data_type: z.string().nullish().default("CURRENCY"),
  cps_trend_indicator: z.string().nullish(),
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]).nullish(),
  investment_data_type: z.string().nullish().default("CURRENCY"),
  investment_google: z.union([z.number(), z.int()]),
  investment_meta: z.union([z.number(), z.int()]),
  investment_trend_indicator: z.string().nullish(),
  month: z.string(),
  month_label: z.string(),
});

/**
 * MediaPerformanceInvestmentCpsSummary
 *
 * MediaPerformanceInvestmentCpsSummary
 */
export const zMediaPerformanceInvestmentCpsSummary = z.object({
  cps: z.union([z.number(), z.int()]),
  cps_change_percentage: z.union([z.number(), z.int()]).nullish(),
  cps_data_type: z.string().nullish().default("CURRENCY"),
  cps_trend_indicator: z.string().nullish(),
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]).nullish(),
  investment_data_type: z.string().nullish().default("CURRENCY"),
  investment_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceInvestmentCpsResponse
 *
 * MediaPerformanceInvestmentCpsResponse
 */
export const zMediaPerformanceInvestmentCpsResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  percentage_symbol: z.string().nullish().default("%"),
  series: z.array(zMediaPerformanceInvestmentCpsItem),
  summary: zMediaPerformanceInvestmentCpsSummary,
});

/**
 * MediaPerformanceInvestmentRevenueItem
 *
 * MediaPerformanceInvestmentRevenueItem
 */
export const zMediaPerformanceInvestmentRevenueItem = z.object({
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]).nullish(),
  investment_data_type: z.string().nullish().default("CURRENCY"),
  investment_google: z.union([z.number(), z.int()]),
  investment_meta: z.union([z.number(), z.int()]),
  investment_trend_indicator: z.string().nullish(),
  month: z.string(),
  month_label: z.string(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  revenue_data_type: z.string().nullish().default("CURRENCY"),
  revenue_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceInvestmentRevenueSummary
 *
 * MediaPerformanceInvestmentRevenueSummary
 */
export const zMediaPerformanceInvestmentRevenueSummary = z.object({
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]).nullish(),
  investment_data_type: z.string().nullish().default("CURRENCY"),
  investment_trend_indicator: z.string().nullish(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  revenue_data_type: z.string().nullish().default("CURRENCY"),
  revenue_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceInvestmentRevenueResponse
 *
 * MediaPerformanceInvestmentRevenueResponse
 */
export const zMediaPerformanceInvestmentRevenueResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  percentage_symbol: z.string().nullish().default("%"),
  series: z.array(zMediaPerformanceInvestmentRevenueItem),
  summary: zMediaPerformanceInvestmentRevenueSummary,
});

/**
 * MediaPerformanceInvestmentRoasItem
 *
 * MediaPerformanceInvestmentRoasItem
 */
export const zMediaPerformanceInvestmentRoasItem = z.object({
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]).nullish(),
  investment_data_type: z.string().nullish().default("CURRENCY"),
  investment_google: z.union([z.number(), z.int()]),
  investment_meta: z.union([z.number(), z.int()]),
  investment_trend_indicator: z.string().nullish(),
  month: z.string(),
  month_label: z.string(),
  roas: z.union([z.number(), z.int()]),
  roas_change_percentage: z.union([z.number(), z.int()]).nullish(),
  roas_data_type: z.string().nullish().default("CURRENCY"),
  roas_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceInvestmentRoasSummary
 *
 * MediaPerformanceInvestmentRoasSummary
 */
export const zMediaPerformanceInvestmentRoasSummary = z.object({
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]).nullish(),
  investment_data_type: z.string().nullish().default("CURRENCY"),
  investment_trend_indicator: z.string().nullish(),
  roas: z.union([z.number(), z.int()]),
  roas_change_percentage: z.union([z.number(), z.int()]).nullish(),
  roas_data_type: z.string().nullish().default("CURRENCY"),
  roas_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceInvestmentRoasResponse
 *
 * MediaPerformanceInvestmentRoasResponse
 */
export const zMediaPerformanceInvestmentRoasResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  percentage_symbol: z.string().nullish().default("%"),
  series: z.array(zMediaPerformanceInvestmentRoasItem),
  summary: zMediaPerformanceInvestmentRoasSummary,
});

/**
 * MediaPerformanceInvestmentSessionsItem
 *
 * MediaPerformanceInvestmentSessionsItem
 */
export const zMediaPerformanceInvestmentSessionsItem = z.object({
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]).nullish(),
  investment_data_type: z.string().nullish().default("CURRENCY"),
  investment_google: z.union([z.number(), z.int()]),
  investment_meta: z.union([z.number(), z.int()]),
  investment_trend_indicator: z.string().nullish(),
  month: z.string(),
  month_label: z.string(),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceInvestmentSessionsSummary
 *
 * MediaPerformanceInvestmentSessionsSummary
 */
export const zMediaPerformanceInvestmentSessionsSummary = z.object({
  investment: z.union([z.number(), z.int()]),
  investment_change_percentage: z.union([z.number(), z.int()]).nullish(),
  investment_data_type: z.string().nullish().default("CURRENCY"),
  investment_trend_indicator: z.string().nullish(),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceInvestmentSessionsResponse
 *
 * MediaPerformanceInvestmentSessionsResponse
 */
export const zMediaPerformanceInvestmentSessionsResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  percentage_symbol: z.string().nullish().default("%"),
  series: z.array(zMediaPerformanceInvestmentSessionsItem),
  summary: zMediaPerformanceInvestmentSessionsSummary,
});

/**
 * MediaPerformanceRevenueConversionItem
 *
 * MediaPerformanceRevenueConversionItem
 */
export const zMediaPerformanceRevenueConversionItem = z.object({
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string().nullish(),
  month: z.string(),
  month_label: z.string(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  revenue_data_type: z.string().nullish().default("CURRENCY"),
  revenue_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceRevenueConversionSummary
 *
 * MediaPerformanceRevenueConversionSummary
 */
export const zMediaPerformanceRevenueConversionSummary = z.object({
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string().nullish(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  revenue_data_type: z.string().nullish().default("CURRENCY"),
  revenue_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceRevenueConversionResponse
 *
 * MediaPerformanceRevenueConversionResponse
 */
export const zMediaPerformanceRevenueConversionResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  percentage_symbol: z.string().nullish().default("%"),
  series: z.array(zMediaPerformanceRevenueConversionItem),
  summary: zMediaPerformanceRevenueConversionSummary,
});

/**
 * SessionOriginMediaItem
 *
 * SessionOriginMediaItem
 */
export const zSessionOriginMediaItem = z.object({
  revenue_share_percentage: z.union([z.number(), z.int()]),
  sessions: z.union([z.number(), z.int()]),
  sessions_share_percentage: z.union([z.number(), z.int()]),
  source_medium: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  transactions: z.union([z.number(), z.int()]),
});

/**
 * SessionOriginMediaSummary
 *
 * SessionOriginMediaSummary
 */
export const zSessionOriginMediaSummary = z.object({
  revenue_change_percentage: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]),
});

/**
 * SessionOriginMediaTotalRow
 *
 * SessionOriginMediaTotalRow
 */
export const zSessionOriginMediaTotalRow = z.object({
  revenue_share_percentage: z.union([z.number(), z.int()]),
  sessions: z.union([z.number(), z.int()]),
  sessions_share_percentage: z.union([z.number(), z.int()]),
  source_medium: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
});

/**
 * SessionOriginMediaResponse
 *
 * SessionOriginMediaResponse
 */
export const zSessionOriginMediaResponse = z.object({
  items: z.array(zSessionOriginMediaItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
  summary: zSessionOriginMediaSummary,
  total_row: zSessionOriginMediaTotalRow,
});

/**
 * MediaPerformanceSessionsAovItem
 *
 * MediaPerformanceSessionsAovItem
 */
export const zMediaPerformanceSessionsAovItem = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z
    .union([z.number(), z.int()])
    .nullish(),
  average_order_value_data_type: z.string().nullish().default("CURRENCY"),
  average_order_value_trend_indicator: z.string().nullish(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string().nullish(),
  month: z.string(),
  month_label: z.string(),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceSessionsAovSummary
 *
 * MediaPerformanceSessionsAovSummary
 */
export const zMediaPerformanceSessionsAovSummary = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z
    .union([z.number(), z.int()])
    .nullish(),
  average_order_value_data_type: z.string().nullish().default("CURRENCY"),
  average_order_value_trend_indicator: z.string().nullish(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string().nullish(),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceSessionsAovResponse
 *
 * MediaPerformanceSessionsAovResponse
 */
export const zMediaPerformanceSessionsAovResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  percentage_symbol: z.string().nullish().default("%"),
  series: z.array(zMediaPerformanceSessionsAovItem),
  summary: zMediaPerformanceSessionsAovSummary,
});

/**
 * MediaPerformanceSessionsBreakdownChannelItem
 *
 * MediaPerformanceSessionsBreakdownChannelItem
 */
export const zMediaPerformanceSessionsBreakdownChannelItem = z.object({
  channel_group: z.string(),
  channel_group_data_type: z.string().nullish().default("TEXT"),
  revenue_share_percentage: z.union([z.number(), z.int()]),
  revenue_share_percentage_data_type: z.string().nullish().default("PERCENT"),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_share_percentage: z.union([z.number(), z.int()]),
  sessions_share_percentage_data_type: z.string().nullish().default("PERCENT"),
  sessions_trend_indicator: z.string().nullish(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceSessionsBreakdownChannelsTable
 *
 * MediaPerformanceSessionsBreakdownChannelsTable
 */
export const zMediaPerformanceSessionsBreakdownChannelsTable = z.object({
  items: z.array(zMediaPerformanceSessionsBreakdownChannelItem),
  pagination: zPagination,
});

/**
 * MediaPerformanceSessionsBreakdownSourceItem
 *
 * MediaPerformanceSessionsBreakdownSourceItem
 */
export const zMediaPerformanceSessionsBreakdownSourceItem = z.object({
  conversion_rate: z.union([z.number(), z.int()]),
  revenue_share_percentage: z.union([z.number(), z.int()]),
  revenue_share_percentage_data_type: z.string().nullish().default("PERCENT"),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_share_percentage: z.union([z.number(), z.int()]),
  sessions_share_percentage_data_type: z.string().nullish().default("PERCENT"),
  sessions_trend_indicator: z.string().nullish(),
  source_medium: z.string(),
  source_medium_data_type: z.string().nullish().default("TEXT"),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceSessionsBreakdownSourcesTable
 *
 * MediaPerformanceSessionsBreakdownSourcesTable
 */
export const zMediaPerformanceSessionsBreakdownSourcesTable = z.object({
  items: z.array(zMediaPerformanceSessionsBreakdownSourceItem),
  pagination: zPagination,
});

/**
 * MediaPerformanceSessionsBreakdownResponse
 *
 * MediaPerformanceSessionsBreakdownResponse
 */
export const zMediaPerformanceSessionsBreakdownResponse = z.object({
  channels: zMediaPerformanceSessionsBreakdownChannelsTable,
  currency_symbol: z.string().nullish().default("R$"),
  percentage_symbol: z.string().nullish().default("%"),
  sources: zMediaPerformanceSessionsBreakdownSourcesTable,
});

/**
 * MediaPerformanceSessionsConversionItem
 *
 * MediaPerformanceSessionsConversionItem
 */
export const zMediaPerformanceSessionsConversionItem = z.object({
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string().nullish(),
  month: z.string(),
  month_label: z.string(),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceSessionsConversionSummary
 *
 * MediaPerformanceSessionsConversionSummary
 */
export const zMediaPerformanceSessionsConversionSummary = z.object({
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string().nullish(),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceSessionsConversionResponse
 *
 * MediaPerformanceSessionsConversionResponse
 */
export const zMediaPerformanceSessionsConversionResponse = z.object({
  percentage_symbol: z.string().nullish().default("%"),
  series: z.array(zMediaPerformanceSessionsConversionItem),
  summary: zMediaPerformanceSessionsConversionSummary,
});

/**
 * MediaPerformanceSessionsRevenueItem
 *
 * MediaPerformanceSessionsRevenueItem
 */
export const zMediaPerformanceSessionsRevenueItem = z.object({
  month: z.string(),
  month_label: z.string(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  revenue_data_type: z.string().nullish().default("CURRENCY"),
  revenue_trend_indicator: z.string().nullish(),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceSessionsRevenueSummary
 *
 * MediaPerformanceSessionsRevenueSummary
 */
export const zMediaPerformanceSessionsRevenueSummary = z.object({
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  revenue_data_type: z.string().nullish().default("CURRENCY"),
  revenue_trend_indicator: z.string().nullish(),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceSessionsRevenueResponse
 *
 * MediaPerformanceSessionsRevenueResponse
 */
export const zMediaPerformanceSessionsRevenueResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  percentage_symbol: z.string().nullish().default("%"),
  series: z.array(zMediaPerformanceSessionsRevenueItem),
  summary: zMediaPerformanceSessionsRevenueSummary,
});

/**
 * MediaPerformanceSessionsRoasItem
 *
 * MediaPerformanceSessionsRoasItem
 */
export const zMediaPerformanceSessionsRoasItem = z.object({
  month: z.string(),
  month_label: z.string(),
  roas: z.union([z.number(), z.int()]),
  roas_change_percentage: z.union([z.number(), z.int()]).nullish(),
  roas_data_type: z.string().nullish().default("NUMBER"),
  roas_trend_indicator: z.string().nullish(),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceSessionsRoasSummary
 *
 * MediaPerformanceSessionsRoasSummary
 */
export const zMediaPerformanceSessionsRoasSummary = z.object({
  roas: z.union([z.number(), z.int()]),
  roas_change_percentage: z.union([z.number(), z.int()]).nullish(),
  roas_data_type: z.string().nullish().default("NUMBER"),
  roas_trend_indicator: z.string().nullish(),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string().nullish(),
});

/**
 * MediaPerformanceSessionsRoasResponse
 *
 * MediaPerformanceSessionsRoasResponse
 */
export const zMediaPerformanceSessionsRoasResponse = z.object({
  percentage_symbol: z.string().nullish().default("%"),
  series: z.array(zMediaPerformanceSessionsRoasItem),
  summary: zMediaPerformanceSessionsRoasSummary,
});

/**
 * SegmentItem
 */
export const zSegmentItem = z.object({
  name: z.string(),
  slug: z.string(),
});

/**
 * SegmentListResponse
 */
export const zSegmentListResponse = z.object({
  segments: z.array(zSegmentItem),
});

/**
 * LojaVirtualAnalyticsResponse
 *
 * LojaVirtualAnalyticsResponse
 */
export const zLojaVirtualAnalyticsResponse = z.object({
  investimento_total: z.union([z.number(), z.int()]),
  investimento_total_data_type: z.string(),
  investimento_total_trend_indicator: z.string(),
  marketing: z.union([z.number(), z.int()]),
  marketing_data_type: z.string(),
  marketing_trend_indicator: z.string(),
  pedidos: z.int(),
  pedidos_data_type: z.string(),
  pedidos_trend_indicator: z.string(),
  receita_total: z.union([z.number(), z.int()]),
  receita_total_data_type: z.string(),
  receita_total_projection: z.union([z.number(), z.int()]),
  receita_total_projection_data_type: z.string(),
  receita_total_projection_trend_indicator: z.string(),
  receita_total_trend_indicator: z.string(),
  roas: z.union([z.number(), z.int()]),
  roas_data_type: z.string(),
  roas_trend_indicator: z.string(),
  sessoes: z.int(),
  sessoes_data_type: z.string(),
  sessoes_trend_indicator: z.string(),
  taxa_conversao: z.union([z.number(), z.int()]),
  taxa_conversao_data_type: z.string(),
  taxa_conversao_trend_indicator: z.string(),
  ticket_medio: z.union([z.number(), z.int()]),
  ticket_medio_data_type: z.string(),
  ticket_medio_trend_indicator: z.string(),
});

/**
 * ProductsCardsResponse
 *
 * ProductsCardsResponse
 */
export const zProductsCardsResponse = z.object({
  average_item_quantity: z.union([z.number(), z.int()]),
  average_item_quantity_change_percentage: z.union([z.number(), z.int()]),
  average_item_quantity_data_type: z.string().nullish().default("NUMBER"),
  average_item_quantity_trend_indicator: z.string(),
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z.union([z.number(), z.int()]),
  average_order_value_data_type: z.string().nullish().default("CURRENCY"),
  average_order_value_trend_indicator: z.string(),
  average_ticket: z.union([z.number(), z.int()]),
  average_ticket_change_percentage: z.union([z.number(), z.int()]),
  average_ticket_data_type: z.string().nullish().default("CURRENCY"),
  average_ticket_trend_indicator: z.string(),
  average_unit_amount: z.union([z.number(), z.int()]),
  average_unit_amount_change_percentage: z.union([z.number(), z.int()]),
  average_unit_amount_data_type: z.string().nullish().default("CURRENCY"),
  average_unit_amount_trend_indicator: z.string(),
  average_unit_value: z.union([z.number(), z.int()]),
  average_unit_value_change_percentage: z.union([z.number(), z.int()]),
  average_unit_value_data_type: z.string().nullish().default("CURRENCY"),
  average_unit_value_trend_indicator: z.string(),
  avg_items_per_order: z.union([z.number(), z.int()]),
  avg_items_per_order_change_percentage: z.union([z.number(), z.int()]),
  avg_items_per_order_data_type: z.string().nullish().default("NUMBER"),
  avg_items_per_order_trend_indicator: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string(),
  currency_symbol: z.string().nullish().default("R$"),
  item_revenue: z.union([z.number(), z.int()]),
  item_revenue_change_percentage: z.union([z.number(), z.int()]),
  item_revenue_data_type: z.string().nullish().default("CURRENCY"),
  item_revenue_trend_indicator: z.string(),
  items_purchased: z.int(),
  items_purchased_change_percentage: z.union([z.number(), z.int()]),
  items_purchased_data_type: z.string().nullish().default("NUMBER"),
  items_purchased_trend_indicator: z.string(),
  orders: z.int(),
  orders_change_percentage: z.union([z.number(), z.int()]),
  orders_data_type: z.string().nullish().default("NUMBER"),
  orders_trend_indicator: z.string(),
  percentage_symbol: z.string().nullish().default("%"),
  session_conversion_rate: z.union([z.number(), z.int()]),
  session_conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  session_conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  session_conversion_rate_trend_indicator: z.string(),
  transactions: z.int(),
  transactions_change_percentage: z.union([z.number(), z.int()]),
  transactions_data_type: z.string().nullish().default("NUMBER"),
  transactions_trend_indicator: z.string(),
});

/**
 * ProductsDashboardGeoItem
 *
 * ProductsDashboardGeoItem
 */
export const zProductsDashboardGeoItem = z.object({
  city: z.string().nullish(),
  city_data_type: z.string().nullish(),
  item_revenue: z.union([z.number(), z.int()]),
  item_revenue_change_percentage: z.union([z.number(), z.int()]),
  item_revenue_data_type: z.string().nullish().default("CURRENCY"),
  item_revenue_trend_indicator: z.string(),
  items_purchased: z.int(),
  items_purchased_change_percentage: z.union([z.number(), z.int()]),
  items_purchased_data_type: z.string().nullish().default("NUMBER"),
  items_purchased_trend_indicator: z.string(),
  region: z.string().nullish(),
  region_data_type: z.string().nullish(),
});

/**
 * ProductsDashboardGeoResponse
 *
 * ProductsDashboardGeoResponse
 */
export const zProductsDashboardGeoResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zProductsDashboardGeoItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
});

/**
 * ProductsTopCategoriesRevenueTrendPoint
 *
 * ProductsTopCategoriesRevenueTrendPoint
 */
export const zProductsTopCategoriesRevenueTrendPoint = z.object({
  month: z.string(),
  revenue: z.union([z.number(), z.int()]),
});

/**
 * ProductsTopCategoriesRevenueTrendSeriesItem
 *
 * ProductsTopCategoriesRevenueTrendSeriesItem
 */
export const zProductsTopCategoriesRevenueTrendSeriesItem = z.object({
  category_name: z.string(),
  points: z.array(zProductsTopCategoriesRevenueTrendPoint),
  revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_trend_indicator: z.string(),
});

/**
 * ProductsTopCategoriesRevenueTrendResponse
 *
 * ProductsTopCategoriesRevenueTrendResponse
 */
export const zProductsTopCategoriesRevenueTrendResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  percentage_symbol: z.string().nullish().default("%"),
  series: z.array(zProductsTopCategoriesRevenueTrendSeriesItem),
});

/**
 * ProductsDashboardTopSellingResponse
 *
 * ProductsDashboardTopSellingResponse
 */
export const zProductsDashboardTopSellingResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zConversionRateFullTableItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
  total_row: zConversionRateFullTableItem,
});

/**
 * ProductsDashboardFullResponse
 *
 * ProductsDashboardFullResponse
 */
export const zProductsDashboardFullResponse = z.object({
  categories_by_city: zProductsDashboardGeoResponse,
  categories_by_region: zProductsDashboardGeoResponse,
  top_products_revenue_trend: zProductsTopCategoriesRevenueTrendResponse,
  top_selling_products: zProductsDashboardTopSellingResponse,
});

/**
 * GeneralItemPerformanceResponse
 *
 * GeneralItemPerformanceResponse
 */
export const zGeneralItemPerformanceResponse = z.object({
  average_item_quantity: z.union([z.number(), z.int()]),
  average_item_quantity_change_percentage: z
    .union([z.number(), z.int()])
    .nullish(),
  average_item_quantity_data_type: z.string().nullish().default("NUMBER"),
  average_item_quantity_trend_indicator: z.string(),
  average_ticket: z.union([z.number(), z.int()]),
  average_ticket_change_percentage: z.union([z.number(), z.int()]).nullish(),
  average_ticket_data_type: z.string().nullish().default("CURRENCY"),
  average_ticket_trend_indicator: z.string(),
  average_unit_amount: z.union([z.number(), z.int()]),
  average_unit_amount_change_percentage: z
    .union([z.number(), z.int()])
    .nullish(),
  average_unit_amount_data_type: z.string().nullish().default("CURRENCY"),
  average_unit_amount_trend_indicator: z.string(),
  item_revenue: z.union([z.number(), z.int()]),
  item_revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  item_revenue_data_type: z.string().nullish().default("CURRENCY"),
  item_revenue_trend_indicator: z.string(),
  items_purchased: z.union([z.number(), z.int()]),
  items_purchased_change_percentage: z.union([z.number(), z.int()]).nullish(),
  items_purchased_data_type: z.string().nullish().default("NUMBER"),
  items_purchased_trend_indicator: z.string(),
  session_conversion_rate: z.union([z.number(), z.int()]),
  session_conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  transactions: z.union([z.number(), z.int()]),
  transactions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  transactions_data_type: z.string().nullish().default("NUMBER"),
  transactions_trend_indicator: z.string(),
});

/**
 * ProductsRevenueTrendTableItem
 *
 * ProductsRevenueTrendTableItem
 */
export const zProductsRevenueTrendTableItem = z.object({
  item_category: z.string(),
  item_name: z.string(),
  items_added_to_cart: z.union([z.number(), z.int()]),
  items_added_to_cart_change_percentage: z.union([z.number(), z.int()]),
  items_purchased: z.union([z.number(), z.int()]),
  items_purchased_change_percentage: z.union([z.number(), z.int()]),
  items_viewed: z.union([z.number(), z.int()]),
  items_viewed_change_percentage: z.union([z.number(), z.int()]),
  purchase_revenue: z.union([z.number(), z.int()]),
  purchase_revenue_change_percentage: z.union([z.number(), z.int()]),
  session_conversion_rate: z.union([z.number(), z.int()]),
  session_conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  tx_carrinho: z.union([z.number(), z.int()]),
  tx_carrinho_change_percentage: z.union([z.number(), z.int()]),
  tx_conv_itens: z.union([z.number(), z.int()]),
  tx_conv_itens_change_percentage: z.union([z.number(), z.int()]),
});

/**
 * ProductsRevenueTrendPoint
 *
 * ProductsRevenueTrendPoint
 */
export const zProductsRevenueTrendPoint = z.object({
  month: z.string(),
  revenue: z.union([z.number(), z.int()]),
});

/**
 * ProductsRevenueTrendSeriesItem
 *
 * ProductsRevenueTrendSeriesItem
 */
export const zProductsRevenueTrendSeriesItem = z.object({
  points: z.array(zProductsRevenueTrendPoint),
  product_name: z.string(),
  revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_trend_indicator: z.string(),
});

/**
 * ProductsRevenueTrendResponse
 *
 * ProductsRevenueTrendResponse
 */
export const zProductsRevenueTrendResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zProductsRevenueTrendTableItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
  series: z.array(zProductsRevenueTrendSeriesItem),
  total_row: zProductsRevenueTrendTableItem.nullish(),
});

/**
 * ProductsTopCategorySalesChanges
 *
 * ProductsTopCategorySalesChanges
 */
export const zProductsTopCategorySalesChanges = z.object({
  conversion_rate: z.union([z.number(), z.int()]).nullish().default(0),
  items_added_to_cart: z.union([z.number(), z.int()]).nullish().default(0),
  items_purchased: z.union([z.number(), z.int()]).nullish().default(0),
  purchase_revenue: z.union([z.number(), z.int()]).nullish().default(0),
});

/**
 * ProductsTopCategorySalesResponse
 *
 * ProductsTopCategorySalesResponse
 */
export const zProductsTopCategorySalesResponse = z.object({
  category_name: z.string().nullish().default("N/D"),
  category_name_data_type: zDataType.nullish(),
  changes: zProductsTopCategorySalesChanges,
  conversion_rate: z.union([z.number(), z.int()]).nullish().default(0),
  conversion_rate_change_percentage: z
    .union([z.number(), z.int()])
    .nullish()
    .default(0),
  conversion_rate_data_type: zDataType.nullish(),
  conversion_rate_trend_indicator: zTrendIndicator.nullish(),
  currency_symbol: z.string().nullish().default("R$"),
  items_added_to_cart: z.union([z.number(), z.int()]).nullish().default(0),
  items_added_to_cart_change_percentage: z
    .union([z.number(), z.int()])
    .nullish()
    .default(0),
  items_added_to_cart_data_type: zDataType.nullish(),
  items_added_to_cart_trend_indicator: zTrendIndicator.nullish(),
  items_purchased: z.union([z.number(), z.int()]).nullish().default(0),
  items_purchased_change_percentage: z
    .union([z.number(), z.int()])
    .nullish()
    .default(0),
  items_purchased_data_type: zDataType.nullish(),
  items_purchased_trend_indicator: zTrendIndicator.nullish(),
  percentage_symbol: z.string().nullish().default("%"),
  purchase_revenue: z.union([z.number(), z.int()]).nullish().default(0),
  purchase_revenue_change_percentage: z
    .union([z.number(), z.int()])
    .nullish()
    .default(0),
  purchase_revenue_data_type: zDataType.nullish(),
  purchase_revenue_trend_indicator: zTrendIndicator.nullish(),
});

/**
 * RevenueDashboardPerDay
 *
 * RevenueDashboardPerDay
 */
export const zRevenueDashboardPerDay = z.object({
  date_label: z.string(),
  google_investment: z.union([z.number(), z.int()]),
  google_investment_data_type: z.string().nullish().default("CURRENCY"),
  meta_investment: z.union([z.number(), z.int()]),
  meta_investment_data_type: z.string().nullish().default("CURRENCY"),
  orders: z.int(),
  orders_data_type: z.string().nullish().default("NUMBER"),
  roas: z.union([z.number(), z.int()]),
  roas_data_type: z.string().nullish().default("PERCENT"),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
});

/**
 * RevenueDashboardPerHour
 *
 * RevenueDashboardPerHour
 */
export const zRevenueDashboardPerHour = z.object({
  google_investment: z.union([z.number(), z.int()]).nullish().default(0),
  google_investment_data_type: z.string().nullish().default("CURRENCY"),
  hour: z.int(),
  meta_investment: z.union([z.number(), z.int()]).nullish().default(0),
  meta_investment_data_type: z.string().nullish().default("CURRENCY"),
  orders: z.int(),
  orders_data_type: z.string().nullish().default("NUMBER"),
  roas: z.union([z.number(), z.int()]).nullish().default(0),
  roas_data_type: z.string().nullish().default("PERCENT"),
  sessions: z.int(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
});

/**
 * RevenueDashboardPerMonth
 *
 * RevenueDashboardPerMonth
 */
export const zRevenueDashboardPerMonth = z.object({
  google_investment: z.union([z.number(), z.int()]),
  google_investment_data_type: z.string().nullish().default("CURRENCY"),
  meta_investment: z.union([z.number(), z.int()]),
  meta_investment_data_type: z.string().nullish().default("CURRENCY"),
  month_label: z.string(),
  roas: z.union([z.number(), z.int()]),
  roas_data_type: z.string().nullish().default("PERCENT"),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  transactions: z.int(),
  transactions_data_type: z.string().nullish().default("NUMBER"),
});

/**
 * RevenueDashboardPerWeekday
 *
 * RevenueDashboardPerWeekday
 */
export const zRevenueDashboardPerWeekday = z.object({
  google_investment: z.union([z.number(), z.int()]),
  google_investment_data_type: z.string().nullish().default("CURRENCY"),
  meta_investment: z.union([z.number(), z.int()]),
  meta_investment_data_type: z.string().nullish().default("CURRENCY"),
  orders: z.int(),
  orders_data_type: z.string().nullish().default("NUMBER"),
  roas: z.union([z.number(), z.int()]),
  roas_data_type: z.string().nullish().default("PERCENT"),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  weekday_index: z.int(),
  weekday_label: z.string(),
});

/**
 * RevenueDashboardCharts
 *
 * RevenueDashboardCharts
 */
export const zRevenueDashboardCharts = z.object({
  per_day: z.array(zRevenueDashboardPerDay),
  per_hour: z.array(zRevenueDashboardPerHour),
  per_month: z.array(zRevenueDashboardPerMonth),
  per_weekday: z.array(zRevenueDashboardPerWeekday),
});

/**
 * RevenueDashboardKPIs
 *
 * RevenueDashboardKPIs
 */
export const zRevenueDashboardKpis = z.object({
  average_order_value: z.union([z.number(), z.int()]),
  average_order_value_change_percentage: z.union([z.number(), z.int()]),
  average_order_value_data_type: z.string().nullish().default("CURRENCY"),
  average_order_value_trend_indicator: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string(),
  currency_symbol: z.string().nullish().default("R$"),
  engaged_sessions: z.int(),
  engaged_sessions_change_percentage: z.union([z.number(), z.int()]),
  engaged_sessions_data_type: z.string().nullish().default("NUMBER"),
  engaged_sessions_trend_indicator: z.string(),
  engagement_rate: z.union([z.number(), z.int()]),
  engagement_rate_change_percentage: z.union([z.number(), z.int()]),
  engagement_rate_data_type: z.string().nullish().default("PERCENT"),
  engagement_rate_trend_indicator: z.string(),
  google_investment: z.union([z.number(), z.int()]),
  google_investment_change_percentage: z.union([z.number(), z.int()]),
  google_investment_data_type: z.string().nullish().default("CURRENCY"),
  google_investment_trend_indicator: z.string(),
  meta_investment: z.union([z.number(), z.int()]),
  meta_investment_change_percentage: z.union([z.number(), z.int()]),
  meta_investment_data_type: z.string().nullish().default("CURRENCY"),
  meta_investment_trend_indicator: z.string(),
  orders: z.int(),
  orders_change_percentage: z.union([z.number(), z.int()]),
  orders_data_type: z.string().nullish().default("NUMBER"),
  orders_trend_indicator: z.string(),
  percentage_symbol: z.string().nullish().default("%"),
  roas: z.union([z.number(), z.int()]),
  roas_change_percentage: z.union([z.number(), z.int()]),
  roas_data_type: z.string().nullish().default("PERCENT"),
  roas_trend_indicator: z.string(),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string(),
  total_investment: z.union([z.number(), z.int()]),
  total_investment_change_percentage: z.union([z.number(), z.int()]),
  total_investment_data_type: z.string().nullish().default("CURRENCY"),
  total_investment_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string(),
  total_users: z.int(),
  total_users_change_percentage: z.union([z.number(), z.int()]),
  total_users_data_type: z.string().nullish().default("NUMBER"),
  total_users_trend_indicator: z.string(),
});

/**
 * RevenueDashboardResponse
 *
 * RevenueDashboardResponse
 */
export const zRevenueDashboardResponse = z.object({
  charts: zRevenueDashboardCharts,
  currency_symbol: z.string().nullish().default("R$"),
  kpis: zRevenueDashboardKpis,
});

/**
 * ChannelData
 *
 * Dados por canal de aquisição
 */
export const zChannelData = z.object({
  color: z.string(),
  name: z.string(),
  orders: z.int(),
  revenue: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  value: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
});

/**
 * DeviceData
 *
 * Dados por dispositivo
 */
export const zDeviceData = z.object({
  color: z.string(),
  name: z.string(),
  orders: z.int(),
  revenue: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  value: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
});

/**
 * GeographyData
 *
 * Dados geográficos
 */
export const zGeographyData = z.object({
  orders: z.int(),
  participation: z.string(),
  revenue: z.string(),
  state: z.string(),
});

/**
 * DailyPerformance
 *
 * Performance diária por canal
 */
export const zDailyPerformance = z.object({
  date: z.string(),
  direct: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  email: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  google_ads: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  meta_ads: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  organic: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  total: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
});

/**
 * SalesMetrics
 *
 * Métricas detalhadas de vendas
 */
export const zSalesMetrics = z.object({
  change_percentage: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  conversion_rate: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  orders: z.int(),
  revenue: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  ticket: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  trend: z.string(),
});

/**
 * SalesOverview
 *
 * Visão geral das vendas
 */
export const zSalesOverview = z.object({
  average_ticket: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  conversion_rate: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  period_end: z.iso.date(),
  period_start: z.iso.date(),
  total_orders: z.int(),
  total_revenue: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
});

/**
 * SalesTrend
 *
 * Tendência de vendas
 */
export const zSalesTrend = z.object({
  name: z.string(),
  orders: z.int(),
  revenue: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
  ticket: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
});

/**
 * TopCategorySalesItem
 *
 * TopCategorySalesItem
 */
export const zTopCategorySalesItem = z.object({
  category_name: z.string(),
  category_name_data_type: z.string().nullish().default("TEXT"),
  changes: zAnalyticsItemChanges,
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string(),
  items_added_to_cart: z.int(),
  items_added_to_cart_change_percentage: z.union([z.number(), z.int()]),
  items_added_to_cart_data_type: z.string().nullish().default("NUMBER"),
  items_added_to_cart_trend_indicator: z.string(),
  items_purchased: z.int(),
  items_purchased_change_percentage: z.union([z.number(), z.int()]),
  items_purchased_data_type: z.string().nullish().default("NUMBER"),
  items_purchased_trend_indicator: z.string(),
  items_viewed: z.int().nullish(),
  items_viewed_change_percentage: z
    .union([z.number(), z.int()])
    .nullish()
    .default(0),
  items_viewed_data_type: z.string().nullish().default("NUMBER"),
  items_viewed_trend_indicator: z.string().nullish().default("up"),
  purchase_revenue: z.union([z.number(), z.int()]),
  purchase_revenue_change_percentage: z.union([z.number(), z.int()]),
  purchase_revenue_data_type: z.string().nullish().default("CURRENCY"),
  purchase_revenue_trend_indicator: z.string(),
  session_conversion_rate: z.union([z.number(), z.int()]).nullish(),
  session_conversion_rate_data_type: z.string().nullish(),
  session_conversion_rate_trend_indicator: z.string().nullish(),
  sessions: z.int().nullish(),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string().nullish(),
  cart_rate: z.number().nullish(),
  cart_rate_change_percentage: z.number().nullish(),
  cart_rate_data_type: z.string().nullish().default("PERCENT"),
  cart_rate_trend_indicator: z.string().nullish(),
});

/**
 * SyncStatus
 *
 * SyncStatus
 */
export const zSyncStatus = z.object({
  is_syncing: z.boolean(),
  message: z.string(),
});

/**
 * TopCategorySalesAsyncResponse
 *
 * TopCategorySalesAsyncResponse
 */
export const zTopCategorySalesAsyncResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zTopCategorySalesItem),
  pagination: zPagination.nullish(),
  percentage_symbol: z.string().nullish().default("%"),
  sync_status: zSyncStatus.nullish(),
  total_items: z.int(),
  total_row: zTopCategorySalesItem.nullish(),
});

/**
 * PagesAllPagesItem
 *
 * PagesAllPagesItem
 */
export const zPagesAllPagesItem = z.object({
  activeUsers: z.union([z.number(), z.int()]).nullish().default(0),
  activeUsers_data_type: zDataType.nullish(),
  activeUsers_percent_change: z.union([z.number(), z.int()]),
  activeUsers_trend_indicator: zTrendIndicator,
  averageEngagementTime: z.union([z.number(), z.int()]).nullish().default(0),
  averageEngagementTime_data_type: zDataType.nullish(),
  averageEngagementTime_percent_change: z.union([z.number(), z.int()]),
  averageEngagementTime_trend_indicator: zTrendIndicator,
  eventCount: z.union([z.number(), z.int()]).nullish().default(0),
  eventCountPerUser: z.union([z.number(), z.int()]).nullish().default(0),
  eventCountPerUser_data_type: zDataType.nullish(),
  eventCount_data_type: zDataType.nullish(),
  eventCount_percent_change: z.union([z.number(), z.int()]),
  eventCount_trend_indicator: zTrendIndicator,
  keyEvents: z.union([z.number(), z.int()]).nullish().default(0),
  keyEvents_data_type: zDataType.nullish(),
  keyEvents_percent_change: z.union([z.number(), z.int()]),
  keyEvents_trend_indicator: zTrendIndicator,
  pagePath: z.string().nullish(),
  pageTitle: z.string().nullish(),
  purchaseRevenue: z.union([z.number(), z.int()]).nullish().default(0),
  purchaseRevenue_data_type: zDataType.nullish(),
  purchaseRevenue_percent_change: z.union([z.number(), z.int()]),
  purchaseRevenue_trend_indicator: zTrendIndicator,
  screenPageViews: z.union([z.number(), z.int()]).nullish().default(0),
  screenPageViews_data_type: zDataType.nullish(),
  screenPageViews_percent_change: z.union([z.number(), z.int()]),
  screenPageViews_trend_indicator: zTrendIndicator,
  sessions: z.union([z.number(), z.int()]).nullish().default(0),
  sessions_data_type: zDataType.nullish(),
  sessions_percent_change: z.union([z.number(), z.int()]),
  sessions_trend_indicator: zTrendIndicator,
  transactions: z.union([z.number(), z.int()]).nullish().default(0),
  transactions_data_type: zDataType.nullish(),
  transactions_percent_change: z.union([z.number(), z.int()]),
  transactions_trend_indicator: zTrendIndicator,
});

/**
 * PaginationGeneral
 *
 * PaginationGeneral
 */
export const zPaginationGeneral = z.object({
  page: z.int().gte(1),
  page_size: z.int().gte(1),
  total_items: z.int().gte(0),
  total_pages: z.int().gte(0),
});

/**
 * PagesAllPagesTotals
 *
 * PagesAllPagesTotals
 */
export const zPagesAllPagesTotals = z.object({
  activeUsers: z.union([z.number(), z.int()]).nullish().default(0),
  activeUsers_data_type: zDataType.nullish(),
  activeUsers_percent_change: z.union([z.number(), z.int()]),
  activeUsers_trend_indicator: zTrendIndicator,
  averageEngagementTime: z.union([z.number(), z.int()]).nullish().default(0),
  averageEngagementTime_data_type: zDataType.nullish(),
  averageEngagementTime_percent_change: z.union([z.number(), z.int()]),
  averageEngagementTime_trend_indicator: zTrendIndicator,
  eventCount: z.union([z.number(), z.int()]).nullish().default(0),
  eventCountPerUser: z.union([z.number(), z.int()]).nullish().default(0),
  eventCountPerUser_data_type: zDataType.nullish(),
  eventCount_data_type: zDataType.nullish(),
  eventCount_percent_change: z.union([z.number(), z.int()]),
  eventCount_trend_indicator: zTrendIndicator,
  keyEvents: z.union([z.number(), z.int()]).nullish().default(0),
  keyEvents_data_type: zDataType.nullish(),
  keyEvents_percent_change: z.union([z.number(), z.int()]),
  keyEvents_trend_indicator: zTrendIndicator,
  pagePath: z.string().nullish(),
  pageTitle: z.string().nullish().default("Total Geral"),
  purchaseRevenue: z.union([z.number(), z.int()]).nullish().default(0),
  purchaseRevenue_data_type: zDataType.nullish(),
  purchaseRevenue_percent_change: z.union([z.number(), z.int()]),
  purchaseRevenue_trend_indicator: zTrendIndicator,
  screenPageViews: z.union([z.number(), z.int()]).nullish().default(0),
  screenPageViews_data_type: zDataType.nullish(),
  screenPageViews_percent_change: z.union([z.number(), z.int()]),
  screenPageViews_trend_indicator: zTrendIndicator,
  sessions: z.union([z.number(), z.int()]).nullish().default(0),
  sessions_data_type: zDataType.nullish(),
  sessions_percent_change: z.union([z.number(), z.int()]),
  sessions_trend_indicator: zTrendIndicator,
  transactions: z.union([z.number(), z.int()]).nullish().default(0),
  transactions_data_type: zDataType.nullish(),
  transactions_percent_change: z.union([z.number(), z.int()]),
  transactions_trend_indicator: zTrendIndicator,
});

/**
 * PagesAllPagesResponse
 *
 * PagesAllPagesResponse
 */
export const zPagesAllPagesResponse = z.object({
  data: z.array(zPagesAllPagesItem),
  items: z.array(zPagesAllPagesItem),
  pagination: zPaginationGeneral,
  totals: zPagesAllPagesTotals,
});

/**
 * CategoryByCityItem
 *
 * CategoryByCityItem
 */
export const zCategoryByCityItem = z.object({
  city: z.string(),
  city_data_type: z.string().nullish().default("TEXT"),
  item_category: z.string(),
  item_category_data_type: z.string().nullish().default("TEXT"),
  item_revenue: z.union([z.number(), z.int()]),
  item_revenue_change_percentage: z.union([z.number(), z.int()]),
  item_revenue_data_type: z.string().nullish().default("CURRENCY"),
  item_revenue_trend_indicator: z.string(),
});

/**
 * CategoryByCityResponse
 *
 * CategoryByCityResponse
 */
export const zCategoryByCityResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zCategoryByCityItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
});

/**
 * CategoryByRegionItem
 *
 * CategoryByRegionItem
 */
export const zCategoryByRegionItem = z.object({
  item_category: z.string(),
  item_category_data_type: z.string().nullish().default("TEXT"),
  item_revenue: z.union([z.number(), z.int()]),
  item_revenue_change_percentage: z.union([z.number(), z.int()]),
  item_revenue_data_type: z.string().nullish().default("CURRENCY"),
  item_revenue_trend_indicator: z.string(),
  region: z.string(),
  region_data_type: z.string().nullish().default("TEXT"),
});

/**
 * CategoryByRegionResponse
 *
 * CategoryByRegionResponse
 */
export const zCategoryByRegionResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zCategoryByRegionItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
});

/**
 * DevicesSalesItem
 *
 * DevicesSalesItem
 */
export const zDevicesSalesItem = z.object({
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_trend_indicator: z.string(),
  device: z.string(),
  device_data_type: z.string().nullish().default("TEXT"),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string(),
  transactions: z.int(),
});

/**
 * DevicesSalesResponse
 *
 * DevicesSalesResponse
 */
export const zDevicesSalesResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zDevicesSalesItem),
  percentage_symbol: z.string().nullish().default("%"),
  total_row: zDevicesSalesItem,
});

/**
 * DevicesPieItem
 *
 * DevicesPieItem
 */
export const zDevicesPieItem = z.object({
  name: z.string(),
  value: z.union([z.number(), z.int()]),
  value_data_type: z.string().nullish().default("PERCENT"),
});

/**
 * DevicesCharts
 *
 * DevicesCharts
 */
export const zDevicesCharts = z.object({
  revenue: z.array(zDevicesPieItem),
  sessions: z.array(zDevicesPieItem),
});

/**
 * DevicesTableItem
 *
 * DevicesTableItem
 */
export const zDevicesTableItem = z.object({
  device: z.string(),
  device_data_type: z.string().nullish().default("TEXT"),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string(),
});

/**
 * DevicesTable
 *
 * DevicesTable
 */
export const zDevicesTable = z.object({
  items: z.array(zDevicesTableItem),
  pagination: zPagination,
});

/**
 * DevicesSubResponse
 *
 * DevicesSubResponse
 */
export const zDevicesSubResponse = z.object({
  charts: zDevicesCharts,
  table: zDevicesTable,
});

/**
 * StatesTableItem
 *
 * StatesTableItem
 */
export const zStatesTableItem = z.object({
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string(),
  region: z.string(),
  region_data_type: z.string().nullish().default("TEXT"),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string(),
});

/**
 * StatesTable
 *
 * StatesTable
 */
export const zStatesTable = z.object({
  items: z.array(zStatesTableItem),
  pagination: zPagination,
});

/**
 * DevicesStatesCardResponse
 *
 * DevicesStatesCardResponse
 */
export const zDevicesStatesCardResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  devices: zDevicesSubResponse,
  percentage_symbol: z.string().nullish().default("%"),
  states: zStatesTable,
});

/**
 * InternalSearchCardItem
 *
 * InternalSearchCardItem
 */
export const zInternalSearchCardItem = z.object({
  search_term: z.string(),
  search_term_data_type: z.string().nullish().default("TEXT"),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string(),
});

/**
 * InternalSearchCardResponse
 *
 * InternalSearchCardResponse
 */
export const zInternalSearchCardResponse = z.object({
  items: z.array(zInternalSearchCardItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
  total_row: zInternalSearchCardItem,
});

/**
 * PagesLandingPageItem
 *
 * PagesLandingPageItem
 */
export const zPagesLandingPageItem = z.object({
  arpu: z.union([z.number(), z.int()]).nullish().default(0),
  arpu_data_type: zDataType.nullish(),
  arpu_percent_change: z.union([z.number(), z.int()]),
  arpu_trend_indicator: zTrendIndicator,
  paginaDestino: z.string().nullish(),
  pedidos: z.union([z.number(), z.int()]).nullish().default(0),
  pedidos_data_type: zDataType.nullish(),
  pedidos_percent_change: z.union([z.number(), z.int()]),
  pedidos_trend_indicator: zTrendIndicator,
  receitaTotal: z.union([z.number(), z.int()]).nullish().default(0),
  receitaTotal_data_type: zDataType.nullish(),
  receitaTotal_percent_change: z.union([z.number(), z.int()]),
  receitaTotal_trend_indicator: zTrendIndicator,
  sessoes: z.union([z.number(), z.int()]).nullish().default(0),
  sessoes_data_type: zDataType.nullish(),
  sessoes_percent_change: z.union([z.number(), z.int()]),
  sessoes_trend_indicator: zTrendIndicator,
  ticketMedio: z.union([z.number(), z.int()]).nullish().default(0),
  ticketMedio_data_type: zDataType.nullish(),
  ticketMedio_percent_change: z.union([z.number(), z.int()]),
  ticketMedio_trend_indicator: zTrendIndicator,
  totalUsers: z.union([z.number(), z.int()]).nullish().default(0),
  totalUsers_data_type: zDataType.nullish(),
  totalUsers_percent_change: z.union([z.number(), z.int()]),
  totalUsers_trend_indicator: zTrendIndicator,
  txConversao: z.union([z.number(), z.int()]).nullish().default(0),
  txConversao_data_type: zDataType.nullish(),
  txConversao_percent_change: z.union([z.number(), z.int()]),
  txConversao_trend_indicator: zTrendIndicator,
  valorSessao: z.union([z.number(), z.int()]).nullish().default(0),
  valorSessao_data_type: zDataType.nullish(),
  valorSessao_percent_change: z.union([z.number(), z.int()]),
  valorSessao_trend_indicator: zTrendIndicator,
});

/**
 * PagesLandingPageTotals
 *
 * PagesLandingPageTotals
 */
export const zPagesLandingPageTotals = z.object({
  arpu: z.union([z.number(), z.int()]).nullish().default(0),
  arpu_data_type: zDataType.nullish(),
  arpu_percent_change: z.union([z.number(), z.int()]),
  arpu_trend_indicator: zTrendIndicator,
  paginaDestino: z.string().nullish().default("Total Geral"),
  pedidos: z.union([z.number(), z.int()]).nullish().default(0),
  pedidos_data_type: zDataType.nullish(),
  pedidos_percent_change: z.union([z.number(), z.int()]),
  pedidos_trend_indicator: zTrendIndicator,
  receitaTotal: z.union([z.number(), z.int()]).nullish().default(0),
  receitaTotal_data_type: zDataType.nullish(),
  receitaTotal_percent_change: z.union([z.number(), z.int()]),
  receitaTotal_trend_indicator: zTrendIndicator,
  sessoes: z.union([z.number(), z.int()]).nullish().default(0),
  sessoes_data_type: zDataType.nullish(),
  sessoes_percent_change: z.union([z.number(), z.int()]),
  sessoes_trend_indicator: zTrendIndicator,
  ticketMedio: z.union([z.number(), z.int()]).nullish().default(0),
  ticketMedio_data_type: zDataType.nullish(),
  ticketMedio_percent_change: z.union([z.number(), z.int()]),
  ticketMedio_trend_indicator: zTrendIndicator,
  totalUsers: z.union([z.number(), z.int()]).nullish().default(0),
  totalUsers_data_type: zDataType.nullish(),
  totalUsers_percent_change: z.union([z.number(), z.int()]),
  totalUsers_trend_indicator: zTrendIndicator,
  txConversao: z.union([z.number(), z.int()]).nullish().default(0),
  txConversao_data_type: zDataType.nullish(),
  txConversao_percent_change: z.union([z.number(), z.int()]),
  txConversao_trend_indicator: zTrendIndicator,
  valorSessao: z.union([z.number(), z.int()]).nullish().default(0),
  valorSessao_data_type: zDataType.nullish(),
  valorSessao_percent_change: z.union([z.number(), z.int()]),
  valorSessao_trend_indicator: zTrendIndicator,
});

/**
 * PagesLandingPageResponse
 *
 * PagesLandingPageResponse
 */
export const zPagesLandingPageResponse = z.object({
  data: z.array(zPagesLandingPageItem),
  pagination: zPaginationGeneral,
  totals: zPagesLandingPageTotals,
});

/**
 * PagesSourceMediumItem
 *
 * PagesSourceMediumItem
 */
export const zPagesSourceMediumItem = z.object({
  origem_midia: z.string().nullish(),
  origem_midia_data_type: zDataType.nullish(),
  pedidos: z.int().nullish().default(0),
  pedidos_change_percentage: z.union([z.number(), z.int()]),
  pedidos_data_type: zDataType.nullish(),
  pedidos_trend_indicator: zTrendIndicator,
  receita_total: z.union([z.number(), z.int()]).nullish().default(0),
  receita_total_change_percentage: z.union([z.number(), z.int()]),
  receita_total_data_type: zDataType.nullish(),
  receita_total_trend_indicator: zTrendIndicator,
  sessoes: z.int().nullish().default(0),
  sessoes_change_percentage: z.union([z.number(), z.int()]),
  sessoes_data_type: zDataType.nullish(),
  sessoes_trend_indicator: zTrendIndicator,
  taxa_conversao: z.union([z.number(), z.int()]).nullish().default(0),
  taxa_conversao_change_percentage: z.union([z.number(), z.int()]),
  taxa_conversao_data_type: zDataType.nullish(),
  taxa_conversao_trend_indicator: zTrendIndicator,
  ticket_medio: z.union([z.number(), z.int()]).nullish().default(0),
  ticket_medio_change_percentage: z.union([z.number(), z.int()]),
  ticket_medio_data_type: zDataType.nullish(),
  ticket_medio_trend_indicator: zTrendIndicator,
  usuarios_ativos: z.int().nullish().default(0),
  usuarios_ativos_change_percentage: z.union([z.number(), z.int()]),
  usuarios_ativos_data_type: zDataType.nullish(),
  usuarios_ativos_trend_indicator: zTrendIndicator,
});

/**
 * PaginationSourceMedium
 *
 * PaginationSourceMedium
 */
export const zPaginationSourceMedium = z.object({
  current_page: z.int().gte(1),
  page_size: z.int().gte(1),
  total_items: z.int().gte(0),
  total_pages: z.int().gte(0),
});

/**
 * PagesSourceMediumTotal
 *
 * PagesSourceMediumTotal
 */
export const zPagesSourceMediumTotal = z.object({
  origem_midia: z.string().nullish().default("Total Geral"),
  origem_midia_data_type: zDataType.nullish(),
  pedidos: z.int().nullish().default(0),
  pedidos_change_percentage: z.union([z.number(), z.int()]),
  pedidos_data_type: zDataType.nullish(),
  pedidos_trend_indicator: zTrendIndicator,
  receita_total: z.union([z.number(), z.int()]).nullish().default(0),
  receita_total_change_percentage: z.union([z.number(), z.int()]),
  receita_total_data_type: zDataType.nullish(),
  receita_total_trend_indicator: zTrendIndicator,
  sessoes: z.int().nullish().default(0),
  sessoes_change_percentage: z.union([z.number(), z.int()]),
  sessoes_data_type: zDataType.nullish(),
  sessoes_trend_indicator: zTrendIndicator,
  taxa_conversao: z.union([z.number(), z.int()]).nullish().default(0),
  taxa_conversao_change_percentage: z.union([z.number(), z.int()]),
  taxa_conversao_data_type: zDataType.nullish(),
  taxa_conversao_trend_indicator: zTrendIndicator,
  ticket_medio: z.union([z.number(), z.int()]).nullish().default(0),
  ticket_medio_change_percentage: z.union([z.number(), z.int()]),
  ticket_medio_data_type: zDataType.nullish(),
  ticket_medio_trend_indicator: zTrendIndicator,
  usuarios_ativos: z.int().nullish().default(0),
  usuarios_ativos_change_percentage: z.union([z.number(), z.int()]),
  usuarios_ativos_data_type: zDataType.nullish(),
  usuarios_ativos_trend_indicator: zTrendIndicator,
});

/**
 * PagesSourceMediumResponse
 *
 * PagesSourceMediumResponse
 */
export const zPagesSourceMediumResponse = z.object({
  items: z.array(zPagesSourceMediumItem),
  pagination: zPaginationSourceMedium,
  total: zPagesSourceMediumTotal,
});

/**
 * RegionsProductsByCityItem
 *
 * RegionsProductsByCityItem
 */
export const zRegionsProductsByCityItem = z.object({
  city: z.string(),
  city_data_type: z.string().nullish().default("TEXT"),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string(),
  item_revenue: z.union([z.number(), z.int()]),
  item_revenue_change_percentage: z.union([z.number(), z.int()]),
  item_revenue_data_type: z.string().nullish().default("CURRENCY"),
  item_revenue_trend_indicator: z.string(),
  items_purchased: z.union([z.number(), z.int()]),
  items_purchased_change_percentage: z.union([z.number(), z.int()]),
  items_purchased_data_type: z.string().nullish().default("NUMBER"),
  items_purchased_trend_indicator: z.string(),
});

/**
 * RegionsProductsByCityResponse
 *
 * RegionsProductsByCityResponse
 */
export const zRegionsProductsByCityResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zRegionsProductsByCityItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
});

/**
 * RegionsSalesItem
 *
 * RegionsSalesItem
 */
export const zRegionsSalesItem = z.object({
  city: z.string().nullish(),
  city_data_type: z.string().nullish(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]),
  conversion_rate_data_type: z.string().nullish().default("PERCENT"),
  conversion_rate_trend_indicator: z.string(),
  country: z.string().nullish(),
  country_data_type: z.string().nullish(),
  region: z.string().nullish(),
  region_data_type: z.string().nullish(),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]),
  sessions_data_type: z.string().nullish().default("NUMBER"),
  sessions_trend_indicator: z.string(),
  total_revenue: z.union([z.number(), z.int()]),
  total_revenue_change_percentage: z.union([z.number(), z.int()]),
  total_revenue_data_type: z.string().nullish().default("CURRENCY"),
  total_revenue_trend_indicator: z.string(),
  transactions: z.int(),
  transactions_data_type: z.string().nullish().default("NUMBER"),
});

/**
 * AnalyticsPagination
 *
 * AnalyticsPagination
 */
export const zAnalyticsPagination = z.object({
  page: z.int().gte(1),
  page_size: z.int().gte(1),
  total: z.int().gte(0),
  total_items: z.int().nullish(),
  total_pages: z.int().gte(0),
});

/**
 * RegionsSalesResponse
 *
 * RegionsSalesResponse
 */
export const zRegionsSalesResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zRegionsSalesItem),
  pagination: zAnalyticsPagination,
  percentage_symbol: z.string().nullish().default("%"),
  total_row: zRegionsSalesItem,
});

/**
 * RegionCategoryItem
 *
 * RegionCategoryItem
 */
export const zRegionCategoryItem = z.object({
  region: z.string(),
  region_label: z.string(),
  state: z.string(),
  state_abbr: z.string(),
  values: z.record(z.string(), z.union([z.number(), z.int()])),
});

/**
 * RegionsDashboardMetadata
 *
 * RegionsDashboardMetadata
 */
export const zRegionsDashboardMetadata = z.object({
  aggregation_level: z.string().nullish(),
});

/**
 * RegionsDashboardCategoriesResponse
 *
 * RegionsDashboardCategoriesResponse
 */
export const zRegionsDashboardCategoriesResponse = z.object({
  categories: z.array(z.string()),
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zRegionCategoryItem),
  metadata: zRegionsDashboardMetadata.nullish(),
});

/**
 * RegionsCategoryMatrixItem
 *
 * Pivot-table row: region + dynamic category revenue columns + total.
 */
export const zRegionsCategoryMatrixItem = z.object({
  additional_properties: z
    .record(z.string(), z.number())
    .optional()
    .default({}),
  region: z.string(),
  total: z.union([z.number(), z.int()]),
});

/**
 * RegionsCategoryMatrixResponse
 *
 * RegionsCategoryMatrixResponse
 */
export const zRegionsCategoryMatrixResponse = z.object({
  categories: z.array(z.string()),
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zRegionsCategoryMatrixItem),
  pagination: zPagination,
});

/**
 * RegionCityItem
 *
 * RegionCityItem
 */
export const zRegionCityItem = z.object({
  city: z.string(),
  conversion_rate: z.union([z.number(), z.int()]),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_trend_indicator: z.string(),
  orders: z.union([z.number(), z.int()]),
  orders_change_percentage: z.union([z.number(), z.int()]).nullish(),
  orders_trend_indicator: z.string(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  revenue_trend_indicator: z.string(),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions_trend_indicator: z.string(),
  ticket_medio: z.union([z.number(), z.int()]).nullish(),
  ticket_medio_change_percentage: z.union([z.number(), z.int()]).nullish(),
});

/**
 * RegionsDashboardCitiesResponse
 *
 * RegionsDashboardCitiesResponse
 */
export const zRegionsDashboardCitiesResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zRegionCityItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
});

/**
 * RegionItem
 *
 * RegionItem
 */
export const zRegionItem = z.object({
  cart_rate: z.union([z.number(), z.int()]).nullish(),
  cart_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  cart_rate_trend_indicator: z.string(),
  conversion_rate: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_trend_indicator: z.string(),
  item_name: z.string(),
  item_revenue: z.union([z.number(), z.int()]),
  item_revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  item_revenue_trend_indicator: z.string(),
  items_added_to_cart: z.union([z.number(), z.int()]),
  items_added_to_cart_change_percentage: z
    .union([z.number(), z.int()])
    .nullish(),
  items_added_to_cart_trend_indicator: z.string(),
  items_purchased: z.union([z.number(), z.int()]),
  items_purchased_change_percentage: z.union([z.number(), z.int()]).nullish(),
  items_purchased_trend_indicator: z.string(),
  items_viewed: z.union([z.number(), z.int()]),
  items_viewed_change_percentage: z.union([z.number(), z.int()]).nullish(),
  items_viewed_trend_indicator: z.string(),
  sessions: z.int(),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  tx_conv_sessions: z.union([z.number(), z.int()]).nullish(),
  tx_conv_sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  users: z.int(),
  users_change_percentage: z.union([z.number(), z.int()]).nullish(),
});

/**
 * RegionsDashboardItemsResponse
 *
 * RegionsDashboardItemsResponse
 */
export const zRegionsDashboardItemsResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zRegionItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
});

/**
 * RegionStateItem
 *
 * RegionStateItem
 */
export const zRegionStateItem = z.object({
  conversion_rate: z.union([z.number(), z.int()]).nullish(),
  conversion_rate_change_percentage: z.union([z.number(), z.int()]).nullish(),
  cps: z.union([z.number(), z.int()]).nullish(),
  cps_change_percentage: z.union([z.number(), z.int()]).nullish(),
  invest_google: z.union([z.number(), z.int()]),
  invest_google_change_percentage: z.union([z.number(), z.int()]).nullish(),
  invest_meta: z.union([z.number(), z.int()]),
  invest_meta_change_percentage: z.union([z.number(), z.int()]).nullish(),
  region: z.string(),
  region_label: z.string(),
  revenue: z.union([z.number(), z.int()]),
  revenue_change_percentage: z.union([z.number(), z.int()]).nullish(),
  roas: z.union([z.number(), z.int()]).nullish(),
  roas_change_percentage: z.union([z.number(), z.int()]).nullish(),
  sessions: z.union([z.number(), z.int()]),
  sessions_change_percentage: z.union([z.number(), z.int()]).nullish(),
  state: z.string(),
  state_abbr: z.string(),
  ticket_medio: z.union([z.number(), z.int()]).nullish(),
  ticket_medio_change_percentage: z.union([z.number(), z.int()]).nullish(),
  transactions: z.int(),
  transactions_change_percentage: z.union([z.number(), z.int()]).nullish(),
});

/**
 * RegionsDashboardStatesResponse
 *
 * RegionsDashboardStatesResponse
 */
export const zRegionsDashboardStatesResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  items: z.array(zRegionStateItem),
  pagination: zPagination,
  percentage_symbol: z.string().nullish().default("%"),
});

/**
 * RegionInvestmentPayload
 *
 * RegionInvestmentPayload
 */
export const zRegionInvestmentPayload = z.object({
  google: z.union([z.number(), z.int()]),
  meta: z.union([z.number(), z.int()]),
});

/**
 * RegionMetricPayload
 *
 * RegionMetricPayload
 */
export const zRegionMetricPayload = z.object({
  change_percentage: z.union([z.number(), z.int()]).nullish(),
  trend: z.string(),
  value: z.union([z.number(), z.int()]).nullish(),
});

/**
 * RegionSummaryItem
 *
 * RegionSummaryItem
 */
export const zRegionSummaryItem = z.object({
  investments: zRegionInvestmentPayload,
  label: z.string(),
  metrics: z.record(z.string(), zRegionMetricPayload),
  sessions: z.union([z.number(), z.int()]),
  slug: z.string(),
  states: z.array(z.string()),
});

/**
 * RegionsDashboardSummaryResponse
 *
 * RegionsDashboardSummaryResponse
 */
export const zRegionsDashboardSummaryResponse = z.object({
  currency_symbol: z.string().nullish().default("R$"),
  percentage_symbol: z.string().nullish().default("%"),
  regions: z.array(zRegionSummaryItem),
});

/**
 * Body_continue_agent_chat_api_v1_ai_agents_chat_post
 */
export const zBodyContinueAgentChatApiV1AiAgentsChatPost = z.object({
  chat_history: z.string().optional().default("[]"),
  conversation_id: z.string().nullish(),
  files: z.array(z.string()).nullish(),
  filters: z.string().optional().default("{}"),
  insight: z.string(),
  source: z.string(),
  user_message: z.string(),
});

/**
 * AgentChatAttachment
 */
export const zAgentChatAttachment = z.object({
  content_type: z.string(),
  name: z.string(),
  size: z.string(),
  snippet: z.string(),
});

/**
 * AgentChatResponse
 */
export const zAgentChatResponse = z.object({
  attachments: z.array(zAgentChatAttachment),
  conversation_id: z.string().nullish(),
  response: z.string(),
  source: z.string(),
});

/**
 * AgentHistoryMessageItem
 */
export const zAgentHistoryMessageItem = z.object({
  content: z.string(),
  created_at: z.string().nullish(),
  role: z.string(),
});

/**
 * AgentHistoryPaginationInfo
 */
export const zAgentHistoryPaginationInfo = z.object({
  limit: z.int().optional().default(10),
  page: z.int().optional().default(1),
  total: z.int().optional().default(0),
  total_pages: z.int().optional().default(0),
});

/**
 * AgentConversationHistoryResponse
 */
export const zAgentConversationHistoryResponse = z.object({
  conversation_id: z.string(),
  messages: z.array(zAgentHistoryMessageItem).optional().default([]),
  pagination: zAgentHistoryPaginationInfo.nullish(),
});

/**
 * AgentInsightFilters
 */
export const zAgentInsightFilters = z.object({
  end_date: z.string(),
  previous_end_date: z.string(),
  previous_start_date: z.string(),
  start_date: z.string(),
});

/**
 * AgentInsightResponse
 */
export const zAgentInsightResponse = z.object({
  conversation_id: z.string().nullish(),
  filters: zAgentInsightFilters,
  message: z.string().nullish(),
  source: z.string(),
  started_at: z.string().nullish(),
  user_id: z.string().nullish(),
});

/**
 * ChatMessage
 */
export const zChatMessage = z.object({
  content: z.string().optional().default(""),
  role: z.string().optional().default("user"),
});

/**
 * InsightItem
 */
export const zInsightItem = z.object({
  confidence: z.int().nullish(),
  description: z.string().nullish(),
  id: z.string().nullish(),
  impact: z.string().nullish(),
  priority: z.int().nullish(),
  recommendation: z.string().nullish(),
  source: z.string().nullish(),
  status: z.string().nullish(),
  title: z.string().nullish(),
  type: z.string().nullish(),
});

/**
 * ContinueChatRequest
 */
export const zContinueChatRequest = z.object({
  chat_history: z.array(zChatMessage).optional(),
  context_data: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .optional(),
  insight: zInsightItem.optional(),
  user_message: z.string().optional().default(""),
});

/**
 * ContinueChatResponse
 */
export const zContinueChatResponse = z.object({
  response: z.string(),
});

/**
 * GenerateInsightsRequest
 */
export const zGenerateInsightsRequest = z.object({
  integrations: z
    .array(
      z.record(
        z.string(),
        z
          .union([
            z.int(),
            z.string(),
            z.boolean(),
            z.number(),
            z.array(z.string()),
          ])
          .nullable(),
      ),
    )
    .optional(),
  metrics: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .optional(),
  problematicIntegrations: z
    .array(
      z.record(
        z.string(),
        z
          .union([
            z.int(),
            z.string(),
            z.boolean(),
            z.number(),
            z.array(z.string()),
          ])
          .nullable(),
      ),
    )
    .optional(),
});

/**
 * GenerateInsightsResponse
 */
export const zGenerateInsightsResponse = z.object({
  insights: z.array(zInsightItem).optional(),
});

/**
 * ImplementationStepsRequest
 */
export const zImplementationStepsRequest = z.object({
  context_data: z
    .record(
      z.string(),
      z
        .union([
          z.int(),
          z.string(),
          z.boolean(),
          z.number(),
          z.array(z.string()),
        ])
        .nullable(),
    )
    .optional(),
  insight: zInsightItem.optional(),
});

/**
 * ImplementationStepsResponse
 */
export const zImplementationStepsResponse = z.object({
  difficulty: z.string().nullish(),
  estimatedTime: z.string().nullish(),
  expectedImpact: z.string().nullish(),
  resources: z.array(z.string()).optional(),
  steps: z.array(z.string()).optional(),
});

/**
 * DiagnosticPageType
 */
export const zDiagnosticPageType = z.enum(["home", "category", "product"]);

/**
 * DiagnosticAnalysisListItem
 */
export const zDiagnosticAnalysisListItem = z.object({
  analysis_id: z.string(),
  created_at: z.string().nullish(),
  page_types: z.array(zDiagnosticPageType).optional(),
  score_geral: z.int().nullish(),
  site_url: z.string(),
  updated_at: z.string().nullish(),
});

/**
 * DiagnosticAnalysisListResponse
 */
export const zDiagnosticAnalysisListResponse = z.object({
  analyses: z.array(zDiagnosticAnalysisListItem).optional(),
});

/**
 * DiagnosticPhase
 */
export const zDiagnosticPhase = z.object({
  at: z.string(),
  key: z.string(),
  label: z.string(),
});

/**
 * DiagnosticChecklistStatus
 */
export const zDiagnosticChecklistStatus = z.enum([
  "ok",
  "falha",
  "atencao",
  "nao_confirmado",
]);

/**
 * DiagnosticChecklistItem
 */
export const zDiagnosticChecklistItem = z.object({
  dimensao: z.string(),
  item: z.string(),
  status: zDiagnosticChecklistStatus,
});

/**
 * DiagnosticDimensionScore
 */
export const zDiagnosticDimensionScore = z.object({
  detalhe: z.string(),
  score: z.int().gte(0).lte(100),
});

/**
 * DiagnosticDimensions
 *
 * As 10 dimensões pontuadas em toda auditoria.
 *
 * `copy` fica no wire com esse nome, mas o atributo Python precisa ser
 * `copy_text`: um campo chamado `copy` colidiria com `BaseModel.copy`.
 */
export const zDiagnosticDimensions = z.object({
  checkout: zDiagnosticDimensionScore,
  copy: zDiagnosticDimensionScore,
  homepage: zDiagnosticDimensionScore,
  marketing: zDiagnosticDimensionScore,
  merchandising: zDiagnosticDimensionScore,
  mobile: zDiagnosticDimensionScore,
  navegacao: zDiagnosticDimensionScore,
  performance: zDiagnosticDimensionScore,
  produto: zDiagnosticDimensionScore,
  prova_social: zDiagnosticDimensionScore,
});

/**
 * DiagnosticPotential
 */
export const zDiagnosticPotential = z.enum(["alto", "medio", "baixo"]);

/**
 * DiagnosticOpportunity
 */
export const zDiagnosticOpportunity = z.object({
  descricao: z.string(),
  potencial: zDiagnosticPotential,
  titulo: z.string(),
});

/**
 * DiagnosticEsforco
 */
export const zDiagnosticEsforco = z.enum(["baixo", "medio", "alto"]);

/**
 * DiagnosticImpacto
 */
export const zDiagnosticImpacto = z.enum(["alto", "medio", "baixo"]);

/**
 * DiagnosticPrazo
 */
export const zDiagnosticPrazo = z.enum(["imediato", "curto", "medio"]);

/**
 * DiagnosticActionItem
 */
export const zDiagnosticActionItem = z.object({
  descricao: z.string(),
  esforco: zDiagnosticEsforco,
  impacto: zDiagnosticImpacto,
  prazo: zDiagnosticPrazo,
  prioridade: z.int().gte(1),
  titulo: z.string(),
});

/**
 * DiagnosticSeverity
 */
export const zDiagnosticSeverity = z.enum(["alto", "moderado", "baixo"]);

/**
 * DiagnosticProblem
 */
export const zDiagnosticProblem = z.object({
  categoria: z.string(),
  descricao: z.string(),
  severidade: zDiagnosticSeverity,
  titulo: z.string(),
});

/**
 * DiagnosticResult
 */
export const zDiagnosticResult = z.object({
  checklist: z.array(zDiagnosticChecklistItem).optional(),
  dimensoes: zDiagnosticDimensions,
  oportunidades: z.array(zDiagnosticOpportunity).optional(),
  plano_acao: z.array(zDiagnosticActionItem).optional(),
  problemas: z.array(zDiagnosticProblem).optional(),
  score_geral: z.int().gte(0).lte(100),
});

/**
 * DiagnosticJobStatusResponse
 */
export const zDiagnosticJobStatusResponse = z.object({
  analysis_id: z.string(),
  created_at: z.string().nullish(),
  error: z.string().nullish(),
  finished_at: z.string().nullish(),
  job_id: z.string(),
  page_type: zDiagnosticPageType,
  phases: z.array(zDiagnosticPhase).optional(),
  result: zDiagnosticResult.nullish(),
  score: z.int().nullish(),
  started_at: z.string().nullish(),
  status: z.string(),
  updated_at: z.string().nullish(),
  url: z.string(),
});

/**
 * DiagnosticAnalysisDetailResponse
 */
export const zDiagnosticAnalysisDetailResponse = z.object({
  analysis_id: z.string(),
  created_at: z.string().nullish(),
  pages: z.array(zDiagnosticJobStatusResponse).optional(),
  score_geral: z.int().nullish(),
  site_url: z.string(),
  updated_at: z.string().nullish(),
});

/**
 * DiagnosticAnalyzeRequest
 */
export const zDiagnosticAnalyzeRequest = z.object({
  analysis_id: z.uuid().nullish(),
  customer_uuid: z.string().nullish(),
  page_type: zDiagnosticPageType,
  url: z.string().min(1).max(2000),
});

/**
 * DiagnosticAnalyzeResponse
 */
export const zDiagnosticAnalyzeResponse = z.object({
  analysis_id: z.string(),
  credits_remaining: z.int().nullish(),
  job_id: z.string(),
  page_type: zDiagnosticPageType,
  status: z.string(),
});

/**
 * ChatHistoryMessage
 */
export const zChatHistoryMessage = z.object({
  content: z.string(),
  created_at: z.string().nullish(),
  failed: z.boolean().nullish().default(false),
  job_id: z.uuid().nullish(),
  role: z.string(),
});

/**
 * ResolveConversationResponse
 */
export const zResolveConversationResponse = z.object({
  conversation_id: z.string(),
  created_at: z.string().nullish(),
  messages: z.array(zChatHistoryMessage).optional(),
});

/**
 * ConversationListItem
 */
export const zConversationListItem = z.object({
  conversation_id: z.string(),
  created_at: z.string().nullish(),
  title: z.string().nullish(),
  updated_at: z.string().nullish(),
});

/**
 * ConversationListResponse
 */
export const zConversationListResponse = z.object({
  conversations: z.array(zConversationListItem).optional(),
  limit: z.int().optional().default(20),
});

/**
 * StartConversationRequest
 */
export const zStartConversationRequest = z.object({
  account_id: z.string().nullish(),
  customer_uuid: z.string().nullish(),
  end_date: z.iso.date().nullish(),
  start_date: z.iso.date().nullish(),
});

/**
 * StartConversationResponse
 */
export const zStartConversationResponse = z.object({
  conversation_id: z.string(),
  created_at: z.string().nullish(),
});

/**
 * RenameRequest
 */
export const zRenameRequest = z.object({
  title: z.string().min(1).max(200),
});

/**
 * AskRequest
 */
export const zAskRequest = z.object({
  customer_uuid: z.string().nullish(),
  message: z.string().min(1),
});

/**
 * AskResponse
 */
export const zAskResponse = z.object({
  conversation_id: z.string(),
  credits_remaining: z.int().nullish(),
  job_id: z.string(),
  status: z.string(),
});

/**
 * JobStatusResponse
 */
export const zApiMediaChatJobStatusResponse = z.object({
  answer: z.string().nullish(),
  conversation_id: z.string(),
  created_at: z.string().nullish(),
  error: z.string().nullish(),
  finished_at: z.string().nullish(),
  job_id: z.string(),
  phases: z.array(z.record(z.string(), z.unknown())).optional(),
  started_at: z.string().nullish(),
  status: z.string(),
  updated_at: z.string().nullish(),
});

/**
 * TeamItem
 */
export const zTeamItem = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  is_active: z.boolean(),
  member_count: z.int(),
  account_count: z.int(),
  created_at: z.string(),
  updated_at: z.string(),
});

/**
 * TeamListResponse
 */
export const zTeamListResponse = z.object({
  data: z.array(zTeamItem),
});

/**
 * TeamCreateRequest
 */
export const zTeamCreateRequest = z.object({
  name: z.string().min(1).max(255),
  description: z.string().max(500).nullish(),
  member_user_ids: z.array(z.uuid()).max(500).optional(),
  account_ids: z.array(z.uuid()).max(500).optional(),
});

/**
 * TeamMemberItem
 */
export const zTeamMemberItem = z.object({
  user_id: z.string(),
  name: z.string(),
  email: z.string(),
  is_active: z.boolean(),
  joined_at: z.string(),
});

/**
 * TeamAccountItem
 */
export const zTeamAccountItem = z.object({
  account_id: z.string(),
  name: z.string(),
  slug: z.string(),
  status: z.string(),
  customer_uuid: z.string(),
});

/**
 * TeamDetail
 */
export const zTeamDetail = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  is_active: z.boolean(),
  member_count: z.int(),
  account_count: z.int(),
  created_at: z.string(),
  updated_at: z.string(),
  members: z.array(zTeamMemberItem),
  accounts: z.array(zTeamAccountItem),
});

/**
 * TeamResponse
 */
export const zTeamResponse = z.object({
  data: zTeamDetail,
});

/**
 * TeamScopeItem
 */
export const zTeamScopeItem = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
});

/**
 * TeamScopeAccount
 */
export const zTeamScopeAccount = z.object({
  account_id: z.string(),
  name: z.string(),
  slug: z.string(),
  status: z.string(),
  customer_uuid: z.string(),
  can_write: z.boolean(),
});

/**
 * TeamScopeResponse
 */
export const zTeamScopeResponse = z.object({
  data: z.object({
    teams: z.array(zTeamScopeItem),
    accounts: z.array(zTeamScopeAccount),
  }),
});

/**
 * TeamUpdateRequest
 */
export const zTeamUpdateRequest = z.object({
  name: z.string().min(1).max(255).optional(),
  description: z.string().max(500).nullish(),
  is_active: z.boolean().optional(),
});

/**
 * TeamMessageResponse
 */
export const zTeamMessageResponse = z.object({
  message: z.string(),
});

/**
 * TeamMembersRequest
 */
export const zTeamMembersRequest = z.object({
  user_ids: z.array(z.uuid()).max(500),
});

/**
 * TeamAccountsRequest
 */
export const zTeamAccountsRequest = z.object({
  account_ids: z.array(z.uuid()).max(500),
});

/**
 * TeamOverviewTotals
 */
export const zTeamOverviewTotals = z.object({
  total_investment: z.number(),
  marketing_percentage: z.number(),
  total_revenue: z.number(),
  purchase_revenue: z.number(),
  total_transactions: z.int(),
  ecommerce_purchases: z.int(),
  orders: z.int(),
  checkouts: z.int(),
  sessions: z.int(),
  total_sessions: z.int(),
  first_time_purchasers: z.int(),
  total_purchasers: z.int(),
  roas: z.number(),
  conversion_rate: z.number(),
  average_order_value: z.number(),
  revenue_projection: z.number(),
  investment_projection: z.number(),
});

/**
 * TeamOverviewStore
 */
export const zTeamOverviewStore = z.object({
  account_id: z.string(),
  name: z.string(),
  customer_uuid: z.string().nullable(),
  status: z.enum(["ok", "falhou", "sem_dados", "nao_consultada"]),
  total_investment: z.number(),
  total_revenue: z.number(),
  roas: z.number(),
  total_transactions: z.int(),
  sessions: z.int(),
  conversion_rate: z.number(),
  average_order_value: z.number(),
  revenue_change: z.number(),
  investment_change: z.number(),
});

/**
 * TeamOverviewResponse
 */
export const zTeamOverviewResponse = z.object({
  data: z.object({
    team: z.object({
      id: z.string(),
      name: z.string(),
    }),
    period: z.object({
      start_date: z.string(),
      end_date: z.string(),
    }),
    stores_total: z.int(),
    stores_answered: z.int(),
    totals: zTeamOverviewTotals,
    stores: z.array(zTeamOverviewStore),
  }),
});

/**
 * FeedbackCreate
 */
export const zFeedbackCreate = z.object({
  kind: z.enum(["bug", "improvement"]),
  message: z.string().min(10).max(5000),
  page_path: z.string().min(1).max(500),
  page_title: z.string().max(255).nullish(),
  customer_uuid: z.string().max(64).nullish(),
});

/**
 * FeedbackReceipt
 */
export const zFeedbackReceipt = z.object({
  id: z.string(),
  kind: z.enum(["bug", "improvement"]),
  created_at: z.iso.datetime(),
  message: z.string(),
});

/**
 * AdminFeedbackItem
 */
export const zAdminFeedbackItem = z.object({
  id: z.string(),
  kind: z.enum(["bug", "improvement"]),
  status: z.enum(["new", "in_progress", "done", "dismissed"]),
  message: z.string(),
  page_path: z.string(),
  page_title: z.string().nullable(),
  user_agent: z.string().nullable(),
  user: z.object({
    id: z.string().nullable(),
    name: z.string(),
    email: z.string(),
  }),
  account: z
    .object({
      id: z.string().nullable(),
      name: z.string(),
    })
    .nullable(),
  status_changed_at: z.iso.datetime().nullable(),
  status_changed_by: z.string().nullable(),
  created_at: z.iso.datetime(),
  updated_at: z.iso.datetime(),
});

/**
 * AdminFeedbackCounts
 */
export const zAdminFeedbackCounts = z.object({
  new: z.int(),
  in_progress: z.int(),
  done: z.int(),
  dismissed: z.int(),
});

/**
 * AdminFeedbackListResponse
 */
export const zAdminFeedbackListResponse = z.object({
  data: z.array(zAdminFeedbackItem),
  pagination: zPagination,
  counts: zAdminFeedbackCounts,
});

/**
 * FeedbackStatusUpdate
 */
export const zFeedbackStatusUpdate = z.object({
  status: z.enum(["new", "in_progress", "done", "dismissed"]),
});

/**
 * Successful Response
 */
export const zRootGetResponse = zRootResponse;

/**
 * Successful Response
 */
export const zTestAccountsApiV1TestAccountsGetResponse = zTestAccountsResponse;

/**
 * Successful Response
 */
export const zHealthCheckHealthGetResponse = zHealthResponse;

/**
 * Successful Response
 */
export const zReadinessCheckReadyGetResponse = zReadinessResponse;

export const zApiV1Auth2FaBackupCodesPostBody = zRegenerateBackupCodesRequest;

/**
 * Successful Response
 */
export const zApiV1Auth2FaBackupCodesPostResponse = zBackupCodesResponse;

export const zDisable2FaApiV1Auth2FaDisablePostBody = zDisable2FaRequest;

/**
 * Successful Response
 */
export const zDisable2FaApiV1Auth2FaDisablePostResponse = zAuthMessageResponse;

export const zEnable2FaApiV1Auth2FaEnablePostBody = zEnable2FaRequest;

/**
 * Successful Response
 */
export const zEnable2FaApiV1Auth2FaEnablePostResponse = zAuthMessageResponse;

/**
 * Successful Response
 */
export const zSetup2FaApiV1Auth2FaSetupPostResponse = zSetup2FaResponse;

export const zVerify2FaApiV1Auth2FaVerifyPostBody = zTwoFactorRequest;

/**
 * Successful Response
 */
export const zVerify2FaApiV1Auth2FaVerifyPostResponse = zTokenResponse;

export const zChangePasswordApiV1AuthChangePasswordPostBody =
  zChangePasswordRequest;

/**
 * Successful Response
 */
export const zChangePasswordApiV1AuthChangePasswordPostResponse =
  zAuthMessageResponse;

export const zUpdateCheckoutDataApiV1AuthCheckoutDataPostBody =
  zCheckoutDataRequest;

/**
 * Successful Response
 */
export const zUpdateCheckoutDataApiV1AuthCheckoutDataPostResponse =
  zCheckoutDataResponse;

export const zForgotPasswordApiV1AuthForgotPasswordPostBody =
  zForgotPasswordRequest;

/**
 * Successful Response
 */
export const zForgotPasswordApiV1AuthForgotPasswordPostResponse =
  zAuthMessageResponse;

export const zLoginApiV1AuthLoginPostBody = zLoginRequest;

/**
 * Successful Response
 */
export const zLoginApiV1AuthLoginPostResponse = zTokenResponse;

export const zLogoutApiV1AuthLogoutPostQuery = z.object({
  refresh_token: z.string(),
});

/**
 * Successful Response
 */
export const zLogoutApiV1AuthLogoutPostResponse = zAuthMessageResponse;

export const zRefreshTokenApiV1AuthRefreshPostBody = zRefreshTokenRequest;

/**
 * Successful Response
 */
export const zRefreshTokenApiV1AuthRefreshPostResponse = zTokenResponse;

export const zRegisterApiV1AuthRegisterPostBody = zRegisterRequest;

/**
 * Successful Response
 */
export const zRegisterApiV1AuthRegisterPostResponse = zRegisterResponse;

export const zResetPasswordApiV1AuthResetPasswordPostBody =
  zResetPasswordRequest;

/**
 * Successful Response
 */
export const zResetPasswordApiV1AuthResetPasswordPostResponse =
  zAuthMessageResponse;

export const zGetMyProfileApiV1UsersMeGetQuery = z.object({
  customer_uuid: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetMyProfileApiV1UsersMeGetResponse = zProfileResponse;

export const zUpdateMyProfileApiV1UsersMePutBody = zUpdateProfileRequest;

export const zUpdateMyProfileApiV1UsersMePutQuery = z.object({
  customer_uuid: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zUpdateMyProfileApiV1UsersMePutResponse = zProfileResponse;

/**
 * Successful Response
 */
export const zDeleteAvatarApiV1UsersMeAvatarDeleteResponse =
  zUserMessageResponse;

export const zUploadAvatarApiV1UsersMeAvatarPostBody =
  zBodyUploadAvatarApiV1UsersMeAvatarPost;

/**
 * Successful Response
 */
export const zUploadAvatarApiV1UsersMeAvatarPostResponse =
  zUploadAvatarResponse;

export const zDeleteUserConnectionApiV1UsersMeConnectionsDeleteQuery = z.object(
  {
    source: z.string(),
    alias: z.string().nullish(),
    customer_uuid: z.string().min(1),
  },
);

/**
 * Successful Response
 */
export const zDeleteUserConnectionApiV1UsersMeConnectionsDeleteResponse =
  zDisconnectResponse;

export const zGetUserConnectionsApiV1UsersMeConnectionsGetQuery = z.object({
  customer_uuid: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetUserConnectionsApiV1UsersMeConnectionsGetResponse =
  zConnectionStatusResponse;

/**
 * Successful Response
 */
export const zGetUserIntegrationsApiV1UsersMeIntegrationsGetResponse =
  zUserIntegrationsResponse;

/**
 * Successful Response
 */
export const zRevokeAllSessionsApiV1UsersMeSessionsDeleteResponse =
  zUserMessageResponse;

/**
 * Successful Response
 */
export const zGetMySessionsApiV1UsersMeSessionsGetResponse =
  zUserSessionsResponse;

export const zRevokeSessionApiV1UsersMeSessionsSessionIdDeletePath = z.object({
  session_id: z.string(),
});

/**
 * Successful Response
 */
export const zRevokeSessionApiV1UsersMeSessionsSessionIdDeleteResponse =
  zUserMessageResponse;

/**
 * Successful Response
 */
export const zApiV1MyAccountAiCreditPacksGetResponse =
  zAiCreditPackOfferListResponse;

export const zApiV1MyAccountAiCreditPacksPurchasePostBody =
  zAiCreditPurchaseRequest;

/**
 * Successful Response
 */
export const zApiV1MyAccountAiCreditPacksPurchasePostResponse =
  zCheckoutPaymentResponse;

export const zApiV1MyAccountAiCreditPacksPurchasesInvoiceIdQrGetPath = z.object(
  {
    invoice_id: z.uuid(),
  },
);

/**
 * Successful Response
 */
export const zApiV1MyAccountAiCreditPacksPurchasesInvoiceIdQrGetResponse =
  zPixQrResponse;

export const zGetAiCreditsApiV1MyAccountAiCreditsGetQuery = z.object({
  customer_uuid: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetAiCreditsApiV1MyAccountAiCreditsGetResponse =
  zMyAccountAiCreditsResponse;

/**
 * Successful Response
 */
export const zListInvoicesApiV1MyAccountInvoicesGetResponse =
  zMyAccountInvoicesResponse;

export const zGetInvoiceDetailApiV1MyAccountInvoicesInvoiceIdGetPath = z.object(
  {
    invoice_id: z.uuid(),
  },
);

/**
 * Successful Response
 */
export const zGetInvoiceDetailApiV1MyAccountInvoicesInvoiceIdGetResponse =
  zMyAccountInvoiceDetailResponse;

export const zGetPaymentStatusApiV1MyAccountPaymentStatusGatewayPaymentIdGetPath =
  z.object({
    gateway_payment_id: z.string(),
  });

/**
 * Successful Response
 */
export const zGetPaymentStatusApiV1MyAccountPaymentStatusGatewayPaymentIdGetResponse =
  zMyAccountPaymentStatusResponse;

/**
 * Successful Response
 */
export const zGetSubscriptionInfoApiV1MyAccountSubscriptionGetResponse =
  zMyAccountSubscriptionResponse;

/**
 * Successful Response
 */
export const zListAccountUsersApiV1MyAccountUsersGetResponse =
  zMyAccountUsersResponse;

export const zCreateAccountUserApiV1MyAccountUsersPostBody = zAccountUserCreate;

/**
 * Successful Response
 */
export const zCreateAccountUserApiV1MyAccountUsersPostResponse =
  zMyAccountUserResponse;

export const zDeleteAccountUserApiV1MyAccountUsersAccountUserIdDeletePath =
  z.object({
    account_user_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zDeleteAccountUserApiV1MyAccountUsersAccountUserIdDeleteResponse =
  zMyAccountMessageResponse;

export const zUpdateAccountUserApiV1MyAccountUsersAccountUserIdPutBody =
  zAccountUserUpdate;

export const zUpdateAccountUserApiV1MyAccountUsersAccountUserIdPutPath =
  z.object({
    account_user_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zUpdateAccountUserApiV1MyAccountUsersAccountUserIdPutResponse =
  zMyAccountUserResponse;

/**
 * Successful Response
 */
export const zGetMyPlanFeaturesApiV1PlansMyPlanFeaturesGetResponse =
  zMyPlanFeaturesResponse;

/**
 * Successful Response
 */
export const zListAccountsApiV1AccountsGetResponse =
  zManagedAccountListResponse;

export const zCreateAccountApiV1AccountsPostBody = zManagedAccountCreateRequest;

/**
 * Successful Response
 */
export const zCreateAccountApiV1AccountsPostResponse = zManagedAccountResponse;

export const zSwitchToAccountApiV1AccountsSwitchAccountPostBody =
  zManagedAccountSwitchRequest;

/**
 * Successful Response
 */
export const zSwitchToAccountApiV1AccountsSwitchAccountPostResponse =
  zManagedAccountSwitchResponse;

export const zDeleteAccountPermanentlyApiV1AccountsAccountIdDeletePath =
  z.object({
    account_id: z.string(),
  });

/**
 * Successful Response
 */
export const zDeleteAccountPermanentlyApiV1AccountsAccountIdDeleteResponse =
  zManagedAccountDeleteResponse;

export const zUpdateAccountApiV1AccountsAccountIdPutBody =
  zManagedAccountUpdateRequest;

export const zUpdateAccountApiV1AccountsAccountIdPutPath = z.object({
  account_id: z.string(),
});

/**
 * Successful Response
 */
export const zUpdateAccountApiV1AccountsAccountIdPutResponse =
  zManagedAccountResponse;

export const zUpdateAccountStatusApiV1AccountsAccountIdStatusPatchBody =
  zManagedAccountStatusRequest;

export const zUpdateAccountStatusApiV1AccountsAccountIdStatusPatchPath =
  z.object({
    account_id: z.string(),
  });

/**
 * Successful Response
 */
export const zUpdateAccountStatusApiV1AccountsAccountIdStatusPatchResponse =
  zManagedAccountStatusResponse;

/**
 * Successful Response
 */
export const zRequestDataDeletionApiV1DataDeletionPostResponse =
  zDataDeletionResponse;

/**
 * Successful Response
 */
export const zGetStorageUsageApiV1StorageUsageGetResponse =
  zStorageUsageResponse;

/**
 * Successful Response
 */
export const zGetEligiblePlansApiV1SubscriptionsEligiblePlansGetResponse =
  zEligiblePlansResponse;

/**
 * Successful Response
 */
export const zReadRetentionStatusApiV1SubscriptionsRetentionStatusGetResponse =
  zRetentionStatusResponse;

export const zInitiateUpgradeApiV1SubscriptionsUpgradePostBody =
  zUpgradeRequest;

/**
 * Successful Response
 */
export const zInitiateUpgradeApiV1SubscriptionsUpgradePostResponse =
  zCheckoutPaymentResponse;

export const zGetUpgradePixQrApiV1SubscriptionsUpgradeInvoiceIdQrGetPath =
  z.object({
    invoice_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetUpgradePixQrApiV1SubscriptionsUpgradeInvoiceIdQrGetResponse =
  zPixQrResponse;

export const zApiV1AdminAuth2FaBackupCodesPostBody =
  zAdminRegenerateBackupCodesRequest;

/**
 * Successful Response
 */
export const zApiV1AdminAuth2FaBackupCodesPostResponse =
  zAdminBackupCodesResponse;

export const zApiV1AdminAuth2FaReconfigurePostBody =
  zAdminReconfigure2FaRequest;

/**
 * Successful Response
 */
export const zApiV1AdminAuth2FaReconfigurePostResponse = zAdminMessageResponse;

export const zReset2FaApiV1AdminAuth2FaResetPostBody = zAdminReset2FaRequest;

/**
 * Successful Response
 */
export const zReset2FaApiV1AdminAuth2FaResetPostResponse =
  zAdminMessageResponse;

/**
 * Successful Response
 */
export const zSetup2FaApiV1AdminAuth2FaSetupPostResponse =
  zAdmin2FaSetupResponse;

export const zSetup2FaInitialApiV1AdminAuth2FaSetupInitialPostBody =
  zAdmin2FaSetupRequest;

/**
 * Successful Response
 */
export const zSetup2FaInitialApiV1AdminAuth2FaSetupInitialPostResponse =
  zAdmin2FaSetupResponse;

export const zVerify2FaApiV1AdminAuth2FaVerifyPostBody = zAdmin2FaRequest;

/**
 * Successful Response
 */
export const zVerify2FaApiV1AdminAuth2FaVerifyPostResponse = zAdmin2FaResponse;

export const zChangePasswordApiV1AdminAuthChangePasswordPostBody =
  zAdminChangePasswordRequest;

/**
 * Successful Response
 */
export const zChangePasswordApiV1AdminAuthChangePasswordPostResponse =
  zAdminSuccessMessageResponse;

export const zAdminLoginApiV1AdminAuthLoginPostBody = zAdminLoginRequest;

/**
 * Successful Response
 */
export const zAdminLoginApiV1AdminAuthLoginPostResponse = zAdminLoginResponse;

export const zAdminLoginTestApiV1AdminAuthLoginTestPostBody =
  zAdminLoginRequest;

/**
 * Successful Response
 */
export const zAdminLoginTestApiV1AdminAuthLoginTestPostResponse =
  zAdminTokenResponse;

/**
 * Successful Response
 */
export const zAdminLogoutApiV1AdminAuthLogoutPostResponse = z.void();

/**
 * Successful Response
 */
export const zGetCurrentAdminApiV1AdminAuthMeGetResponse =
  zAdminCurrentUserResponse;

export const zConfirmPasswordResetApiV1AdminAuthPasswordResetConfirmPostBody =
  zAdminPasswordResetConfirm;

/**
 * Successful Response
 */
export const zConfirmPasswordResetApiV1AdminAuthPasswordResetConfirmPostResponse =
  zAdminMessageResponse;

export const zRequestPasswordResetApiV1AdminAuthPasswordResetRequestPostBody =
  zAdminPasswordResetRequest;

/**
 * Successful Response
 */
export const zRequestPasswordResetApiV1AdminAuthPasswordResetRequestPostResponse =
  zAdminMessageResponse;

export const zRequestPasswordResetNonexistentApiV1AdminAuthPasswordResetRequestNonexistentPostBody =
  zAdminPasswordResetRequest;

/**
 * Successful Response
 */
export const zRequestPasswordResetNonexistentApiV1AdminAuthPasswordResetRequestNonexistentPostResponse =
  zAdminSuccessMessageResponse;

/**
 * Successful Response
 */
export const zRefreshTokenApiV1AdminAuthRefreshPostResponse =
  zAdminTokenResponse;

export const zRequestPasswordResetEndpointApiV1AdminAuthRequestPasswordResetPostBody =
  zAdminPasswordResetRequest;

/**
 * Successful Response
 */
export const zRequestPasswordResetEndpointApiV1AdminAuthRequestPasswordResetPostResponse =
  zAdminSuccessMessageResponse;

export const zListAdminUsersApiV1AdminAdminUsersGetQuery = z.object({
  skip: z.int().gte(0).optional().default(0),
  limit: z.int().gte(1).lte(100).optional().default(10),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  search: z.string().nullish(),
  profile_id: z.uuid().nullish(),
  is_active: z.boolean().nullish(),
  has_2fa: z.boolean().nullish(),
  department: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_order: z
    .string()
    .regex(/^(asc|desc)$/)
    .optional()
    .default("desc"),
});

/**
 * Successful Response
 */
export const zListAdminUsersApiV1AdminAdminUsersGetResponse =
  zAdminUsersListResponse;

export const zCreateAdminUserApiV1AdminAdminUsersPostBody = zAdminUserCreate;

/**
 * Successful Response
 */
export const zCreateAdminUserApiV1AdminAdminUsersPostResponse =
  zAdminUserMutationResponse;

export const zListAdminUsersApiV1AdminAdminUsersGet2Query = z.object({
  skip: z.int().gte(0).optional().default(0),
  limit: z.int().gte(1).lte(100).optional().default(10),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  search: z.string().nullish(),
  profile_id: z.uuid().nullish(),
  is_active: z.boolean().nullish(),
  has_2fa: z.boolean().nullish(),
  department: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_order: z
    .string()
    .regex(/^(asc|desc)$/)
    .optional()
    .default("desc"),
});

/**
 * Successful Response
 */
export const zListAdminUsersApiV1AdminAdminUsersGet2Response =
  zAdminUsersListResponse;

export const zCreateAdminUserApiV1AdminAdminUsersPost2Body = zAdminUserCreate;

/**
 * Successful Response
 */
export const zCreateAdminUserApiV1AdminAdminUsersPost2Response =
  zAdminUserMutationResponse;

export const zBulkActionAdminUsersApiV1AdminAdminUsersBulkActionPostBody =
  zAdminBulkAction;

/**
 * Successful Response
 */
export const zBulkActionAdminUsersApiV1AdminAdminUsersBulkActionPostResponse =
  zAdminUserBulkActionResponse;

export const zResetPasswordApiV1AdminAdminUsersPasswordResetPostBody =
  zAdminPasswordReset;

/**
 * Successful Response
 */
export const zResetPasswordApiV1AdminAdminUsersPasswordResetPostResponse =
  zAdminUserMessageResponse;

export const zListProfilesApiV1AdminAdminUsersProfilesGetQuery = z.object({
  include_system: z.boolean().optional().default(true),
});

/**
 * Successful Response
 */
export const zListProfilesApiV1AdminAdminUsersProfilesGetResponse =
  zAdminProfileListResponse;

export const zCreateProfileApiV1AdminAdminUsersProfilesPostBody =
  zAdminProfileCreate;

/**
 * Successful Response
 */
export const zCreateProfileApiV1AdminAdminUsersProfilesPostResponse =
  zAdminProfileMutationResponse;

export const zDeleteProfileApiV1AdminAdminUsersProfilesProfileIdDeletePath =
  z.object({
    profile_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zDeleteProfileApiV1AdminAdminUsersProfilesProfileIdDeleteResponse =
  zAdminUserMessageResponse;

export const zUpdateProfileApiV1AdminAdminUsersProfilesProfileIdPutBody =
  zAdminProfileUpdate;

export const zUpdateProfileApiV1AdminAdminUsersProfilesProfileIdPutPath =
  z.object({
    profile_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zUpdateProfileApiV1AdminAdminUsersProfilesProfileIdPutResponse =
  zAdminUserMessageResponse;

export const zDeleteAdminUserApiV1AdminAdminUsersAdminUserIdDeletePath =
  z.object({
    admin_user_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zDeleteAdminUserApiV1AdminAdminUsersAdminUserIdDeleteResponse =
  zAdminUserMessageResponse;

export const zGetAdminUserDetailsApiV1AdminAdminUsersAdminUserIdGetPath =
  z.object({
    admin_user_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetAdminUserDetailsApiV1AdminAdminUsersAdminUserIdGetResponse =
  zAdminUserDetailResponse;

export const zUpdateAdminUserApiV1AdminAdminUsersAdminUserIdPutBody =
  zAdminUserUpdate;

export const zUpdateAdminUserApiV1AdminAdminUsersAdminUserIdPutPath = z.object({
  admin_user_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zUpdateAdminUserApiV1AdminAdminUsersAdminUserIdPutResponse =
  zAdminUserMessageResponse;

export const zUpdatePasswordApiV1AdminAdminUsersAdminUserIdPasswordPutBody =
  zAdminPasswordUpdate;

export const zUpdatePasswordApiV1AdminAdminUsersAdminUserIdPasswordPutPath =
  z.object({
    admin_user_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zUpdatePasswordApiV1AdminAdminUsersAdminUserIdPasswordPutResponse =
  zAdminUserMessageResponse;

export const zReactivateAdminUserApiV1AdminAdminUsersAdminUserIdReactivatePostPath =
  z.object({
    admin_user_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zReactivateAdminUserApiV1AdminAdminUsersAdminUserIdReactivatePostResponse =
  zAdminUserMessageResponse;

export const zResetAdminUserPasswordApiV1AdminAdminUsersAdminUserIdResetPasswordPostBody =
  zAdminUserPasswordResetRequest;

export const zResetAdminUserPasswordApiV1AdminAdminUsersAdminUserIdResetPasswordPostPath =
  z.object({
    admin_user_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zResetAdminUserPasswordApiV1AdminAdminUsersAdminUserIdResetPasswordPostResponse =
  zAdminUserMessageResponse;

export const zRevokeSessionsApiV1AdminAdminUsersAdminUserIdSessionsRevokePostPath =
  z.object({
    admin_user_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zRevokeSessionsApiV1AdminAdminUsersAdminUserIdSessionsRevokePostResponse =
  zAdminUserMessageResponse;

export const zListSubscribersApiV1AdminSubscribersGetQuery = z.object({
  skip: z.int().gte(0).optional().default(0),
  limit: z.int().gte(1).lte(100).optional().default(10),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  search: z.string().nullish(),
  is_active: z.boolean().nullish(),
  has_active_subscription: z.boolean().nullish(),
  plan_id: z.uuid().nullish(),
  created_after: z.iso.datetime().nullish(),
  created_before: z.iso.datetime().nullish(),
  sort_by: z.string().nullish(),
  sort_order: z
    .string()
    .regex(/^(asc|desc)$/)
    .optional()
    .default("desc"),
});

/**
 * Successful Response
 */
export const zListSubscribersApiV1AdminSubscribersGetResponse =
  zAdminSubscriberListResponse;

export const zListSubscribersApiV1AdminSubscribersGet2Query = z.object({
  skip: z.int().gte(0).optional().default(0),
  limit: z.int().gte(1).lte(100).optional().default(10),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  search: z.string().nullish(),
  is_active: z.boolean().nullish(),
  has_active_subscription: z.boolean().nullish(),
  plan_id: z.uuid().nullish(),
  created_after: z.iso.datetime().nullish(),
  created_before: z.iso.datetime().nullish(),
  sort_by: z.string().nullish(),
  sort_order: z
    .string()
    .regex(/^(asc|desc)$/)
    .optional()
    .default("desc"),
});

/**
 * Successful Response
 */
export const zListSubscribersApiV1AdminSubscribersGet2Response =
  zAdminSubscriberListResponse;

export const zCreateSubscriberApiV1AdminSubscribersPostBody = zSubscriberCreate;

/**
 * Successful Response
 */
export const zCreateSubscriberApiV1AdminSubscribersPostResponse =
  zAdminSubscriberMutationResponse;

export const zAssignPlanByUserApiV1AdminSubscribersAssignPlanByUserPostBody =
  zAssignPlanByUserRequest;

/**
 * Successful Response
 */
export const zAssignPlanByUserApiV1AdminSubscribersAssignPlanByUserPostResponse =
  zAssignPlanResponse;

export const zBulkActionSubscribersApiV1AdminSubscribersBulkActionPostBody =
  zSubscriberBulkAction;

/**
 * Successful Response
 */
export const zBulkActionSubscribersApiV1AdminSubscribersBulkActionPostResponse =
  zAdminSubscriberBulkActionResponse;

/**
 * Successful Response
 */
export const zGetSubscribersDistributionByPlanApiV1AdminSubscribersChartsDistributionByPlanGetResponse =
  zAdminSubscriberDistributionResponse;

export const zGetNewSubscribersChartApiV1AdminSubscribersChartsNewSubscribersGetQuery =
  z.object({
    months: z.int().gte(1).lte(36).optional().default(12),
  });

/**
 * Successful Response
 */
export const zGetNewSubscribersChartApiV1AdminSubscribersChartsNewSubscribersGetResponse =
  zAdminSubscriberTimeseriesResponse;

export const zExportSubscribersListApiV1AdminSubscribersExportGetQuery =
  z.object({
    search: z.string().nullish(),
    is_active: z.boolean().nullish(),
    has_active_subscription: z.boolean().nullish(),
    plan_id: z.uuid().nullish(),
    created_after: z.iso.datetime().nullish(),
    created_before: z.iso.datetime().nullish(),
    sort_by: z.string().nullish(),
    sort_order: z
      .string()
      .regex(/^(asc|desc)$/)
      .optional()
      .default("desc"),
    format: z.string().regex(/^csv$/).optional().default("csv"),
  });

export const zListHardDeletesApiV1AdminSubscribersHardDeletesGetQuery =
  z.object({
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(50),
  });

/**
 * Successful Response
 */
export const zListHardDeletesApiV1AdminSubscribersHardDeletesGetResponse =
  zAdminHardDeleteListResponse;

/**
 * Successful Response
 */
export const zGetSubscribersSummaryApiV1AdminSubscribersSummaryGetResponse =
  zAdminSubscriberSummaryResponse;

export const zDeactivateSubscriberApiV1AdminSubscribersSubscriberIdDeletePath =
  z.object({
    subscriber_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zDeactivateSubscriberApiV1AdminSubscribersSubscriberIdDeleteResponse =
  zAdminSubscriberMessageResponse;

export const zGetSubscriberDetailsApiV1AdminSubscribersSubscriberIdGetPath =
  z.object({
    subscriber_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetSubscriberDetailsApiV1AdminSubscribersSubscriberIdGetResponse =
  zAdminSubscriberDetailResponse;

export const zUpdateSubscriberApiV1AdminSubscribersSubscriberIdPutBody =
  zSubscriberUpdate;

export const zUpdateSubscriberApiV1AdminSubscribersSubscriberIdPutPath =
  z.object({
    subscriber_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zUpdateSubscriberApiV1AdminSubscribersSubscriberIdPutResponse =
  zAdminSubscriberMutationResponse;

export const zCreateAccountForSubscriberApiV1AdminSubscribersSubscriberIdAccountsPostBody =
  zCreateAccountForSubscriber;

export const zCreateAccountForSubscriberApiV1AdminSubscribersSubscriberIdAccountsPostPath =
  z.object({
    subscriber_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zCreateAccountForSubscriberApiV1AdminSubscribersSubscriberIdAccountsPostResponse =
  zAdminSubscriberAccountResponse;

export const zGetSubscriberActivityLogApiV1AdminSubscribersSubscriberIdActivityGetPath =
  z.object({
    subscriber_id: z.uuid(),
  });

export const zGetSubscriberActivityLogApiV1AdminSubscribersSubscriberIdActivityGetQuery =
  z.object({
    skip: z.int().gte(0).optional().default(0),
    limit: z.int().gte(1).lte(100).optional().default(10),
  });

/**
 * Successful Response
 */
export const zGetSubscriberActivityLogApiV1AdminSubscribersSubscriberIdActivityGetResponse =
  zAdminSubscriberActivityResponse;

export const zAssignPlanApiV1AdminSubscribersSubscriberIdAssignPlanPostBody =
  zAssignPlanRequest;

export const zAssignPlanApiV1AdminSubscribersSubscriberIdAssignPlanPostPath =
  z.object({
    subscriber_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zAssignPlanApiV1AdminSubscribersSubscriberIdAssignPlanPostResponse =
  zAssignPlanResponse;

export const zCreateAccountForSubscriberAltApiV1AdminSubscribersSubscriberIdCreateAccountPostBody =
  zAdminSubscriberCreateAccountRequest;

export const zCreateAccountForSubscriberAltApiV1AdminSubscribersSubscriberIdCreateAccountPostPath =
  z.object({
    subscriber_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zCreateAccountForSubscriberAltApiV1AdminSubscribersSubscriberIdCreateAccountPostResponse =
  zAdminSubscriberAccountResponse;

export const zHardDeleteSubscriberDataApiV1AdminSubscribersSubscriberIdHardDeleteDeleteBody =
  zAdminHardDeleteRequest;

export const zHardDeleteSubscriberDataApiV1AdminSubscribersSubscriberIdHardDeleteDeletePath =
  z.object({
    subscriber_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zHardDeleteSubscriberDataApiV1AdminSubscribersSubscriberIdHardDeleteDeleteResponse =
  zAdminHardDeleteResponse;

export const zGetSubscriberInvoicesApiV1AdminSubscribersSubscriberIdInvoicesGetPath =
  z.object({
    subscriber_id: z.uuid(),
  });

export const zGetSubscriberInvoicesApiV1AdminSubscribersSubscriberIdInvoicesGetQuery =
  z.object({
    skip: z.int().gte(0).optional().default(0),
    limit: z.int().gte(1).lte(100).optional().default(10),
  });

/**
 * Successful Response
 */
export const zGetSubscriberInvoicesApiV1AdminSubscribersSubscriberIdInvoicesGetResponse =
  zAdminSubscriberInvoicesResponse;

export const zReactivateSubscriberApiV1AdminSubscribersSubscriberIdReactivatePostPath =
  z.object({
    subscriber_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zReactivateSubscriberApiV1AdminSubscribersSubscriberIdReactivatePostResponse =
  zAdminSubscriberMessageResponse;

export const zSuspendSubscriberApiV1AdminSubscribersSubscriberIdSuspendPostPath =
  z.object({
    subscriber_id: z.uuid(),
  });

export const zSuspendSubscriberApiV1AdminSubscribersSubscriberIdSuspendPostQuery =
  z.object({
    reason: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zSuspendSubscriberApiV1AdminSubscribersSubscriberIdSuspendPostResponse =
  zAdminSubscriberMessageResponse;

export const zListCoursesApiV1AdminCoursesGetQuery = z.object({
  skip: z.int().gte(0).optional().default(0),
  limit: z.int().gte(1).lte(100).optional().default(10),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  search: z.string().nullish(),
  is_active: z.boolean().nullish(),
  is_public: z.boolean().nullish(),
  has_price: z.boolean().nullish(),
  sort_by: z.string().nullish(),
  sort_order: z
    .string()
    .regex(/^(asc|desc)$/)
    .optional()
    .default("desc"),
});

/**
 * Successful Response
 */
export const zListCoursesApiV1AdminCoursesGetResponse =
  zAdminCourseListResponse;

export const zListCoursesApiV1AdminCoursesGet2Query = z.object({
  skip: z.int().gte(0).optional().default(0),
  limit: z.int().gte(1).lte(100).optional().default(10),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  search: z.string().nullish(),
  is_active: z.boolean().nullish(),
  is_public: z.boolean().nullish(),
  has_price: z.boolean().nullish(),
  sort_by: z.string().nullish(),
  sort_order: z
    .string()
    .regex(/^(asc|desc)$/)
    .optional()
    .default("desc"),
});

/**
 * Successful Response
 */
export const zListCoursesApiV1AdminCoursesGet2Response =
  zAdminCourseListResponse;

export const zCreateCourseApiV1AdminCoursesPostBody = zCourseCreate;

/**
 * Successful Response
 */
export const zCreateCourseApiV1AdminCoursesPostResponse =
  zAdminCourseCreateResponse;

export const zBulkEnrollStudentsApiV1AdminCoursesBulkEnrollPostBody =
  zBulkEnrollment;

/**
 * Successful Response
 */
export const zBulkEnrollStudentsApiV1AdminCoursesBulkEnrollPostResponse =
  zAdminCourseBulkEnrollResponse;

export const zGetEnrollmentsEvolutionApiV1AdminCoursesChartsEnrollmentsEvolutionGetQuery =
  z.object({
    months: z.int().gte(1).lte(36).optional().default(12),
  });

/**
 * Successful Response
 */
export const zGetEnrollmentsEvolutionApiV1AdminCoursesChartsEnrollmentsEvolutionGetResponse =
  zAdminCourseEnrollmentsEvolutionResponse;

export const zGetTopCoursesApiV1AdminCoursesChartsTopCoursesGetQuery = z.object(
  {
    days: z.int().gte(7).lte(365).optional().default(90),
  },
);

/**
 * Successful Response
 */
export const zGetTopCoursesApiV1AdminCoursesChartsTopCoursesGetResponse =
  zAdminCourseTopCoursesResponse;

export const zCloneCourseApiV1AdminCoursesClonePostBody = zCourseClone;

/**
 * Successful Response
 */
export const zCloneCourseApiV1AdminCoursesClonePostResponse =
  zAdminCourseCloneResponse;

export const zCreateLessonApiV1AdminCoursesLessonsPostBody = zLessonCreate;

/**
 * Successful Response
 */
export const zCreateLessonApiV1AdminCoursesLessonsPostResponse =
  zAdminCourseLessonCreateResponse;

export const zReorderLessonsApiV1AdminCoursesLessonsReorderPostBody =
  zLegacyCourseReorderRequest;

/**
 * Successful Response
 */
export const zReorderLessonsApiV1AdminCoursesLessonsReorderPostResponse =
  zAdminCourseMessageResponse;

export const zDeleteLessonApiV1AdminCoursesLessonsLessonIdDeletePath = z.object(
  {
    lesson_id: z.uuid(),
  },
);

/**
 * Successful Response
 */
export const zDeleteLessonApiV1AdminCoursesLessonsLessonIdDeleteResponse =
  zAdminCourseMessageResponse;

export const zGetLessonDetailsApiV1AdminCoursesLessonsLessonIdGetPath =
  z.object({
    lesson_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetLessonDetailsApiV1AdminCoursesLessonsLessonIdGetResponse =
  zAdminCourseLessonDetailResponse;

export const zUpdateLessonApiV1AdminCoursesLessonsLessonIdPutBody =
  zLessonUpdate;

export const zUpdateLessonApiV1AdminCoursesLessonsLessonIdPutPath = z.object({
  lesson_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zUpdateLessonApiV1AdminCoursesLessonsLessonIdPutResponse =
  zAdminCourseMessageResponse;

export const zListLessonMediaApiV1AdminCoursesLessonsLessonIdMediaGetPath =
  z.object({
    lesson_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zListLessonMediaApiV1AdminCoursesLessonsLessonIdMediaGetResponse =
  zAdminCourseMediaListResponse;

export const zCreateLessonMediaApiV1AdminCoursesLessonsLessonIdMediaPostBody =
  zLessonMediaCreate;

export const zCreateLessonMediaApiV1AdminCoursesLessonsLessonIdMediaPostPath =
  z.object({
    lesson_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zCreateLessonMediaApiV1AdminCoursesLessonsLessonIdMediaPostResponse =
  zAdminCourseMediaCreateResponse;

export const zUploadLessonMediaApiV1AdminCoursesLessonsLessonIdUploadMediaPostBody =
  zBodyUploadLessonMediaApiV1AdminCoursesLessonsLessonIdUploadMediaPost;

export const zUploadLessonMediaApiV1AdminCoursesLessonsLessonIdUploadMediaPostPath =
  z.object({
    lesson_id: z.uuid(),
  });

export const zUploadLessonMediaApiV1AdminCoursesLessonsLessonIdUploadMediaPostQuery =
  z.object({
    title: z.string(),
    description: z.string().nullish(),
    media_type: z.string(),
    order: z.int().optional().default(0),
  });

/**
 * Successful Response
 */
export const zUploadLessonMediaApiV1AdminCoursesLessonsLessonIdUploadMediaPostResponse =
  zAdminCourseLessonUploadMediaResponse;

export const zReorderMediaApiV1AdminCoursesMediaReorderPostBody =
  zLegacyCourseReorderRequest;

/**
 * Successful Response
 */
export const zReorderMediaApiV1AdminCoursesMediaReorderPostResponse =
  zAdminCourseMessageResponse;

export const zDeleteLessonMediaApiV1AdminCoursesMediaMediaIdDeletePath =
  z.object({
    media_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zDeleteLessonMediaApiV1AdminCoursesMediaMediaIdDeleteResponse =
  zAdminCourseMessageResponse;

export const zUpdateLessonMediaApiV1AdminCoursesMediaMediaIdPutBody =
  zLessonMediaUpdate;

export const zUpdateLessonMediaApiV1AdminCoursesMediaMediaIdPutPath = z.object({
  media_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zUpdateLessonMediaApiV1AdminCoursesMediaMediaIdPutResponse =
  zAdminCourseMediaUpdateResponse;

export const zCreateModuleApiV1AdminCoursesModulesPostBody = zModuleCreate;

/**
 * Successful Response
 */
export const zCreateModuleApiV1AdminCoursesModulesPostResponse =
  zAdminCourseModuleCreateResponse;

export const zReorderModulesApiV1AdminCoursesModulesReorderPostBody =
  zLegacyCourseReorderRequest;

/**
 * Successful Response
 */
export const zReorderModulesApiV1AdminCoursesModulesReorderPostResponse =
  zAdminCourseMessageResponse;

export const zDeleteModuleApiV1AdminCoursesModulesModuleIdDeletePath = z.object(
  {
    module_id: z.uuid(),
  },
);

/**
 * Successful Response
 */
export const zDeleteModuleApiV1AdminCoursesModulesModuleIdDeleteResponse =
  zAdminCourseMessageResponse;

export const zGetModuleDetailsApiV1AdminCoursesModulesModuleIdGetPath =
  z.object({
    module_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetModuleDetailsApiV1AdminCoursesModulesModuleIdGetResponse =
  zAdminCourseModuleDetailResponse;

export const zUpdateModuleApiV1AdminCoursesModulesModuleIdPutBody =
  zModuleUpdate;

export const zUpdateModuleApiV1AdminCoursesModulesModuleIdPutPath = z.object({
  module_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zUpdateModuleApiV1AdminCoursesModulesModuleIdPutResponse =
  zAdminCourseMessageResponse;

/**
 * Successful Response
 */
export const zGetCoursesSummaryApiV1AdminCoursesSummaryGetResponse =
  zAdminCourseSummaryResponse;

export const zUploadFileApiV1AdminCoursesUploadPostBody =
  zBodyUploadFileApiV1AdminCoursesUploadPost;

/**
 * Successful Response
 */
export const zUploadFileApiV1AdminCoursesUploadPostResponse =
  zAdminCourseUploadResponse;

export const zDeleteCourseApiV1AdminCoursesCourseIdDeletePath = z.object({
  course_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zDeleteCourseApiV1AdminCoursesCourseIdDeleteResponse =
  zAdminCourseMessageResponse;

export const zGetCourseDetailsApiV1AdminCoursesCourseIdGetPath = z.object({
  course_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zGetCourseDetailsApiV1AdminCoursesCourseIdGetResponse =
  zAdminCourseDetailResponse;

export const zUpdateCourseApiV1AdminCoursesCourseIdPutBody = zCourseUpdate;

export const zUpdateCourseApiV1AdminCoursesCourseIdPutPath = z.object({
  course_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zUpdateCourseApiV1AdminCoursesCourseIdPutResponse =
  zAdminCourseUpdateResponse;

export const zBulkEnrollCourseStudentsApiV1AdminCoursesCourseIdBulkEnrollPostBody =
  zLegacyCourseBulkEnrollmentRequest;

export const zBulkEnrollCourseStudentsApiV1AdminCoursesCourseIdBulkEnrollPostPath =
  z.object({
    course_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zBulkEnrollCourseStudentsApiV1AdminCoursesCourseIdBulkEnrollPostResponse =
  zAdminCourseBulkEnrollCourseResponse;

export const zCloneCourseEndpointApiV1AdminCoursesCourseIdClonePostBody =
  zLegacyCourseCloneRequest;

export const zCloneCourseEndpointApiV1AdminCoursesCourseIdClonePostPath =
  z.object({
    course_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zCloneCourseEndpointApiV1AdminCoursesCourseIdClonePostResponse =
  zAdminCourseCloneResponse;

export const zGetCourseEnrollmentStatsApiV1AdminCoursesCourseIdEnrollmentStatsGetPath =
  z.object({
    course_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetCourseEnrollmentStatsApiV1AdminCoursesCourseIdEnrollmentStatsGetResponse =
  zAdminCourseEnrollmentStatsV2Response;

export const zCreateCourseModuleApiV1AdminCoursesCourseIdModulesPostBody =
  zLegacyCourseModuleCreateRequest;

export const zCreateCourseModuleApiV1AdminCoursesCourseIdModulesPostPath =
  z.object({
    course_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zCreateCourseModuleApiV1AdminCoursesCourseIdModulesPostResponse =
  zAdminCourseModuleCreateV2Response;

export const zCreateCourseLessonApiV1AdminCoursesCourseIdModulesModuleIdLessonsPostBody =
  zLegacyCourseLessonCreateRequest;

export const zCreateCourseLessonApiV1AdminCoursesCourseIdModulesModuleIdLessonsPostPath =
  z.object({
    course_id: z.uuid(),
    module_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zCreateCourseLessonApiV1AdminCoursesCourseIdModulesModuleIdLessonsPostResponse =
  zAdminCourseLessonCreateV2Response;

export const zGetCourseStudentProgressApiV1AdminCoursesCourseIdStudentProgressGetPath =
  z.object({
    course_id: z.uuid(),
  });

export const zGetCourseStudentProgressApiV1AdminCoursesCourseIdStudentProgressGetQuery =
  z.object({
    skip: z.int().gte(0).optional().default(0),
    limit: z.int().gte(1).lte(100).optional().default(10),
  });

/**
 * Successful Response
 */
export const zGetCourseStudentProgressApiV1AdminCoursesCourseIdStudentProgressGetResponse =
  zAdminCourseStudentProgressResponse;

export const zGetStudentsProgressApiV1AdminCoursesCourseIdStudentsGetPath =
  z.object({
    course_id: z.uuid(),
  });

export const zGetStudentsProgressApiV1AdminCoursesCourseIdStudentsGetQuery =
  z.object({
    skip: z.int().gte(0).optional().default(0),
    limit: z.int().gte(1).lte(100).optional().default(10),
    search: z.string().nullish(),
    status: z
      .string()
      .regex(/^(active|completed)$/)
      .nullish(),
  });

/**
 * Successful Response
 */
export const zGetStudentsProgressApiV1AdminCoursesCourseIdStudentsGetResponse =
  zAdminCourseStudentsResponse;

export const zMarkAlertAsReadApiV1AdminBillingAlertsAlertIdReadPutPath =
  z.object({
    alert_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zMarkAlertAsReadApiV1AdminBillingAlertsAlertIdReadPutResponse =
  zAdminBillingMessageResponse;

/**
 * Successful Response
 */
export const zGetQuarterlyRevenueByPlanApiV1AdminBillingChartsQuarterlyByPlanGetResponse =
  zAdminBillingQuarterlyRevenueResponse;

/**
 * Successful Response
 */
export const zGetRevenueEvolutionByPlanApiV1AdminBillingChartsRevenueEvolutionGetResponse =
  zAdminBillingRevenueEvolutionResponse;

export const zListCouponsApiV1AdminBillingCouponsGetQuery = z.object({
  include_inactive: z.boolean().optional().default(false),
});

/**
 * Successful Response
 */
export const zListCouponsApiV1AdminBillingCouponsGetResponse =
  zAdminBillingCouponListResponse;

export const zCreateCouponApiV1AdminBillingCouponsPostBody =
  zSchemasAdminBillingCouponCreate;

/**
 * Successful Response
 */
export const zCreateCouponApiV1AdminBillingCouponsPostResponse =
  zAdminBillingCouponResponse;

export const zUpdateCouponApiV1AdminBillingCouponsCouponIdPutBody =
  zSchemasAdminBillingCouponUpdate;

export const zUpdateCouponApiV1AdminBillingCouponsCouponIdPutPath = z.object({
  coupon_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zUpdateCouponApiV1AdminBillingCouponsCouponIdPutResponse =
  zAdminBillingMessageResponse;

export const zGetCustomerBillingHistoryApiV1AdminBillingCustomersSubscriberIdHistoryGetPath =
  z.object({
    subscriber_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetCustomerBillingHistoryApiV1AdminBillingCustomersSubscriberIdHistoryGetResponse =
  zAdminBillingCustomerHistoryResponse;

export const zExportTransactionsApiV1AdminBillingExportGetQuery = z.object({
  period: z.int().optional().default(30),
  status: z.string().nullish(),
  format: z.string().optional().default("csv"),
});

export const zListInvoicesApiV1AdminBillingInvoicesGetQuery = z.object({
  skip: z.int().gte(0).optional().default(0),
  limit: z.int().gte(1).lte(100).optional().default(10),
  subscriber_id: z.uuid().nullish(),
  status: z
    .string()
    .regex(/^(pending|paid|overdue|cancelled)$/)
    .nullish(),
  date_from: z.iso.date().nullish(),
  date_to: z.iso.date().nullish(),
  min_amount: z.number().gte(0).nullish(),
  max_amount: z.number().gte(0).nullish(),
  search: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zListInvoicesApiV1AdminBillingInvoicesGetResponse =
  zAdminBillingInvoiceListResponse;

export const zGetInvoiceDetailsApiV1AdminBillingInvoicesInvoiceIdGetPath =
  z.object({
    invoice_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetInvoiceDetailsApiV1AdminBillingInvoicesInvoiceIdGetResponse =
  zAdminBillingInvoiceDetailResponse;

export const zUpdateInvoiceApiV1AdminBillingInvoicesInvoiceIdPutBody =
  zInvoiceUpdate;

export const zUpdateInvoiceApiV1AdminBillingInvoicesInvoiceIdPutPath = z.object(
  {
    invoice_id: z.uuid(),
  },
);

/**
 * Successful Response
 */
export const zUpdateInvoiceApiV1AdminBillingInvoicesInvoiceIdPutResponse =
  zAdminBillingMessageResponse;

export const zRegisterPaymentApiV1AdminBillingPaymentsPostBody =
  zPaymentRegister;

/**
 * Successful Response
 */
export const zRegisterPaymentApiV1AdminBillingPaymentsPostResponse =
  zAdminBillingPaymentResponse;

export const zProcessRefundApiV1AdminBillingPaymentsPaymentIdRefundPostBody =
  zRefundRequest;

export const zProcessRefundApiV1AdminBillingPaymentsPaymentIdRefundPostPath =
  z.object({
    payment_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zProcessRefundApiV1AdminBillingPaymentsPaymentIdRefundPostResponse =
  zAdminBillingRefundResponse;

/**
 * Successful Response
 */
export const zGetBillingSummaryApiV1AdminBillingSummaryGetResponse =
  zAdminBillingSummaryResponse;

/**
 * Successful Response
 */
export const zGetBillingSummaryFixApiV1AdminBillingSummaryFixGetResponse =
  zAdminBillingSummaryFixResponse;

export const zListTransactionsApiV1AdminBillingTransactionsGetQuery = z.object({
  page: z.int().gte(1).optional().default(1),
  limit: z.int().gte(1).lte(100).optional().default(10),
  period: z.int().optional().default(30),
  date_from: z.iso.date().nullish(),
  date_to: z.iso.date().nullish(),
  search: z.string().nullish(),
  status: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_order: z
    .string()
    .regex(/^(asc|desc)$/)
    .optional()
    .default("desc"),
});

/**
 * Successful Response
 */
export const zListTransactionsApiV1AdminBillingTransactionsGetResponse =
  zAdminBillingTransactionListResponse;

export const zGetTransactionDetailsApiV1AdminBillingTransactionsTransactionIdGetPath =
  z.object({
    transaction_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetTransactionDetailsApiV1AdminBillingTransactionsTransactionIdGetResponse =
  zAdminBillingTransactionDetailResponse;

/**
 * Successful Response
 */
export const zApiV1AdminAiCreditPacksGetResponse = zAiCreditPackListResponse;

export const zApiV1AdminAiCreditPacksPostBody = zAiCreditPackCreate;

/**
 * Successful Response
 */
export const zApiV1AdminAiCreditPacksPostResponse = zAiCreditPackResponse;

export const zApiV1AdminAiCreditPacksPackIdDeletePath = z.object({
  pack_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zApiV1AdminAiCreditPacksPackIdDeleteResponse =
  zAiCreditPackDeleteResponse;

export const zApiV1AdminAiCreditPacksPackIdPutBody = zAiCreditPackUpdate;

export const zApiV1AdminAiCreditPacksPackIdPutPath = z.object({
  pack_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zApiV1AdminAiCreditPacksPackIdPutResponse = zAiCreditPackResponse;

export const zListCouponsApiV1AdminCouponsGetQuery = z.object({
  skip: z.int().gte(0).optional().default(0),
  limit: z.int().gte(1).lte(100).optional().default(10),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  search: z.string().nullish(),
  status: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_order: z
    .string()
    .regex(/^(asc|desc)$/)
    .optional()
    .default("desc"),
});

/**
 * Successful Response
 */
export const zListCouponsApiV1AdminCouponsGetResponse = zCouponListResponse;

export const zListCouponsApiV1AdminCouponsGet2Query = z.object({
  skip: z.int().gte(0).optional().default(0),
  limit: z.int().gte(1).lte(100).optional().default(10),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  search: z.string().nullish(),
  status: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_order: z
    .string()
    .regex(/^(asc|desc)$/)
    .optional()
    .default("desc"),
});

/**
 * Successful Response
 */
export const zListCouponsApiV1AdminCouponsGet2Response = zCouponListResponse;

export const zCreateCouponApiV1AdminCouponsPostBody =
  zSchemasAdminCouponCouponCreate;

/**
 * Successful Response
 */
export const zCreateCouponApiV1AdminCouponsPostResponse = zCouponCreateResponse;

export const zApiV1AdminCouponsRedemptionsGetQuery = z.object({
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  search: z.string().nullish(),
  invoice_status: z
    .enum(["pending", "paid", "overdue", "cancelled"])
    .optional(),
  sort_by: z
    .enum(["used_at", "code", "discount_applied"])
    .optional()
    .default("used_at"),
  sort_order: z.enum(["asc", "desc"]).optional().default("desc"),
});

/**
 * Successful Response
 */
export const zApiV1AdminCouponsRedemptionsGetResponse =
  zCouponRedemptionListResponse;

export const zUsageTimeseriesApiV1AdminCouponsUsageTimeseriesGetQuery =
  z.object({
    months: z.int().gte(1).lte(24).optional().default(12),
  });

/**
 * Successful Response
 */
export const zUsageTimeseriesApiV1AdminCouponsUsageTimeseriesGetResponse =
  zCouponUsageTimeseriesResponse;

export const zDeleteCouponApiV1AdminCouponsCouponIdDeletePath = z.object({
  coupon_id: z.string(),
});

/**
 * Successful Response
 */
export const zDeleteCouponApiV1AdminCouponsCouponIdDeleteResponse =
  zCouponSuccessResponse;

export const zUpdateCouponApiV1AdminCouponsCouponIdPutBody =
  zSchemasAdminCouponCouponUpdate;

export const zUpdateCouponApiV1AdminCouponsCouponIdPutPath = z.object({
  coupon_id: z.string(),
});

/**
 * Successful Response
 */
export const zUpdateCouponApiV1AdminCouponsCouponIdPutResponse =
  zCouponSuccessResponse;

export const zInactivateCouponApiV1AdminCouponsCouponIdInactivatePostPath =
  z.object({
    coupon_id: z.string(),
  });

/**
 * Successful Response
 */
export const zInactivateCouponApiV1AdminCouponsCouponIdInactivatePostResponse =
  zCouponMessageResponse;

export const zListFeaturesApiV1AdminFeaturesGetQuery = z.object({
  category: z.string().nullish(),
  is_active: z.boolean().nullish(),
  is_premium: z.boolean().nullish(),
});

/**
 * Successful Response
 */
export const zListFeaturesApiV1AdminFeaturesGetResponse =
  zAdminFeatureListResponse;

export const zListFeaturesApiV1AdminFeaturesGet2Query = z.object({
  category: z.string().nullish(),
  is_active: z.boolean().nullish(),
  is_premium: z.boolean().nullish(),
});

/**
 * Successful Response
 */
export const zListFeaturesApiV1AdminFeaturesGet2Response =
  zAdminFeatureListResponse;

export const zCreateFeatureApiV1AdminFeaturesPostBody = zFeatureCreate;

/**
 * Successful Response
 */
export const zCreateFeatureApiV1AdminFeaturesPostResponse =
  zAdminFeatureMutationResponse;

/**
 * Successful Response
 */
export const zListCategoriesApiV1AdminFeaturesCategoriesGetResponse =
  zAdminFeatureCategoriesResponse;

export const zGetPlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesGetPath =
  z.object({
    plan_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetPlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesGetResponse =
  zAdminFeaturePlanFeaturesResponse;

export const zUpdatePlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesPutBody =
  zPlanFeatureBulkUpdate;

export const zUpdatePlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesPutPath =
  z.object({
    plan_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zUpdatePlanFeaturesApiV1AdminFeaturesPlansPlanIdFeaturesPutResponse =
  zAdminFeaturePlanFeaturesUpdateResponse;

export const zDeleteFeatureApiV1AdminFeaturesFeatureIdDeletePath = z.object({
  feature_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zDeleteFeatureApiV1AdminFeaturesFeatureIdDeleteResponse =
  zAdminFeatureMessageResponse;

export const zGetFeatureDetailsApiV1AdminFeaturesFeatureIdGetPath = z.object({
  feature_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zGetFeatureDetailsApiV1AdminFeaturesFeatureIdGetResponse =
  zAdminFeatureDetailResponse;

export const zUpdateFeatureApiV1AdminFeaturesFeatureIdPutBody = zFeatureUpdate;

export const zUpdateFeatureApiV1AdminFeaturesFeatureIdPutPath = z.object({
  feature_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zUpdateFeatureApiV1AdminFeaturesFeatureIdPutResponse =
  zAdminFeatureMutationResponse;

export const zListPlansApiV1AdminPlansGetQuery = z.object({
  skip: z.int().gte(0).optional().default(0),
  limit: z.int().gte(1).lte(200).optional().default(10),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(200).optional().default(10),
  include_inactive: z.boolean().optional().default(false),
  include_stats: z.boolean().optional().default(true),
  search: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_order: z
    .string()
    .regex(/^(asc|desc)$/)
    .optional()
    .default("desc"),
});

/**
 * Successful Response
 */
export const zListPlansApiV1AdminPlansGetResponse = zAdminPlanListResponse;

export const zListPlansApiV1AdminPlansGet2Query = z.object({
  skip: z.int().gte(0).optional().default(0),
  limit: z.int().gte(1).lte(200).optional().default(10),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(200).optional().default(10),
  include_inactive: z.boolean().optional().default(false),
  include_stats: z.boolean().optional().default(true),
  search: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_order: z
    .string()
    .regex(/^(asc|desc)$/)
    .optional()
    .default("desc"),
});

/**
 * Successful Response
 */
export const zListPlansApiV1AdminPlansGet2Response = zAdminPlanListResponse;

export const zCreatePlanApiV1AdminPlansPostBody = zPlanCreate;

/**
 * Successful Response
 */
export const zCreatePlanApiV1AdminPlansPostResponse =
  zAdminPlanMutationResponse;

export const zSoftDeletePlanApiV1AdminPlansPlanIdDeletePath = z.object({
  plan_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zSoftDeletePlanApiV1AdminPlansPlanIdDeleteResponse =
  zAdminPlanMessageResponse;

export const zGetPlanDetailsApiV1AdminPlansPlanIdGetPath = z.object({
  plan_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zGetPlanDetailsApiV1AdminPlansPlanIdGetResponse =
  zAdminPlanDetailResponse;

export const zUpdatePlanApiV1AdminPlansPlanIdPutBody = zPlanUpdate;

export const zUpdatePlanApiV1AdminPlansPlanIdPutPath = z.object({
  plan_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zUpdatePlanApiV1AdminPlansPlanIdPutResponse =
  zAdminPlanMutationResponse;

export const zUpdatePlanFeaturesApiV1AdminPlansPlanIdFeaturesPutBody =
  zPlanFeatureUpdate;

export const zUpdatePlanFeaturesApiV1AdminPlansPlanIdFeaturesPutPath = z.object(
  {
    plan_id: z.uuid(),
  },
);

/**
 * Successful Response
 */
export const zUpdatePlanFeaturesApiV1AdminPlansPlanIdFeaturesPutResponse =
  zAdminPlanFeaturesResponse;

export const zReactivatePlanApiV1AdminPlansPlanIdReactivatePostPath = z.object({
  plan_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zReactivatePlanApiV1AdminPlansPlanIdReactivatePostResponse =
  zAdminPlanReactivateResponse;

export const zValidateCouponApiV1PublicCouponsValidateGetQuery = z.object({
  code: z.string().min(2).max(20),
  email: z.string().nullish(),
  plan_id: z.uuid().nullish(),
});

/**
 * Successful Response
 */
export const zValidateCouponApiV1PublicCouponsValidateGetResponse =
  zCouponValidationResponse;

/**
 * Successful Response
 */
export const zListPublicPlansApiV1PublicPlansGetResponse = zPublicPlansResponse;

/**
 * Successful Response
 */
export const zListSegmentsApiV1AdminBenchmarkSegmentsGetResponse =
  zBenchmarkSegmentListResponse;

export const zCreateSegmentApiV1AdminBenchmarkSegmentsPostBody =
  zBenchmarkSegmentCreate;

/**
 * Successful Response
 */
export const zCreateSegmentApiV1AdminBenchmarkSegmentsPostResponse =
  zBenchmarkSegmentResponse;

export const zDeleteSegmentApiV1AdminBenchmarkSegmentsSegmentIdDeletePath =
  z.object({
    segment_id: z.string(),
  });

export const zDeleteSegmentApiV1AdminBenchmarkSegmentsSegmentIdDeleteQuery =
  z.object({
    move_to: z.string().optional(),
  });

/**
 * Response Delete Segment Api V1 Admin Benchmark Segments  Segment Id  Delete
 *
 * Successful Response
 */
export const zDeleteSegmentApiV1AdminBenchmarkSegmentsSegmentIdDeleteResponse =
  z.record(z.string(), z.boolean());

export const zUpdateSegmentApiV1AdminBenchmarkSegmentsSegmentIdPutBody =
  zBenchmarkSegmentUpdate;

export const zUpdateSegmentApiV1AdminBenchmarkSegmentsSegmentIdPutPath =
  z.object({
    segment_id: z.string(),
  });

/**
 * Successful Response
 */
export const zUpdateSegmentApiV1AdminBenchmarkSegmentsSegmentIdPutResponse =
  zBenchmarkSegmentUpdateResponse;

export const zAdminBenchmarkStoresApiV1AdminBenchmarkStoresGetQuery = z.object({
  window: z.string().optional().default("30d"),
});

/**
 * Successful Response
 */
export const zAdminBenchmarkStoresApiV1AdminBenchmarkStoresGetResponse =
  zAdminBenchmarkStoresResponse;

export const zGetRecentActivitiesApiV1AdminDashboardActivitiesGetQuery =
  z.object({
    limit: z.int().lte(50).optional().default(10),
  });

/**
 * Successful Response
 */
export const zGetRecentActivitiesApiV1AdminDashboardActivitiesGetResponse =
  zAdminDashboardActivitiesResponse;

export const zGetRecentAlertsApiV1AdminDashboardAlertsGetQuery = z.object({
  limit: z.int().gte(1).lte(50).optional().default(10),
});

/**
 * Successful Response
 */
export const zGetRecentAlertsApiV1AdminDashboardAlertsGetResponse =
  zAdminDashboardAlertsResponse;

/**
 * Successful Response
 */
export const zGetChurnAnalysisApiV1AdminDashboardChurnAnalysisGetResponse =
  zAdminDashboardChurnResponse;

/**
 * Successful Response
 */
export const zGetDailyForecastSeriesApiV1AdminDashboardForecastDailyGetResponse =
  zAdminDashboardForecastResponse;

export const zGetGrowthMetricsApiV1AdminDashboardGrowthGetQuery = z.object({
  period: z.string().optional().default("last_30_days"),
});

/**
 * Successful Response
 */
export const zGetGrowthMetricsApiV1AdminDashboardGrowthGetResponse =
  zAdminDashboardGrowthResponse;

/**
 * Successful Response
 */
export const zGetSystemHealthApiV1AdminDashboardHealthGetResponse =
  zAdminDashboardHealthResponse;

/**
 * Successful Response
 */
export const zUpdateDailyMetricsApiV1AdminDashboardMetricsUpdatePostResponse =
  zAdminDashboardMutationResponse;

export const zGetRevenueMetricsApiV1AdminDashboardRevenueGetQuery = z.object({
  period: z.string().optional().default("monthly"),
});

/**
 * Successful Response
 */
export const zGetRevenueMetricsApiV1AdminDashboardRevenueGetResponse =
  zAdminDashboardRevenueMetricsResponse;

/**
 * Successful Response
 */
export const zGetSubscriptionMetricsApiV1AdminDashboardSubscriptionsGetResponse =
  zAdminDashboardSubscriptionMetricsResponse;

/**
 * Successful Response
 */
export const zGetSubscriptionDistributionApiV1AdminDashboardSubscriptionsDistributionGetResponse =
  zAdminDashboardDistributionResponse;

/**
 * Successful Response
 */
export const zGetDashboardSummaryApiV1AdminDashboardSummaryGetResponse =
  zAdminDashboardSummaryResponse;

export const zGetTopPlansApiV1AdminDashboardTopPlansGetQuery = z.object({
  limit: z.int().lte(10).optional().default(5),
});

/**
 * Successful Response
 */
export const zGetTopPlansApiV1AdminDashboardTopPlansGetResponse =
  zAdminDashboardTopPlansResponse;

export const zGetUserMetricsApiV1AdminDashboardUsersGetQuery = z.object({
  period: z.string().optional().default("weekly"),
});

/**
 * Successful Response
 */
export const zGetUserMetricsApiV1AdminDashboardUsersGetResponse =
  zAdminDashboardUserMetricsResponse;

export const zListDataDeletionRequestsApiV1AdminDataDeletionGetQuery = z.object(
  {
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(50),
  },
);

/**
 * Successful Response
 */
export const zListDataDeletionRequestsApiV1AdminDataDeletionGetResponse =
  zAdminDataDeletionListResponse;

export const zListDataDeletionRequestsApiV1AdminDataDeletionGet2Query =
  z.object({
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(50),
  });

/**
 * Successful Response
 */
export const zListDataDeletionRequestsApiV1AdminDataDeletionGet2Response =
  zAdminDataDeletionListResponse;

/**
 * Successful Response
 */
export const zApiV1AdminAiPromptsGetResponse = zAiPromptListResponse;

export const zApiV1AdminAiPromptsKeyDeletePath = z.object({
  key: z.string(),
});

/**
 * Successful Response
 */
export const zApiV1AdminAiPromptsKeyDeleteResponse = zAiPromptResponse;

export const zApiV1AdminAiPromptsKeyPutBody = zAiPromptUpdateRequest;

export const zApiV1AdminAiPromptsKeyPutPath = z.object({
  key: z.string(),
});

/**
 * Successful Response
 */
export const zApiV1AdminAiPromptsKeyPutResponse = zAiPromptResponse;

/**
 * Successful Response
 */
export const zGetSettingsApiV1AdminSettingsGetResponse = zSettingsResponse;

export const zUpdateSettingsApiV1AdminSettingsPutBody = zSettingsUpdate;

/**
 * Successful Response
 */
export const zUpdateSettingsApiV1AdminSettingsPutResponse = zSettingsResponse;

/**
 * Successful Response
 */
export const zGetSettingsApiV1AdminSettingsGet2Response = zSettingsResponse;

export const zUpdateSettingsApiV1AdminSettingsPut2Body = zSettingsUpdate;

/**
 * Successful Response
 */
export const zUpdateSettingsApiV1AdminSettingsPut2Response = zSettingsResponse;

/**
 * Successful Response
 */
export const zGetMaintenanceStatusApiV1AdminSettingsMaintenanceModeStatusGetResponse =
  zMaintenanceModeStatusResponse;

export const zToggleMaintenanceModeApiV1AdminSettingsMaintenanceModeTogglePostBody =
  zMaintenanceModeToggleRequest;

/**
 * Successful Response
 */
export const zToggleMaintenanceModeApiV1AdminSettingsMaintenanceModeTogglePostResponse =
  zMaintenanceModeStatusResponse;

export const zGetAdminStorageApiV1AdminStorageGetQuery = z.object({
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(50),
  customer_uuid: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_order: z
    .string()
    .regex(/^(asc|desc)$/)
    .optional()
    .default("desc"),
});

/**
 * Successful Response
 */
export const zGetAdminStorageApiV1AdminStorageGetResponse =
  zAdminStorageListResponse;

export const zSetStorageLimitsApiV1AdminStorageLimitsPostBody =
  zSetLimitsRequest;

/**
 * Successful Response
 */
export const zSetStorageLimitsApiV1AdminStorageLimitsPostResponse =
  zSetLimitsResponse;

export const zReceiveAsaasWebhookApiV1WebhooksAsaasPostBody =
  zAsaasWebhookPayload;

export const zReceiveAsaasWebhookApiV1WebhooksAsaasPostHeaders = z.object({
  "asaas-access-token": z.string().nullish(),
});

/**
 * Successful Response
 */
export const zReceiveAsaasWebhookApiV1WebhooksAsaasPostResponse = zWebhookAck;

export const zUpdateSyncConfigApiV1AdminSyncConfigPutBody = zSyncConfigUpdate;

/**
 * Successful Response
 */
export const zUpdateSyncConfigApiV1AdminSyncConfigPutResponse =
  zSyncConfigUpdateResponse;

/**
 * Successful Response
 */
export const zDisableSyncApiV1AdminSyncDisablePostResponse =
  zSyncMessageResponse;

/**
 * Successful Response
 */
export const zEnableSyncApiV1AdminSyncEnablePostResponse = zSyncMessageResponse;

export const zForceSyncIntegrationApiV1AdminSyncForceSyncPostBody =
  zForceSyncRequest;

/**
 * Successful Response
 */
export const zForceSyncIntegrationApiV1AdminSyncForceSyncPostResponse =
  zSyncForceResponse;

/**
 * Successful Response
 */
export const zGetSyncHealthApiV1AdminSyncHealthGetResponse =
  zSyncHealthResponse;

/**
 * Successful Response
 */
export const zGetIntegrationTypesApiV1AdminSyncIntegrationsGetResponse =
  zSyncIntegrationTypesResponse;

/**
 * Successful Response
 */
export const zGetSyncStatsApiV1AdminSyncStatsGetResponse = zSyncStatsResponse;

/**
 * Successful Response
 */
export const zGetSyncStatusApiV1AdminSyncStatusGetResponse =
  zApiSyncControlSyncStatusResponse;

export const zGetAvailableAccountsApiV1ExternalAccountsAvailableGetQuery =
  z.object({
    source: z.string(),
    customer_uuid: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetAvailableAccountsApiV1ExternalAccountsAvailableGetResponse =
  zAvailableAccountsResponse;

export const zSelectAccountsApiV1ExternalAccountsSelectPostBody =
  zSelectAccountRequest;

/**
 * Successful Response
 */
export const zSelectAccountsApiV1ExternalAccountsSelectPostResponse =
  zSelectAccountResponse;

export const zGetSelectedAccountsApiV1ExternalAccountsSelectedGetQuery =
  z.object({
    source: z.string().nullish(),
    customer_uuid: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetSelectedAccountsApiV1ExternalAccountsSelectedGetResponse =
  zSelectedExternalAccountsResponse;

export const zGetIntegrationAuthUrlApiV1IntegrationsNexusAuthUrlGetQuery =
  z.object({
    source: z.string(),
    alias: z.string().nullish(),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetIntegrationAuthUrlApiV1IntegrationsNexusAuthUrlGetResponse =
  zIntegrationAuthUrlResponse;

export const zIntegrationOauthCallbackApiV1IntegrationsNexusCallbackGetQuery =
  z.object({
    code: z.string(),
    state: z.string(),
  });

export const zDisconnectIntegrationApiV1IntegrationsNexusDisconnectDeleteQuery =
  z.object({
    source: z.string(),
    customer_uuid: z.string().min(1),
  });

/**
 * Successful Response
 */
export const zDisconnectIntegrationApiV1IntegrationsNexusDisconnectDeleteResponse =
  zIntegrationDisconnectResponse;

/**
 * Successful Response
 */
export const zGetGoogleAdsAuthUrlApiV1IntegrationsNexusGoogleAdsAuthUrlGetResponse =
  zIntegrationAuthUrlResponse;

/**
 * Successful Response
 */
export const zGetGoogleAnalyticsAuthUrlApiV1IntegrationsNexusGoogleAnalyticsAuthUrlGetResponse =
  zIntegrationAuthUrlResponse;

/**
 * Successful Response
 */
export const zGetInstagramInsightsAuthUrlApiV1IntegrationsNexusInstagramInsightsAuthUrlGetResponse =
  zIntegrationAuthUrlResponse;

/**
 * Successful Response
 */
export const zGetMetaAdsAuthUrlApiV1IntegrationsNexusMetaAdsAuthUrlGetResponse =
  zIntegrationAuthUrlResponse;

export const zRefreshIntegrationTokenApiV1IntegrationsNexusRefreshTokenPostQuery =
  z.object({
    source: z.string(),
    account_id: z.string().optional(),
  });

/**
 * Successful Response
 */
export const zRefreshIntegrationTokenApiV1IntegrationsNexusRefreshTokenPostResponse =
  zIntegrationRefreshTokenResponse;

/**
 * Successful Response
 */
export const zGetSearchConsoleAuthUrlApiV1IntegrationsNexusSearchConsoleAuthUrlGetResponse =
  zIntegrationAuthUrlResponse;

export const zGetOauthAuthUrlApiV1OauthAuthUrlGetQuery = z.object({
  source: z.string(),
  partner_uuid: z.string(),
  customer_uuid: z.string(),
  redirect_url: z.string(),
  alias: z.string().nullish(),
  customer_name: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetOauthAuthUrlApiV1OauthAuthUrlGetResponse =
  zOAuthAuthUrlResponse;

export const zOauthCallbackProxyApiV1OauthCallbackGetQuery = z.object({
  code: z.string().nullish(),
  state: z.string().nullish(),
  error: z.string().nullish(),
  error_description: z.string().nullish(),
});

export const zRefreshOauthTokenApiV1OauthRefreshPostQuery = z.object({
  source: z.string(),
  partner_uuid: z.string(),
  customer_uuid: z.string(),
  alias: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zRefreshOauthTokenApiV1OauthRefreshPostResponse =
  zOAuthTokenResponse;

export const zTriggerSyncApiV1SyncPostBody = zSyncTriggerRequest;

/**
 * Response Trigger Sync Api V1 Sync Post
 *
 * Successful Response
 */
export const zTriggerSyncApiV1SyncPostResponse = z.union([
  zSyncResponse,
  zBackfillScheduledResponse,
]);

export const zGetCustomerSyncStatusApiV1SyncStatusGetQuery = z.object({
  customer_uuid: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetCustomerSyncStatusApiV1SyncStatusGetResponse =
  zNexusSdkModelsSyncStatusResponseSyncStatusResponse;

export const zGetSyncJobStatusApiV1SyncJobIdGetPath = z.object({
  job_id: z.uuid(),
});

export const zGetSyncJobStatusApiV1SyncJobIdGetQuery = z.object({
  customer_uuid: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetSyncJobStatusApiV1SyncJobIdGetResponse =
  zNexusSdkModelsJobStatusResponseJobStatusResponse;

export const zGetGa4PropertiesApiV1AnalyticsGa4PropertiesGetQuery = z.object({
  customer_uuid: z.string().nullish(),
  account_id: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetGa4PropertiesApiV1AnalyticsGa4PropertiesGetResponse =
  zGa4PropertiesResponse;

/**
 * Response Get Google Analytics Accounts Api V1 Integrations Google Analytics Accounts Get
 *
 * Successful Response
 */
export const zGetGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsAccountsGetResponse =
  z.array(zGoogleAnalyticsAccount);

export const zGetAdvancedMetricsApiV1IntegrationsGoogleAnalyticsAdvancedMetricsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
  });

/**
 * Successful Response
 */
export const zGetAdvancedMetricsApiV1IntegrationsGoogleAnalyticsAdvancedMetricsGetResponse =
  zGoogleAnalyticsAdvancedResponse;

/**
 * Successful Response
 */
export const zGetGoogleAnalyticsAuthUrlApiV1IntegrationsGoogleAnalyticsAuthUrlGetResponse =
  zIntegrationAuthUrlResponse;

export const zGoogleAnalyticsOauthCallbackApiV1IntegrationsGoogleAnalyticsCallbackGetQuery =
  z.object({
    code: z.string(),
    state: z.string(),
  });

export const zGetCompleteDataApiV1IntegrationsGoogleAnalyticsCompleteDataGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
  });

/**
 * Successful Response
 */
export const zGetCompleteDataApiV1IntegrationsGoogleAnalyticsCompleteDataGetResponse =
  zGoogleAnalyticsCompleteResponse;

export const zDisconnectGoogleAnalyticsApiV1IntegrationsGoogleAnalyticsDisconnectDeleteQuery =
  z.object({
    customer_uuid: z.string(),
  });

/**
 * Successful Response
 */
export const zDisconnectGoogleAnalyticsApiV1IntegrationsGoogleAnalyticsDisconnectDeleteResponse =
  zGoogleAnalyticsDisconnectResponse;

export const zGetGoogleAnalyticsGeographyApiV1IntegrationsGoogleAnalyticsGeographyGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    limit: z.int().optional().default(20),
  });

/**
 * Successful Response
 */
export const zGetGoogleAnalyticsGeographyApiV1IntegrationsGoogleAnalyticsGeographyGetResponse =
  zGoogleAnalyticsGeographyResponse;

export const zGetGoogleAnalyticsMetricsApiV1IntegrationsGoogleAnalyticsMetricsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
  });

/**
 * Successful Response
 */
export const zGetGoogleAnalyticsMetricsApiV1IntegrationsGoogleAnalyticsMetricsGetResponse =
  zGoogleAnalyticsMetricsResponse;

export const zGetGoogleAnalyticsOverviewApiV1IntegrationsGoogleAnalyticsOverviewGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
  });

/**
 * Successful Response
 */
export const zGetGoogleAnalyticsOverviewApiV1IntegrationsGoogleAnalyticsOverviewGetResponse =
  zGoogleAnalyticsOverviewData;

export const zGetConsolidatedOverviewApiV1IntegrationsGoogleAnalyticsOverviewConsolidatedGetQuery =
  z.object({
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    property_ids: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetConsolidatedOverviewApiV1IntegrationsGoogleAnalyticsOverviewConsolidatedGetResponse =
  zGoogleAnalyticsConsolidatedOverviewResponse;

export const zGetGoogleAnalyticsPageMetricsApiV1IntegrationsGoogleAnalyticsPagesGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    limit: z.int().optional().default(50),
  });

/**
 * Successful Response
 */
export const zGetGoogleAnalyticsPageMetricsApiV1IntegrationsGoogleAnalyticsPagesGetResponse =
  zGoogleAnalyticsPageMetricsResponse;

export const zGetPerformanceInsightsApiV1IntegrationsGoogleAnalyticsPerformanceInsightsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
  });

/**
 * Successful Response
 */
export const zGetPerformanceInsightsApiV1IntegrationsGoogleAnalyticsPerformanceInsightsGetResponse =
  zGoogleAnalyticsPerformanceInsightsResponse;

export const zGetGoogleAnalyticsRealtimeApiV1IntegrationsGoogleAnalyticsRealtimeGetQuery =
  z.object({
    account_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetGoogleAnalyticsRealtimeApiV1IntegrationsGoogleAnalyticsRealtimeGetResponse =
  zGoogleAnalyticsRealTimeResponse;

/**
 * Successful Response
 */
export const zGetGoogleAnalyticsStatusApiV1IntegrationsGoogleAnalyticsStatusGetResponse =
  zGoogleAnalyticsConnectionStatus;

export const zSyncGoogleAnalyticsDataApiV1IntegrationsGoogleAnalyticsSyncPostBody =
  zGoogleAnalyticsSyncRequest;

/**
 * Successful Response
 */
export const zSyncGoogleAnalyticsDataApiV1IntegrationsGoogleAnalyticsSyncPostResponse =
  zGoogleAnalyticsSyncResponse;

/**
 * Successful Response
 */
export const zSyncGoogleAnalyticsAccountsApiV1IntegrationsGoogleAnalyticsSyncAccountsPostResponse =
  zGoogleAnalyticsSyncAccountsResponse;

export const zSyncAdvancedDataApiV1IntegrationsGoogleAnalyticsSyncAdvancedPostQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
  });

/**
 * Successful Response
 */
export const zSyncAdvancedDataApiV1IntegrationsGoogleAnalyticsSyncAdvancedPostResponse =
  zGoogleAnalyticsAdvancedSyncResponse;

export const zSyncAllPropertiesApiV1IntegrationsGoogleAnalyticsSyncAllPostQuery =
  z.object({
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
    force: z.boolean().optional().default(false),
  });

/**
 * Successful Response
 */
export const zSyncAllPropertiesApiV1IntegrationsGoogleAnalyticsSyncAllPostResponse =
  zGoogleAnalyticsSyncAllResponse;

export const zSyncCompleteDataApiV1IntegrationsGoogleAnalyticsSyncCompletePostBody =
  zGoogleAnalyticsSyncRequest;

/**
 * Successful Response
 */
export const zSyncCompleteDataApiV1IntegrationsGoogleAnalyticsSyncCompletePostResponse =
  zGoogleAnalyticsCompleteSyncResponse;

export const zGetGoogleAnalyticsTechnologyApiV1IntegrationsGoogleAnalyticsTechnologyGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    limit: z.int().optional().default(20),
  });

/**
 * Successful Response
 */
export const zGetGoogleAnalyticsTechnologyApiV1IntegrationsGoogleAnalyticsTechnologyGetResponse =
  zGoogleAnalyticsTechnologyResponse;

export const zGetGoogleAdsManagerTotalApiV1GoogleAdsManagerTotalGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetGoogleAdsManagerTotalApiV1GoogleAdsManagerTotalGetResponse =
  zGoogleAdsManagerTotalResponse;

/**
 * Response Get Google Ads Accounts Api V1 Integrations Google Ads Accounts Get
 *
 * Successful Response
 */
export const zGetGoogleAdsAccountsApiV1IntegrationsGoogleAdsAccountsGetResponse =
  z.array(zGoogleAdsAccountInfo);

export const zGetGoogleAdsAdPerformanceApiV1IntegrationsGoogleAdsAdPerformanceGetQuery =
  z.object({
    account_id: z.string(),
    start_date: z.string(),
    end_date: z.string(),
    campaign_id: z.int().nullish(),
    ad_type: z.string().nullish(),
    limit: z.int().optional().default(50),
  });

/**
 * Successful Response
 */
export const zGetGoogleAdsAdPerformanceApiV1IntegrationsGoogleAdsAdPerformanceGetResponse =
  zGoogleAdsAdPerformanceListResponse;

/**
 * Successful Response
 */
export const zGetGoogleAdsAuthUrlApiV1IntegrationsGoogleAdsAuthUrlGetResponse =
  zGoogleAdsAuthUrl;

export const zGoogleAdsOauthCallbackApiV1IntegrationsGoogleAdsCallbackGetQuery =
  z.object({
    code: z.string(),
    state: z.string(),
  });

export const zGetGoogleAdsCampaignsApiV1IntegrationsGoogleAdsCampaignsGetQuery =
  z.object({
    account_id: z.string(),
  });

/**
 * Response Get Google Ads Campaigns Api V1 Integrations Google Ads Campaigns Get
 *
 * Successful Response
 */
export const zGetGoogleAdsCampaignsApiV1IntegrationsGoogleAdsCampaignsGetResponse =
  z.array(zGoogleAdsCampaign);

export const zGetGoogleAdsCityMetricsApiV1IntegrationsGoogleAdsCityMetricsGetQuery =
  z.object({
    account_id: z.string(),
    start_date: z.string(),
    end_date: z.string(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
  });

/**
 * Successful Response
 */
export const zGetGoogleAdsCityMetricsApiV1IntegrationsGoogleAdsCityMetricsGetResponse =
  zGoogleAdsCityMetricsResponse;

export const zGetCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsCompleteDataGetQuery =
  z.object({
    account_id: z.string(),
    start_date: z.string(),
    end_date: z.string(),
  });

/**
 * Successful Response
 */
export const zGetCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsCompleteDataGetResponse =
  zGoogleAdsCompleteResponse;

export const zGetGoogleAdsDemographicsApiV1IntegrationsGoogleAdsDemographicsGetQuery =
  z.object({
    account_id: z.string(),
    start_date: z.string(),
    end_date: z.string(),
    age_range: z.string().nullish(),
    gender: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetGoogleAdsDemographicsApiV1IntegrationsGoogleAdsDemographicsGetResponse =
  zGoogleAdsDemographicsResponse;

export const zGetGoogleAdsDeviceMetricsApiV1IntegrationsGoogleAdsDeviceMetricsGetQuery =
  z.object({
    account_id: z.string(),
    start_date: z.string(),
    end_date: z.string(),
  });

/**
 * Successful Response
 */
export const zGetGoogleAdsDeviceMetricsApiV1IntegrationsGoogleAdsDeviceMetricsGetResponse =
  zGoogleAdsDeviceMetricsResponse;

export const zDisconnectGoogleAdsApiV1IntegrationsGoogleAdsDisconnectDeleteQuery =
  z.object({
    customer_uuid: z.string(),
  });

/**
 * Successful Response
 */
export const zDisconnectGoogleAdsApiV1IntegrationsGoogleAdsDisconnectDeleteResponse =
  zGoogleAdsDisconnectResponse;

export const zGetGoogleAdsExtensionsPerformanceApiV1IntegrationsGoogleAdsExtensionsGetQuery =
  z.object({
    account_id: z.string(),
    start_date: z.string(),
    end_date: z.string(),
    extension_type: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetGoogleAdsExtensionsPerformanceApiV1IntegrationsGoogleAdsExtensionsGetResponse =
  zGoogleAdsExtensionsResponse;

export const zGetGoogleAdsGeographicPerformanceApiV1IntegrationsGoogleAdsGeographicGetQuery =
  z.object({
    account_id: z.string(),
    start_date: z.string(),
    end_date: z.string(),
    country_code: z.string().nullish(),
    city_name: z.string().nullish(),
    limit: z.int().optional().default(20),
  });

/**
 * Successful Response
 */
export const zGetGoogleAdsGeographicPerformanceApiV1IntegrationsGoogleAdsGeographicGetResponse =
  zGoogleAdsGeographicResponse;

export const zGetGoogleAdsHourlyMetricsApiV1IntegrationsGoogleAdsHourlyMetricsGetQuery =
  z.object({
    account_id: z.string(),
    start_date: z.string(),
    end_date: z.string(),
    campaign_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetGoogleAdsHourlyMetricsApiV1IntegrationsGoogleAdsHourlyMetricsGetResponse =
  zGoogleAdsHourlyMetricsResponse;

export const zGetGoogleAdsKeywordsApiV1IntegrationsGoogleAdsKeywordsGetQuery =
  z.object({
    account_id: z.string(),
    campaign_id: z.string().nullish(),
  });

/**
 * Response Get Google Ads Keywords Api V1 Integrations Google Ads Keywords Get
 *
 * Successful Response
 */
export const zGetGoogleAdsKeywordsApiV1IntegrationsGoogleAdsKeywordsGetResponse =
  z.array(zGoogleAdsKeyword);

export const zGetGoogleAdsMetricsApiV1IntegrationsGoogleAdsMetricsGetQuery =
  z.object({
    account_id: z.string(),
    start_date: z.string(),
    end_date: z.string(),
    campaign_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetGoogleAdsMetricsApiV1IntegrationsGoogleAdsMetricsGetResponse =
  zGoogleAdsMetrics;

export const zGetGoogleAdsPerformanceInsightsApiV1IntegrationsGoogleAdsPerformanceInsightsGetQuery =
  z.object({
    customer_id: z.string(),
    start_date: z.string(),
    end_date: z.string(),
  });

/**
 * Successful Response
 */
export const zGetGoogleAdsPerformanceInsightsApiV1IntegrationsGoogleAdsPerformanceInsightsGetResponse =
  zGoogleAdsPerformanceInsights;

/**
 * Successful Response
 */
export const zGetGoogleAdsStatusApiV1IntegrationsGoogleAdsStatusGetResponse =
  zGoogleAdsConnectionStatus;

export const zSyncGoogleAdsDataApiV1IntegrationsGoogleAdsSyncPostQuery =
  z.object({
    account_id: z.string(),
  });

/**
 * Successful Response
 */
export const zSyncGoogleAdsDataApiV1IntegrationsGoogleAdsSyncPostResponse =
  zGoogleAdsSyncResponse;

export const zSyncCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsSyncCompletePostQuery =
  z.object({
    customer_id: z.string(),
    start_date: z.string(),
    end_date: z.string(),
  });

/**
 * Successful Response
 */
export const zSyncCompleteGoogleAdsDataApiV1IntegrationsGoogleAdsSyncCompletePostResponse =
  zGoogleAdsCompleteSyncResponse;

/**
 * Response Get Accounts Api V1 Integrations Meta Ads Accounts Get
 *
 * Successful Response
 */
export const zGetAccountsApiV1IntegrationsMetaAdsAccountsGetResponse =
  z.array(zMetaAdsAccount);

export const zGetMetaAdsAdPerformanceApiV1IntegrationsMetaAdsAdPerformanceGetQuery =
  z.object({
    start_date: z.string(),
    end_date: z.string(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(50).optional().default(20),
    sort_by: z.string().nullish(),
    sort_order: z.string().nullish(),
    q: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetMetaAdsAdPerformanceApiV1IntegrationsMetaAdsAdPerformanceGetResponse =
  zMetaAdsAdPerformanceResponse;

/**
 * Successful Response
 */
export const zGetAuthUrlApiV1IntegrationsMetaAdsAuthUrlGetResponse =
  zMetaAdsAuthUrlResponse;

export const zOauthCallbackApiV1IntegrationsMetaAdsCallbackGetQuery = z.object({
  code: z.string(),
  state: z.string(),
});

/**
 * Successful Response
 */
export const zOauthCallbackApiV1IntegrationsMetaAdsCallbackGetResponse =
  zMetaAdsCallbackResponse;

export const zGetCampaignsApiV1IntegrationsMetaAdsCampaignsGetQuery = z.object({
  account_id: z.uuid(),
});

/**
 * Response Get Campaigns Api V1 Integrations Meta Ads Campaigns Get
 *
 * Successful Response
 */
export const zGetCampaignsApiV1IntegrationsMetaAdsCampaignsGetResponse =
  z.array(zMetaAdsCampaignSummary);

export const zClearAccountDataApiV1IntegrationsMetaAdsClearDataDeleteQuery =
  z.object({
    account_id: z.uuid(),
    confirm: z.boolean().optional().default(false),
  });

/**
 * Successful Response
 */
export const zClearAccountDataApiV1IntegrationsMetaAdsClearDataDeleteResponse =
  zMetaAdsClearDataResponse;

export const zGetCompleteDataApiV1IntegrationsMetaAdsCompleteDataGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
  });

/**
 * Successful Response
 */
export const zGetCompleteDataApiV1IntegrationsMetaAdsCompleteDataGetResponse =
  zMetaAdsCompleteResponse;

/**
 * Successful Response
 */
export const zGetConnectionStatusApiV1IntegrationsMetaAdsConnectionStatusGetResponse =
  zMetaAdsConnectionStatus;

export const zGetCreativeApiV1IntegrationsMetaAdsCreativeGetQuery = z.object({
  account_id: z.uuid(),
  start_date: z.iso.date().nullish(),
  end_date: z.iso.date().nullish(),
  creative_type: z.string().nullish(),
});

/**
 * Response Get Creative Api V1 Integrations Meta Ads Creative Get
 *
 * Successful Response
 */
export const zGetCreativeApiV1IntegrationsMetaAdsCreativeGetResponse =
  z.array(zMetaAdsCreative);

export const zGetDemographicsApiV1IntegrationsMetaAdsDemographicsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
    age_group: z.string().nullish(),
    gender: z.string().nullish(),
  });

/**
 * Response Get Demographics Api V1 Integrations Meta Ads Demographics Get
 *
 * Successful Response
 */
export const zGetDemographicsApiV1IntegrationsMetaAdsDemographicsGetResponse =
  z.array(zMetaAdsDemographics);

export const zGetMetaAdsFeaturedAdsetsApiV1IntegrationsMetaAdsFeaturedAdsetsGetQuery =
  z.object({
    start_date: z.string(),
    end_date: z.string(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(50).optional().default(20),
    sort_by: z.string().nullish(),
    sort_order: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetMetaAdsFeaturedAdsetsApiV1IntegrationsMetaAdsFeaturedAdsetsGetResponse =
  zMetaAdsFeaturedAdsetsResponse;

export const zGetMetaAdsHourlyMetricsApiV1IntegrationsMetaAdsHourlyMetricsGetQuery =
  z.object({
    account_id: z.string(),
    start_date: z.string(),
    end_date: z.string(),
  });

/**
 * Response Get Meta Ads Hourly Metrics Api V1 Integrations Meta Ads Hourly Metrics Get
 *
 * Successful Response
 */
export const zGetMetaAdsHourlyMetricsApiV1IntegrationsMetaAdsHourlyMetricsGetResponse =
  z.array(zMetaAdsHourlyPerformanceItem);

export const zGetInterestsApiV1IntegrationsMetaAdsInterestsGetQuery = z.object({
  account_id: z.uuid(),
  start_date: z.iso.date().nullish(),
  end_date: z.iso.date().nullish(),
  interest_name: z.string().nullish(),
});

/**
 * Response Get Interests Api V1 Integrations Meta Ads Interests Get
 *
 * Successful Response
 */
export const zGetInterestsApiV1IntegrationsMetaAdsInterestsGetResponse =
  z.array(zMetaAdsInterests);

export const zGetMetricsApiV1IntegrationsMetaAdsMetricsGetQuery = z.object({
  account_id: z.uuid(),
  start_date: z.iso.date().nullish(),
  end_date: z.iso.date().nullish(),
});

/**
 * Response Get Metrics Api V1 Integrations Meta Ads Metrics Get
 *
 * Successful Response
 */
export const zGetMetricsApiV1IntegrationsMetaAdsMetricsGetResponse =
  z.array(zMetaAdsMetrics);

export const zGetPerformanceInsightsApiV1IntegrationsMetaAdsPerformanceInsightsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
  });

/**
 * Successful Response
 */
export const zGetPerformanceInsightsApiV1IntegrationsMetaAdsPerformanceInsightsGetResponse =
  zMetaAdsPerformanceInsights;

export const zGetPlacementApiV1IntegrationsMetaAdsPlacementGetQuery = z.object({
  account_id: z.uuid(),
  start_date: z.iso.date().nullish(),
  end_date: z.iso.date().nullish(),
  platform_position: z.string().nullish(),
  device_platform: z.string().nullish(),
  publisher_platform: z.string().nullish(),
});

/**
 * Response Get Placement Api V1 Integrations Meta Ads Placement Get
 *
 * Successful Response
 */
export const zGetPlacementApiV1IntegrationsMetaAdsPlacementGetResponse =
  z.array(zMetaAdsPlacement);

export const zGetMetaAdsPlatformMetricsApiV1IntegrationsMetaAdsPlatformMetricsGetQuery =
  z.object({
    account_id: z.string(),
    start_date: z.string(),
    end_date: z.string(),
  });

/**
 * Response Get Meta Ads Platform Metrics Api V1 Integrations Meta Ads Platform Metrics Get
 *
 * Successful Response
 */
export const zGetMetaAdsPlatformMetricsApiV1IntegrationsMetaAdsPlatformMetricsGetResponse =
  z.array(zMetaAdsPlatformReachItem);

export const zGetAccountSummaryApiV1IntegrationsMetaAdsSummaryGetQuery =
  z.object({
    account_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetAccountSummaryApiV1IntegrationsMetaAdsSummaryGetResponse =
  zMetaAdsSummaryResponse;

export const zSyncMetricsApiV1IntegrationsMetaAdsSyncPostBody =
  zMetaAdsSyncRequest;

/**
 * Successful Response
 */
export const zSyncMetricsApiV1IntegrationsMetaAdsSyncPostResponse =
  zMetaAdsSyncResponse;

export const zSyncCompleteDataApiV1IntegrationsMetaAdsSyncCompletePostBody =
  zMetaAdsSyncRequest;

/**
 * Successful Response
 */
export const zSyncCompleteDataApiV1IntegrationsMetaAdsSyncCompletePostResponse =
  zMetaAdsSyncResponse;

/**
 * Successful Response
 */
export const zGetTestDataApiV1IntegrationsMetaAdsTestDataGetResponse =
  zMetaAdsTestDataResponse;

export const zGetMetaAdsInstagramKpiApiV1MetaAdsInstagramKpiGetQuery = z.object(
  {
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    previous_start_date: z.iso.date(),
    previous_end_date: z.iso.date(),
    account_id: z.string().nullish(),
  },
);

/**
 * Successful Response
 */
export const zGetMetaAdsInstagramKpiApiV1MetaAdsInstagramKpiGetResponse =
  zMetaAdsInstagramKpiResponse;

export const zGetMetaAdsInstagramTimeseriesApiV1MetaAdsInstagramTimeseriesGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetMetaAdsInstagramTimeseriesApiV1MetaAdsInstagramTimeseriesGetResponse =
  zMetaAdsInstagramTimeseriesResponse;

export const zGetMetaAdsManagerTotalApiV1MetaAdsManagerTotalGetQuery = z.object(
  {
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
  },
);

/**
 * Successful Response
 */
export const zGetMetaAdsManagerTotalApiV1MetaAdsManagerTotalGetResponse =
  zMetaAdsManagerTotalResponse;

export const zGetInstagramDemographicsApiV1InstagramDemographicsGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetInstagramDemographicsApiV1InstagramDemographicsGetResponse =
  zInstagramDemographicsResponse;

export const zGetInstagramEngagementApiV1InstagramEngagementGetQuery = z.object(
  {
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
  },
);

/**
 * Successful Response
 */
export const zGetInstagramEngagementApiV1InstagramEngagementGetResponse =
  zInstagramEngagementResponse;

export const zGetInstagramKpisCompleteApiV1InstagramKpisCompleteGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    previous_start_date: z.iso.date(),
    previous_end_date: z.iso.date(),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetInstagramKpisCompleteApiV1InstagramKpisCompleteGetResponse =
  zInstagramKpisCompleteResponse;

export const zGetInstagramPostsApiV1InstagramPostsGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(50).optional().default(10),
  sort_by: z.string().optional().default("date"),
  sort_order: z
    .string()
    .regex(/^(asc|desc)$/)
    .optional()
    .default("desc"),
  q: z.string().nullish(),
  filters: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetInstagramPostsApiV1InstagramPostsGetResponse =
  zInstagramPostsResponse;

export const zGetInstagramProfileMetricsApiV1InstagramProfileMetricsGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetInstagramProfileMetricsApiV1InstagramProfileMetricsGetResponse =
  zInstagramProfileMetricsResponse;

export const zGetInstagramStoriesApiV1InstagramStoriesGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(10).optional().default(10),
  sort_by: z.string().optional().default("date"),
  sort_order: z
    .string()
    .regex(/^(asc|desc)$/)
    .optional()
    .default("desc"),
  q: z.string().nullish(),
  filters: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetInstagramStoriesApiV1InstagramStoriesGetResponse =
  zInstagramStoriesResponse;

export const zGetInstagramTimeseriesCompleteApiV1InstagramTimeseriesCompleteGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetInstagramTimeseriesCompleteApiV1InstagramTimeseriesCompleteGetResponse =
  zInstagramTimeseriesCompleteResponse;

export const zGetInstagramCardMetricApiV1InstagramCardsMetricSlugGetPath =
  z.object({
    metric_slug: z.string(),
  });

export const zGetInstagramCardMetricApiV1InstagramCardsMetricSlugGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    previous_start_date: z.iso.date(),
    previous_end_date: z.iso.date(),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetInstagramCardMetricApiV1InstagramCardsMetricSlugGetResponse =
  zInstagramCardMetricResponse;

export const zGetInstagramDemographicsDimensionApiV1InstagramDemographicsDimensionSlugGetPath =
  z.object({
    dimension_slug: z.string(),
  });

export const zGetInstagramDemographicsDimensionApiV1InstagramDemographicsDimensionSlugGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
  });

/**
 * Response Get Instagram Demographics Dimension Api V1 Instagram Demographics  Dimension Slug  Get
 *
 * Successful Response
 */
export const zGetInstagramDemographicsDimensionApiV1InstagramDemographicsDimensionSlugGetResponse =
  z.union([
    zInstagramDemographicDimensionResponseInstagramAgeDemographicItem,
    zInstagramDemographicDimensionResponseInstagramCityDemographicItem,
    zInstagramDemographicDimensionResponseInstagramGenderDemographicItem,
  ]);

export const zGetInstagramTimeseriesMetricApiV1InstagramTimeseriesMetricSlugGetPath =
  z.object({
    metric_slug: z.string(),
  });

export const zGetInstagramTimeseriesMetricApiV1InstagramTimeseriesMetricSlugGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetInstagramTimeseriesMetricApiV1InstagramTimeseriesMetricSlugGetResponse =
  zInstagramTimeseriesMetricResponse;

/**
 * Response Get Accounts Api V1 Integrations Instagram Insights Accounts Get
 *
 * Successful Response
 */
export const zGetAccountsApiV1IntegrationsInstagramInsightsAccountsGetResponse =
  z.array(zInstagramAccount);

export const zGetAudienceInsightsApiV1IntegrationsInstagramInsightsAudienceInsightsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
    age_range: z.string().nullish(),
    gender: z.string().nullish(),
    country: z.string().nullish(),
  });

/**
 * Response Get Audience Insights Api V1 Integrations Instagram Insights Audience Insights Get
 *
 * Successful Response
 */
export const zGetAudienceInsightsApiV1IntegrationsInstagramInsightsAudienceInsightsGetResponse =
  z.array(zInstagramAudienceInsights);

/**
 * Successful Response
 */
export const zGetAuthUrlApiV1IntegrationsInstagramInsightsAuthUrlGetResponse =
  zInstagramAuthUrlResponse;

export const zOauthCallbackApiV1IntegrationsInstagramInsightsCallbackGetQuery =
  z.object({
    code: z.string(),
    state: z.string(),
  });

/**
 * Successful Response
 */
export const zOauthCallbackApiV1IntegrationsInstagramInsightsCallbackGetResponse =
  zInstagramCallbackResponse;

export const zClearAccountDataApiV1IntegrationsInstagramInsightsClearDataDeleteQuery =
  z.object({
    account_id: z.uuid(),
    confirm: z.boolean().optional().default(false),
  });

/**
 * Successful Response
 */
export const zClearAccountDataApiV1IntegrationsInstagramInsightsClearDataDeleteResponse =
  zInstagramClearDataResponse;

export const zGetCompleteDataApiV1IntegrationsInstagramInsightsCompleteDataGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
  });

/**
 * Successful Response
 */
export const zGetCompleteDataApiV1IntegrationsInstagramInsightsCompleteDataGetResponse =
  zInstagramCompleteResponse;

/**
 * Successful Response
 */
export const zGetConnectionStatusApiV1IntegrationsInstagramInsightsConnectionStatusGetResponse =
  zInstagramConnectionStatus;

export const zGetDailyMetricsApiV1IntegrationsInstagramInsightsDailyMetricsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
  });

/**
 * Response Get Daily Metrics Api V1 Integrations Instagram Insights Daily Metrics Get
 *
 * Successful Response
 */
export const zGetDailyMetricsApiV1IntegrationsInstagramInsightsDailyMetricsGetResponse =
  z.array(zInstagramDailyMetrics);

export const zGetEngagementTrendsApiV1IntegrationsInstagramInsightsEngagementTrendsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
    period: z
      .string()
      .regex(/^(daily|weekly|monthly)$/)
      .optional()
      .default("daily"),
  });

/**
 * Response Get Engagement Trends Api V1 Integrations Instagram Insights Engagement Trends Get
 *
 * Successful Response
 */
export const zGetEngagementTrendsApiV1IntegrationsInstagramInsightsEngagementTrendsGetResponse =
  z.array(zInstagramEngagementTrend);

export const zGetHashtagMetricsApiV1IntegrationsInstagramInsightsHashtagMetricsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
    hashtag: z.string().nullish(),
    min_engagement: z.int().nullish(),
  });

/**
 * Response Get Hashtag Metrics Api V1 Integrations Instagram Insights Hashtag Metrics Get
 *
 * Successful Response
 */
export const zGetHashtagMetricsApiV1IntegrationsInstagramInsightsHashtagMetricsGetResponse =
  z.array(zInstagramHashtagMetrics);

export const zGetPerformanceInsightsApiV1IntegrationsInstagramInsightsPerformanceInsightsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
  });

/**
 * Successful Response
 */
export const zGetPerformanceInsightsApiV1IntegrationsInstagramInsightsPerformanceInsightsGetResponse =
  zInstagramPerformanceInsights;

export const zGetPostsMetricsApiV1IntegrationsInstagramInsightsPostsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
    media_type: z.string().nullish(),
  });

/**
 * Response Get Posts Metrics Api V1 Integrations Instagram Insights Posts Get
 *
 * Successful Response
 */
export const zGetPostsMetricsApiV1IntegrationsInstagramInsightsPostsGetResponse =
  z.array(zInstagramPostMetrics);

export const zGetReelsMetricsApiV1IntegrationsInstagramInsightsReelsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
    min_plays: z.int().nullish(),
  });

/**
 * Response Get Reels Metrics Api V1 Integrations Instagram Insights Reels Get
 *
 * Successful Response
 */
export const zGetReelsMetricsApiV1IntegrationsInstagramInsightsReelsGetResponse =
  z.array(zInstagramReelMetrics);

/**
 * Successful Response
 */
export const zGetStatusApiV1IntegrationsInstagramInsightsStatusGetResponse =
  zInstagramConnectionStatus;

export const zGetStoriesMetricsApiV1IntegrationsInstagramInsightsStoriesGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
    story_type: z.string().nullish(),
  });

/**
 * Response Get Stories Metrics Api V1 Integrations Instagram Insights Stories Get
 *
 * Successful Response
 */
export const zGetStoriesMetricsApiV1IntegrationsInstagramInsightsStoriesGetResponse =
  z.array(zInstagramStoryMetrics);

export const zGetAccountSummaryApiV1IntegrationsInstagramInsightsSummaryGetQuery =
  z.object({
    account_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetAccountSummaryApiV1IntegrationsInstagramInsightsSummaryGetResponse =
  zInstagramSummaryResponse;

export const zSyncBasicMetricsApiV1IntegrationsInstagramInsightsSyncPostBody =
  zInstagramSyncRequest;

/**
 * Successful Response
 */
export const zSyncBasicMetricsApiV1IntegrationsInstagramInsightsSyncPostResponse =
  zInstagramSyncResponse;

export const zSyncCompleteDataApiV1IntegrationsInstagramInsightsSyncCompletePostBody =
  zInstagramSyncRequest;

/**
 * Successful Response
 */
export const zSyncCompleteDataApiV1IntegrationsInstagramInsightsSyncCompletePostResponse =
  zInstagramSyncResponse;

export const zGetTopPostsApiV1IntegrationsInstagramInsightsTopPostsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
    limit: z.int().gte(1).lte(50).optional().default(10),
    metric: z
      .string()
      .regex(
        /^(engagement_rate|likes|comments|shares|saves|impressions|reach)$/,
      )
      .optional()
      .default("engagement_rate"),
  });

/**
 * Response Get Top Posts Api V1 Integrations Instagram Insights Top Posts Get
 *
 * Successful Response
 */
export const zGetTopPostsApiV1IntegrationsInstagramInsightsTopPostsGetResponse =
  z.array(zInstagramTopPost);

/**
 * Response Get Accounts Api V1 Integrations Search Console Accounts Get
 *
 * Successful Response
 */
export const zGetAccountsApiV1IntegrationsSearchConsoleAccountsGetResponse =
  z.array(zSearchConsoleAccount);

/**
 * Successful Response
 */
export const zGetAuthUrlApiV1IntegrationsSearchConsoleAuthUrlGetResponse =
  zSearchConsoleAuthUrlResponse;

export const zOauthCallbackApiV1IntegrationsSearchConsoleCallbackGetQuery =
  z.object({
    code: z.string(),
    state: z.string(),
  });

/**
 * Successful Response
 */
export const zOauthCallbackApiV1IntegrationsSearchConsoleCallbackGetResponse =
  zSearchConsoleCallbackResponse;

export const zClearAccountDataApiV1IntegrationsSearchConsoleClearDataDeleteQuery =
  z.object({
    account_id: z.uuid(),
    confirm: z.boolean().optional().default(false),
  });

/**
 * Successful Response
 */
export const zClearAccountDataApiV1IntegrationsSearchConsoleClearDataDeleteResponse =
  zSearchConsoleClearDataResponse;

export const zGetCompleteDataApiV1IntegrationsSearchConsoleCompleteDataGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
  });

/**
 * Successful Response
 */
export const zGetCompleteDataApiV1IntegrationsSearchConsoleCompleteDataGetResponse =
  zSearchConsoleCompleteResponse;

/**
 * Successful Response
 */
export const zGetConnectionStatusApiV1IntegrationsSearchConsoleConnectionStatusGetResponse =
  zSearchConsoleConnectionStatus;

export const zGetCoreWebVitalsApiV1IntegrationsSearchConsoleCoreWebVitalsGetQuery =
  z.object({
    account_id: z.uuid(),
  });

/**
 * Response Get Core Web Vitals Api V1 Integrations Search Console Core Web Vitals Get
 *
 * Successful Response
 */
export const zGetCoreWebVitalsApiV1IntegrationsSearchConsoleCoreWebVitalsGetResponse =
  z.array(zSearchConsoleCoreWebVitals);

export const zGetIndexCoverageApiV1IntegrationsSearchConsoleIndexCoverageGetQuery =
  z.object({
    account_id: z.uuid(),
  });

/**
 * Response Get Index Coverage Api V1 Integrations Search Console Index Coverage Get
 *
 * Successful Response
 */
export const zGetIndexCoverageApiV1IntegrationsSearchConsoleIndexCoverageGetResponse =
  z.array(zSearchConsoleIndexCoverage);

export const zGetMetricsApiV1IntegrationsSearchConsoleMetricsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
    query: z.string().nullish(),
    page: z.string().nullish(),
    country: z.string().nullish(),
    device: z.string().nullish(),
  });

/**
 * Response Get Metrics Api V1 Integrations Search Console Metrics Get
 *
 * Successful Response
 */
export const zGetMetricsApiV1IntegrationsSearchConsoleMetricsGetResponse =
  z.array(zSearchConsoleMetrics);

export const zGetPerformanceInsightsApiV1IntegrationsSearchConsolePerformanceInsightsGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
  });

/**
 * Successful Response
 */
export const zGetPerformanceInsightsApiV1IntegrationsSearchConsolePerformanceInsightsGetResponse =
  zSearchConsolePerformanceInsights;

export const zGetRichResultsApiV1IntegrationsSearchConsoleRichResultsGetQuery =
  z.object({
    account_id: z.uuid(),
  });

/**
 * Response Get Rich Results Api V1 Integrations Search Console Rich Results Get
 *
 * Successful Response
 */
export const zGetRichResultsApiV1IntegrationsSearchConsoleRichResultsGetResponse =
  z.array(zSearchConsoleRichResults);

/**
 * Successful Response
 */
export const zGetStatusApiV1IntegrationsSearchConsoleStatusGetResponse =
  zSearchConsoleConnectionStatus;

export const zGetAccountSummaryApiV1IntegrationsSearchConsoleSummaryGetQuery =
  z.object({
    account_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetAccountSummaryApiV1IntegrationsSearchConsoleSummaryGetResponse =
  zSearchConsoleSummaryResponse;

export const zSyncMetricsApiV1IntegrationsSearchConsoleSyncPostBody =
  zSearchConsoleSyncRequest;

/**
 * Successful Response
 */
export const zSyncMetricsApiV1IntegrationsSearchConsoleSyncPostResponse =
  zSearchConsoleSyncResponse;

export const zSyncCompleteDataApiV1IntegrationsSearchConsoleSyncCompletePostBody =
  zSearchConsoleSyncRequest;

/**
 * Successful Response
 */
export const zSyncCompleteDataApiV1IntegrationsSearchConsoleSyncCompletePostResponse =
  zSearchConsoleSyncResponse;

export const zGetTopPagesApiV1IntegrationsSearchConsoleTopPagesGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
    limit: z.int().gte(1).lte(50).optional().default(10),
  });

/**
 * Response Get Top Pages Api V1 Integrations Search Console Top Pages Get
 *
 * Successful Response
 */
export const zGetTopPagesApiV1IntegrationsSearchConsoleTopPagesGetResponse =
  z.array(zSearchConsoleTopPage);

export const zGetTopQueriesApiV1IntegrationsSearchConsoleTopQueriesGetQuery =
  z.object({
    account_id: z.uuid(),
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
    limit: z.int().gte(1).lte(50).optional().default(10),
  });

/**
 * Response Get Top Queries Api V1 Integrations Search Console Top Queries Get
 *
 * Successful Response
 */
export const zGetTopQueriesApiV1IntegrationsSearchConsoleTopQueriesGetResponse =
  z.array(zSearchConsoleTopQuery);

export const zGetSeoCardsDataApiV1SeoCardsGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  customer_uuid: z.string().nullish(),
  account_id: z.string().nullish(),
  brand_name: z.string().nullish(),
  brand_terms: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetSeoCardsDataApiV1SeoCardsGetResponse = zSeoCardsResponse;

export const zGetSeoDevicesApiV1SeoDevicesGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  customer_uuid: z.string(),
  account_id: z.string().nullish(),
  brand_name: z.string().nullish(),
  brand_terms: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  brand_only: z.boolean().optional().default(false),
});

/**
 * Successful Response
 */
export const zGetSeoDevicesApiV1SeoDevicesGetResponse = zSeoDevicesResponse;

export const zApiV1SeoBrandTermsGetQuery = z.object({
  customer_uuid: z.string().optional(),
});

/**
 * Successful Response
 */
export const zApiV1SeoBrandTermsGetResponse = zSeoBrandTermsResponse;

export const zApiV1SeoBrandTermsPutBody = z.object({
  terms: z.array(z.string().max(255)).max(50),
});

export const zApiV1SeoBrandTermsPutQuery = z.object({
  customer_uuid: z.string().optional(),
});

/**
 * Successful Response
 */
export const zApiV1SeoBrandTermsPutResponse = zSeoBrandTermsResponse;

export const zGetAnalyticsOverviewApiV1AnalyticsOverviewGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  period: z.string().optional().default("7d"),
  comparison_type: z.string().nullish(),
  comparison_label: z.string().nullish(),
  custom_start_date: z.iso.date().nullish(),
  custom_end_date: z.iso.date().nullish(),
  customer_uuid: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetAnalyticsOverviewApiV1AnalyticsOverviewGetResponse =
  zAnalyticsOverviewResponse;

export const zGetChannelDailyAnalysisApiV1ChannelDailyAnalysisGetQuery =
  z.object({
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    customer_uuid: z.string().nullish(),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetChannelDailyAnalysisApiV1ChannelDailyAnalysisGetResponse =
  zChannelDailyAnalysisResponse;

export const zGetChannelGroupingCardDataApiV1ChannelGroupingCardGetQuery =
  z.object({
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    period: z.string().optional().default("7d"),
    comparison_type: z.string().nullish(),
    comparison_label: z.string().nullish(),
    custom_start_date: z.iso.date().nullish(),
    custom_end_date: z.iso.date().nullish(),
    customer_uuid: z.string().nullish(),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetChannelGroupingCardDataApiV1ChannelGroupingCardGetResponse =
  zChannelGroupingCardResponse;

export const zGetChannelMonthlyAnalysisApiV1ChannelMonthlyAnalysisGetQuery =
  z.object({
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    customer_uuid: z.string().nullish(),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetChannelMonthlyAnalysisApiV1ChannelMonthlyAnalysisGetResponse =
  zChannelMonthlyAnalysisResponse;

export const zGetSourceAnalysisCardApiV1SourceAnalysisCardGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  period: z.string().optional().default("7d"),
  comparison: z.string().nullish().default("previous_period"),
  comparison_label: z.string().nullish(),
  custom_start_date: z.iso.date().nullish(),
  custom_end_date: z.iso.date().nullish(),
  customer_uuid: z.string().nullish(),
  account_id: z.string().nullish(),
  filter_search_term: z.string().nullish(),
  filter_device: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_category: z.string().nullish(),
  filter_product: z.string().nullish(),
  filter_date: z.iso.date().nullish(),
});

/**
 * Successful Response
 */
export const zGetSourceAnalysisCardApiV1SourceAnalysisCardGetResponse =
  zSourceAnalysisCardResponse;

export const zApiV1AcquisitionAudienceQualityGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish(),
  filters: z.string().nullish(),
  filter_channel_group: z.string().nullish(),
  filter_source_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_new_returning: z.string().nullish(),
  filter_gender: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zApiV1AcquisitionAudienceQualityGetResponse =
  zAcquisitionTableResponse;

export const zGetAcquisitionCampaignsApiV1AcquisitionCampaignsGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish(),
    filters: z.string().nullish(),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
    filter_new_returning: z.string().nullish(),
    filter_landing_page: z.string().nullish(),
    filter_gender: z.string().nullish(),
    filter_age: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetAcquisitionCampaignsApiV1AcquisitionCampaignsGetResponse =
  zAcquisitionTableResponse;

export const zGetAcquisitionChannelGroupingApiV1AcquisitionChannelGroupingGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    property_id: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish(),
    filters: z.string().nullish(),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
    filter_device: z.string().nullish(),
    filter_new_returning: z.string().nullish(),
    filter_landing_page: z.string().nullish(),
    filter_gender: z.string().nullish(),
    filter_age: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetAcquisitionChannelGroupingApiV1AcquisitionChannelGroupingGetResponse =
  zAcquisitionChannelGroupingResponse;

export const zGetAcquisitionDashboardApiV1AcquisitionGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  account_id: z.string().nullish(),
  filter_channel_group: z.string().nullish(),
  filter_source_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetAcquisitionDashboardApiV1AcquisitionGetResponse =
  zAcquisitionDashboardResponse;

export const zGetAcquisitionDrilldownApiV1AcquisitionDrilldownGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    dimension: z.enum(["channel_group", "source_medium", "campaign"]),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish(),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetAcquisitionDrilldownApiV1AcquisitionDrilldownGetResponse =
  zAcquisitionDrilldownResponse;

export const zGetAcquisitionFullApiV1AcquisitionFullGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  account_id: z.string().nullish(),
  channels_page: z.int().gte(1).optional().default(1),
  sources_page: z.int().gte(1).optional().default(1),
  campaigns_page: z.int().gte(1).optional().default(1),
  nvr_page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish(),
  filters: z.string().nullish(),
  filter_channel_group: z.string().nullish(),
  filter_source_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetAcquisitionFullApiV1AcquisitionFullGetResponse =
  zAcquisitionFullResponse;

export const zApiV1AcquisitionGeoTablesGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  account_id: z.string().nullish(),
  states_page: z.int().gte(1).optional().default(1),
  cities_page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  filter_channel_group: z.string().nullish(),
  filter_source_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_new_returning: z.string().nullish(),
  filter_landing_page: z.string().nullish(),
  filter_gender: z.string().nullish(),
  filter_age: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zApiV1AcquisitionGeoTablesGetResponse =
  zAcquisitionGeoTablesResponse;

export const zGetAcquisitionGeoUsersApiV1AcquisitionGeoUsersGetQuery = z.object(
  {
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    new_by_region_page: z.int().gte(1).optional().default(1),
    ret_by_region_page: z.int().gte(1).optional().default(1),
    new_by_region_source_page: z.int().gte(1).optional().default(1),
    ret_by_region_source_page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish(),
    filters: z.string().nullish(),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
  },
);

/**
 * Successful Response
 */
export const zGetAcquisitionGeoUsersApiV1AcquisitionGeoUsersGetResponse =
  zAcquisitionGeoUsersFullResponse;

export const zGetAcquisitionGeoUsersNewByRegionApiV1AcquisitionGeoUsersNewByRegionGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish(),
    filters: z.string().nullish(),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetAcquisitionGeoUsersNewByRegionApiV1AcquisitionGeoUsersNewByRegionGetResponse =
  zAcquisitionGeoUsersTableResponse;

export const zGetAcquisitionGeoUsersNewByRegionSourceApiV1AcquisitionGeoUsersNewByRegionSourceGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish(),
    filters: z.string().nullish(),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetAcquisitionGeoUsersNewByRegionSourceApiV1AcquisitionGeoUsersNewByRegionSourceGetResponse =
  zAcquisitionGeoUsersTableResponse;

export const zGetAcquisitionGeoUsersReturningByRegionApiV1AcquisitionGeoUsersReturningByRegionGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish(),
    filters: z.string().nullish(),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetAcquisitionGeoUsersReturningByRegionApiV1AcquisitionGeoUsersReturningByRegionGetResponse =
  zAcquisitionGeoUsersTableResponse;

export const zGetAcquisitionGeoUsersReturningByRegionSourceApiV1AcquisitionGeoUsersReturningByRegionSourceGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish(),
    filters: z.string().nullish(),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetAcquisitionGeoUsersReturningByRegionSourceApiV1AcquisitionGeoUsersReturningByRegionSourceGetResponse =
  zAcquisitionGeoUsersTableResponse;

export const zGetAcquisitionKpisApiV1AcquisitionKpisGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  account_id: z.string().nullish(),
  filter_channel_group: z.string().nullish(),
  filter_source_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_new_returning: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetAcquisitionKpisApiV1AcquisitionKpisGetResponse =
  zAcquisitionKpisResponse;

export const zGetAcquisitionNewVsReturningApiV1AcquisitionNewVsReturningGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish(),
    filters: z.string().nullish(),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
    filter_new_returning: z.string().nullish(),
    filter_landing_page: z.string().nullish(),
    filter_gender: z.string().nullish(),
    filter_age: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetAcquisitionNewVsReturningApiV1AcquisitionNewVsReturningGetResponse =
  zAcquisitionTableResponse;

export const zApiV1AcquisitionOrdersGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(25),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish(),
  filters: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zApiV1AcquisitionOrdersGetResponse = zAcquisitionOrdersResponse;

export const zGetAcquisitionSourceMediumApiV1AcquisitionSourceMediumGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    dimension: z.string().optional().default("source_medium"),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish(),
    filters: z.string().nullish(),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
    filter_new_returning: z.string().nullish(),
    filter_landing_page: z.string().nullish(),
    filter_gender: z.string().nullish(),
    filter_age: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetAcquisitionSourceMediumApiV1AcquisitionSourceMediumGetResponse =
  zAcquisitionTableResponse;

export const zGetAcquisitionTimelineApiV1AcquisitionTimelineGetQuery = z.object(
  {
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    item_name: z.string().nullish(),
    item_name_operator: z.string().optional().default("contains"),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
    filter_category: z.string().nullish(),
    filter_product: z.string().nullish(),
    filter_device: z.string().nullish(),
    filter_age: z.string().nullish(),
    filter_gender: z.string().nullish(),
    filter_new_returning: z.string().nullish(),
  },
);

/**
 * Successful Response
 */
export const zGetAcquisitionTimelineApiV1AcquisitionTimelineGetResponse =
  zAcquisitionTimelineResponse;

export const zGetCampaignFilterFieldsApiV1CampaignFilterFieldsGetQuery =
  z.object({
    customer_uuid: z.string(),
    platform: z.string(),
  });

/**
 * Response Get Campaign Filter Fields Api V1 Campaign Filter Fields Get
 *
 * Successful Response
 */
export const zGetCampaignFilterFieldsApiV1CampaignFilterFieldsGetResponse =
  z.array(zCampaignFilterFieldResponse);

export const zGetCampaignFilterSuggestionsApiV1CampaignFilterSuggestionsGetQuery =
  z.object({
    customer_uuid: z.string(),
    platform: z.string(),
    field: z.string(),
    search: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    limit: z.int().nullish(),
  });

/**
 * Response Get Campaign Filter Suggestions Api V1 Campaign Filter Suggestions Get
 *
 * Successful Response
 */
export const zGetCampaignFilterSuggestionsApiV1CampaignFilterSuggestionsGetResponse =
  z.array(z.string());

export const zGetCampaignFiltersApiV1CampaignFiltersGetQuery = z.object({
  customer_uuid: z.string(),
  platform: z.string(),
  field: z.string(),
});

/**
 * Successful Response
 */
export const zGetCampaignFiltersApiV1CampaignFiltersGetResponse =
  zCampaignFiltersResponse;

export const zUpdateCampaignFiltersApiV1CampaignFiltersPutBody =
  zCampaignFiltersUpdate;

export const zUpdateCampaignFiltersApiV1CampaignFiltersPutQuery = z.object({
  customer_uuid: z.string(),
  platform: z.string(),
  field: z.string(),
});

/**
 * Successful Response
 */
export const zUpdateCampaignFiltersApiV1CampaignFiltersPutResponse =
  zCampaignFiltersResponse;

export const zGetCampaignsCardPagesApiV1AnalyticsCampaignsPagesGetQuery =
  z.object({
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().nullish().default("previous_period"),
    customer_uuid: z.string().nullish(),
    account_id: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish().default("desc"),
    filters: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetCampaignsCardPagesApiV1AnalyticsCampaignsPagesGetResponse =
  zCampaignsCardPagesResponse;

export const zGetUtmAdContentApiV1UtmAdContentGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish().default("desc"),
  filters: z.string().nullish(),
  filter_session_source: z.string().nullish(),
  filter_session_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_ad_content: z.string().nullish(),
  filter_date: z.iso.date().nullish(),
});

/**
 * Successful Response
 */
export const zGetUtmAdContentApiV1UtmAdContentGetResponse =
  zUtmAdContentTableResponse;

export const zGetUtmCampaignsApiV1UtmCampaignsGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish().default("desc"),
  filters: z.string().nullish(),
  filter_session_source: z.string().nullish(),
  filter_session_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_ad_content: z.string().nullish(),
  filter_date: z.iso.date().nullish(),
});

/**
 * Successful Response
 */
export const zGetUtmCampaignsApiV1UtmCampaignsGetResponse =
  zUtmCampaignTableResponse;

export const zGetUtmCardsApiV1UtmCardsGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  account_id: z.string().nullish(),
  filter_session_source: z.string().nullish(),
  filter_session_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_ad_content: z.string().nullish(),
  filter_date: z.iso.date().nullish(),
});

/**
 * Successful Response
 */
export const zGetUtmCardsApiV1UtmCardsGetResponse = zUtmCardsResponse;

export const zGetUtmMediumApiV1UtmMediumGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish().default("desc"),
  filters: z.string().nullish(),
  filter_session_source: z.string().nullish(),
  filter_session_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_ad_content: z.string().nullish(),
  filter_date: z.iso.date().nullish(),
});

/**
 * Successful Response
 */
export const zGetUtmMediumApiV1UtmMediumGetResponse = zUtmMediumTableResponse;

export const zGetUtmSessionSourceApiV1UtmSessionSourceGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish().default("desc"),
  filters: z.string().nullish(),
  filter_session_source: z.string().nullish(),
  filter_session_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_ad_content: z.string().nullish(),
  filter_date: z.iso.date().nullish(),
});

/**
 * Successful Response
 */
export const zGetUtmSessionSourceApiV1UtmSessionSourceGetResponse =
  zUtmSourceTableResponse;

export const zGetConversionRateCardsV2ApiV1ConversionRateCardsV2GetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetConversionRateCardsV2ApiV1ConversionRateCardsV2GetResponse =
  zConversionRateCardsKpisResponse;

export const zGetConversionRateDashboardApiV1ConversionRateDashboardGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetConversionRateDashboardApiV1ConversionRateDashboardGetResponse =
  zConversionRateDashboardResponse;

export const zGetConversionRateDemographicsApiV1ConversionRateDemographicsGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    dimension: z.string().optional().default("gender"),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish(),
    filters: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetConversionRateDemographicsApiV1ConversionRateDemographicsGetResponse =
  zConversionRateDemographicsV2Response;

export const zGetConversionRateDemographicsV2ApiV1ConversionRateDemographicsV2GetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    dimension: z.string().optional().default("gender"),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish(),
    filters: z.string().nullish(),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
    filter_device: z.string().nullish(),
    filter_new_returning: z.string().nullish(),
    filter_landing_page: z.string().nullish(),
    filter_gender: z.string().nullish(),
    filter_age: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetConversionRateDemographicsV2ApiV1ConversionRateDemographicsV2GetResponse =
  zConversionRateDemographicsV2Response;

export const zGetConversionRateFullApiV1ConversionRateFullGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  account_id: z.string().nullish(),
  item_name: z.string().nullish(),
  item_name_operator: z.string().optional().default("contains"),
  categories_page: z.int().gte(1).optional().default(1),
  products_page: z.int().gte(1).optional().default(1),
  sources_page: z.int().gte(1).optional().default(1),
  campaigns_page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(10).optional().default(10),
  filter_channel_group: z.string().nullish(),
  filter_source_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_device: z.string().nullish(),
  filter_gender: z.string().nullish(),
  filter_age: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetConversionRateFullApiV1ConversionRateFullGetResponse =
  zConversionRateFullResponse;

export const zGetConversionRateUtmCampaignsApiV1ConversionRateUtmCampaignsGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish(),
    filters: z.string().nullish(),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
    filter_device: z.string().nullish(),
    filter_gender: z.string().nullish(),
    filter_age: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetConversionRateUtmCampaignsApiV1ConversionRateUtmCampaignsGetResponse =
  zUtmCampaignsConversionResponse;

export const zGetDailyControlApiV1DailyControlCardGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  period: z.string().optional().default("7d"),
  comparison: z.string().nullish().default("previous_period"),
  comparison_label: z.string().nullish(),
  custom_start_date: z.iso.date().nullish(),
  custom_end_date: z.iso.date().nullish(),
  customer_uuid: z.string().nullish(),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish(),
  filters: z.string().nullish(),
  filter_search_term: z.string().nullish(),
  filter_device: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_category: z.string().nullish(),
  filter_product: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetDailyControlApiV1DailyControlCardGetResponse =
  zDailyControlCardResponse;

export const zGetGoogleAnalyticsConversionRateCardsKpisApiV1GoogleAnalyticsConversionRateCardsKpisGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
    filter_device: z.string().nullish(),
    filter_gender: z.string().nullish(),
    filter_age: z.string().nullish(),
    item_name: z.string().nullish(),
    item_name_operator: z.string().optional().default("contains"),
  });

/**
 * Successful Response
 */
export const zGetGoogleAnalyticsConversionRateCardsKpisApiV1GoogleAnalyticsConversionRateCardsKpisGetResponse =
  zConversionRateCardsKpisResponse;

export const zGetSalesFunnelApiV1SalesFunnelCardGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  period: z.string().optional().default("7d"),
  comparison: z.string().nullish().default("previous_period"),
  comparison_label: z.string().nullish(),
  custom_start_date: z.iso.date().nullish(),
  custom_end_date: z.iso.date().nullish(),
  customer_uuid: z.string().nullish(),
  account_id: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetSalesFunnelApiV1SalesFunnelCardGetResponse =
  zSalesFunnelCardResponse;

export const zApiV1SalesFunnelStage1BreakdownGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().nullish().default("previous_period"),
  account_id: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zApiV1SalesFunnelStage1BreakdownGetResponse =
  zSalesFunnelStage1Response;

export const zProxyAdsDashboardChartApiV1AdsDashboardPlatformChartsChartGetPath =
  z.object({
    platform: z.string(),
    chart: z.string(),
  });

export const zProxyAdsDashboardChartApiV1AdsDashboardPlatformChartsChartGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zProxyAdsDashboardChartApiV1AdsDashboardPlatformChartsChartGetResponse =
  zAdsDashboardChartResponse;

export const zProxyAdsDashboardKpiApiV1AdsDashboardPlatformKpisMetricGetPath =
  z.object({
    platform: z.string(),
    metric: z.string(),
  });

export const zProxyAdsDashboardKpiApiV1AdsDashboardPlatformKpisMetricGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zProxyAdsDashboardKpiApiV1AdsDashboardPlatformKpisMetricGetResponse =
  zAdsDashboardKpiResponse;

export const zProxyAdsDashboardTableApiV1AdsDashboardPlatformTablesTableGetPath =
  z.object({
    platform: z.string(),
    table: z.string(),
  });

export const zProxyAdsDashboardTableApiV1AdsDashboardPlatformTablesTableGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
  });

/**
 * Response Proxy Ads Dashboard Table Api V1 Ads Dashboard  Platform  Tables  Table  Get
 *
 * Successful Response
 */
export const zProxyAdsDashboardTableApiV1AdsDashboardPlatformTablesTableGetResponse =
  z.union([
    zAdsDashboardTableResponseCampaignTableItem,
    zAdsDashboardTableResponseCreativeTypeTableItem,
    zAdsDashboardTableResponseDemographicsTableItem,
    zAdsDashboardTableResponseHourlyTableItem,
    zAdsDashboardTableResponsePositioningTableItem,
    zAdsDashboardTableResponseProductTableItem,
    zAdsDashboardTableResponseSearchTermTableItem,
    zAdsDashboardTableResponseUrlDestinationTableItem,
  ]);

export const zGetAvailableMonthsApiV1BenchmarkAvailableMonthsGetQuery =
  z.object({
    scope: z.string(),
    customer_uuid: z.uuid(),
  });

/**
 * Successful Response
 */
export const zGetAvailableMonthsApiV1BenchmarkAvailableMonthsGetResponse =
  zBenchmarkAvailableMonthsResponse;

export const zGetDataApiV1BenchmarkDataPostQuery = z.object({
  customer_uuid: z.uuid(),
  scope: z.string(),
  segment: z.string().nullish(),
  window: z.string().optional().default("30d"),
  hide_my_account: z.boolean().optional().default(false),
});

/**
 * Successful Response
 */
export const zGetDataApiV1BenchmarkDataPostResponse = zBenchmarkDataResponse;

export const zFinalizeUpdateApiV1BenchmarkFinalizeUpdatePostQuery = z.object({
  customer_uuid: z.uuid(),
});

/**
 * Successful Response
 */
export const zFinalizeUpdateApiV1BenchmarkFinalizeUpdatePostResponse =
  zBenchmarkFinalizeUpdateResponse;

export const zGetHistoricalDataApiV1BenchmarkHistoricalDataPostQuery = z.object(
  {
    customer_uuid: z.uuid(),
    scope: z.string(),
    year_month: z.string(),
    granularity: z.string(),
    segment: z.string().nullish(),
    hide_my_account: z.boolean().optional().default(false),
  },
);

/**
 * Successful Response
 */
export const zGetHistoricalDataApiV1BenchmarkHistoricalDataPostResponse =
  zBenchmarkDataResponse;

export const zGetParticipationReportApiV1BenchmarkParticipationReportPostQuery =
  z.object({
    customer_uuid: z.uuid(),
    window: z.string().optional().default("7d"),
  });

/**
 * Successful Response
 */
export const zGetParticipationReportApiV1BenchmarkParticipationReportPostResponse =
  zBenchmarkParticipationReportResponse;

export const zGetSegmentsApiV1BenchmarkSegmentsGetQuery = z.object({
  scope: z.string(),
  customer_uuid: z.uuid(),
});

/**
 * Successful Response
 */
export const zGetSegmentsApiV1BenchmarkSegmentsGetResponse =
  zBenchmarkSegmentsResponse;

export const zSyncAccountApiV1BenchmarkSyncAccountPostQuery = z.object({
  account_id: z.string(),
  customer_uuid: z.uuid(),
  name: z.string(),
  segment: z.string().nullish(),
  agency_customer_uuid: z.uuid().nullish(),
  partner_uuid: z.uuid(),
});

/**
 * Successful Response
 */
export const zSyncAccountApiV1BenchmarkSyncAccountPostResponse =
  zBenchmarkSyncAccountResponse;

export const zUpdateAccountApiV1BenchmarkUpdateAccountPostQuery = z.object({
  account_id: z.string(),
  window: z.string().optional().default("30d"),
});

/**
 * Successful Response
 */
export const zUpdateAccountApiV1BenchmarkUpdateAccountPostResponse =
  zBenchmarkUpdateAccountResponse;

export const zGetUpdateQueueApiV1BenchmarkUpdateQueuePostQuery = z.object({
  customer_uuid: z.uuid(),
});

/**
 * Successful Response
 */
export const zGetUpdateQueueApiV1BenchmarkUpdateQueuePostResponse =
  zBenchmarkUpdateQueueResponse;

export const zGetHistoricalAdsPerformanceApiV1HistoricalAdsPerformanceGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    google_page: z.int().gte(1).optional().default(1),
    meta_page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(10).optional().default(10),
    granularity: z.enum(["day", "month", "quarter", "semester"]).nullish(),
  });

/**
 * Successful Response
 */
export const zGetHistoricalAdsPerformanceApiV1HistoricalAdsPerformanceGetResponse =
  zHistoricalAdsPerformanceResponse;

export const zGetHistoricalGoogleAdsChartApiV1HistoricalGoogleAdsChartGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    granularity: z.enum(["day", "month", "quarter", "semester"]).nullish(),
  });

/**
 * Successful Response
 */
export const zGetHistoricalGoogleAdsChartApiV1HistoricalGoogleAdsChartGetResponse =
  zHistoricalGoogleAdsChartResponse;

export const zGetHistoricalGoogleAdsTableApiV1HistoricalGoogleAdsTableGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    granularity: z.enum(["day", "month", "quarter", "semester"]).nullish(),
  });

/**
 * Successful Response
 */
export const zGetHistoricalGoogleAdsTableApiV1HistoricalGoogleAdsTableGetResponse =
  zHistoricalGoogleAdsTableResponse;

export const zGetHistoricalMetaAdsChartApiV1HistoricalMetaAdsChartGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    granularity: z.enum(["day", "month", "quarter", "semester"]).nullish(),
  });

/**
 * Successful Response
 */
export const zGetHistoricalMetaAdsChartApiV1HistoricalMetaAdsChartGetResponse =
  zHistoricalMetaAdsChartResponse;

export const zGetHistoricalMetaAdsTableApiV1HistoricalMetaAdsTableGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    granularity: z.enum(["day", "month", "quarter", "semester"]).nullish(),
  });

/**
 * Successful Response
 */
export const zGetHistoricalMetaAdsTableApiV1HistoricalMetaAdsTableGetResponse =
  zHistoricalMetaAdsTableResponse;

export const zGetMediaPerformanceAovConversionApiV1MediaPerformanceAovConversionGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceAovConversionApiV1MediaPerformanceAovConversionGetResponse =
  zMediaPerformanceAovConversionResponse;

export const zGetMediaPerformanceCardsApiV1MediaPerformanceCardsGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceCardsApiV1MediaPerformanceCardsGetResponse =
  zMediaPerformanceCardsResponse;

export const zGetMediaPerformanceChannelGroupsApiV1MediaPerformanceChannelGroupsGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceChannelGroupsApiV1MediaPerformanceChannelGroupsGetResponse =
  zChannelGroupsResponse;

export const zGetMediaPerformanceGeneralPerformanceApiV1MediaPerformanceGeneralPerformanceGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceGeneralPerformanceApiV1MediaPerformanceGeneralPerformanceGetResponse =
  zGeneralPerformanceResponse;

export const zGetMediaPerformanceInvestmentCpsApiV1MediaPerformanceInvestmentCpsGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceInvestmentCpsApiV1MediaPerformanceInvestmentCpsGetResponse =
  zMediaPerformanceInvestmentCpsResponse;

export const zGetMediaPerformanceInvestmentRevenueApiV1MediaPerformanceInvestmentRevenueGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceInvestmentRevenueApiV1MediaPerformanceInvestmentRevenueGetResponse =
  zMediaPerformanceInvestmentRevenueResponse;

export const zGetMediaPerformanceInvestmentRoasApiV1MediaPerformanceInvestmentRoasGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceInvestmentRoasApiV1MediaPerformanceInvestmentRoasGetResponse =
  zMediaPerformanceInvestmentRoasResponse;

export const zGetMediaPerformanceInvestmentSessionsApiV1MediaPerformanceInvestmentSessionsGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceInvestmentSessionsApiV1MediaPerformanceInvestmentSessionsGetResponse =
  zMediaPerformanceInvestmentSessionsResponse;

export const zGetMediaPerformanceRevenueConversionApiV1MediaPerformanceRevenueConversionGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceRevenueConversionApiV1MediaPerformanceRevenueConversionGetResponse =
  zMediaPerformanceRevenueConversionResponse;

export const zGetMediaPerformanceSessionOriginMediaApiV1MediaPerformanceSessionOriginMediaGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceSessionOriginMediaApiV1MediaPerformanceSessionOriginMediaGetResponse =
  zSessionOriginMediaResponse;

export const zGetMediaPerformanceSessionsAovApiV1MediaPerformanceSessionsAovGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceSessionsAovApiV1MediaPerformanceSessionsAovGetResponse =
  zMediaPerformanceSessionsAovResponse;

export const zGetMediaPerformanceSessionsBreakdownApiV1MediaPerformanceSessionsBreakdownGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceSessionsBreakdownApiV1MediaPerformanceSessionsBreakdownGetResponse =
  zMediaPerformanceSessionsBreakdownResponse;

export const zGetMediaPerformanceSessionsConversionApiV1MediaPerformanceSessionsConversionGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceSessionsConversionApiV1MediaPerformanceSessionsConversionGetResponse =
  zMediaPerformanceSessionsConversionResponse;

export const zGetMediaPerformanceSessionsRevenueApiV1MediaPerformanceSessionsRevenueGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceSessionsRevenueApiV1MediaPerformanceSessionsRevenueGetResponse =
  zMediaPerformanceSessionsRevenueResponse;

export const zGetMediaPerformanceSessionsRoasApiV1MediaPerformanceSessionsRoasGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetMediaPerformanceSessionsRoasApiV1MediaPerformanceSessionsRoasGetResponse =
  zMediaPerformanceSessionsRoasResponse;

/**
 * Successful Response
 */
export const zListSegmentsApiV1SegmentsGetResponse = zSegmentListResponse;

export const zGetLojaVirtualAnalyticsApiV1LojaVirtualAnalyticsGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.string(),
    end_date: z.string(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
  });

/**
 * Successful Response
 */
export const zGetLojaVirtualAnalyticsApiV1LojaVirtualAnalyticsGetResponse =
  zLojaVirtualAnalyticsResponse;

export const zGetProductsCardsApiV1ProductsCardsGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  account_id: z.string().nullish(),
  filter_channel_group: z.string().nullish(),
  filter_source_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_new_returning: z.string().nullish(),
  filter_landing_page: z.string().nullish(),
  filter_gender: z.string().nullish(),
  filter_age: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetProductsCardsApiV1ProductsCardsGetResponse =
  zProductsCardsResponse;

export const zGetProductsDashboardFullApiV1ProductsDashboardGetQuery = z.object(
  {
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    account_id: z.string().nullish(),
    products_page: z.int().gte(1).optional().default(1),
    products_page_size: z.int().gte(1).lte(100).optional().default(10),
    regions_page: z.int().gte(1).optional().default(1),
    regions_page_size: z.int().gte(1).lte(100).optional().default(10),
    cities_page: z.int().gte(1).optional().default(1),
    cities_page_size: z.int().gte(1).lte(100).optional().default(10),
    filter_search_term: z.string().nullish(),
    filter_device: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
    filter_category: z.string().nullish(),
    filter_category2: z.string().nullish(),
    filter_category3: z.string().nullish(),
    filter_category4: z.string().nullish(),
    filter_category5: z.string().nullish(),
    filter_brand: z.string().nullish(),
    filter_variant: z.string().nullish(),
    filter_product: z.string().nullish(),
    filter_date: z.iso.date().nullish(),
  },
);

/**
 * Successful Response
 */
export const zGetProductsDashboardFullApiV1ProductsDashboardGetResponse =
  zProductsDashboardFullResponse;

export const zGetProductsGeneralItemPerformanceApiV1ProductsGeneralItemPerformanceGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    property_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
    filter_category: z.string().nullish(),
    filter_category2: z.string().nullish(),
    filter_category3: z.string().nullish(),
    filter_category4: z.string().nullish(),
    filter_category5: z.string().nullish(),
    filter_brand: z.string().nullish(),
    filter_variant: z.string().nullish(),
    filter_product: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetProductsGeneralItemPerformanceApiV1ProductsGeneralItemPerformanceGetResponse =
  zGeneralItemPerformanceResponse;

export const zGetProductsRevenueTrendApiV1ProductsRevenueTrendGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
    limit: z.int().gte(1).lte(10).optional().default(5),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(50).optional().default(10),
    item_name: z.string().nullish(),
    item_name_operator: z.string().optional().default("contains"),
    filter_category: z.string().nullish(),
    filter_category2: z.string().nullish(),
    filter_category3: z.string().nullish(),
    filter_category4: z.string().nullish(),
    filter_category5: z.string().nullish(),
    filter_brand: z.string().nullish(),
    filter_variant: z.string().nullish(),
    filter_product: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_device: z.string().nullish(),
    filter_gender: z.string().nullish(),
    filter_age: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetProductsRevenueTrendApiV1ProductsRevenueTrendGetResponse =
  zProductsRevenueTrendResponse;

export const zGetProductsTopCategoriesRevenueTrendApiV1ProductsTopCategoriesRevenueTrendGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    account_id: z.string().nullish(),
    comparison: z.string().optional().default("previous_period"),
    filter_category: z.string().nullish(),
    filter_category2: z.string().nullish(),
    filter_category3: z.string().nullish(),
    filter_category4: z.string().nullish(),
    filter_category5: z.string().nullish(),
    filter_brand: z.string().nullish(),
    filter_variant: z.string().nullish(),
    filter_product: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetProductsTopCategoriesRevenueTrendApiV1ProductsTopCategoriesRevenueTrendGetResponse =
  zProductsTopCategoriesRevenueTrendResponse;

export const zApiProductsTopCategorySalesEndpointQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  account_id: z.string().nullish(),
  comparison: z.string().optional().default("previous_period"),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish(),
  filters: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zApiProductsTopCategorySalesEndpointResponse =
  zProductsTopCategorySalesResponse;

export const zGetRevenueDashboardApiV1RevenueDashboardGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  account_id: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetRevenueDashboardApiV1RevenueDashboardGetResponse =
  zRevenueDashboardResponse;

export const zGetSalesByChannelApiV1SalesByChannelGetQuery = z.object({
  start_date: z.iso.date().nullish(),
  end_date: z.iso.date().nullish(),
});

/**
 * Response Get Sales By Channel Api V1 Sales By Channel Get
 *
 * Successful Response
 */
export const zGetSalesByChannelApiV1SalesByChannelGetResponse =
  z.array(zChannelData);

export const zGetSalesByDeviceApiV1SalesByDeviceGetQuery = z.object({
  start_date: z.iso.date().nullish(),
  end_date: z.iso.date().nullish(),
});

/**
 * Response Get Sales By Device Api V1 Sales By Device Get
 *
 * Successful Response
 */
export const zGetSalesByDeviceApiV1SalesByDeviceGetResponse =
  z.array(zDeviceData);

export const zGetSalesByGeographyApiV1SalesByGeographyGetQuery = z.object({
  start_date: z.iso.date().nullish(),
  end_date: z.iso.date().nullish(),
});

/**
 * Response Get Sales By Geography Api V1 Sales By Geography Get
 *
 * Successful Response
 */
export const zGetSalesByGeographyApiV1SalesByGeographyGetResponse =
  z.array(zGeographyData);

export const zGetDailyPerformanceApiV1SalesDailyPerformanceGetQuery = z.object({
  start_date: z.iso.date().nullish(),
  end_date: z.iso.date().nullish(),
});

/**
 * Response Get Daily Performance Api V1 Sales Daily Performance Get
 *
 * Successful Response
 */
export const zGetDailyPerformanceApiV1SalesDailyPerformanceGetResponse =
  z.array(zDailyPerformance);

export const zGetSalesMetricsApiV1SalesMetricsGetQuery = z.object({
  start_date: z.iso.date().nullish(),
  end_date: z.iso.date().nullish(),
});

/**
 * Successful Response
 */
export const zGetSalesMetricsApiV1SalesMetricsGetResponse = zSalesMetrics;

export const zGetSalesOverviewApiV1SalesOverviewGetQuery = z.object({
  start_date: z.iso.date().nullish(),
  end_date: z.iso.date().nullish(),
});

/**
 * Successful Response
 */
export const zGetSalesOverviewApiV1SalesOverviewGetResponse = zSalesOverview;

export const zGetSalesTrendsApiV1SalesTrendsGetQuery = z.object({
  start_date: z.iso.date().nullish(),
  end_date: z.iso.date().nullish(),
});

/**
 * Response Get Sales Trends Api V1 Sales Trends Get
 *
 * Successful Response
 */
export const zGetSalesTrendsApiV1SalesTrendsGetResponse = z.array(zSalesTrend);

export const zGetTopCategorySalesApiV1TopCategorySalesGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  period: z.string().optional().default("7d"),
  comparison: z.string().nullish().default("previous_period"),
  dimension: z.string().nullish(),
  comparison_label: z.string().nullish(),
  custom_start_date: z.iso.date().nullish(),
  custom_end_date: z.iso.date().nullish(),
  customer_uuid: z.string().nullish(),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish(),
  filters: z.string().nullish(),
  filter_search_term: z.string().nullish(),
  filter_device: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_category: z.string().nullish(),
  filter_category2: z.string().nullish(),
  filter_category3: z.string().nullish(),
  filter_category4: z.string().nullish(),
  filter_category5: z.string().nullish(),
  filter_brand: z.string().nullish(),
  filter_variant: z.string().nullish(),
  filter_product: z.string().nullish(),
  filter_date: z.iso.date().nullish(),
});

/**
 * Successful Response
 */
export const zGetTopCategorySalesApiV1TopCategorySalesGetResponse =
  zTopCategorySalesAsyncResponse;

export const zGetTopSellingProductsApiV1TopSellingProductsGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().nullish().default("previous_period"),
  dimension: z.string().nullish(),
  customer_uuid: z.string().nullish(),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish(),
  filters: z.string().nullish(),
  filter_search_term: z.string().nullish(),
  filter_device: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_category: z.string().nullish(),
  filter_category2: z.string().nullish(),
  filter_category3: z.string().nullish(),
  filter_category4: z.string().nullish(),
  filter_category5: z.string().nullish(),
  filter_brand: z.string().nullish(),
  filter_variant: z.string().nullish(),
  filter_product: z.string().nullish(),
  filter_date: z.iso.date().nullish(),
});

/**
 * Successful Response
 */
export const zGetTopSellingProductsApiV1TopSellingProductsGetResponse =
  zProductsDashboardTopSellingResponse;

export const zGetAllPagesApiV1PagesAllPagesGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().nullish().default("previous_period"),
  customer_uuid: z.string().nullish(),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish().default("desc"),
  filters: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetAllPagesApiV1PagesAllPagesGetResponse = zPagesAllPagesResponse;

export const zGetCategoryByCityApiV1CategoryByCityGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish(),
  filters: z.string().nullish(),
  filter_category: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_search_term: z.string().nullish(),
  filter_device: z.string().nullish(),
  filter_product: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_date: z.iso.date().nullish(),
});

/**
 * Successful Response
 */
export const zGetCategoryByCityApiV1CategoryByCityGetResponse =
  zCategoryByCityResponse;

export const zGetCategoryByStateApiV1CategoryByStateGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish(),
  filters: z.string().nullish(),
  filter_category: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_product: z.string().nullish(),
  filter_search_term: z.string().nullish(),
  filter_device: z.string().nullish(),
  filter_date: z.iso.date().nullish(),
});

/**
 * Successful Response
 */
export const zGetCategoryByStateApiV1CategoryByStateGetResponse =
  zCategoryByRegionResponse;

export const zGetDevicesSalesApiV1DevicesSalesGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().nullish().default("previous_period"),
  customer_uuid: z.string().nullish(),
  account_id: z.string().nullish(),
  filter_channel_group: z.string().nullish(),
  filter_source_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_device: z.string().nullish(),
  filter_gender: z.string().nullish(),
  filter_age: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetDevicesSalesApiV1DevicesSalesGetResponse =
  zDevicesSalesResponse;

export const zGetDevicesStatesApiV1DevicesStatesCardGetQuery = z.object({
  customer_uuid: z.string(),
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  account_id: z.string().nullish(),
  comparison: z.string().optional().default("previous_period"),
  states_page: z.int().gte(1).optional().default(1),
  states_page_size: z.int().gte(1).lte(100).optional().default(10),
});

/**
 * Successful Response
 */
export const zGetDevicesStatesApiV1DevicesStatesCardGetResponse =
  zDevicesStatesCardResponse;

export const zGetInternalSearchApiV1InternalSearchCardGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().nullish().default("previous_period"),
  customer_uuid: z.string().nullish(),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish(),
  filters: z.string().nullish(),
  filter_date: z.iso.date().nullish(),
  filter_device: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_category: z.string().nullish(),
  filter_product: z.string().nullish(),
  filter_search_term: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetInternalSearchApiV1InternalSearchCardGetResponse =
  zInternalSearchCardResponse;

export const zGetLandingPagesApiV1PagesLandingPageGetQuery = z.object({
  start_date: z.string(),
  end_date: z.string(),
  comparison: z.string().nullish().default("previous_period"),
  customer_uuid: z.string().nullish(),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish().default("desc"),
  filters: z.string().nullish(),
  filter_channel_group: z.string().nullish(),
  filter_source_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_new_returning: z.string().nullish(),
  filter_landing_page: z.string().nullish(),
  filter_gender: z.string().nullish(),
  filter_age: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetLandingPagesApiV1PagesLandingPageGetResponse =
  zPagesLandingPageResponse;

export const zGetPagesSourceMediumApiV1PagesSourceMediumGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().nullish().default("previous_period"),
  customer_uuid: z.string().nullish(),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish().default("desc"),
  filters: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetPagesSourceMediumApiV1PagesSourceMediumGetResponse =
  zPagesSourceMediumResponse;

export const zGetRegionsProductsByCityApiV1RegionsProductsByCityGetQuery =
  z.object({
    customer_uuid: z.string(),
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(10).optional().default(10),
  });

/**
 * Successful Response
 */
export const zGetRegionsProductsByCityApiV1RegionsProductsByCityGetResponse =
  zRegionsProductsByCityResponse;

export const zGetRegionsSalesApiV1RegionsSalesGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().nullish().default("previous_period"),
  dimension: z.enum(["region", "city"]).nullish(),
  customer_uuid: z.string().nullish(),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish(),
  filters: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetRegionsSalesApiV1RegionsSalesGetResponse =
  zRegionsSalesResponse;

export const zGetRegionsSalesByCityApiV1RegionsSalesByCityGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().nullish().default("previous_period"),
  customer_uuid: z.string().nullish(),
  account_id: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  filter_channel_group: z.string().nullish(),
  filter_source_medium: z.string().nullish(),
  filter_campaign: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
  filter_device: z.string().nullish(),
  filter_gender: z.string().nullish(),
  filter_age: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zGetRegionsSalesByCityApiV1RegionsSalesByCityGetResponse =
  zRegionsSalesResponse;

export const zGetRegionsSalesByStateApiV1RegionsSalesByStateGetQuery = z.object(
  {
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().nullish().default("previous_period"),
    customer_uuid: z.string().nullish(),
    account_id: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    filter_channel_group: z.string().nullish(),
    filter_source_medium: z.string().nullish(),
    filter_campaign: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
    filter_device: z.string().nullish(),
    filter_gender: z.string().nullish(),
    filter_age: z.string().nullish(),
  },
);

/**
 * Successful Response
 */
export const zGetRegionsSalesByStateApiV1RegionsSalesByStateGetResponse =
  zRegionsSalesResponse;

export const zGetRegionsSalesOverviewApiV1RegionsSalesOverviewGetQuery =
  z.object({
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().nullish().default("previous_period"),
    customer_uuid: z.string().nullish(),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zGetRegionsSalesOverviewApiV1RegionsSalesOverviewGetResponse =
  zRegionsSalesResponse;

export const zProxyRegionsCategoriesApiV1RegionsDashboardCategoriesGetQuery =
  z.object({
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    customer_uuid: z.string().nullish(),
    property_id: z.string().nullish(),
    account_id: z.string().nullish(),
    region: z.string().nullish(),
    page: z.int().gte(1).optional().default(1),
    page_size: z.int().gte(1).lte(100).optional().default(10),
    q: z.string().nullish(),
    sort_by: z.string().nullish(),
    sort_dir: z.string().nullish(),
    filters: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zProxyRegionsCategoriesApiV1RegionsDashboardCategoriesGetResponse =
  zRegionsDashboardCategoriesResponse;

export const zProxyRegionsCategoryMatrixApiV1RegionsDashboardCategoryMatrixGetQuery =
  z.object({
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    customer_uuid: z.string().nullish(),
    property_id: z.string().nullish(),
    account_id: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zProxyRegionsCategoryMatrixApiV1RegionsDashboardCategoryMatrixGetResponse =
  zRegionsCategoryMatrixResponse;

export const zProxyRegionsCitiesApiV1RegionsDashboardCitiesGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  customer_uuid: z.string().nullish(),
  property_id: z.string().nullish(),
  account_id: z.string().nullish(),
  region: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish(),
  filters: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zProxyRegionsCitiesApiV1RegionsDashboardCitiesGetResponse =
  zRegionsDashboardCitiesResponse;

export const zProxyRegionsItemsApiV1RegionsDashboardItemsGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  customer_uuid: z.string().nullish(),
  property_id: z.string().nullish(),
  account_id: z.string().nullish(),
  region: z.string().nullish(),
  category: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish(),
  filters: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zProxyRegionsItemsApiV1RegionsDashboardItemsGetResponse =
  zRegionsDashboardItemsResponse;

export const zProxyRegionsStatesApiV1RegionsDashboardStatesGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison: z.string().optional().default("previous_period"),
  customer_uuid: z.string().nullish(),
  property_id: z.string().nullish(),
  account_id: z.string().nullish(),
  region: z.string().nullish(),
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  q: z.string().nullish(),
  sort_by: z.string().nullish(),
  sort_dir: z.string().nullish(),
  filters: z.string().nullish(),
  filter_region: z.string().nullish(),
  filter_city: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zProxyRegionsStatesApiV1RegionsDashboardStatesGetResponse =
  zRegionsDashboardStatesResponse;

export const zProxyRegionsSummaryApiV1RegionsDashboardSummaryGetQuery =
  z.object({
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    comparison: z.string().optional().default("previous_period"),
    customer_uuid: z.string().nullish(),
    property_id: z.string().nullish(),
    account_id: z.string().nullish(),
    filter_region: z.string().nullish(),
    filter_city: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zProxyRegionsSummaryApiV1RegionsDashboardSummaryGetResponse =
  zRegionsDashboardSummaryResponse;

export const zContinueAgentChatApiV1AiAgentsChatPostBody =
  zBodyContinueAgentChatApiV1AiAgentsChatPost;

/**
 * Successful Response
 */
export const zContinueAgentChatApiV1AiAgentsChatPostResponse =
  zAgentChatResponse;

export const zFetchAgentConversationHistoryApiV1AiAgentsPlatformConversationsConversationIdHistoryGetPath =
  z.object({
    platform: z.string(),
    conversation_id: z.string(),
  });

export const zFetchAgentConversationHistoryApiV1AiAgentsPlatformConversationsConversationIdHistoryGetQuery =
  z.object({
    page: z.int().gte(1).optional().default(1),
    limit: z.int().gte(1).lte(100).optional().default(10),
  });

/**
 * Successful Response
 */
export const zFetchAgentConversationHistoryApiV1AiAgentsPlatformConversationsConversationIdHistoryGetResponse =
  zAgentConversationHistoryResponse;

export const zFetchAgentInsightGetApiV1AiAgentsPlatformInsightGetPath =
  z.object({
    platform: z.string(),
  });

export const zFetchAgentInsightGetApiV1AiAgentsPlatformInsightGetQuery =
  z.object({
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    previous_start_date: z.iso.date().nullish(),
    previous_end_date: z.iso.date().nullish(),
    account_id: z.string().nullish(),
  });

/**
 * Successful Response
 */
export const zFetchAgentInsightGetApiV1AiAgentsPlatformInsightGetResponse =
  zAgentInsightResponse;

export const zFetchAgentInsightApiV1AiAgentsPlatformInsightPostPath = z.object({
  platform: z.string(),
});

export const zFetchAgentInsightApiV1AiAgentsPlatformInsightPostQuery = z.object(
  {
    start_date: z.iso.date(),
    end_date: z.iso.date(),
    previous_start_date: z.iso.date().nullish(),
    previous_end_date: z.iso.date().nullish(),
    account_id: z.string().nullish(),
  },
);

/**
 * Successful Response
 */
export const zFetchAgentInsightApiV1AiAgentsPlatformInsightPostResponse =
  zAgentInsightResponse;

export const zContinueChatApiV1AiInsightsChatPostBody = zContinueChatRequest;

/**
 * Successful Response
 */
export const zContinueChatApiV1AiInsightsChatPostResponse =
  zContinueChatResponse;

export const zGenerateInsightsApiV1AiInsightsGenerateInsightsPostBody =
  zGenerateInsightsRequest;

/**
 * Successful Response
 */
export const zGenerateInsightsApiV1AiInsightsGenerateInsightsPostResponse =
  zGenerateInsightsResponse;

export const zGetImplementationStepsApiV1AiInsightsImplementationStepsPostBody =
  zImplementationStepsRequest;

/**
 * Successful Response
 */
export const zGetImplementationStepsApiV1AiInsightsImplementationStepsPostResponse =
  zImplementationStepsResponse;

export const zListAnalysesApiV1DiagnosticAnalysesGetQuery = z.object({
  customer_uuid: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zListAnalysesApiV1DiagnosticAnalysesGetResponse =
  zDiagnosticAnalysisListResponse;

export const zDeleteAnalysisApiV1DiagnosticAnalysesAnalysisIdDeletePath =
  z.object({
    analysis_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zDeleteAnalysisApiV1DiagnosticAnalysesAnalysisIdDeleteResponse =
  z.void();

export const zGetAnalysisApiV1DiagnosticAnalysesAnalysisIdGetPath = z.object({
  analysis_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zGetAnalysisApiV1DiagnosticAnalysesAnalysisIdGetResponse =
  zDiagnosticAnalysisDetailResponse;

export const zAnalyzePageApiV1DiagnosticAnalyzePostBody =
  zDiagnosticAnalyzeRequest;

/**
 * Successful Response
 */
export const zAnalyzePageApiV1DiagnosticAnalyzePostResponse =
  zDiagnosticAnalyzeResponse;

export const zGetJobStatusApiV1DiagnosticJobsJobIdGetPath = z.object({
  job_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zGetJobStatusApiV1DiagnosticJobsJobIdGetResponse =
  zDiagnosticJobStatusResponse;

export const zResolveConversationApiV1MediaChatConversationGetQuery = z.object({
  account_id: z.string().nullish(),
  customer_uuid: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zResolveConversationApiV1MediaChatConversationGetResponse =
  zResolveConversationResponse;

export const zListConversationsApiV1MediaChatConversationsGetQuery = z.object({
  account_id: z.string().nullish(),
  customer_uuid: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zListConversationsApiV1MediaChatConversationsGetResponse =
  zConversationListResponse;

export const zStartConversationApiV1MediaChatConversationsPostBody =
  zStartConversationRequest;

/**
 * Successful Response
 */
export const zStartConversationApiV1MediaChatConversationsPostResponse =
  zStartConversationResponse;

export const zDeleteConversationApiV1MediaChatConversationsConversationIdDeletePath =
  z.object({
    conversation_id: z.uuid(),
  });

/**
 * Successful Response
 */
export const zDeleteConversationApiV1MediaChatConversationsConversationIdDeleteResponse =
  z.void();

export const zRenameConversationApiV1MediaChatConversationsConversationIdPatchBody =
  zRenameRequest;

export const zRenameConversationApiV1MediaChatConversationsConversationIdPatchPath =
  z.object({
    conversation_id: z.uuid(),
  });

/**
 * Response Rename Conversation Api V1 Media Chat Conversations  Conversation Id  Patch
 *
 * Successful Response
 */
export const zRenameConversationApiV1MediaChatConversationsConversationIdPatchResponse =
  z.record(z.string(), z.unknown());

export const zAskApiV1MediaChatConversationsConversationIdAskPostBody =
  zAskRequest;

export const zAskApiV1MediaChatConversationsConversationIdAskPostPath =
  z.object({
    conversation_id: z.uuid(),
  });

export const zAskApiV1MediaChatConversationsConversationIdAskPostQuery =
  z.object({
    start_date: z.iso.date().nullish(),
    end_date: z.iso.date().nullish(),
  });

/**
 * Successful Response
 */
export const zAskApiV1MediaChatConversationsConversationIdAskPostResponse =
  zAskResponse;

export const zGetHistoryApiV1MediaChatConversationsConversationIdHistoryGetPath =
  z.object({
    conversation_id: z.uuid(),
  });

export const zGetHistoryApiV1MediaChatConversationsConversationIdHistoryGetQuery =
  z.object({
    page: z.int().optional().default(1),
    limit: z.int().optional().default(20),
  });

/**
 * Response Get History Api V1 Media Chat Conversations  Conversation Id  History Get
 *
 * Successful Response
 */
export const zGetHistoryApiV1MediaChatConversationsConversationIdHistoryGetResponse =
  z.record(z.string(), z.unknown());

export const zGetJobStatusApiV1MediaChatJobsJobIdGetPath = z.object({
  job_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zGetJobStatusApiV1MediaChatJobsJobIdGetResponse =
  zApiMediaChatJobStatusResponse;

/**
 * Successful Response
 */
export const zApiV1TeamsGetResponse = zTeamListResponse;

export const zApiV1TeamsPostBody = zTeamCreateRequest;

/**
 * Successful Response
 */
export const zApiV1TeamsPostResponse = zTeamResponse;

/**
 * Successful Response
 */
export const zApiV1TeamsMyScopeGetResponse = zTeamScopeResponse;

export const zApiV1TeamsTeamIdDeletePath = z.object({
  team_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zApiV1TeamsTeamIdDeleteResponse = zTeamMessageResponse;

export const zApiV1TeamsTeamIdGetPath = z.object({
  team_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zApiV1TeamsTeamIdGetResponse = zTeamResponse;

export const zApiV1TeamsTeamIdPutBody = zTeamUpdateRequest;

export const zApiV1TeamsTeamIdPutPath = z.object({
  team_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zApiV1TeamsTeamIdPutResponse = zTeamResponse;

export const zApiV1TeamsTeamIdMembersPutBody = zTeamMembersRequest;

export const zApiV1TeamsTeamIdMembersPutPath = z.object({
  team_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zApiV1TeamsTeamIdMembersPutResponse = zTeamResponse;

export const zApiV1TeamsTeamIdAccountsPutBody = zTeamAccountsRequest;

export const zApiV1TeamsTeamIdAccountsPutPath = z.object({
  team_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zApiV1TeamsTeamIdAccountsPutResponse = zTeamResponse;

export const zApiV1TeamsTeamIdOverviewGetPath = z.object({
  team_id: z.uuid(),
});

export const zApiV1TeamsTeamIdOverviewGetQuery = z.object({
  start_date: z.iso.date(),
  end_date: z.iso.date(),
  comparison_type: z.string().nullish(),
});

/**
 * Successful Response
 */
export const zApiV1TeamsTeamIdOverviewGetResponse = zTeamOverviewResponse;

export const zApiV1FeedbackPostBody = zFeedbackCreate;

/**
 * Successful Response
 */
export const zApiV1FeedbackPostResponse = zFeedbackReceipt;

export const zApiV1AdminFeedbackGetQuery = z.object({
  page: z.int().gte(1).optional().default(1),
  page_size: z.int().gte(1).lte(100).optional().default(10),
  status: z.enum(["new", "in_progress", "done", "dismissed"]).optional(),
  kind: z.enum(["bug", "improvement"]).optional(),
  search: z.string().max(255).optional(),
});

/**
 * Successful Response
 */
export const zApiV1AdminFeedbackGetResponse = zAdminFeedbackListResponse;

export const zApiV1AdminFeedbackFeedbackIdPatchBody = zFeedbackStatusUpdate;

export const zApiV1AdminFeedbackFeedbackIdPatchPath = z.object({
  feedback_id: z.uuid(),
});

/**
 * Successful Response
 */
export const zApiV1AdminFeedbackFeedbackIdPatchResponse = zAdminFeedbackItem;
